import { HopQRCodeModal } from '@omni/components/contact/hop-qr-code-modal/hop-qr-code-modal';
import { getComponent } from '@omni/services/navigation/component-registry';
import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OmniAccordionViewDataModel } from '@omni/models/omniAccordionViewDataModel';
import { Brand, ProductRecordType } from '../../../classes/brand/brand.class';
import { BusinessLineVal, BusinessProcessType, Control, ControlDataType, DateFormat, DisplayText, DynamicForm, EditConfig, FieldConfigFilterOperatorType, FormChangeRequestType, FormTabs, FormType, LookupSearchResult, MDM_USER_TYPE, OTHER_LOOKUP_OPTION_ID, SetBookingProductFilter, SubgridLayout, ViewType } from '../../../classes/dynamic-form/dynamic-form.class';
import { CUSTOM_ADDRESS_FIELDS, SHARED_CREATE_FORM } from '../../../config/dynamic-forms/shared-form/shared-create-form';
import { AddressDataService } from '../../../data-services/address/address.data.service';
import { DynamicFormComponentModel, DynamicFormType } from '../../../models/dynamic-form-component.model';
import { IndDynamicFormLookupListDetailModel } from '../../../models/dynamicFormLookupListDetailModel';
import { IndDropdownListDetailModel } from '../../../models/indDropdownListModel';
import { FormFieldType, IndFormFieldViewDataModel } from '../../../models/indFormFieldDataModel';
import { IndPageTitleViewDataModel } from '../../../models/indPageTitleDataModel';
import { IndSectionHeaderViewDataModel } from '../../../models/indSectionHeaderDataModel';
import { MainCardViewDataModel } from '../../../models/MainCardViewDataModel';
import { MainToolTemplateDetail } from '../../../models/mainToolTemplateDetail.model';
import { MainToolTemplateListSelectionType } from '../../../models/mainToolTemplateDetail.model';
import { SelectListData } from '../../../models/select-list-data-model';
import { AccountOfflineService, AccountSelectedFor } from '../../../services/account/account.offline.service';
import { AlertService } from '../../../services/alert/alert.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { BrandOfflineService } from '../../../services/brand/brand.service';
import { ContactOfflineService } from '../../../services/contact/contact.service';
import { DateTimeFormatsService } from '../../../services/date-time-formats/date-time-formats.service';
import { DeviceService } from '../../../services/device/device.service';
import { DynamicFormsService } from '../../../services/dynamic-forms/dynamic-forms-service';
import { isOptionValueSet, roundToPrecision } from '../../../services/dynamic-forms/dynamic-form-values';
import { EventsService } from '../../../services/events/events.service';
import { EntityNameForTranslation, LocalizationService } from '../../../services/localization/localization.service';
import { TrackingEventNames, TrackService } from '../../../services/logging/tracking.service';
import { NavigationService, PageName } from '../../../services/navigation/navigation.service';
import { NotificationService, ToastStyle } from '../../../services/notification/notification.service';
import { ComponentViewMode, UIService } from '../../../services/ui/ui.service';
import { DynamicFormLookupPopoverComponent } from '../dynamic-form-lookup-popover/dynamic-form-lookup-popover';
import { IndDropdownListComponent } from '../ind-dropdown-list/ind-dropdown-list';
import { MdmService } from '@omni/services/mdm/mdm.service';
import { DynamicsClientService } from '@omni/data-services/dynamics-client/dynamics-client.service';
import { CONTACT_FETCH_QUERIES } from "../../../config/fetch-xml/contact-fetchXMLs";
import { FooterService } from '@omni/services/footer/footer.service';
import { DiskService } from '@omni/services/disk/disk.service';
import { PopoverComponent } from '../../popover/popover';
import { ChangeRequestType, MDMRequestType } from '@omni/classes/mdm/source-type-optionset.class';
import { multilingualLanguageToAttributeMapping } from '@omni/config/dynamic-forms/default-contact/default-contact-create';
import * as XML2JS from 'xml2js';
import { ACCOUNT_ACCOUNT_AFFILIATIONS_CR_REF_ENTITY, ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY, ACCOUNT_ACCOUNT_FROM_CR_ATTRIBUTE_NAME,
         ACCOUNT_ACCOUNT_FROM_FILTER_ATTRIBUTE_NAME, ACCOUNT_ACCOUNT_TO_CR_ATTRIBUTE_NAME, ACCOUNT_ACCOUNT_TO_FILTER_ATTRIBUTE_NAME,
         CONTACT_CONTACT_AFFILIATIONS_CR_REF_ENTITY, CONTACT_CONTACT_AFFILIATIONS_REF_ENTITY, CONTACT_CONTACT_FROM_CR_ATTRIBUTE_NAME,
         CONTACT_CONTACT_FROM_FILTER_ATTRIBUTE_NAME, CONTACT_CONTACT_TO_CR_ATTRIBUTE_NAME, CONTACT_CONTACT_TO_FILTER_ATTRIBUTE_NAME } from '../../../config/dynamic-forms/affiliations-contants';
import { FeatureActionsMap } from '@omni/classes/authentication/user.class';
import { IndDateTimeFormViewDataModel } from '@omni/models/indDateTimeFormDataModel';
import { CurViewPageType, DateTimeFieldType, IndDatetimeFormComponent } from '../ind-datetime-form/ind-datetime-form';
import { ActivityService } from '@omni/services/activity/activity.service';
import { DatePipe } from '@angular/common';
import { DCR_ATTACHMENT_MIME_TYPES_SUPPORTED_REGEX, MAXIMUM_NOTE_ATTACHMENT_SIZE, toBase64 } from '@omni/utility/util';
import { isValidEmailAddress } from '@omni/utility/common.utility';
import { SetBookingStatus } from '@omni/classes/activity/set-booking.activity.class';
import { SetBookingDataService } from '@omni/data-services/set-booking/set-booking.data.service';
import { fetchQueries } from '@omni/config/dynamics-fetchQueries';
import { MOBILE_FORMS_DISPLAY_ENTITY_FILTER } from '@omni/config/dynamic-forms/dynamic-forms-fetchxml';
import { MainToolTemplateDeatilData } from '@omni/models/mainToolTemplateDetailData.model';
import { SelectionConfig } from '@omni/interfaces/shared/shared.interface';
import { capitalize, cloneDeep, isEmpty, isString, startCase, uniqBy } from 'lodash-es';

const DEFAULT_FORM_LANGUAGE_CODE = '0000';

const compareBy = (...props) => (a, b) => {
  for (let i = 0; i < props.length; i++) {
    const ascValue = props[i].startsWith('-') ? -1 : 1;
    const prop = props[i].startsWith('-') ? props[i].substr(1) : props[i];
    if (a[prop]) {
      if (b[prop]) {
        if (a[prop] !== b[prop]) {
          return a[prop] > b[prop] ? ascValue : -ascValue;
        }
      } else {
        return ascValue;
      }
    } else {
      return ascValue === 1 ? -1 : 0;
    }
  }
  return 0;
};
/**
 * Generated class for the DynamicFormComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'ind-dynamic-form',
  templateUrl: 'ind-dynamic-form.html',
  styleUrls: ['ind-dynamic-form.scss']
})
export class DynamicFormComponent {

  private _isFormSaved = false;
  private _isPageTitleRequestInProgress = false;
  public formDetail: DynamicFormComponentModel;

  private _footerRestoreObserver: IntersectionObserver | null = null;
  private _footerRestoreHadBeenVisible = false;
  private _footerRestoreIsVisible = false;
  /** Tracks whether the footer Submit button should currently be enabled, mirroring the header Submit state. */
  private _footerSubmitEnabled = false;

  public isSearchBarEnabled = false;

  public searchText = '';
  public searchPlaceholder = '';
  public isSearchPopoverActive = false;
  public searchPopoverOptions: Array<{
    id: string,
    primaryText: string,
    data: any,
  }> = [];
  public selectedSearchOption: any;
  public isSelectedFromSearch = false;

  private _mode: string;
  private _previousMode: string;
  private _isFormDirty = false;
  public dynamicFormPageTitle: IndPageTitleViewDataModel;
  public firstSectionHeader: IndSectionHeaderViewDataModel;
  private  _activeLanguageCode = '1033';
  private _currentFormValue: { [x: string]: any };
  private _currentFormStringValues: { [x: string]: any };
  private _customFormValue: { [x: string]: any }; //object to store custom fields

  private readonly $ngDestroy: any = new Subject<boolean>();

  public linkedEntityValues: {
    [x: string]: Array<OmniAccordionViewDataModel>;
  };

  private _dropdownPopover: HTMLIonPopoverElement;
  private _lookupPopover: HTMLIonPopoverElement;
  private _activeLookupSearchControl: Control;
  private _activeProductSelectControl: Control;
  private _activeMainTemplateLookupSelectControl: Control;

  public currentFormView: Array<{
    id: string,
    type: string,
    view: any,
    timeView?: any,
    data?: string,
    control?: Control,
    isCollapsed?: boolean,
    section?: string
  }> = [];
  private _dynamicForm: DynamicForm;

  @ViewChild('dynamicFormDate', { static: true }) dynamicFormDateTimePicker: HTMLIonDatetimeElement;
  shortMonth: string[] = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

  public showSearchListDropdown = false;
  @Input() MODE: string;
  @Input() PREVIOUS_MODE: string;
  @Input() FORM_DETAIL: any;
  @Input() TYPE;
  @Input() EDIT_CONFIG: EditConfig;
  @Input() LINKED_ENTITY_DB_PREFIX;
  @Input() RAW_DATA;
  @Input() REF_ENTITY_NAME;
  @Input() from: any;
  @Input() EDIT_FLOW: string;

  public editConfig: EditConfig = EditConfig.ADD_NEW;
  public linkedEntityDBPrefix: string = '';
  public rawData;
  public referencingEntityName: string = '';
  public changeRequest: boolean = false;
  private disableForm: boolean = false;
  public isAccountAccountAffiliationPopover = false;
  public isAccountContactAffiliationPopover = false;
  public isAddressOneKeyPopover = false;
  public isAddressPopover = false;

  private startDate: Date;
  private endDate: Date;
  public _dateTimePickerActiveControl: Control;
  public startTime: { [x: string]: any } = {};
  public endTime: { [x: string]: any } = {};
  public prevStartTime: { [x: string]: any } = {};
  public prevEndTime: { [x: string]: any } = {};

  // private hasAccountAccountAffiliationForm: boolean = false;
  private hasAccountContactAffiliationForm: boolean = false;
  private hasAddressForm: boolean = false;
  // private hasCountryFieldInAddressForm: boolean = false;

  // for address edit form with auto-populated
  private addedNewACAffiliation: boolean = false;
  public addedNewAddressForAccountCR: boolean = false;
  public isEditModeForAddress: boolean = false;
  public currentEditFormView: Array<{
    id: string,
    type: string,
    view: any,
    data?: string,
    control?: Control,
  }> = [];
  private _dynamicFormForAddressEdit: DynamicForm;
  private _foundFormForACAffiliationCR: DynamicForm;
  private _foundFormForAddressCR: DynamicForm;
  private formEditAddressDetail: DynamicFormComponentModel;
  public isExpandedCurrentEditFormView: boolean = false;
  public hasExistingLinkedDataForAddressAccountCR: boolean = false;
  public labelForExistingAddress: string;
  private isHandleEditAddressFormField: boolean = false;
  private _existingFormValue: { [x: string]: any };
  public _existingCustomFormValue: { [x: string]: any };
  private _existingFormStringValues: { [x: string]: any };
  private isAutoPopulatedLinkedDataFlow: boolean = false;
  public isViewFromEditFormToAccordionForm: boolean = false;
  public errorMessage: string;
  public addressAttrName: string;
  private _stateIdBasedOnCity: string;
  private _isClicked: { [x: string]: boolean } = {};
  public worksCardHeader: IndSectionHeaderViewDataModel;
  public isWorkCardAdded = false;
  public workCardTitle = '';
  workCardBase64str: any;
  workCardFile: any;
  @ViewChild('workcardAttachInput') workcardAttachInput: ElementRef;
  public practiceCertificateHeader: IndSectionHeaderViewDataModel;
  public isPracticeCertificateAdded = false;
  public practiceCertificateTitle = '';
  practiceCertificateBase64str: any;
  practiceCertificateFile: any;
  @ViewChild('practiceCertificateAttachInput') practiceCertificateAttachInput: ElementRef;
  public businessLine: number = -1;
  private _DCR_isVxMDMFlow = false;

  private _runInitViewDataAfterBusinessRuleLogic:boolean = false;
  // Config-driven field rules (IO Config: FORM_FIELD_RULES_<ENTITY>). undefined = not yet loaded for this form.
  private _configuredFieldRules: any[];
  public searchKeyWordFromMainToolTemplate = '';
  public selectedFilterFromMainToolTemplate: any;
  private isLayoverPushView: boolean;
  private layoverViewPushedFrom: string;
  private _isInNgOnInit: boolean = false;
  // True only while _setDefaultValue() applies a configured default in CREATE_MODE.
  // Default values are applied from _targetControlViewData AFTER _isInNgOnInit is cleared,
  // so without this guard a system default would be treated as a user edit and mark the
  // pristine form dirty (spurious discard popup on back). System defaults are not user input.
  private _isApplyingDefaultValue: boolean = false;

  // Consolidated Map for Address CR attribute mappings
  private readonly addressCRAttributeMapping = new Map<string, { sourceKey: string; copyFormattedValue: boolean }>([
    ['exe_line1_new', { sourceKey: 'indskr_address.indskr_line1', copyFormattedValue: false }],
    ['exe_line2_new', { sourceKey: 'indskr_address.indskr_line2', copyFormattedValue: false }],
    ['exe_addressline1_new', { sourceKey: 'indskr_address.indskr_line1', copyFormattedValue: false }],
    ['exe_addressline2_new', { sourceKey: 'indskr_address.indskr_line2', copyFormattedValue: false }],
    ['exe_city_new', { sourceKey: 'indskr_address.indskr_city_lu', copyFormattedValue: true }],
    ['exe_stateprovince_new', { sourceKey: 'indskr_address.indskr_state_lu', copyFormattedValue: true }],
    ['exe_postalcode_new', { sourceKey: 'indskr_address.indskr_postalcode_lu', copyFormattedValue: true }],
    ['exe_country_new', { sourceKey: 'indskr_address.indskr_country_lu', copyFormattedValue: true }],
    ['exe_isprimary_new', { sourceKey: 'indskr_indskr_customeraddress_v2.indskr_isprimary', copyFormattedValue: true }],
    ['exe_name_new', { sourceKey: 'indskr_address.indskr_composite', copyFormattedValue: false }],
    ['exe_isprimary', { sourceKey: 'indskr_indskr_customeraddress_v2.indskr_isprimary', copyFormattedValue: true }],
    ['exe_address', { sourceKey: 'indskr_indskr_customeraddress_v2.indskr_address', copyFormattedValue: true }]
  ]);

  constructor(
    public translate: TranslateService,
    public navService: NavigationService,
    public uiService: UIService,
    public authService: AuthenticationService,
    private readonly dynamicFormsService: DynamicFormsService,
    private readonly popoverCtrl: PopoverController,
    public dateTimeFormatsService: DateTimeFormatsService,
    private readonly device: DeviceService,
    private readonly events: EventsService,
    private readonly notificationService: NotificationService,
    private readonly addressService: AddressDataService,
    private readonly localizationService: LocalizationService,
    private readonly trackingService: TrackService,
    private readonly alertService: AlertService,
    private readonly accountService: AccountOfflineService,
    private readonly UIService: UIService,
    private readonly contactService: ContactOfflineService,
    private readonly brandService: BrandOfflineService,
    private readonly mdmService: MdmService,
    public readonly footerService: FooterService,
    private dynamics: DynamicsClientService,
    private disk: DiskService,
    public activityService: ActivityService,
    private datePipe: DatePipe,
    private setBookingDataService: SetBookingDataService,
    private readonly _hostRef: ElementRef<HTMLElement>
  ) {
    this._activeLanguageCode = this.localizationService.selectedLanguage.localeID;
  }

  private _markControlReadOnlyIfDefault(control: any): void {
    if (this._mode == 'EDIT_MODE' && this.formDetail.dynamicFormType == DynamicFormType.DEFAULTFORM) {
      control.isReadOnly = true;
    }
  }

  private async _processOneKeyLookupField(control: any, rawObject: any): Promise<void> {
    if (rawObject['_' + control.attributeName + '_value'] && this.localizationService.multiLingualFieldsData && this.localizationService.multiLingualFieldsData.length > 0) {
      const foundRecord = this.localizationService.multiLingualFieldsData.find(a => a['omnione_onekeycodeslabelsid'] == rawObject['_' + control.attributeName + '_value']);
      let translatedLang: string = '';
      const key = this.localizationService.getOneKeyTableAttributes();
      if (foundRecord) translatedLang = foundRecord[key] ? foundRecord[key] || '' : foundRecord['omnione_en_long_label'] || '';
      if (foundRecord && foundRecord['omnione_onekeycodeslabelsid'] && translatedLang) {
        const onekeyCodesLabelsId = foundRecord['omnione_onekeycodeslabelsid'] || '';
        let codIdOneKey = '';
        if (foundRecord && foundRecord['omnione_cod_id_onekey']) {
          codIdOneKey = foundRecord['omnione_cod_id_onekey'];
          this._setAttributeValue(control, onekeyCodesLabelsId, false, codIdOneKey);
          this._setAttributeStringValue(control.attributeName, translatedLang);
        } else {
          const schemaFieldName = foundRecord['omnione_schemafieldname'] || '';
          try {
            await this.dynamicFormsService.getLookupCodIdOnekey(schemaFieldName, onekeyCodesLabelsId).then((res) => {
              if (!isEmpty(res)) codIdOneKey = res;
              this._setAttributeValue(control, onekeyCodesLabelsId, false, codIdOneKey);
              this._setAttributeStringValue(control.attributeName, translatedLang);
            });
          } catch (error) {
            console.log("Error getting lookup codIdOnekey");
            this._setAttributeValue(control, onekeyCodesLabelsId, false, codIdOneKey);
            this._setAttributeStringValue(control.attributeName, translatedLang);
          }
        }
      }
    }
  }

  private _toggleExeltisDeleteReasonVisibility(isVisible: boolean): void {
    this._dynamicForm.metadata.forEach((tab) => {
      if (tab && tab.controls && tab.controls.length > 0) {
        const deleteReasonControl = tab.controls.find(control => control.attributeName === 'exe_deletereason_new');
        if (deleteReasonControl) {
          deleteReasonControl.forceHide = !isVisible;
          deleteReasonControl.isRequired = isVisible;
          if (!isVisible) {
            this._clearAttributeValue(deleteReasonControl);
          }
        }
      }
    });
  }

  // ---- Generic lookup 'Other' -> free-text field support -------------------
  // Declarative registry (no mobileappform config needed): a lookup field that
  // offers a synthetic 'Other' entry revealing a free-text field, optionally
  // scoped to the form's contact. The behaviour activates only for a listed field
  // that is actually present on the current form. Add an entry to extend to
  // another field - the engine below is entirely generic.
  private readonly _otherOptionLookupRegistry: ReadonlyArray<{ lookupField: string; otherField: string; contactFilterAttribute?: string }> = [
    { lookupField: 'exe_address', otherField: 'exe_updatedaddress', contactFilterAttribute: 'indskr_customer' },
  ];

  // Wires the registry to the current form: for each listed lookup present, mark it
  // with its otherOptionField, scope its lookup query to the contact, and hide the
  // free-text field until 'Other' is selected.
  private _setupOtherOptionLookups(): void {
    this._otherOptionLookupRegistry.forEach(cfg => {
      const lookupControl = this._getTargetControl(cfg.lookupField);
      if (!lookupControl || lookupControl.dataType !== ControlDataType.LookupType) return;
      lookupControl.otherOptionField = cfg.otherField;
      if (cfg.contactFilterAttribute) {
        this._applyContactFilterToLookup(lookupControl, cfg.contactFilterAttribute);
      }
      this._toggleOtherOptionField(lookupControl, false);
    });
  }

  // Returns every lookup control on the form that has an otherOptionField wired.
  private _getOtherOptionLookupControls(): Control[] {
    const controls: Control[] = [];
    this._dynamicForm?.metadata?.forEach(tab => {
      tab?.controls?.forEach(control => {
        if (control.dataType === ControlDataType.LookupType && control.otherOptionField) {
          controls.push(control);
        }
      });
    });
    return controls;
  }

  // Scopes a lookup's fetch XML to the form's contact by adding an eq condition on
  // the given attribute. Idempotent: any previously injected condition for the same
  // attribute is removed first, so a cached/shared metadata object always reflects
  // the current contact.
  private _applyContactFilterToLookup(lookupControl: Control, attribute: string): void {
    const contactId = this.contactService?.contactInformation?.ID || '';
    if (!contactId || !attribute || !lookupControl?.lookupQueries?.fetchXml) return;
    let fetchXml = lookupControl.lookupQueries.fetchXml.replace(new RegExp(`<condition attribute="${attribute}"[^>]*>`, 'g'), '');
    const condition = `<condition attribute="${attribute}" operator="eq" value="${contactId}" />`;
    if (fetchXml.includes('<filter type="and">')) {
      fetchXml = fetchXml.replace('<filter type="and">', `<filter type="and">${condition}`);
    } else {
      fetchXml = fetchXml.replace(/(<entity\b[^>]*>)/, `$1<filter type="and">${condition}</filter>`);
    }
    lookupControl.lookupQueries.fetchXml = fetchXml;
  }

  // Shows/hides the free-text field named by a lookup's otherOptionField and keeps
  // the two mutually mandatory (one-of): the lookup itself is required whenever the
  // free-text field is hidden (a real record must be chosen), and the free-text
  // field is required whenever it is shown ('Other' chosen). When hidden its value
  // is cleared so stale free-text is never submitted after a real record is selected.
  private _toggleOtherOptionField(lookupControl: Control, isVisible: boolean): void {
    const dependentControl = lookupControl?.otherOptionField
      ? this._getTargetControl(lookupControl.otherOptionField)
      : undefined;
    if (!dependentControl) return;
    // One-of enforcement: exe_address mandatory, else exe_updatedaddress must have a value.
    lookupControl.isRequired = !isVisible;
    dependentControl.forceHide = !isVisible;
    dependentControl.isRequired = isVisible;
    if (!isVisible) {
      this._clearAttributeValue(dependentControl);
      // Memo/string fields are not wiped by _clearAttributeValue, so clear the
      // stored value explicitly.
      if (this._currentFormValue && this._currentFormValue.hasOwnProperty(dependentControl.attributeName)) {
        delete this._currentFormValue[dependentControl.attributeName];
      }
      if (this._currentFormStringValues && this._currentFormStringValues.hasOwnProperty(dependentControl.attributeName)) {
        delete this._currentFormStringValues[dependentControl.attributeName];
      }
    }
  }

  // Initial state after parse: reveal any dependent free-text field that already
  // holds a value (existing record filled via 'Other'); keep the rest hidden.
  private _initOtherOptionLookups(): void {
    this._getOtherOptionLookupControls().forEach(lookupControl => {
      const hasValue = !!(this._currentFormValue && this._currentFormValue[lookupControl.otherOptionField]);
      this._toggleOtherOptionField(lookupControl, hasValue);
    });
  }

  private async _parseRawObjectDataToValues(rawObject: any) {
    if (this._dynamicForm && this._dynamicForm.metadata && this._dynamicForm.metadata.length > 0) {
      this._dynamicForm.metadata.forEach((tab, tabIndex) => {
        if (tab && tab.controls && tab.controls.length > 0) {
          tab.controls.forEach(async control => {
            switch (control.dataType) {
              case ControlDataType.MoneyType:
              case ControlDataType.IntegerType:
              case ControlDataType.DecimalType:
              case ControlDataType.DoubleType:
              case ControlDataType.MemoType:
              case ControlDataType.StringType:
                const fieldName = control.isCustomAttribute && control.schemaName ? control.schemaName : control.attributeName;
                const fieldValue = rawObject[control.attributeName] ?? rawObject[control.schemaName] ?? rawObject[fieldName];
                if (fieldValue) {
                  if (this.MODE =='EDIT_MODE' && this.TYPE != "OMNIPRESENCE" && (this._dynamicForm.entityName == 'indskr_contactcr' || this._dynamicForm.entityName =='indskr_accountcr')) {
                    if (control.isVisible && (control.isRequired || control.isCustomAttribute) && !control.forceHide) {
                      this._setAttributeValue(control, fieldValue, false);
                    }
                  } else {
                    this._setAttributeValue(control, fieldValue, false);
                  }
                  this._markControlReadOnlyIfDefault(control);
                }
                break;
              case ControlDataType.LookupType:
                if (rawObject['_' + control.attributeName + '_value']) {
                  if (this.MODE =='EDIT_MODE' && this.TYPE != "OMNIPRESENCE" && (this._dynamicForm.entityName == 'indskr_contactcr' || this._dynamicForm.entityName =='indskr_accountcr')) {
                    if (control.isVisible && (control.isRequired || control.isCustomAttribute) && !control.forceHide) {

                      let otherFieldsToInclude;
                      // Hardcoded logic for DCR Vx MDM
                      // TODO: add configuration for this instead of hardcode
                      if (this._DCR_isVxMDMFlow) {
                        let fieldNamesToIncludeInSelectionData = this._getFieldNamesToIncludeInSelectionData(control);
                        if (fieldNamesToIncludeInSelectionData) {
                          otherFieldsToInclude = {};
                          for (const fieldName of fieldNamesToIncludeInSelectionData) {
                            if (rawObject['_' + control.attributeName + '_' + fieldName]) {
                              otherFieldsToInclude[fieldName] = rawObject['_' + control.attributeName + '_' + fieldName];
                            }
                          }
                        }
                      }

                      if(control.lookupEntityPrimaryId && control.lookupEntityPrimaryId == "omnione_onekeycodeslabelsid"){
                        await this._processOneKeyLookupField(control, rawObject);
                      }else{
                        this._setAttributeValue(control, rawObject['_' + control.attributeName + '_value'], false, '', true, otherFieldsToInclude);
                        this._setAttributeStringValue(control.attributeName, rawObject['_' + control.attributeName + '_value@OData.Community.Display.V1.FormattedValue']);
                      }
                    }
                  }else if(control.lookupEntityPrimaryId && control.lookupEntityPrimaryId == "omnione_onekeycodeslabelsid"){
                    await this._processOneKeyLookupField(control, rawObject);
                  }else {
                    this._setAttributeValue(control, rawObject['_' + control.attributeName + '_value'], false);
                    this._setAttributeStringValue(control.attributeName, rawObject['_' + control.attributeName + '_value@OData.Community.Display.V1.FormattedValue']);
                  }
                  this._markControlReadOnlyIfDefault(control);
                }
                break;
              case ControlDataType.BooleanType:
                if (rawObject.hasOwnProperty(control.attributeName)) {
                  if (this.MODE =='EDIT_MODE' && this.TYPE != "OMNIPRESENCE" && (this._dynamicForm.entityName == 'indskr_contactcr' || this._dynamicForm.entityName =='indskr_accountcr')) {
                    if (control.isVisible && (control.isRequired || control.isCustomAttribute) && !control.forceHide) {
                      (rawObject[control.attributeName]) ? this._setAttributeValue(control, true, false) : this._setAttributeValue(control, false, false);
                    }
                  } else {
                    (rawObject[control.attributeName]) ? this._setAttributeValue(control, true, false) : this._setAttributeValue(control, false, false);
                  }
                  this._markControlReadOnlyIfDefault(control);
                }
                break;
              case ControlDataType.MultiSelectPicklistType:
                if (rawObject[control.attributeName]) {
                  this._setAttributeValue(control, rawObject[control.attributeName], false);
                  let str = rawObject[control.attributeName+'@OData.Community.Display.V1.FormattedValue'].replace(/;/g, ',');
                  if (this.MODE =='EDIT_MODE' && this.TYPE != "OMNIPRESENCE" && (this._dynamicForm.entityName == 'indskr_contactcr' || this._dynamicForm.entityName =='indskr_accountcr')) {
                    if (control.isVisible && (control.isRequired || control.isCustomAttribute) && !control.forceHide) {
                      this._setAttributeStringValue(control.attributeName,str);
                    }
                  } else {
                    this._setAttributeStringValue(control.attributeName,str);
                  }
                  this._markControlReadOnlyIfDefault(control);
                }
                break;
              case ControlDataType.PicklistType:
                if (isOptionValueSet(rawObject[control.attributeName])) {
                  if (this.MODE =='EDIT_MODE' && this.TYPE != "OMNIPRESENCE" && (this._dynamicForm.entityName == 'indskr_contactcr' || this._dynamicForm.entityName =='indskr_accountcr')) {
                    if (control.isVisible && (control.isRequired || control.isCustomAttribute) && !control.forceHide) {
                      this._setAttributeValue(control, rawObject[control.attributeName], false);
                      this._setAttributeStringValue(control.attributeName, rawObject[control.attributeName + '@OData.Community.Display.V1.FormattedValue']);
                    }
                  } else {
                    this._setAttributeValue(control, rawObject[control.attributeName], false);
                    this._setAttributeStringValue(control.attributeName, rawObject[control.attributeName + '@OData.Community.Display.V1.FormattedValue']);
                  }
                  this._markControlReadOnlyIfDefault(control);
                }
                break;
              case ControlDataType.DateTimeType:
                if (rawObject[control.attributeName] || rawObject[control.attributeName + '@OData.Community.Display.V1.FormattedValue']) {
                  let date: Date;
                  if (rawObject[control.attributeName]) {
                    date = new Date(rawObject[control.attributeName]);
                    if (!this.dateTimeFormatsService.isValidDate(date)) {
                      date = new Date(parseInt(rawObject[control.attributeName]));
                      if (!this.dateTimeFormatsService.isValidDate(date) && rawObject[control.attributeName + '@OData.Community.Display.V1.FormattedValue']) {
                        date = new Date(rawObject[control.attributeName + '@OData.Community.Display.V1.FormattedValue']);
                      }
                    }
                  } else if (rawObject[control.attributeName + '@OData.Community.Display.V1.FormattedValue']) {
                      date = new Date(rawObject[control.attributeName + '@OData.Community.Display.V1.FormattedValue']);
                  }
                  if (this.dateTimeFormatsService.isValidDate(date)) {
                    if (control.dateFormat === DateFormat.DateAndTime) {
                      this._setAttributeValueDate(control, date);
                    } else if (control.dateFormat === DateFormat.DateOnly) {
                      date.setHours(0, 0, 0, 0);
                      this._setAttributeValueDate(control, date);
                    }
                  } else {
                    this._setAttributeValue(control, "");
                    this._setAttributeStringValue(control.attributeName, "");
                  }
                  if (control.attributeName == 'indskr_startdate' && this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) {
                    if (this.startTime && this.startTime.hasOwnProperty(control.attributeName)) {
                      this.startTime[control.attributeName] = this._currentFormStringValues[control.attributeName];
                    } else {
                      this.startTime = {
                        indskr_startdate: this._currentFormStringValues[control.attributeName]
                      }
                    }
                  } else if (control.attributeName == 'indskr_enddate' && this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) {
                    if (this.endTime && this.endTime.hasOwnProperty(control.attributeName)) {
                      this.endTime[control.attributeName] = this._currentFormStringValues[control.attributeName];
                    } else {
                      this.endTime = {
                        indskr_enddate: this._currentFormStringValues[control.attributeName]
                      }
                    }
                  }
                  this._markControlReadOnlyIfDefault(control);
                }
                break;
              case ControlDataType.StateType:
              case ControlDataType.StatusType:
                if (this.MODE =='EDIT_MODE') {
                  control.isReadOnly = true;
                  if (rawObject[control.attributeName] || rawObject[control.attributeName] == 0) {
                    this._setAttributeValue(control, rawObject[control.attributeName]);
                    let str = rawObject[control.attributeName + '@OData.Community.Display.V1.FormattedValue'];
                    if (rawObject[control.attributeName + '@OData.Community.Display.V1.FormattedValue'] == "In Progress" && this.changeRequest) {
                      str = "In Process";
                    }
                    if (!isEmpty(str)) this._setAttributeStringValue(control.attributeName, str);
                  } else {
                    this._setAttributeValue(control, "");
                    this._setAttributeStringValue(control.attributeName, "")
                  }
                }
                break;
              case null:
                // Handle Subgrid case
                if(this.formDetail.enableSubgridDataEditing){
                  await this._initializeSubgridData(control);
                }
                default:
                break;
            }
          });
        }
      });
    }
  }
// Business flow - Main form - Existing Linked Entity Data
  private async _parseRawObjectDataToValuesLinkedEntity() {
    if (this._dynamicForm && this._dynamicForm.metadata && this._dynamicForm.metadata.length > 0) {
      this._dynamicForm.metadata.forEach((tab) => {
        if (tab && tab.controls && tab.controls.length > 0) {
          tab.controls.forEach(async control => {
            if (control.dataType == null) {
              let response = await this._initializeSubgridData(control);
              if (control.linkedEntityConfig && response) this._initViewData();
            }
          });
        }
      });
    }
  }
  // Business flow - Linked Entity Edit form
  private async _parseRawObjectDataToValuesExistingData(rawObject: any, isUpdatedLinkedEntityFormData: boolean) {
    if (this._dynamicForm && this._dynamicForm.metadata && this._dynamicForm.metadata.length > 0) {
      this._dynamicForm.metadata.forEach((tab) => {
        if (tab && tab.controls && tab.controls.length > 0) {
          tab.controls.forEach(async control => {
            let entityName = this.formDetail.formMetadata.entityName;
            const isAddressEntity: boolean = entityName == "indskr_indskr_customeraddress_v2" || entityName == "indskr_customeraddresscr";
            const isEmailAddressCREntity: boolean = entityName == "indskr_emailaddresscr" && this.TYPE == 'OMNIPRESENCE'  
                                                    && this._dynamicForm
                                                    && this._dynamicForm?.formType == FormType.EDITFORM
            let foundFormValue: string;
            let foundFormStringValue: string;
            switch (control.dataType) {
              case ControlDataType.MoneyType:
              case ControlDataType.IntegerType:
              case ControlDataType.DecimalType:
              case ControlDataType.DoubleType:
              case ControlDataType.MemoType:
              case ControlDataType.StringType:
                if (isUpdatedLinkedEntityFormData) {
                  if (control.isCustom) {
                    if (rawObject.customFormValue && rawObject.customFormValue.hasOwnProperty(control.attributeName)) {
                      foundFormValue = rawObject.customFormValue[control.attributeName] || '';
                    }
                  } else {
                    if (rawObject.formValue && rawObject.formValue.hasOwnProperty(control.attributeName)) {
                      foundFormValue = rawObject.formValue[control.attributeName] || '';
                    }
                  }
                } else {
                  const lookupKey = entityName + '.' + control.attributeName;
                  foundFormValue = rawObject[lookupKey] || '';
                  if (!foundFormValue && (isAddressEntity || isEmailAddressCREntity)) {
                    entityName = isAddressEntity ? "indskr_address" : 'indskr_email_address';
                    foundFormValue = rawObject[entityName + '.' + control.attributeName] || '';
                  }
                }
                if (foundFormValue) {
                  this._setAttributeValue(control, foundFormValue, false);
                }
                break;
              case ControlDataType.LookupType:
                let targetAttributeName = control.isCustom ? control.schemaName : (control.isCustomAttribute ? control.schemaName : control.attributeName);
                if (isUpdatedLinkedEntityFormData) {
                  let foundObj;
                  if (control.isCustom && rawObject.customFormValue.lookupfields) {
                    foundObj = rawObject.customFormValue.lookupfields.filter(x=>x.name == targetAttributeName)
                  } else if (!control.isCustom && rawObject.formValue.lookupfields) {
                    foundObj = rawObject.formValue.lookupfields.filter(x=>x.name == targetAttributeName);
                  }
                  if (foundObj.length > 0) {
                    foundFormValue = foundObj[0].id || '';
                    if (rawObject.formStringValue && rawObject.formStringValue.hasOwnProperty(control.attributeName)) {
                      foundFormStringValue = rawObject.formStringValue[control.attributeName] || '';
                    }
                  }
                } else {
                  const lookupKey = entityName + '.' + control.attributeName;
                  const formattedKey = entityName + '.' + control.attributeName + '@OData.Community.Display.V1.FormattedValue';
                  foundFormValue = rawObject[lookupKey] || '';
                  foundFormStringValue = rawObject[formattedKey] || '';
                  if (!foundFormValue && (isAddressEntity || isEmailAddressCREntity)) {
                    entityName = isAddressEntity ? "indskr_address" : 'indskr_email_address';
                    foundFormValue = rawObject[entityName + '.' + control.attributeName] || '';
                    foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '@OData.Community.Display.V1.FormattedValue'] || '';
                  }
                  if(!isEmpty(foundFormValue) && isEmpty(foundFormStringValue)) {
                    foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '_value'] || '';
                  }
                }
                if (foundFormValue) {
                  this._setAttributeValue(control, foundFormValue, false);
                  this._setAttributeStringValue(control.attributeName, foundFormStringValue);
                  this._markControlReadOnlyIfDefault(control);
                }
                break;
              case ControlDataType.BooleanType:
                if (isUpdatedLinkedEntityFormData) {
                  if (control.isCustom) {
                    if (rawObject.customFormValue && rawObject.customFormValue.hasOwnProperty(control.attributeName)) {
                      foundFormValue = rawObject.customFormValue[control.attributeName] || '';
                    }
                  } else {
                    if (rawObject.formValue && rawObject.formValue.hasOwnProperty(control.attributeName)) {
                      foundFormValue = rawObject.formValue[control.attributeName] || '';
                    }
                    if (control.attributeName == "indskr_isprimary" && rawObject.formValue && !rawObject.formValue.hasOwnProperty(control.attributeName) && rawObject.formStringValue.indskr_isprimary == "No") {
                      this._setAttributeValue(control, false, false);
                    }
                  }
                } else {
                  foundFormValue = rawObject[entityName + '.' + control.attributeName];
                  if (foundFormValue == undefined && (isAddressEntity || isEmailAddressCREntity)) {
                    entityName = isAddressEntity ? "indskr_address" : 'indskr_email_address';
                    foundFormValue = rawObject[entityName + '.' + control.attributeName];
                  }
                }
                if (rawObject.hasOwnProperty(entityName + '.' + control.attributeName) || (rawObject.formValue && rawObject.formValue.hasOwnProperty(control.attributeName))) {
                  foundFormValue ? this._setAttributeValue(control, true, false) : this._setAttributeValue(control, false, false);
                  this._markControlReadOnlyIfDefault(control);
                } else if (!this._currentFormValue?.hasOwnProperty(control.attributeName)) {
                  // New linked entity with no raw data — initialise boolean to false so the value
                  // is always included in the payload (matches the visual "No" default in the form).
                  this._setAttributeValue(control, false, false);
                  this._setAttributeStringValue(control.attributeName, this.translate.instant('NO'));
                }
                break;
              case ControlDataType.MultiSelectPicklistType:
                if (isUpdatedLinkedEntityFormData) {
                  if (control.isCustom) {
                    if (rawObject.customFormValue && rawObject.customFormValue.hasOwnProperty(control.attributeName)) {
                      foundFormValue = rawObject.customFormValue[control.attributeName] || '';
                    }
                  } else {
                    if (rawObject.formValue && rawObject.formValue.hasOwnProperty(control.attributeName)) {
                      foundFormValue = rawObject.formValue[control.attributeName] || '';
                    }
                  }
                  if (rawObject.formStringValue && rawObject.formStringValue.hasOwnProperty(control.attributeName)) {
                    foundFormStringValue = rawObject.formStringValue[control.attributeName].replace(/;/g, ',') || '';
                  }
                } else {
                  foundFormValue = rawObject[entityName + '.' + control.attributeName] || '';
                  foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '@OData.Community.Display.V1.FormattedValue'].replace(/;/g, ',') || '';
                  if (!foundFormValue && (isAddressEntity || isEmailAddressCREntity)) {
                    entityName = isAddressEntity ? "indskr_address" : 'indskr_email_address';
                    foundFormValue = rawObject[entityName + '.' + control.attributeName] || '';
                    foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '@OData.Community.Display.V1.FormattedValue'].replace(/;/g, ',') || '';
                  }
                }
                if(!isEmpty(foundFormValue) && isEmpty(foundFormStringValue)) {
                  foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '_value'].replace(/;/g, ',') || '';
                }
                if (foundFormValue) {
                  this._setAttributeValue(control, foundFormValue, false);
                  this._setAttributeStringValue(control.attributeName, foundFormStringValue);
                  this._markControlReadOnlyIfDefault(control);
                }
                break;
              case ControlDataType.PicklistType:
                if (isUpdatedLinkedEntityFormData) {
                  if (control.isCustom) {
                    if (rawObject.customFormValue && rawObject.customFormValue.hasOwnProperty(control.attributeName)) {
                      foundFormValue = rawObject.customFormValue[control.attributeName] ?? '';
                    }
                  } else {
                    if (rawObject.formValue && rawObject.formValue.hasOwnProperty(control.attributeName)) {
                      foundFormValue = rawObject.formValue[control.attributeName] ?? '';
                    }
                  }
                  if (rawObject.formStringValue && rawObject.formStringValue.hasOwnProperty(control.attributeName)) {
                    foundFormStringValue = rawObject.formStringValue[control.attributeName] || '';
                  }
                } else {
                  foundFormValue = rawObject[entityName + '.' + control.attributeName] ?? '';
                  foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '@OData.Community.Display.V1.FormattedValue'] || '';
                  if (!isOptionValueSet(foundFormValue) && (isAddressEntity || isEmailAddressCREntity)) {
                    entityName = isAddressEntity ? "indskr_address" : 'indskr_email_address';
                    foundFormValue = rawObject[entityName + '.' + control.attributeName] ?? '';
                    foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '@OData.Community.Display.V1.FormattedValue'] || '';
                  }
                  if(!isEmpty(foundFormValue) && isEmpty(foundFormStringValue)) {
                    foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '_value'] || '';
                  }
                }
                if (isOptionValueSet(foundFormValue)) {
                  this._setAttributeValue(control, foundFormValue, false);
                  this._setAttributeStringValue(control.attributeName, foundFormStringValue);
                  this._markControlReadOnlyIfDefault(control);
                }
                break;
              case ControlDataType.DateTimeType:
                if (isUpdatedLinkedEntityFormData) {
                  if (control.isCustom) {
                    if (rawObject.customFormValue && rawObject.customFormValue.hasOwnProperty(control.attributeName)) {
                      foundFormValue = rawObject.customFormValue[control.attributeName] || '';
                    }
                  } else {
                    if (rawObject.formValue && rawObject.formValue.hasOwnProperty(control.attributeName)) {
                      foundFormValue = rawObject.formValue[control.attributeName] || '';
                    }
                  }
                  if (rawObject.formStringValue && rawObject.formStringValue.hasOwnProperty(control.attributeName)) {
                    foundFormStringValue = rawObject.formStringValue[control.attributeName] || '';
                  }
                } else {
                  foundFormValue = rawObject[entityName + '.' + control.attributeName] || '';
                  foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '@OData.Community.Display.V1.FormattedValue'] || '';
                  if (!foundFormValue && (isAddressEntity || isEmailAddressCREntity)) {
                    entityName = isAddressEntity ? "indskr_address" : 'indskr_email_address';
                    foundFormValue = rawObject[entityName + '.' + control.attributeName] || '';
                    foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '@OData.Community.Display.V1.FormattedValue'] || '';
                  }
                  if(!isEmpty(foundFormValue) && isEmpty(foundFormStringValue)) {
                    foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '_value'] || '';
                  }
                }
                if (foundFormValue || foundFormStringValue) {
                  let date: Date;
                  if (foundFormValue) {
                      date = new Date(foundFormValue);
                      if (!this.dateTimeFormatsService.isValidDate(date)) {
                        date = new Date(parseInt(foundFormValue));
                        if (!this.dateTimeFormatsService.isValidDate(date)) {
                          date = new Date(foundFormStringValue);
                        }
                      }
                  } else if (foundFormStringValue) {
                      date = new Date(foundFormStringValue);
                  }
                  if (this.dateTimeFormatsService.isValidDate(date)) {
                    if (control.dateFormat === DateFormat.DateAndTime) {
                      this._setAttributeValueDate(control, date);
                    } else if (control.dateFormat === DateFormat.DateOnly) {
                      date.setHours(0, 0, 0, 0);
                      this._setAttributeValueDate(control, date);
                    }
                  } else {
                    this._setAttributeValue(control, "");
                    this._setAttributeStringValue(control.attributeName, "");
                  }
                  if (control.attributeName == 'indskr_startdate' && this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) {
                    if (this.startTime && this.startTime.hasOwnProperty(control.attributeName)) {
                      this.startTime[control.attributeName] = this._currentFormStringValues[control.attributeName];
                    } else {
                      this.startTime = {
                        indskr_startdate: this._currentFormStringValues[control.attributeName]
                      }
                    }
                  } else if (control.attributeName == 'indskr_enddate' && this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) {
                    if (this.endTime && this.endTime.hasOwnProperty(control.attributeName)) {
                      this.endTime[control.attributeName] = this._currentFormStringValues[control.attributeName];
                    } else {
                      this.endTime = {
                        indskr_enddate: this._currentFormStringValues[control.attributeName]
                      }
                    }
                  }
                  this._markControlReadOnlyIfDefault(control);
                }
                break;
              case ControlDataType.StateType:
              case ControlDataType.StatusType:
                if (this.MODE =='EDIT_MODE') {
                  control.isReadOnly = true;
                  foundFormValue = rawObject[entityName + '.' + control.attributeName] || '';
                  foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '@OData.Community.Display.V1.FormattedValue'] || '';
                  if(!isEmpty(foundFormValue) && isEmpty(foundFormStringValue)) {
                    foundFormStringValue = rawObject[entityName + '.' + control.attributeName + '_value'] || '';
                  }
                  if (foundFormStringValue || foundFormStringValue == '0') {
                    this._setAttributeValue(control, foundFormValue, false);
                    if (foundFormStringValue == "In Progress" && this.changeRequest) {
                      foundFormStringValue = "In Process";
                    }
                    if (!isEmpty(foundFormStringValue)) this._setAttributeStringValue(control.attributeName, foundFormStringValue);
                  } else {
                    this._setAttributeValue(control, "");
                    this._setAttributeStringValue(control.attributeName, "")
                  }
                }
                break;
              default:
                break;
            }
          });
        }
      });
    }
  }

  async ngOnInit() {
    this._isInNgOnInit = true;
    if (this.MODE) {
      this._mode = this.MODE;
      this._previousMode = this.MODE;
    }
    if(this.from && this.from!="") {
      this.isLayoverPushView = true;
      this.layoverViewPushedFrom = this.from;
    }
    if (this.TYPE === "ONE_KEY" || this.TYPE === "OMNIPRESENCE" || this.TYPE == "SANOFI_CHINA") {
      this.changeRequest = true;
      this.businessLine = this.authService.user.buConfigs && this.authService.user.buConfigs.indskr_businessline ? this.authService.user.buConfigs.indskr_businessline : -1;
      if (this.TYPE =='SANOFI_CHINA' && (this.businessLine == 2 || this.businessLine == 3)) {
        this.worksCardHeader = {
          id: 'work-card-section-header',
          title: this.translate.instant('ATTACHMENT_1'),
          controls: [{
            id: 'attach_work_cards',
            text: this.translate.instant('ATTACH'),
            isDisabled: this.device.isOffline || this.disableForm
          }]
        };
        this.practiceCertificateHeader = {
          id: 'practice-certificate-section-header',
          title: this.translate.instant('ATTACHMENT_2'),
          controls: [{
            id: 'attach_practice_certificate',
            text: this.translate.instant('ATTACH'),
            isDisabled: this.device.isOffline || this.disableForm
          }]
        };
      }
    }

    if (this.FORM_DETAIL) {
      this.formDetail = this.FORM_DETAIL;
      if (this.formDetail.formMetadata) {
        this._dynamicForm = this.formDetail.formMetadata;
        if(this._dynamicForm.entityName == 'indskr_setbooking'){
          // For Kit Booking Create and Edit form Hardcode the attribute names for start date and end date fields as all the validation and logics are hardcoded to specific attribute names
          // These hardcoded attribute names are reverted when form is closed on Save operation
          this._dynamicForm.metadata.forEach((tab) => {
            if (tab && tab.controls && tab.controls.length > 0) {
              let startDateControlIndex = tab.controls.findIndex(a => a.attributeName == 'indskr_operationstartdate');
              let endDateControlIndex = tab.controls.findIndex(a => a.attributeName == 'indskr_operationenddate');
              if(startDateControlIndex >= 0){
                tab.controls[startDateControlIndex].attributeName = 'indskr_startdate';
              }
              if(endDateControlIndex >= 0){
                tab.controls[endDateControlIndex].attributeName = 'indskr_enddate';
              }
            }
          });
        }

        if (this._dynamicForm?.formId?.includes("Exeltis Delete CR Form")) {
          // Hide exe_deletereason_new field initially - it will be controlled by exe_noseeflag_new field
          this._toggleExeltisDeleteReasonVisibility(false);
        }

        // Wire registered 'Other'-option lookups present on this form: append the
        // 'Other' entry, scope the lookup to the contact, hide the free-text field.
        this._setupOtherOptionLookups();

        if (!this.changeRequest || (this.changeRequest && this.TYPE == "OMNIPRESENCE")) {
          if (!this.formDetail.isEditFormWithLinkedData && this._mode == "EDIT_MODE" && this.TYPE == 'OMNIPRESENCE') {
            this.editConfig = EditConfig.BOTH;
            if (this.EDIT_FLOW == "business_contact_cr_email_address_cr") {
              this.editConfig = EditConfig.UPDATE_EXISTING;
            }
          } else if (!this.formDetail.isEditFormWithLinkedData && this._mode == "EDIT_MODE") {
            this.editConfig = this._dynamicForm.editConfig;
          } else if (this.formDetail.isEditFormWithLinkedData) {
            this.editConfig = this.EDIT_CONFIG;
          }
        }
      }

      // Check if it's DCR Vx-MDM Business Line flow
      if (
        this.changeRequest
        && this.businessLine === BusinessLineVal.VACCINE_MDM
        && this.formDetail.LookupEntitySetName === 'indskr_contactcrs'
        && this.formDetail.formMetadata?.raw?.indskr_mdmusertype === MDM_USER_TYPE.VACCINE_MDM
        && (this._mode === 'CREATE_MODE' || this._mode === 'EDIT_MODE')
      ) {
        this._DCR_isVxMDMFlow = true;
      }

      if (this.formDetail.footerView) {
        this.footerService.initButtons(this.formDetail.footerView);
      }

      this._runHardcodedLogic();
      if (this.formDetail.formEntityObject && !this.formDetail.isEditFormWithLinkedData) {
        this._parseRawObjectDataToValues(this.formDetail.formEntityObject);
        if(this._mode == "EDIT_MODE" || this._mode == "CREATE_MODE"){
          this._isFormDirty = false;
          this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
          if (this.formDetail && this.formDetail.eventsHandler) {
            this.formDetail.eventsHandler(false, 'ISFORMDIRTY');
          }
        }
        if (this.formDetail.formEntityObject.indskr_mdmid) {
          this.dynamicFormsService.mdmId = this.formDetail.formEntityObject.indskr_mdmid;
        }

        // Check initial value of exe_noseeflag_new and show/hide exe_deletereason_new accordingly
        if (this._dynamicForm?.formId?.includes("Exeltis Delete CR Form")) {
          const isNoSeeFlagYes = this._currentFormValue && this._currentFormValue['exe_noseeflag_new'] === true;
          this._toggleExeltisDeleteReasonVisibility(isNoSeeFlagYes);
          // Rebuild the view to reflect the forceHide change
          setTimeout(() => {
            this._initViewData();
          }, 0);
        }

        // On an existing record, reveal any 'Other' free-text field that already
        // holds a value (it was filled via 'Other').
        if (this._getOtherOptionLookupControls().some(c => this._currentFormValue && this._currentFormValue[c.otherOptionField])) {
          this._initOtherOptionLookups();
          setTimeout(() => {
            this._initViewData();
          }, 0);
        }
      }
      if (this.formDetail.mainEntityObjectId) {
        this._currentFormValue = {
          ...this.formDetail.mainEntityObjectId,
          ...this._currentFormValue
        };
        this._isFormSaved = true;
      }
      if (this.formDetail.showSearchBar) {
        this.isSearchBarEnabled = true;
        this.searchPlaceholder = this.translate.instant('SEARCH') + ' ' + (this.formDetail.title ? this.formDetail.title : '');
      }
      if (this.formDetail.linkedEntityParentData) {
        if (!this.formDetail.isEditFormWithLinkedData) {
          this._currentFormValue = { lookupfields: [this.formDetail.linkedEntityParentData] };
        } else {
          this._currentFormValue = { lookupfields: [this.formDetail.linkedEntityParentData], ...this._currentFormValue };
        }
      }
      if (this.formDetail.formMetadata.entityName === 'indskr_accountcontactaffiliationcr' || this.formDetail.formMetadata.entityName === 'indskr_accountaccountaffiliationcr'
          || this.formDetail.formMetadata.entityName === 'indskr_customeraddresscrs') {
        this._initViewData();
      } else this._initViewData(true);

      // Business flow, Fill the form with existing linked entity data
      if ((!this.changeRequest || (this.changeRequest && this.TYPE == "OMNIPRESENCE")) 
        && (this.editConfig == EditConfig.UPDATE_EXISTING || this.editConfig == EditConfig.BOTH || 
      (this.editConfig == EditConfig.ADD_NEW && (this.formDetail.LookupEntitySetName == 'indskr_setbookingproducts' || this.formDetail.isEditFormWithLinkedData)))) {
        // main form view
        if (!this.formDetail.isEditFormWithLinkedData && (this._mode == "EDIT_MODE" || (this._mode == "CREATE_MODE" && this.formDetail.LookupEntitySetName == 'indskr_setbookingproducts'))) {
          await this._parseRawObjectDataToValuesLinkedEntity();
        }
        // linked entity form view
        else if (this.formDetail.isEditFormWithLinkedData && this._mode == "CREATE_MODE") {
          await this._parseRawObjectDataToValuesExistingData(this.formDetail.formEntityObject, this.formDetail.isUpdatedLinkedEnityFormData).then(()=> {
            this._initViewData();
          });
        }
      }
      this._runBusinessRulesLogic();
      // skipPopulate: re-derive show/hide/required for a persisted value on load, but never
      // overwrite an already-saved field value just from opening the record.
      this._runConfiguredFieldRules('indskr_preferredmodeofcontact', undefined, true);
    }

    if (this.formDetail.dynamicFormType == DynamicFormType.DEFAULTFORM) {

      let loaderison = false;
      for (let tab of this._dynamicForm.metadata) {
        for (let con of tab.controls) {
          if (con.dataType == ControlDataType.PicklistType || con.dataType == ControlDataType.MultiSelectPicklistType) {
            if (!loaderison) {
              this.uiService.displayLoader();
              loaderison = true;
            }
            let optionSetName = con.optionSetName ? con.optionSetName : con.attributeName;
            if(!(optionSetName === 'indskr_accountsourcetype' || optionSetName === 'indskr_contactsourcetype'))
              con.optionSet = await this.dynamicFormsService.getOptionSet(optionSetName);
          }
        }
      }
      this.uiService.dismissLoader();
    }
    // display/add existing linked data for auto-populated
    if (this.changeRequest && this.EDIT_FLOW != "change_request_category_flow") {
      this._foundFormForAddressCR = await this.dynamicFormsService.getFormDefinitionForEntity('indskr_addresscr', FormType.CREATEFORM);
    }
    if (this.changeRequest && this._mode == "EDIT_MODE") {
      // foundForm is for address edit in account CR
      this._foundFormForACAffiliationCR = await this.dynamicFormsService.getFormDefinitionForEntity('indskr_accountcontactaffiliationcr', FormType.CREATEFORM);
      this._dynamicFormForAddressEdit = await this.dynamicFormsService.getFormDefinitionForEntity("indskr_customeraddresscr", FormType.CREATEFORM);
      if (this.formDetail.LookupEntitySetName == "indskr_contactcrs" || this.formDetail.LookupEntitySetName == "indskr_contactcr") {
        this.autoPopulatedLinkedData('accountContactAffiliation', false);
        this.autoPopulatedLinkedData('contactAddress', false);
      } else if (this.formDetail.LookupEntitySetName == "indskr_accountcrs" || this.formDetail.LookupEntitySetName == "indskr_accountcr") {
        this.autoPopulatedLinkedData('accountAddress', false).then(() =>{
          this.addressAttrName = this.dynamicFormsService.addressAttributeName;
        });
      }
    }
    if (this._dynamicForm.entityName == 'indskr_setbooking') {
      const today = new Date();
      let startTime;
      if(isEmpty(this.startTime) || (this.startTime && !this.startTime.hasOwnProperty('indskr_startdate'))) {
        let targetControl: Control = this._getTargetControl('indskr_startdate');
        startTime = new Date(new Date().setDate(new Date().getDate() + 1)).setHours(8,0,0,0);
        this.startTime['indskr_startdate'] = new Date(startTime).toISOString();
        this._updateFormDateModernDatePicker(this.startTime['indskr_startdate'], true, targetControl);
      }
      if(isEmpty(this.endTime) || (this.endTime && !this.endTime.hasOwnProperty('indskr_enddate'))) {
        let targetControl: Control = this._getTargetControl('indskr_enddate');
        let kigBookingDuration = cloneDeep(this.authService.user.buSettings['indskr_kitbookingduration']);
        let endTime = kigBookingDuration ? new Date(this.startTime['indskr_startdate']).setMinutes(kigBookingDuration,0,0) : new Date(new Date().setDate(new Date().getDate() + 1)).setHours(23,59,59,59);
        this.endTime['indskr_enddate'] = new Date(endTime).toISOString();
        this._updateFormDateModernDatePicker(this.endTime['indskr_enddate'], true, targetControl);
      }
      if (!(this._currentFormValue && this._currentFormValue.hasOwnProperty('lookupfields') && this._currentFormValue['lookupfields'].findIndex(a => a.name == 'indskr_salesconsultant')==-1)
          || (this._currentFormValue && this._mode=="CREATE_MODE" && this.isLayoverPushView && (this.layoverViewPushedFrom == "KitBookingfromAccountTool" || this.layoverViewPushedFrom == "KitBookingfromContactTool"))
      ) {
        let salesCon = this._currentFormValue['lookupfields']?.find(a => a.name == 'indskr_salesconsultant');
        if(isEmpty(salesCon) || (salesCon && salesCon.id && salesCon.id == this.authService.user.systemUserID)) {
          let targetControl = this._getTargetControl('indskr_salesconsultant');
          this._activeLookupSearchControl = targetControl;
          let data = {
            isDone: true,
            selectedItem: {
              id: this.authService.user.systemUserID,
              name: this.authService.user.displayName
            }
          }
          this._handleLookupComponentCallback(data);
          this._activeLookupSearchControl = undefined;
        }
      }
      if(!(this._currentFormValue && this._currentFormValue.hasOwnProperty('indskr_operationtype'))) {
        let targetControl: Control = this._getTargetControl('indskr_operationtype');
        let typeConfig =  this.authService.user.ioConfigurations?.find(o=>o.configName=="KitBooking.OperationTypes.SubTypes.Relation");
        let data = { id:'', title:''};
        let dropdownListDetail: IndDropdownListDetailModel = this.dynamicFormsService.getDropdownListViewFromOptionSet(targetControl.optionSet, '', this._activeLanguageCode);
        if(typeConfig && typeConfig.configValue) {
          let selectedTypeConfig = JSON.parse(typeConfig.configValue).find(o=> o["BU"].toLowerCase().trim() == this.authService.user.businessUnitName.toLowerCase().trim());
          if(selectedTypeConfig && dropdownListDetail && dropdownListDetail.data) {
            let foundOption = dropdownListDetail.data.find(option => option.title.toLowerCase().trim() == selectedTypeConfig['operationType'].toLowerCase().trim());
            if(foundOption) {
              data.title = foundOption.title;
              data.id = foundOption.id;
            }
          }
        }
        this._setAttributeStringValue(targetControl.attributeName, data.title);
        this._setAttributeValue(targetControl, data.id, false);
      }
    }
    this.events.observe('device:deviceIsOffline').pipe(takeUntil(this.$ngDestroy)).subscribe(() => {
      this._initViewData();
    });
    this.events.observe('device:deviceIsOnline').pipe(takeUntil(this.$ngDestroy)).subscribe(() => {
      this._initViewData();
    });
    this.events.observe('updateMandatoryField').pipe(takeUntil(this.$ngDestroy)).subscribe((field: PageName) => {
      this._initViewData();
    });
    // Update start/end time field with selected time from the time picker
    this.dateTimeFormatsService.updateSelectedTimeConfiguredForm$.pipe(takeUntil(this.$ngDestroy)).subscribe((timeData) => {
      if (timeData) {
        let targetControl: Control;
        if (timeData.controlId) {
          targetControl = this._getTargetControl(timeData.controlId);
        }
        if (timeData.id == DateTimeFieldType.StartTimeField && targetControl !=undefined) {
          if (this.startTime && this.startTime.hasOwnProperty(targetControl.attributeName)) {
            this.startTime[targetControl.attributeName] = timeData.time;
          } else {
            this.startTime = {
              [targetControl.attributeName]: timeData.time
            }
          }
          // Auto calculated enddate field
          if (timeData.controlId == 'indskr_startdate') {
            let secondaryTargetControl: Control = this._getTargetControl('indskr_enddate');
            let startTime = this.startTime[targetControl.attributeName] ? this.startTime[targetControl.attributeName] : '';
            let endTime = this.endTime['indskr_enddate'] ? this.endTime['indskr_enddate'] : '';
            let diffInMin: number;
            if (startTime && endTime) {
              diffInMin = this.dateTimeFormatsService.getDifferenceInMinutes(endTime, startTime);
            }
            if (this._dynamicForm.entityName == 'indskr_setbooking') {
              let kigBookingDuration = cloneDeep(this.authService.user.buSettings['indskr_kitbookingduration']);
              if(kigBookingDuration) {
                let endTime = this.dateTimeFormatsService.addMinutesToDate(new Date(startTime), kigBookingDuration);
                this.endTime['indskr_enddate'] = new Date(endTime).toISOString();
                this._updateFormDateModernDatePicker(this.endTime['indskr_enddate'], true, secondaryTargetControl);
              }
              this._updateFormDateModernDatePicker(startTime, false, targetControl);
            } else if (secondaryTargetControl && diffInMin <= 0) {
              if (this.endTime && this.endTime.hasOwnProperty('indskr_enddate')) {
                this.endTime['indskr_enddate'] = timeData.addedTime;
              } else {
                this.endTime = {
                  indskr_enddate: timeData.addedTime
                }
              }
              this._updateFormDateModernDatePicker(timeData.addedTime, false, secondaryTargetControl);
            }
          }
          setTimeout(() => {
            this.handleStartDateTimeValue(targetControl);
          }, 0);
        } else if (timeData.id == DateTimeFieldType.EndTimeField && targetControl !=undefined) {
          if (this.endTime && this.endTime.hasOwnProperty('indskr_enddate')) {
            this.endTime['indskr_enddate'] = timeData.time;
          } else {
            this.endTime = {
              indskr_enddate: timeData.time,
            }
          }
          setTimeout(() => {
            this.handleEndDateTimeValue(targetControl);
          }, 0);
        }
      }
    });
    this._isInNgOnInit = false;
  }

  ngOnDestroy() {
    this.searchKeyWordFromMainToolTemplate = '';
    this.$ngDestroy.next(true);
    this.$ngDestroy.complete();
    if(!(this.navService.getActiveChildNavViewPageName() === PageName.DynamicFormComponent)) {
      this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
      this.setBookingDataService._isCreateEditKitBookingFormDirty = false;
    }
    if (this._footerRestoreObserver) {
      this._footerRestoreObserver.disconnect();
      this._footerRestoreObserver = null;
    }
  }

  /**
   * Restores the footer when this view becomes visible again after being hidden by a page pushed
   * over it (e.g. Contact lookup from the Medical Inquiry edit form). Only active when
   * formDetail.footerView is set and the parent is not already managing restoration.
   */
  ngAfterViewInit(): void {
    if (!this.formDetail?.footerView || this.formDetail?.footerViewManagedByParent) return;
    if (typeof IntersectionObserver === 'undefined') return;

    this._footerRestoreObserver = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        const entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) {
          if (!this._footerRestoreIsVisible) {
            this._footerRestoreIsVisible = true;
            if (this._footerRestoreHadBeenVisible) {
              this.footerService.initButtons(this.formDetail.footerView);
              // Restore the Submit button to the same enabled/disabled state as the header Submit.
              if (this._footerSubmitEnabled) {
                this.footerService.enableButtons(['submitMedicalInquiry']);
              } else {
                this.footerService.disableButton(['submitMedicalInquiry']);
              }
            }
          }
        } else {
          if (this._footerRestoreIsVisible) {
            this._footerRestoreIsVisible = false;
            this._footerRestoreHadBeenVisible = true;
          }
        }
      },
      { threshold: 0.1 }
    );
    this._footerRestoreObserver.observe(this._hostRef.nativeElement);
  }

  private initFormPageTitleAndButtons(isFormValid: boolean) {
    const buttons = [];
    if (this.formDetail.leftHeaderBtnText && !this.formDetail.isEditFormWithLinkedData) {
      buttons.push({
        id: 'cancel',
        imgSrc: 'assets/imgs/header_cancel.svg',
        name: this.formDetail.leftHeaderBtnText,
        isDisabled: false,
        align: 'right',
      });
    }
    if (this.formDetail.leftHeaderBtnIcon) {
      buttons.push({
        id: 'close',
        icon: this.formDetail.leftHeaderBtnIcon,
        isDisabled: false,
        align: 'left',
      });
    }
    if (this.formDetail.leftHeaderBtnText && this.formDetail.isEditFormWithLinkedData) {
      buttons.push({
        id: 'scrap',
        imgSrc: 'assets/imgs/header_cancel.svg',
        name: this.formDetail.leftHeaderBtnText,
        isDisabled: false,
        align: 'right',
      });
    }
    if (this.formDetail.rightHeaderBtnText) {
      /*************Edit business information in offline - Non-OneKey contacts*************/
      if(this.formDetail.formMetadata.entityName == 'contact' || this.formDetail.formMetadata.entityName == 'indskr_contactcr') {
          buttons.push({
            id: 'done',
            imgSrc: this.formDetail.rightHeaderImgSrc,
            name: this.formDetail.rightHeaderBtnText || this.translate.instant('CR_SAVE'),
            isDisabled: this.disableForm || !isFormValid || !this._isFormDirty,
            align: 'right'
          });
        }
      /*************Edit business information in offline - Non-OneKey contacts*************/
        else {
          buttons.push({
            id: 'done',
            imgSrc: this.formDetail.rightHeaderImgSrc,
            name: this.formDetail.rightHeaderBtnText,
            isDisabled: this.disableForm || !isFormValid || !this._isFormDirty,
            align: 'right'
          });
        }
    }
    if(this.formDetail.rightHeaderBtnTextArray){
      for(let i=0; i<this.formDetail.rightHeaderBtnTextArray.length; i++){
        const isScrapButtonDisabled = this.formDetail.rightHeaderBtnIdsArray[i] == "SCRAPKITBOOKING" &&
        !(this.formDetail.formEntityObject?.indskr_status == SetBookingStatus.DRAFT ||
          this.formDetail.formEntityObject?.indskr_status == SetBookingStatus.SUBMITTED);
        const isSaveButtonDisabled = this.formDetail.rightHeaderBtnIdsArray[i] == "SAVEKITBOOKING" &&
          (!this._isFormDirty ||
            this.formDetail.formEntityObject?.indskr_status == SetBookingStatus.SUBMITTED ||
            this.formDetail.formEntityObject?.indskr_status == SetBookingStatus.SYNCERROR ||
            this.formDetail.formEntityObject?.indskr_status == SetBookingStatus.REQUESTED ||
            this.device.isOffline
          ) ||
          (this.formDetail.rightHeaderBtnIdsArray[i] == "SAVEMEDICALINQUIRY" && !this._isFormDirty)
        buttons.push({
          id: this.formDetail.rightHeaderBtnIdsArray[i],
          imgSrc: this.formDetail.rightHeaderImgSrcArray[i],
          name: this.formDetail.rightHeaderBtnTextArray[i],
          isDisabled: this.disableForm || (!isFormValid && this.formDetail.rightHeaderBtnIdsArray[i]!="SCRAPKITBOOKING" && this.formDetail.rightHeaderBtnIdsArray[i]!="SCRAPMEDICALINQUIRY") || isScrapButtonDisabled || isSaveButtonDisabled,
          align: 'right'
        });
      }
    }

    this.dynamicFormPageTitle = {
      id: 'dynamic-form-page-title',
      title: this.localizationService.getTranslatedString(this.formDetail.title, EntityNameForTranslation.MobileAppForm),
      controls: buttons,
    };

    // Keep footer Submit in sync with the header Submit button state.
    if (this.formDetail?.footerView && !this.formDetail?.footerViewManagedByParent) {
      const submitHeaderBtn = buttons.find(b => b.id === 'SUBMITMEDICALINQUIRY');
      if (submitHeaderBtn) {
        this._footerSubmitEnabled = !submitHeaderBtn.isDisabled;
        if (this._footerSubmitEnabled) {
          this.footerService.enableButtons(['submitMedicalInquiry']);
        } else {
          this.footerService.disableButton(['submitMedicalInquiry']);
        }
      }
    }

    // MedicalInquiryNew: sync footer Submit based on form validity (parent enables after first save via footerSubmitUnlocked).
    if (this.formDetail?.footerView === 'MedicalInquiryNew') {
      const submitUnlocked = !!(this.formDetail as any).footerSubmitUnlocked;
      const shouldEnableSubmit = isFormValid && submitUnlocked;
      if (shouldEnableSubmit) {
        this.footerService.enableButtons(['submitMedicalInquiry']);
      } else {
        this.footerService.disableButton(['submitMedicalInquiry']);
      }
    }
  }

  private async _initViewData(isFirstInit?: boolean) {
    this._updateMITopicVisibility();
    let isFormValid = true;
    this.isAccountAccountAffiliationPopover = false;
    this.isAccountContactAffiliationPopover = false;
    this.isAddressOneKeyPopover = false;
    this.isAddressPopover = false;
    let nextFormView = this.currentFormView;

    if (this._dynamicForm && this._dynamicForm.metadata && this._dynamicForm.metadata.length > 0) {
      nextFormView = [];
      this.currentFormView = [];
      const nonVisibleFormSection = this.setBookingDataService.formSectionConfigure?.filter(config => config['_indskr_mobileappform_value'] == this.formDetail.formMetadata.mobileFormId && !config['indskr_visibility']);
      //formSectionConfigure is currently only supported in Setbooking flow. Hard coding is required to display required fields only for the update Email CR flow.
      let isUpdateEmailCRflow: boolean = false;
      let shouldBeVisibleAttributeList = [];
      let shouldBeVisibleLinkedEntityList = [];
      if (this.TYPE == 'OMNIPRESENCE' && this.MODE == 'EDIT_MODE' && this._dynamicForm.entityName === "indskr_contactcr" && this._dynamicForm?.formChangeRequestType === FormChangeRequestType.Update) {
        isUpdateEmailCRflow = true;
        shouldBeVisibleAttributeList = ["indskr_mdmrequesttype", "indskr_requestcomments"];
        shouldBeVisibleLinkedEntityList = ["indskr_emailaddresscrs"];
      }

      for (let tabIndex = 0; tabIndex < this._dynamicForm.metadata.length; tabIndex++) {
        const tab = this._dynamicForm.metadata[tabIndex];
        let isClearEnabled = false;
        let isSectionHide = false;
        if (this.formDetail.customFields && tabIndex == 0) {
          isClearEnabled = true;
          if (isFirstInit) tab.controls = [...this.formDetail.customFields, ...tab.controls];
        }
        if (!this.changeRequest && this.formDetail.showClearButton && tabIndex == 0) isClearEnabled = true;
        if (tab && tab.controls && tab.controls.length > 0) {
          tab.displayNames?.forEach(section => {
            if(!isEmpty(nonVisibleFormSection) && nonVisibleFormSection.some(sec => sec['indskr_name'].toLowerCase().trim() == section.description.toLowerCase().trim())) {
              isSectionHide = true;
            }
          })
          if(isSectionHide) continue;
          const visibleControls = tab.controls.filter(c => c.forceHide !== true);
          // const isTabWithOnlySubgrid = visibleControls.length === 1 &&
          //   !visibleControls[0].dataType &&
          //   visibleControls[0].subgrid;
          let secHeader = this._getSectionHeaderViewForTab(tab, isClearEnabled);
          if (secHeader) nextFormView.push(secHeader);
          for (const control of tab.controls) {
            if (isUpdateEmailCRflow) {
              let isVisible = shouldBeVisibleAttributeList.includes(control?.attributeName) || shouldBeVisibleLinkedEntityList.includes(control?.lookupEntitySetName);
              if (!isVisible) {
                control.forceHide = true;
                continue;
              } else {
                // If the create form is not existing, control's forceHide is set to true in form service.
                // Update Email CR flow feature in DSE, the create form is not existing, so we need to set forceHide to false in isVisible case.
                control.forceHide = false;
              }
            }

            let view = await this._getViewForControl(control, tab, isFirstInit);
            if (view) {
              if(this.changeRequest) {
                this.disableDefaultValues(view);
              } else {
                this.disableDefaultValuesForBusiness(view);
              }
              nextFormView.push(view);
            }
            if(control.dataType && this.formDetail.formMetadata.entityName == 'indskr_indskr_customeraddress_v2' && this.selectedSearchOption) {
              let formView = nextFormView.find(data => data.id == control.attributeName);
              if(formView){
                if(formView.view?.inputText !== this.selectedSearchOption[control.attributeName]) this.dynamicFormsService.isSearchedAddress = false;
              }
            }
            // Check for validation
            if(!control.forceHide) {
              if (control.isRequired && control.dataType) {
                isFormValid = this._checkControlValidation(control) && isFormValid;
              } else if ((this.changeRequest || (!this.changeRequest && this._mode == "EDIT_MODE") || (!this.changeRequest && this._mode == "CREATE_MODE" && this._isFormSaved)) && control.isVisible && !control.dataType){
                isFormValid = this._checkLinkedEntityControlValidation(control, isUpdateEmailCRflow) && isFormValid;
              }
            }
          }
        }
      }
      if (this.dynamicFormsService.isSelectedDataFromSearch  && (this.formDetail.formMetadata.entityName == 'indskr_accountcr' || this.formDetail.formMetadata.entityName == 'indskr_contactcr')) {
        nextFormView.forEach(data => {
          if (data.control?.isRequired) {
            if (data.view?.inputText.length > 0) {
              isFormValid = true && isFormValid;
            } else isFormValid = false;
          }
        });
      }
      this.currentFormView = nextFormView;
    }
    //Additional mandatory related entities form fields check
    if (this.formDetail.formMetadata.entityName == 'indskr_accountcr' || this.formDetail.formMetadata.entityName == 'indskr_contactcr'
      || this.formDetail.formMetadata.entityName == 'indskr_customeraddresscr') {
      if (this._dynamicForm && this._dynamicForm.metadata) {
        for (let tabIdx = 0; tabIdx < this._dynamicForm.metadata.length; tabIdx++) {
          const tab = this._dynamicForm.metadata[tabIdx];
          if (tab && tab.controls && tab.controls.length > 0) {
            tab.controls.forEach(control => {
              // To Check entities for Auto-populated Data Flow
              if (this.formDetail.formMetadata.entityName == 'indskr_accountcr') {
                if (control.isVisible && (control.lookupEntityPrimaryId == "indskr_customeraddresscrid")) {
                  this.hasAddressForm = true;
                }
              } else if (this.formDetail.formMetadata.entityName == 'indskr_contactcr') {
                if (control.isVisible && (control.lookupEntityPrimaryId == "indskr_accountcontactaffiliationcrid")) {
                  this.hasAccountContactAffiliationForm = true;
                }
              }
            });
          }
        };
        if (this.TYPE == 'SANOFI_CHINA' && (this.businessLine == 2) && (this.isWorkCardAdded || this.isPracticeCertificateAdded)) {
          this._isFormDirty = true;
        } else if (this.TYPE == 'SANOFI_CHINA' && (this.businessLine == 2) && !this.isWorkCardAdded && !this.isPracticeCertificateAdded) {
          this._isFormDirty = false;
        }
      }
    }
    if (this.isAutoPopulatedLinkedDataFlow && !isEmpty(this.formEditAddressDetail) && !this.addedNewAddressForAccountCR && isFormValid !=undefined) {
      isFormValid = this._initViewEditFormData() && isFormValid;
    }

    this.initFormPageTitleAndButtons(isFormValid);

  }

  private async _targetControlViewData(control: Control) {
    let isFormValid = true;
    this.isAccountAccountAffiliationPopover = false;
    this.isAccountContactAffiliationPopover = false;
    this.isAddressOneKeyPopover = false;
    this.isAddressPopover = false;

    if (this._dynamicForm && this._dynamicForm.metadata && this._dynamicForm.metadata.length > 0) {

      let isUpdateEmailCRflow: boolean = false;
      let shouldBeVisibleAttributeList = [];
      let shouldBeVisibleLinkedEntityList = [];
      if (this.TYPE == 'OMNIPRESENCE' && this.MODE == 'EDIT_MODE' && this._dynamicForm.entityName === "indskr_contactcr" && this._dynamicForm?.formChangeRequestType === FormChangeRequestType.Update) {
        isUpdateEmailCRflow = true;
        shouldBeVisibleAttributeList = ["indskr_mdmrequesttype", "indskr_requestcomments"];
        shouldBeVisibleLinkedEntityList = ["indskr_emailaddresscrs"];
      }

      this._dynamicForm.metadata.forEach((tab, tabIndex) => {
        if (tab && tab.controls && tab.controls.length > 0) {
          tab.controls.forEach(control => {

            if (isUpdateEmailCRflow) {
              let isVisible = shouldBeVisibleAttributeList.includes(control?.attributeName) || shouldBeVisibleLinkedEntityList.includes(control?.lookupEntitySetName);
              if (!isVisible) {
                control.forceHide = true;
                return;
              } else {
                // If the create form is not existing, control's forceHide is set to true in form service.
                // Update Email CR flow feature in DSE, the create form is not existing, so we need to set forceHide to false in isVisible case.
                control.forceHide = false;
              }
            }

            // Check for validation
            if(!control.forceHide && control.isVisible) {
              if (control.isRequired && control.dataType) {
                isFormValid = this._checkControlValidation(control) && isFormValid;
              } else if ((this.changeRequest || (!this.changeRequest && this._mode == "EDIT_MODE") || (!this.changeRequest && this._mode == "CREATE_MODE" && this._isFormSaved)) && control.isVisible && !control.dataType){
                isFormValid = this._checkLinkedEntityControlValidation(control, isUpdateEmailCRflow) && isFormValid;
              }
            }
          });
        }
      });
      if (this.dynamicFormsService.isSelectedDataFromSearch  && (this.formDetail.formMetadata.entityName == 'indskr_accountcr' || this.formDetail.formMetadata.entityName == 'indskr_contactcr')) {
        this.currentFormView.forEach(data => {
          if (data.control?.isRequired) {
            if (data.view?.inputText.length > 0) {
              isFormValid = true && isFormValid;
            } else isFormValid = false;
          }
        });
      }
    }
    //Additional mandatory related entities form fields check
    if (this.formDetail.formMetadata.entityName == 'indskr_accountcr' || this.formDetail.formMetadata.entityName == 'indskr_contactcr'
      || this.formDetail.formMetadata.entityName == 'indskr_customeraddresscr') {
      if (this._dynamicForm && this._dynamicForm.metadata) {
        for (let tabIdx = 0; tabIdx < this._dynamicForm.metadata.length; tabIdx++) {
          const tab = this._dynamicForm.metadata[tabIdx];
          if (tab && tab.controls && tab.controls.length > 0) {
            tab.controls.forEach(control => {
              // To Check entities for Auto-populated Data Flow
              if (this.formDetail.formMetadata.entityName == 'indskr_accountcr') {
                if (control.isVisible && (control.lookupEntityPrimaryId == "indskr_customeraddresscrid")) {
                  this.hasAddressForm = true;
                }
              } else if (this.formDetail.formMetadata.entityName == 'indskr_contactcr') {
                if (control.isVisible && (control.lookupEntityPrimaryId == "indskr_accountcontactaffiliationcrid")) {
                  this.hasAccountContactAffiliationForm = true;
                }
              }
            });
          }
        };
        if (this.TYPE == 'SANOFI_CHINA' && (this.businessLine == 2) && (this.isWorkCardAdded || this.isPracticeCertificateAdded)) {
          this._isFormDirty = true;
        } else if (this.TYPE == 'SANOFI_CHINA' && (this.businessLine == 2) && !this.isWorkCardAdded && !this.isPracticeCertificateAdded) {
          this._isFormDirty = false;
        }
      }
    }
    if (this.isAutoPopulatedLinkedDataFlow && !isEmpty(this.formEditAddressDetail) && !this.addedNewAddressForAccountCR && isFormValid !=undefined) {
      isFormValid = this._initViewEditFormData() && isFormValid;
    }

    // update target control field
    if(control.attributeName && !isEmpty(this.currentFormView)) {
      const targetControlView = await this._getViewForControl(control);
      let index = -1;
      if(!control.dataType) {
        // For linked entity sections, find by data (control.attributeName) so scrap/ADD button state updates when product checkbox is toggled
        // TODO : verify this once form views are fixed
        index = this.currentFormView.findIndex(v => v.data === control.attributeName);
        if (index === -1) {
          let sectionHeaderName: string = this.localizationService.getTranslatedString(this._getDisplayText(control.displayNames), EntityNameForTranslation.MobileAppForm);
          index = this.currentFormView.findIndex(v => v.view?.id === sectionHeaderName);
        }
      } else if(control.dataType == ControlDataType.DateTimeType) {
        const isBirthDateField: boolean = (control.attributeName == 'omnione_yearofbirth' || control.attributeName == 'omnione_dayandmonthofbirth');
        if(isBirthDateField) {
          index = this.currentFormView.findIndex(v=>v.view.id == control.attributeName);
        }else {
          index = this.currentFormView.findIndex(v=>v.view.controlId == control.attributeName);
        }
      }else {
        index = this.currentFormView.findIndex(v=>v.view.id == control.attributeName);
      }

      if(index > -1) {
        this.currentFormView[index] = targetControlView;
      }
    }

    this.initFormPageTitleAndButtons(isFormValid);

  }
  // initView for address edit form - Account CR
  private _initViewEditFormData(isFirstInit?: boolean): boolean {
    let isFormValid = true;
    this.isAccountAccountAffiliationPopover = false;
    this.isAccountContactAffiliationPopover = false;
    this. isAddressOneKeyPopover = false;
    this.isAddressPopover = false;

    // set view data for address edit form with existing data - Account CR-Address
    if (this._dynamicFormForAddressEdit && this._dynamicFormForAddressEdit.metadata && this._dynamicFormForAddressEdit.metadata.length > 0) {
      this.currentEditFormView = [];
      this._dynamicFormForAddressEdit.metadata.forEach((tab, tabIndex) => {
        if (this.formEditAddressDetail.customFields && tabIndex == 0) {
          if (isFirstInit) tab.controls = [...this.formEditAddressDetail.customFields, ...tab.controls];
        }
        if (tab && tab.controls && tab.controls.length > 0) {
          tab.controls.forEach(control => {
            let view = this._getViewAddressEditFormForControl(control);
            if (view) {
              this.currentEditFormView.push(view);
            }
            // Check for validation
            if(!this.dynamicFormsService.isSelectedDataFromSearch) {
              if (control.isRequired && control.dataType && !control.forceHide) {
                isFormValid = this._checkControlValidation(control, true) && isFormValid;
              }
            }
          });
        }
      });
    }
    return isFormValid;
  }

  private disableDefaultValues(view) {
    switch (view.id) {
      case "indskr_name":
        if (this.MODE === "EDIT_MODE" && !this._isFormSaved) {
          view.view.isDisabled = false;
          view.view.showArrow = true;
        }
        break;
      case "indskr_firstname":
        if (this.MODE === "EDIT_MODE" && !this._isFormSaved) {
          view.view.isDisabled = false;
          view.view.showArrow = true;
        }
        break;
      case "indskr_lastname":
        if (this.MODE === "EDIT_MODE" && !this._isFormSaved) {
          view.view.isDisabled = false;
          view.view.showArrow = true;
        }
        break;
      case "indskr_mdm":
        view.view.isDisabled = true;
        view.view.inputValue = this.formDetail.formEntityObject.indskr_mdm == BusinessProcessType.SanofiChina ? "SanofiChina" : "OneKey";
        view.view.inputText = this.formDetail.formEntityObject.indskr_mdm == BusinessProcessType.SanofiChina ? "SanofiChina" : "OneKey";
        view.view.showArrow = false;
        break;
      case "indskr_mdmrequesttype":
        let inputValueStr: string = this.translate.instant('UPDATE');
        if (this.formDetail.formEntityObject?.indskr_mdmrequesttype == MDMRequestType.CREATE) {
          inputValueStr = this.translate.instant('CREATE');
        } else if (this.formDetail.formEntityObject?.indskr_mdmrequesttype == MDMRequestType.UPDATE_EMAIL) {
          inputValueStr = this.translate.instant('UPDATE_EMAIL');
        }
        view.view.isDisabled = true;
        view.view.inputValue = inputValueStr;
        view.view.inputText = inputValueStr;
        view.view.showArrow = false;
        break;
      case "indskr_mdmid":
        view.view.isDisabled = true;
        view.view.inputValue = this.formDetail.formEntityObject.indskr_mdmid;
        view.view.inputText = this.formDetail.formEntityObject.indskr_mdmid;
        view.view.showArrow = false;
        break;
      case "indskr_accountsourcetype":
        if (this.TYPE == "OMNIPRESENCE") {
          view.view.inputValue = "Business";
          view.view.inputText = "Business";
        } else {
          view.view.inputValue = "MDM";
          view.view.inputText = "MDM";
        }
        view.view.isDisabled = true;
        view.view.showArrow = false;
        break;
      case "indskr_contactsourcetype":
        if(this.TYPE == "OMNIPRESENCE"){
        }else{
          view.view.inputValue = "MDM";
          view.view.inputText = "MDM";
        }
        view.view.isDisabled = true;
        view.view.showArrow = false;
        break;
    }
  }

  private getOptionSetMap(view, value) {
    if (view.control && view.control.optionSet && !isEmpty(view.control.optionSet)) {
      const optionMap = {key:"", value:""};
      const options = view.control.optionSet;
      options.forEach(o => {
        if (o['displayNames'] && !isEmpty(o['displayNames'])) {
          o['displayNames'].forEach(d => {
            if (d['description'] && d['description'] == value) {
              optionMap['key'] = d['description'];
              optionMap['value'] = o['value'];
            }
          })
        }
      })
      return optionMap;
    }
  }

  private disableDefaultValuesForBusiness(view) {
    switch (view.id) {
      case "indskr_accountsourcetype":
        const accountSource: string = this.formDetail.formEntityObject?.indskr_accountsourcetype == ChangeRequestType.MDM ? 'OneKey' : this.translate.instant('BUSINESS');
        view.view.isDisabled = true;
        view.view.inputValue = accountSource;
        view.view.inputText = accountSource;
        view.view.showArrow = false;
        break;
      case "indskr_contactsourcetype":
        const contactSource: string = this.formDetail.formEntityObject?.indskr_contactsourcetype == ChangeRequestType.MDM ? 'OneKey' : this.translate.instant('BUSINESS');
        view.view.isDisabled = true;
        view.view.inputValue = contactSource;
        view.view.inputText = contactSource;
        view.view.showArrow = false;
        break;
    }
  }

  private _checkControlValidation(control, isEditAddressForm?: boolean): boolean {
    if (!control.isVisible) return true;
    let flag: boolean = true;
    const currentValue = !isEditAddressForm ? (control.isCustom ? this._customFormValue : this._currentFormValue) : (control.isCustom ? this._existingCustomFormValue : this._existingFormValue);
    switch (control.dataType) {
      case ControlDataType.StringType:
      case ControlDataType.MoneyType:
      case ControlDataType.IntegerType:
      case ControlDataType.DecimalType:
      case ControlDataType.DoubleType:
      case ControlDataType.MemoType:
        if (currentValue && currentValue[control.attributeName]) {
          if (isNaN(currentValue[control.attributeName])) {
            flag = currentValue[control.attributeName];
          } else {
            flag = true;
          }
        } else {
          flag = false;
        }
        break;
      case ControlDataType.LookupType:
        let objName = control.isCustomAttribute ? control.schemaName : control.attributeName;
        if (currentValue && currentValue.hasOwnProperty('lookupfields')) {
          const idx = currentValue['lookupfields'].findIndex(a => a.name == objName && !(a['isDeleted'] && a['isDeleted'] === true));
          flag = idx >= 0;
        } else flag = false;
        break
      case ControlDataType.BooleanType:
        // Required boolean is valid only when value is explicitly true or false; null/undefined means cleared/invalid.
        const boolVal = currentValue && currentValue[control.attributeName];
        flag = boolVal === true || boolVal === false;
        break;
      case ControlDataType.MultiSelectPicklistType:
      case ControlDataType.PicklistType:
        if (currentValue && currentValue[control.attributeName]) {
          if (isNaN(currentValue[control.attributeName])) {
            flag = currentValue[control.attributeName];
          } else {
            flag = true;
          }
        } else {
          flag = false;
        }
        break;
      case ControlDataType.DateTimeType:
        if (currentValue && currentValue[control.attributeName]) {
          if (isNaN(currentValue[control.attributeName])) {
            flag = currentValue[control.attributeName];
          } else {
            flag = true;
          }
        } else {
          flag = false;
        }
        break;
      default:
        break;
    }
    return flag;
  }

  private _checkLinkedEntityControlValidation(control: Control, isSkip: boolean = false): boolean {
    if (isSkip) return true;
    let flag = true;
    if (!this.changeRequest && this._mode == 'EDIT_MODE' && this.editConfig == EditConfig.ADD_NEW
      && control.linkedEntityConfig && control.linkedEntityConfig.isRequired && control.linkedEntityConfig.minNumber) {
      // * This is for checking the total number of linked Entity Entered *
      let numOfLinkedEntity = 0;
      if(this.dynamicFormsService.numOfLinkedEntity && this.dynamicFormsService.numOfLinkedEntity[control.lookupEntitySetName]){
        numOfLinkedEntity = this.dynamicFormsService.numOfLinkedEntity[control.lookupEntitySetName];
      }
      if (this._mode == 'EDIT_MODE' && control.linkedEntityConfig && numOfLinkedEntity > 0) {
        if(this.linkedEntityValues && this.linkedEntityValues[control.attributeName]){
          // If you change the Max number to less than the stored data in Dynamics, Save button will not be activated.
          flag = (numOfLinkedEntity + this.linkedEntityValues[control.attributeName].length < control.linkedEntityConfig.minNumber) ? false : true;
        } else {
          flag = (numOfLinkedEntity < control.linkedEntityConfig.minNumber) ? false : true;
        }
      } else if (control.linkedEntityConfig && control.linkedEntityConfig.minNumber) {
        if (this.linkedEntityValues && this.linkedEntityValues[control.attributeName]) {
          flag = this.linkedEntityValues[control.attributeName].length >= control.linkedEntityConfig.minNumber ? true : false;
        } else {
          flag = false;
        }
      }
      return flag;
    } else {
      // * checking the number of linked entity per request
      if (control.linkedEntityConfig && control.linkedEntityConfig.isRequired && control.linkedEntityConfig.minNumber) {
        if (this.linkedEntityValues && this.linkedEntityValues[control.attributeName]) {
          flag = this.linkedEntityValues[control.attributeName].length >= control.linkedEntityConfig.minNumber ? true : false;
        } else {
          flag = false;
        }
      }
      return flag;
    }
  }

  private _getSectionHeaderViewForTab(tab: FormTabs, clearEnabled: boolean = false) {
    if (tab.displayNames && tab.displayNames.length > 0) {
      try {
        let headerLabel: string = this.localizationService.getTranslatedString(this._getDisplayText(tab.displayNames), EntityNameForTranslation.MobileAppForm);
        return {
          id: headerLabel+'_section_header',
          type: 'section-header',
          view: {
            id: headerLabel,
            title: headerLabel,
            doNotModifyTitleCase: true,
            controls: clearEnabled && !this.dynamicFormsService.isSelectedDataFromSearch ? [
              {
                id: headerLabel + '_' + 'CLEAR',
                text: this.translate.instant('CLEAR'),

              },{
                id: `${headerLabel}-collapsible`,
                icon: 'assets/imgs/up-arrow.svg',
                isDisabled: false
              }
            ] : [
              {
                id: `${headerLabel}-collapsible`,
                icon: 'assets/imgs/up-arrow.svg',
                isDisabled: false
              }
            ],
          },
        };
      } catch (error) {
        console.log('Error parsing section header view from tab' + error);
      }
    }
  }

  private _isNumericField(control: Control) {
    return control.dataType == ControlDataType.IntegerType || control.dataType == ControlDataType.DoubleType || control.dataType == ControlDataType.DecimalType
  }

  private async _getViewForControl(control: Control, tab?: FormTabs, isFirstInit?: boolean) {
    if (control.dataType) {
      if (this.dynamicFormsService.checkIfControlShouldNotBeVisible(control) || control.forceHide || control.isVisible === false) {
        if (this.MODE == 'CREATE_MODE') {
          return null;
        } else if (this.MODE == 'EDIT_MODE') {
          if (control.dataType == ControlDataType.StateType || control.dataType == ControlDataType.StatusType) {
            if (!control.isVisible) return null
          } else return null;
        }
      }
      if (this.changeRequest && this.EDIT_FLOW != 'change_request_category_flow') {
        if (control.lookupEntityPrimaryId == "indskr_lu_postalcodeid" || control.lookupEntityPrimaryId == "indskr_lu_districtid") {
          control.dependsOn = 'indskr_City_lu';
        }
      }
      const isBirthDateField: boolean = (control.attributeName == 'omnione_yearofbirth' || control.attributeName == 'omnione_dayandmonthofbirth');
      let displayText:DisplayText[] = tab && tab.displayNames ? tab.displayNames : this._getTargetTabDisplayNamesByControl(control.attributeName);
      let headerLabel: string = this.localizationService.getTranslatedString(this._getDisplayText(displayText), EntityNameForTranslation.MobileAppForm);
      let sectionId: string = headerLabel+'_section_header';
      if (control.attributeName == 'indskr_country_lu' && control.schemaName === 'indskr_Country_LU') {
        await this.uiService.displayLoader();
        const lookupResults = await this.dynamicFormsService.getLookupResults('', control, '', true);
        if (lookupResults?.length == 1) {
          if (!this._currentFormStringValues) this._currentFormStringValues = {};
          this._currentFormStringValues[control.attributeName] = lookupResults[0].name;
          if(!this._customFormValue) this._customFormValue = {};
          // Don't overwrite existing lookupfields - merge instead
          if (!this._customFormValue['lookupfields']) {
            this._customFormValue['lookupfields'] = [];
          }
          const existingIndex = this._customFormValue['lookupfields'].findIndex((lf: any) => lf.name === control.schemaName);
          const lookupfieldObj = {
            entity: 'indskr_lu_countries',
            id: lookupResults[0].id,
            name: control.schemaName
          };
          if (existingIndex >= 0) {
            this._customFormValue['lookupfields'][existingIndex] = lookupfieldObj;
          } else {
            this._customFormValue['lookupfields'].push(lookupfieldObj);
          }
        }
        await this.uiService.dismissLoader();
      }
      try {
        if (control.dataType != ControlDataType.DateTimeType || (control.dataType == ControlDataType.DateTimeType && isBirthDateField)) {
          if(this.MODE == 'CREATE_MODE' && isFirstInit && control.defaultValue != null && control.defaultValue != undefined && !this.formDetail.isEditFormWithLinkedData) this._setDefaultValue(control);
          let labelText: string = this._getDisplayText(control.displayNames, control.isCustom, control.attributeName);
          let placeholderText: string = this._getDisplayText(control.descriptions, control.isCustom);
          let fieldView: IndFormFieldViewDataModel = {
            label: labelText,
            inputText: !this._isNumericField(control) ? this.localizationService.getTranslatedString(this._getInputTextForFormField(control), EntityNameForTranslation.MobileAppForm) : this._getInputTextForFormField(control),
            inputValue: !this._isNumericField(control) ? this.localizationService.getTranslatedString(this._getInputTextForFormField(control), EntityNameForTranslation.MobileAppForm) : this._getInputTextForFormField(control),
            maxLength: this.dynamicFormsService.getFormFieldType(control) == FormFieldType.INLINE_INPUT ? control.maxLength : 100,
            id: control.attributeName,
            isReadOnly: (control.isReadOnly || this.dynamicFormsService.getFormFieldType(control) != FormFieldType.INLINE_INPUT || !this.dynamicFormsService.capturesTyping(control)),
            isDisabled: this._isControlDisabled(control),
            showArrow: this._isShowArrow(control),
            inputType: (control.dataType == ControlDataType.DecimalType || control.dataType == ControlDataType.DoubleType || control.dataType == ControlDataType.IntegerType || control.dataType == ControlDataType.MoneyType) ? 'number' : 'text',
            formFieldType: this.dynamicFormsService.getFormFieldType(control),
            isRequired: control.isRequired,
            isInvalid: false,
            isEmptyRequiredField: control.isRequired ? this._isClicked && this._isClicked[control.attributeName] && !this._getInputTextForFormField(control) : false,
            errorMessage: control.isRequired ? this.translate.instant('THIS_IS_A_REQUIRED_FIELD') : undefined,
            inputValidator:(id: string,value: any, event) => control.isRequired ? this._validateMandatoryField(id, value, event, false) : true,
            eventHandler: (id: string, event, eventName) => this._handleFormFieldEvent(id, event, eventName),
          };
          if(placeholderText && placeholderText.trim() != ''){
            fieldView.customPlaceholderLabel = placeholderText;
          }else{
            fieldView.placeholderLabel = labelText;
          }
          return {
            id: fieldView.id,
            type: 'form-field',
            view: fieldView,
            control: control,
            section: sectionId
          };
        } else if (control.dataType == ControlDataType.DateTimeType) {
            let dateFieldView: IndDateTimeFormViewDataModel;
            let timeFieldView: IndDateTimeFormViewDataModel;
            let isStartDateTimeFieldType: boolean = true;
            isStartDateTimeFieldType = control.attributeName != 'indskr_enddate' ? true : false;
            let labelText: string = this._getDisplayText(control.displayNames, control.isCustom);
            // DateOnly Field
            if (control.dateFormat == DateFormat.DateOnly) {
              this._dateTimePickerActiveControl = control;
              let dateFieldValue: string ='';
              const getDateTimeValue = this._getInputTextForFormField(control);
              if (!isEmpty(getDateTimeValue)) {
                const parsedDate = new Date(getDateTimeValue);
                const formattedDateTimeValue = this.dateTimeFormatsService.isValidDate(parsedDate) ? parsedDate.toISOString() : '';
                if (!isEmpty(formattedDateTimeValue)) {
                  let currentDateTimeValue = new Date(formattedDateTimeValue);
                  dateFieldValue = this.datePipe.transform(currentDateTimeValue, this.dateTimeFormatsService.date, undefined, this.translate.currentLang);
                }
              }
              dateFieldView = {
                isDateField: true,
                label: labelText,
                customPlaceholderLabel: this.translate.instant('SELECT_DATE'),
                inputText: dateFieldValue,
                inputValue: dateFieldValue,
                fromViewPage: CurViewPageType.ConfiguredForm,
                id: isStartDateTimeFieldType ? DateTimeFieldType.StartDateField : DateTimeFieldType.EndDateField,
                controlId: control.attributeName,
                isReadOnly: true,
                isDisabled: this._isControlDisabled(control),
                showArrow: this._isShowArrow(control),
                isRequired: control.isRequired,
                isInvalid: false,
                isEmptyRequiredField: control.isRequired ? this._isClicked && this._isClicked[control.attributeName] && isEmpty(this._getInputTextForFormField(control)) : false,
                errorMessage: control.isRequired ? this.translate.instant('THIS_IS_A_REQUIRED_FIELD') : undefined,
                inputValidator:(id: string,value: any, event) => control.isRequired ? this._validateMandatoryField(control.attributeName, value, event, false) : true,
                eventHandler: (id: string, event, eventName, dataRef) => this._handleFormFieldEvent(control.attributeName, event, eventName, dataRef),
              };
              return {
                id: dateFieldView.id,
                type: 'form-field',
                view: dateFieldView,
                control: control,
                section: sectionId
              };
            // Date and Time Field
            } else if (control.dateFormat == DateFormat.DateAndTime) {
              this._dateTimePickerActiveControl = control;
              let dateFieldValue: string = '';
              let timeFieldValue: string = '';
              const getDateTimeValue = this._getInputTextForFormField(control);
              if (!isEmpty(getDateTimeValue)) {
                const parsedDate = new Date(getDateTimeValue);
                const formattedDateTimeValue = this.dateTimeFormatsService.isValidDate(parsedDate) ? parsedDate.toISOString() : '';
                if (!isEmpty(formattedDateTimeValue)) {
                  let currentDateTimeValue = new Date(formattedDateTimeValue);
                  dateFieldValue = this.datePipe.transform(currentDateTimeValue, this.dateTimeFormatsService.date, undefined, this.translate.currentLang);
                  timeFieldValue = currentDateTimeValue.toLocaleTimeString('en-US', { hour12: this.dateTimeFormatsService.is12HourFormat, hour: '2-digit', minute: '2-digit' });
                  if (!this.dateTimeFormatsService.is12HourFormat && timeFieldValue.includes("24:")) {
                    timeFieldValue = timeFieldValue.replace("24:", "00:");
                  }
                }
              }
              let getSecondaryDateTimeValue: string = '';
              const secondaryTargetControl: Control = isStartDateTimeFieldType ? this._getTargetControl('indskr_enddate') : this._getTargetControl('indskr_startdate');
              if (secondaryTargetControl) {
                getSecondaryDateTimeValue = this._getInputTextForFormField(secondaryTargetControl);
              }
              const dateTextTrans = this.translate.instant('DATE');
              let labelDateText: string = labelText;
              if (labelText.includes('Date') || labelText.includes('date') || labelText.includes(dateTextTrans) || labelText.includes(dateTextTrans.toLowerCase())) {
                labelDateText = labelText;
              } else {
                labelDateText = labelDateText + ' ' + dateTextTrans;
              }
              dateFieldView = {
                isDateField: true,
                label: labelDateText,
                customPlaceholderLabel: this.translate.instant('SELECT_DATE'),
                inputText: dateFieldValue,
                inputValue: dateFieldValue,
                startDateTimeValue: isStartDateTimeFieldType ? getDateTimeValue : getSecondaryDateTimeValue ? getSecondaryDateTimeValue : getDateTimeValue,
                endDateTimeValue: isStartDateTimeFieldType ? getSecondaryDateTimeValue ? getSecondaryDateTimeValue : getDateTimeValue : getDateTimeValue,
                fromViewPage: CurViewPageType.ConfiguredForm,
                id: isStartDateTimeFieldType ? DateTimeFieldType.StartDateField : DateTimeFieldType.EndDateField,
                controlId: control.attributeName,
                isReadOnly: true,
                isDisabled: this._isControlDisabled(control),
                showArrow: this._isShowArrow(control),
                isRequired: control.isRequired,
                isInvalid: false,
                isEmptyRequiredField: control.isRequired ? this._isClicked && this._isClicked[control.attributeName] && isEmpty(this._getInputTextForFormField(control)) : false,
                errorMessage: control.isRequired ? this.translate.instant('THIS_IS_A_REQUIRED_FIELD') : undefined,
                inputValidator:(id: string,value: any, event) => control.isRequired ? this._validateMandatoryField(control.attributeName, value, event, false) : true,
                eventHandler: (id: string, event, eventName, dataRef) => this._handleFormFieldEvent(control.attributeName, event, eventName, dataRef),
              };
              if(this._mode == 'EDIT_MODE' && this.formDetail?.formMetadata?.entityName == 'indskr_setbooking'
                && this.formDetail.formEntityObject?.indskr_status == SetBookingStatus.COMPLETED
                && (control.attributeName =="indskr_startdate" || control.attributeName =="indskr_enddate"))
                dateFieldView.isDisabled = true;
              const timeTextTrans = this.translate.instant('TIME');
              let labelTimeText: string = labelText;
              if (labelText.includes('Date')) {
                labelTimeText = labelText.replace('Date', 'Time');
              } else if (labelText.includes('date')) {
                labelTimeText = labelText.replace('date', 'time');
              } else if (labelText.includes(dateTextTrans)) {
                labelTimeText = labelText.replace(dateTextTrans, timeTextTrans);
              } else if (labelText.includes(dateTextTrans.toLowerCase())) {
                labelTimeText = labelText.replace(dateTextTrans.toLowerCase(), timeTextTrans.toLowerCase());
              } else {
                labelTimeText = labelTimeText + ' ' + timeTextTrans;
              }
              timeFieldView = {
                isTimeField: true,
                label: labelTimeText,
                customPlaceholderLabel: this.translate.instant('SELECT_TIME'),
                inputText: timeFieldValue,
                inputValue: timeFieldValue,
                startDateTimeValue: isStartDateTimeFieldType ? getDateTimeValue : getSecondaryDateTimeValue ? getSecondaryDateTimeValue : getDateTimeValue,
                endDateTimeValue: isStartDateTimeFieldType ? getSecondaryDateTimeValue ? getSecondaryDateTimeValue : getDateTimeValue : getDateTimeValue,
                fromViewPage: CurViewPageType.ConfiguredForm,
                id: isStartDateTimeFieldType ? DateTimeFieldType.StartTimeField : DateTimeFieldType.EndTimeField,
                controlId: control.attributeName,
                isReadOnly: true,
                isDisabled: dateFieldView.inputText == '' || this._isControlDisabled(control),
                showArrow: dateFieldView.inputText != '' && this._isShowArrow(control),
                isRequired: control.isRequired,
                isInvalid: false,
                isEmptyRequiredField: control.isRequired ? this._isClicked && this._isClicked[control.attributeName] && isEmpty(this._getInputTextForFormField(control)) : false,
                errorMessage: control.isRequired ? this.translate.instant('THIS_IS_A_REQUIRED_FIELD') : undefined,
                inputValidator:(id: string,value: any, event) => control.isRequired ? this._validateMandatoryField(control.attributeName, value, event, false) : true,
              };
              return {
                id: dateFieldView.id,
                type: 'form-field',
                view: dateFieldView,
                timeView: timeFieldView,
                control: control,
                section: sectionId
              };
            }
        }
      } catch (error) {
        console.log('Error occured while parsing controls view' + error);
      }
    } else {// Related entity field
      try {
        if (control.forceHide === true) {
          return null;
        } else {
          this.dynamicFormsService.getCustomDisplayNameFromField(control, this.formDetail.dynamicFormType);
          let headerLabel: string = this.localizationService.getTranslatedString(this._getDisplayText(control.displayNames), EntityNameForTranslation.MobileAppForm);
          let isMaxNumReached = this._isMaxNumOfLinkedEntityReached(control);
          let isSectionButtonsDisabled = this._mode == 'EDIT_MODE' && 
            this.formDetail?.formMetadata?.entityName == 'indskr_setbooking' &&
            this.formDetail.formEntityObject?.indskr_status == SetBookingStatus.COMPLETED &&
            control.lookupEntitySetName =="indskr_setbookingproducts";
          let buttons = [];
          if(control.linkedEntityConfig && control.linkedEntityConfig.abilityToRemoveRecords == '548910000') {
            buttons.push({
              id: `${control.attributeName}_SCRAP`,
              text: this.translate.instant('SCRAP'),
              isRequired: false,
              isDisabled: this.disableForm || (this.linkedEntityValues && this.linkedEntityValues[control.attributeName] && this.linkedEntityValues[control.attributeName].filter(x=> x.isCheckedForScrap)?.length == 0)
                          || isEmpty(this.linkedEntityValues) || (this.linkedEntityValues && isEmpty(this.linkedEntityValues[control.attributeName]))
                          || isSectionButtonsDisabled
            })
          }
          const shouldHideAddButton = this.formDetail.formMetadata.entityName == 'indskr_contactcr' &&
            this.changeRequest &&
            control.subgrid.targetEntityType == "exe_customerpositionchangerequest" &&
            !(this._dynamicForm?.formId?.includes("Exeltis Shared Target CR Form") ||
              this._dynamicForm?.formId?.includes("Exeltis Realignment CR Form"));
          
          if (!shouldHideAddButton) {
            buttons.push({
              id: control.attributeName + '_' + 'ADD',
              text: (this.editConfig == EditConfig.ADD_NEW || this.editConfig == EditConfig.BOTH) ? this.translate.instant('ADD') : '',
              isRequired: control.isRequired,
              isDisabled: this.disableForm || ((!this._isFormSaved) && !this.changeRequest) || isMaxNumReached || isSectionButtonsDisabled
                || (this.linkedEntityValues && this.linkedEntityValues[control.attributeName] && this.linkedEntityValues[control.attributeName].filter(x => x.isCheckedForScrap)?.length > 0)
            })
          }
          buttons.push(
            {
              id: `${control.attributeName}-collapsible`,
              icon: 'assets/imgs/up-arrow.svg',
              isDisabled: false
            }
          )
          let view = {
            id: headerLabel,
            type: 'section-header',
            view: {
              id: headerLabel,
              title: headerLabel,
              doNotModifyTitleCase: true,
              isRequired: control.isRequired || control.linkedEntityConfig ? control.linkedEntityConfig['isRequired'] ? control.linkedEntityConfig['isRequired'] : control.linkedEntityConfig['minNumber'] > 0 ? true : false : false,
              controls: buttons
            },
            data: control.attributeName,
          };
          return view;
        }
      } catch (error) {
        console.log('Error occured while related entity field view' + error);
      }
    }
  }

  private _isMaxNumOfLinkedEntityReached(control: Control) {
    if (!this.changeRequest && this._mode == 'EDIT_MODE' && this.editConfig == EditConfig.ADD_NEW) {
      // *checking if the TOTAL number of linked entity entered reaches to the max limitations
      let numOfLinkedEntity = 0;
      if(this.dynamicFormsService.numOfLinkedEntity && this.dynamicFormsService.numOfLinkedEntity[control.lookupEntitySetName]){
        numOfLinkedEntity = this.dynamicFormsService.numOfLinkedEntity[control.lookupEntitySetName];
      }
      if (this._mode == 'EDIT_MODE' && control.linkedEntityConfig && numOfLinkedEntity > 0) {
        if(this.linkedEntityValues && this.linkedEntityValues[control.attributeName]){
          return numOfLinkedEntity + this.linkedEntityValues[control.attributeName].length >= control.linkedEntityConfig.maxNumber ? true : false;
        } else {
          return numOfLinkedEntity >= control.linkedEntityConfig.maxNumber ? true : false;
        }
      } else if (control.linkedEntityConfig && this.linkedEntityValues && this.linkedEntityValues[control.attributeName]) {
        return this.linkedEntityValues[control.attributeName].length >= control.linkedEntityConfig.maxNumber ? true : false;
      } else {
        return false;
      }
    } else {
      // *checking the number of linked entity entered Per REQUEST reaches to the max limitation
      if (control.linkedEntityConfig && this.linkedEntityValues && this.linkedEntityValues[control.attributeName]) {
        if (this.changeRequest && this.isAutoPopulatedLinkedDataFlow){
          return this.linkedEntityValues[control.attributeName].length > control.linkedEntityConfig.maxNumber ? true : false;
        } else {
          //Display only the records that are newly Added
          return this.linkedEntityValues[control.attributeName].filter(value => 
            isEmpty(value['linkedEntityExistingDataAddressId']) && isEmpty(value['linkedEntityExistingDataId'])
          ).length >= control.linkedEntityConfig.maxNumber ? true : false;
        }
      } else {
        return false;
      }
    }
  }
  // getView for address edit form - Account CR
  private _getViewAddressEditFormForControl(control: Control) {
    if (control.dataType) {
      if (this.dynamicFormsService.checkIfControlShouldNotBeVisible(control) || control.forceHide) {
        return null;
      }
      if (this.changeRequest && this.EDIT_FLOW != 'change_request_category_flow' && (control.lookupEntityPrimaryId == "indskr_lu_postalcodeid" || control.lookupEntityPrimaryId == "indskr_lu_districtid")) {
        control.dependsOn = 'indskr_City_lu';
      }
      try {
        let labelText: string = this._getDisplayText(control.displayNames, control.isCustom);
        let placeholderText: string = this._getDisplayText(control.descriptions, control.isCustom);
        let fieldView: IndFormFieldViewDataModel = {
          label: labelText,
          inputText: this._getInputTextForAddressEditFormField(control),
          inputValue: this._getInputTextForAddressEditFormField(control),
          maxLength: this.dynamicFormsService.getFormFieldType(control) == FormFieldType.INLINE_INPUT ? control.maxLength : 100,
          id: control.attributeName,
          isReadOnly: (control.isReadOnly || this.dynamicFormsService.getFormFieldType(control) != FormFieldType.INLINE_INPUT || !this.dynamicFormsService.capturesTyping(control)),
          isDisabled: this._isControlDisabled(control),
          showArrow: this._isShowArrow(control),
          inputType: (control.dataType == ControlDataType.DecimalType || control.dataType == ControlDataType.DoubleType || control.dataType == ControlDataType.IntegerType || control.dataType == ControlDataType.MoneyType) ? 'number' : 'text',
          formFieldType: this.dynamicFormsService.getFormFieldType(control),
          isRequired: control.isRequired,
          isInvalid: false,
          inputValidator:(id: string,value: any, event) => control.isRequired ? this._validateMandatoryField(id, value, event, true) : true,
          eventHandler: (id: string, event, eventName) => this._handleEditAddressFormFieldEvent(id, event, eventName),
        };
        if (placeholderText && placeholderText.trim() != '') {
          fieldView.customPlaceholderLabel = placeholderText;
        } else {
          fieldView.placeholderLabel = labelText;
        }
        return {
          id: fieldView.id,
          type: 'form-field',
          view: fieldView,
          control: control
        };
      } catch (error) {
        console.log('Error occured while parsing controls view' + error);
      }
    } else {// Related entity field
      try {
        if (control.forceHide === true) {
          return null;
        } else {
          let headerLabel: string = this.localizationService.getTranslatedString(this._getDisplayText(control.displayNames), EntityNameForTranslation.MobileAppForm);
          let isMaxNumReached = this._isMaxNumOfLinkedEntityReached(control);
          let view = {
            id: headerLabel,
            type: 'section-header',
            view: {
              id: headerLabel,
              title: headerLabel,
              doNotModifytitleCase: true,
              isRequired: control.isRequired || control.linkedEntityConfig ? control.linkedEntityConfig['isRequired'] ? control.linkedEntityConfig['isRequired'] : control.linkedEntityConfig['minNumber'] > 0 ? true : false : false,
              controls: [
                {
                  id: control.attributeName + '_' + 'ADD',
                  text: this.translate.instant('ADD'),
                  isDisabled: this.disableForm || ((!this._isFormSaved) && !this.changeRequest) || isMaxNumReached
                },{
                  id: `${control.attributeName}-collapsible`,
                  icon: 'assets/imgs/up-arrow.svg',
                  isDisabled: false
                }
              ],
            },
            data: control.attributeName,
          };
          return view;
        }
      } catch (error) {
        console.log('Error occured while related entity field view' + error);
      }
    }
  }

  private _getDisplayText(dtArray: DisplayText[], isCustomControl: boolean = false, attributeName: string = '') {
    if (!dtArray) return '';
    let displayText: string;
    //-------Custom label--hard coded start
    //statuscode
    if (this.businessLine == -1) {
      if (attributeName && attributeName == 'statuscode' && this.formDetail && this.formDetail.formMetadata
      && (this.formDetail.formMetadata.entityName == 'account' || this.formDetail.formMetadata.entityName == 'contact'
        || this.formDetail.formMetadata.entityName == 'indskr_accountcr' || this.formDetail.formMetadata.entityName == 'indskr_contactcr')) {
        return displayText = this.translate.instant('VERIFICATION');
      }
    }
    const refEntityName = this.formDetail.formMetadata.entityName;
    const affiliationsRefNames = [
      ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY, CONTACT_CONTACT_AFFILIATIONS_REF_ENTITY,
      ACCOUNT_ACCOUNT_AFFILIATIONS_CR_REF_ENTITY, CONTACT_CONTACT_AFFILIATIONS_CR_REF_ENTITY,
    ];
    const isAffiliationsData = affiliationsRefNames.includes(refEntityName);
    if (isAffiliationsData && attributeName) {
      //A-A-Affiliation in account form
      if (refEntityName == ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY) {
        if (attributeName == ACCOUNT_ACCOUNT_FROM_FILTER_ATTRIBUTE_NAME && !isEmpty(this.dynamicFormsService.accountAffiliatedToLabelText)) {
          return displayText = this.dynamicFormsService.accountAffiliatedToLabelText;
        } else if (attributeName == ACCOUNT_ACCOUNT_TO_FILTER_ATTRIBUTE_NAME && !isEmpty(this.dynamicFormsService.accountAffiliatedFromLabelText)) {
          return displayText = this.dynamicFormsService.accountAffiliatedFromLabelText;
        }
      }
      //C-C-Affiliation in contact form
      else if (refEntityName == CONTACT_CONTACT_AFFILIATIONS_REF_ENTITY) {
        if (attributeName == CONTACT_CONTACT_FROM_FILTER_ATTRIBUTE_NAME && !isEmpty(this.dynamicFormsService.contactAffiliatedToLabelText)) {
          return displayText = this.dynamicFormsService.contactAffiliatedToLabelText;
        } else if (attributeName == CONTACT_CONTACT_TO_FILTER_ATTRIBUTE_NAME && !isEmpty(this.dynamicFormsService.contactAffiliatedFromLabelText)) {
          return displayText = this.dynamicFormsService.contactAffiliatedFromLabelText;
        }
      }
      //A-A-Affiliation in account CR form
      else if (refEntityName == ACCOUNT_ACCOUNT_AFFILIATIONS_CR_REF_ENTITY) {
        if (attributeName == ACCOUNT_ACCOUNT_FROM_CR_ATTRIBUTE_NAME && !isEmpty(this.dynamicFormsService.accountCrAffiliatedToLabelText)) {
          return displayText = this.dynamicFormsService.accountCrAffiliatedToLabelText;
        } else if (attributeName == ACCOUNT_ACCOUNT_TO_CR_ATTRIBUTE_NAME && !isEmpty(this.dynamicFormsService.accountCrAffiliatedFromLabelText)) {
          return displayText = this.dynamicFormsService.accountCrAffiliatedFromLabelText;
        }
      }
      //C-C-Affiliation in contact CR form
      else if (refEntityName == CONTACT_CONTACT_AFFILIATIONS_CR_REF_ENTITY) {
        if (attributeName == CONTACT_CONTACT_FROM_CR_ATTRIBUTE_NAME && !isEmpty(this.dynamicFormsService.contactCrAffiliatedToLabelText)) {
          return displayText = this.dynamicFormsService.contactCrAffiliatedToLabelText;
        } else if (attributeName == CONTACT_CONTACT_TO_CR_ATTRIBUTE_NAME && !isEmpty(this.dynamicFormsService.contactCrAffiliatedFromLabelText)) {
          return displayText = this.dynamicFormsService.contactCrAffiliatedFromLabelText;
        }
      }
    }
    //-------hard coded end

    const langCode = (this.formDetail.dynamicFormType == DynamicFormType.DEFAULTFORM) ? DEFAULT_FORM_LANGUAGE_CODE : this._activeLanguageCode;
    const dt = dtArray.find(value => value.languagecode == langCode);

    if (dt) {
      displayText = dt.languagecode == DEFAULT_FORM_LANGUAGE_CODE ? this.translate.instant(dt.description) : dt.description;
    } else {
      let en = dtArray.find(value => value.languagecode == '1033'); // default to english if no translation for the specific language;
      if (en) {
        displayText = en.description
      } else {
        //recheck the default form language code in the case of custom fields
        const defalutLang = dtArray.find(value => value.languagecode == '0000');
        if(defalutLang && defalutLang.description) {
          displayText = this.translate.instant(defalutLang.description);
        } else {
          displayText = '';
        }
      }
    }
    return displayText;
  }

  private _getInputTextForFormField(control: Control): string {
    if (control && control.dataType) {
      switch (control.dataType) {
        case ControlDataType.StringType:
        case ControlDataType.MoneyType:
        case ControlDataType.IntegerType:
        case ControlDataType.DecimalType:
        case ControlDataType.DoubleType:
        case ControlDataType.MemoType:
          if (control.isCustom) {
            return (this._customFormValue && this._customFormValue[control.attributeName]) ? this._customFormValue[control.attributeName] : '';
          } else {
            return (this._currentFormValue && this._currentFormValue[control.attributeName]) ? this._currentFormValue[control.attributeName] : '';
          }
        case ControlDataType.LookupType:
          return (this._currentFormValue && this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) ? this._currentFormStringValues[control.attributeName] : '';
        case ControlDataType.BooleanType:
          return (this._currentFormValue && this._currentFormValue.hasOwnProperty(control.attributeName) && this._currentFormValue[control.attributeName] != null) ? (this._currentFormValue[control.attributeName] ? this.translate.instant('YES') : this.translate.instant('NO')) : '';
        case ControlDataType.StateType:
          return (this._currentFormValue && (this._currentFormValue[control.attributeName] || this._currentFormValue[control.attributeName]==0) && this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) ? this._currentFormStringValues[control.attributeName] : '';
        case ControlDataType.StatusType:
        case ControlDataType.MultiSelectPicklistType:
        case ControlDataType.PicklistType:
          if (control.isCustom) {
            return (this._customFormValue && isOptionValueSet(this._customFormValue[control.attributeName]) && this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) ? this._currentFormStringValues[control.attributeName] : '';
          }
          else{
            return (this._currentFormValue && isOptionValueSet(this._currentFormValue[control.attributeName]) && this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) ? this._currentFormStringValues[control.attributeName] : '';
          }
        case ControlDataType.DateTimeType:
          if (control.attributeName =='omnione_yearofbirth') {
            if ((this._currentFormValue && this._currentFormValue[control.attributeName] && this._currentFormStringValues && this._currentFormStringValues[control.attributeName])) {
              const currentValueUTC = new Date(this._currentFormStringValues[control.attributeName]).toISOString();
              const currentDateAndTimeValue = new Date(currentValueUTC);
              const yearOfBirth = this.dateTimeFormatsService.formatDate(currentDateAndTimeValue, 'YYYY');
              return yearOfBirth ? yearOfBirth : '';
            }
          } else if(control.attributeName =='omnione_dayandmonthofbirth') {
            if ((this._currentFormValue && this._currentFormValue[control.attributeName] && this._currentFormStringValues && this._currentFormStringValues[control.attributeName])) {
              const currentValueUTC = new Date(this._currentFormStringValues[control.attributeName]).toISOString();
              const currentDateAndTimeValue = new Date(currentValueUTC);
              const getYearValue = currentDateAndTimeValue.getFullYear().toString();
              const getTranslateDate = this.datePipe.transform(currentDateAndTimeValue, this.dateTimeFormatsService.date, undefined, this.translate.currentLang);
              const regExpFindYear = new RegExp('(\/?\-?\,?\s?' + getYearValue + '?\,?\s?\-?\/?)', 'gi');
              let dayAndMonthOnly = getTranslateDate.replace(regExpFindYear, '');
              dayAndMonthOnly = dayAndMonthOnly.replace(',', '');
              return dayAndMonthOnly ? dayAndMonthOnly : '';
            }
          } else {
            if (this._currentFormValue && this._currentFormValue[control.attributeName] && this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) {
              let currentValue = this._currentFormStringValues[control.attributeName];
              const currentValueUTC = new Date(currentValue).toISOString();
              return currentValueUTC;
            } else return '';
          }
        default:
          return '';
      }
    } else {
      return '';
    }
  }
  // getInputText for address edit form - Account CR
  private _getInputTextForAddressEditFormField(control: Control): string {
    if (control && control.dataType) {
      switch (control.dataType) {
        case ControlDataType.StringType:
        case ControlDataType.MoneyType:
        case ControlDataType.IntegerType:
        case ControlDataType.DecimalType:
        case ControlDataType.DoubleType:
        case ControlDataType.MemoType:
          if (control.isCustom) {
            return (this._existingCustomFormValue && this._existingCustomFormValue[control.attributeName]) ? this._existingCustomFormValue[control.attributeName] : '';
          } else {
            return (this._existingFormValue && this._existingFormValue[control.attributeName]) ? this._existingFormValue[control.attributeName] : '';
          }
        case ControlDataType.LookupType:
          return (this._existingFormValue && this._existingFormStringValues && this._existingFormStringValues[control.attributeName]) ? this._existingFormStringValues[control.attributeName] : '';
        case ControlDataType.BooleanType:
          return (this._existingFormValue && this._existingFormValue.hasOwnProperty(control.attributeName) && this._existingFormValue[control.attributeName] != null) ? (this._existingFormValue[control.attributeName] ? this.translate.instant('YES') : this.translate.instant('No')) : '';
        case ControlDataType.MultiSelectPicklistType:
        case ControlDataType.PicklistType:
          return (this._existingFormValue && this._existingFormValue[control.attributeName] && this._existingFormStringValues && this._existingFormStringValues[control.attributeName]) ? this._existingFormStringValues[control.attributeName] : '';
        case ControlDataType.DateTimeType:
          return (this._existingFormValue && this._existingFormValue[control.attributeName] && this._existingFormStringValues && this._existingFormStringValues[control.attributeName]) ? this._existingFormStringValues[control.attributeName] : '';
        default:
          return '';
      }
    } else {
      return '';
    }
  }

  private _isControlDisabled(control: Control) {
    if(this.disableForm)return true;
    if(this.dynamicFormsService.isSelectedDataFromAddressOneKey && this.selectedSearchOption && this.selectedSearchOption[control.attributeName]) return true;
    if(control.dataType == ControlDataType.StateType || control.dataType == ControlDataType.StatusType) return true;
    if (control.isCustom) {
      if (this.isSelectedFromSearch) {
        if(this.selectedSearchOption && this.selectedSearchOption[control.attributeName]) return true;
        else if(!this.changeRequest) return true;
      }
      if (control.dependsOn) {
        if (!this.isHandleEditAddressFormField) {
          if (!(this._customFormValue && this._customFormValue['lookupfields'])) {
            return true;
          } else {
            let isDepndsOnSet = this._customFormValue['lookupfields'].find(x => x.name == control.dependsOn);
            return (control.isReadOnly || !isDepndsOnSet) || (control.dataType == ControlDataType.LookupType && this.contactService.disableEditForVeevaContactOnly());
          }
        } else {
          if (!(this._existingCustomFormValue && this._existingCustomFormValue['lookupfields'])) {
            return true;
          } else {
            let isDepndsOnSet = this._existingCustomFormValue['lookupfields'].find(x => x.name == control.dependsOn);
            return (control.isReadOnly || !isDepndsOnSet) || (control.dataType == ControlDataType.LookupType && this.contactService.disableEditForVeevaContactOnly());
          }
        }
      }
    }
    return control.isReadOnly || (control.dataType == ControlDataType.LookupType && this.contactService.disableEditForVeevaContactOnly());
  }

  private _isShowArrow(control: Control) {
    if(this.disableForm) return false;
    if(control.dataType == ControlDataType.StateType || control.dataType == ControlDataType.StatusType) return false;
    if(this.dynamicFormsService.isSelectedDataFromAddressOneKey && this.selectedSearchOption && this.selectedSearchOption[control.attributeName]) return false;
    if (control.isCustom) {
      if (this.isSelectedFromSearch) {
        if(this.selectedSearchOption && this.selectedSearchOption[control.attributeName]) return false;
        else if(!this.changeRequest) return false;
      }
      if (control.dependsOn) {
        if (!this.isHandleEditAddressFormField) {
          if (!(this._customFormValue && this._customFormValue['lookupfields'])) {
            return false;
          } else {
            let isDepndsOnSet = this._customFormValue['lookupfields'].find(x => x.name == control.dependsOn);
            return (!control.isReadOnly && isDepndsOnSet);
          }
        } else {
          if (!(this._existingCustomFormValue && this._existingCustomFormValue['lookupfields'])) {
            return false;
          } else {
            let isDepndsOnSet = this._existingCustomFormValue['lookupfields'].find(x => x.name == control.dependsOn);
            return (!control.isReadOnly && isDepndsOnSet);
          }
        }
      }
    }
    return !control.isReadOnly || (control.dataType == ControlDataType.LookupType);
  }

  public async onPageTitleControlClick(id: string) {
    const shouldPreventDuplicateRequest = this._isPageTitleRequestButton(id);
    if (shouldPreventDuplicateRequest && this._isPageTitleRequestInProgress) return;

    if (shouldPreventDuplicateRequest) this._isPageTitleRequestInProgress = true;

    try {
    switch (id) {
      case 'close':
      case 'cancel':
        if (this.formDetail && this.formDetail.eventsHandler) {
          const isDirty = this._isFormDirty || this.dynamicFormsService.linkedEntityFormIsDirtyTracker;
          const data: any = {
            formValue: this._currentFormValue,
            formStringValue: this._currentFormStringValues,
            customFormValue: this._customFormValue,
            eventsHandler: (d: any, eventName: string) => this.callbackFromParentComponent(d, eventName),
            displayConfirmation: isDirty,
          };
          if (this.formDetail.LookupEntitySetName === 'indskr_medicalinquiries') {
            data.isDirty = isDirty;
          }
          if (this.layoverViewPushedFrom) {
            data.layoverViewPushedFrom = this.layoverViewPushedFrom;
          }
          await this.formDetail.eventsHandler(data, 'CANCELBUTTONCLICK', this.formDetail);
        }
        break;
      case 'scrap':
        if (this.formDetail && this.formDetail.eventsHandler) {
          let data = {
            formValue: this._currentFormValue,
            formStringValue: this._currentFormStringValues,
            customFormValue: this._customFormValue,
            eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
            displayConfirmation: this._isFormDirty || this.dynamicFormsService.linkedEntityFormIsDirtyTracker,
          }
          await this.formDetail.eventsHandler(data, 'SCARPBUTTONCLICK', this.formDetail);
        }
        break;
      case 'done':
        if (this._mode == 'EDIT_MODE') {
          // In case of auto-populated data flow
          if (this.changeRequest && this.isAutoPopulatedLinkedDataFlow) {
            let addressAttrName = this.dynamicFormsService.addressAttributeName || '';
            let accountAffiliationAttrName = this.dynamicFormsService.accountAffiliationAttributeName || '';
            // Send auto-populated existing data to payload if the account-contact affiliation data did not replace the existing data in Contact CR.
            if (this.hasAccountContactAffiliationForm && !this.addedNewACAffiliation && this.formDetail.LookupEntitySetName == 'indskr_contactcrs') {
              if (accountAffiliationAttrName) {
                await this.autoPopulatedLinkedData('accountContactAffiliation', true).then(async () => {
                  if (addressAttrName) {
                    await this.autoPopulatedLinkedData('contactAddress', true).then(async () => {
                      if (this.formDetail && this.formDetail.eventsHandler && this._validateCurrentFormValue()) {
                        if (this._currentFormValue && !isEmpty(this.formDetail.formEntityObject) && this.formDetail.formEntityObject['indskr_mdm']) {
                          this._currentFormValue['indskr_mdm'] = this.formDetail.formEntityObject['indskr_mdm'];
                        }
                        this.dynamicFormsService.okCRMapper = this._currentFormStringValues;
                        let data = {
                            formValue: this._currentFormValue,
                            formStringValue: this._currentFormStringValues,
                            isFormSaved: this._isFormSaved,
                            eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
                        }
                        await this.formDetail.eventsHandler(data, 'DONEBUTTONCLICK', this.formDetail);
                      }
                    });
                  } else {
                    if (this.formDetail && this.formDetail.eventsHandler && this._validateCurrentFormValue()) {
                      this.dynamicFormsService.okCRMapper = this._currentFormStringValues;
                      let data = {
                          formValue: this._currentFormValue,
                          formStringValue: this._currentFormStringValues,
                          isFormSaved: this._isFormSaved,
                          eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
                      }
                      await this.formDetail.eventsHandler(data, 'DONEBUTTONCLICK', this.formDetail);
                    }
                  }
                });
              }
            // Send auto-populated existing data to payload if the address data did not replace the existing data in Account CR.
            } else if (this.hasAddressForm && !this.addedNewAddressForAccountCR && (this.formDetail.LookupEntitySetName == 'indskr_accountcrs' || this.formDetail.LookupEntitySetName == 'indskr_accountcr')) {
              if (addressAttrName) {
                await this.autoPopulatedLinkedData('accountAddress', true).then(async () => {
                  if (this.formDetail && this.formDetail.eventsHandler && this._validateCurrentFormValue()) {
                    this.dynamicFormsService.okCRMapper = this._currentFormStringValues;
                    let data = {
                        formValue: this._currentFormValue,
                        formStringValue: this._currentFormStringValues,
                        isFormSaved: this._isFormSaved,
                        eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
                    }
                    await this.formDetail.eventsHandler(data, 'DONEBUTTONCLICK', this.formDetail);
                  }
                });
              } else {
                if (this.formDetail && this.formDetail.eventsHandler && this._validateCurrentFormValue()) {
                  this.dynamicFormsService.okCRMapper = this._currentFormStringValues;
                  let data = {
                      formValue: this._currentFormValue,
                      formStringValue: this._currentFormStringValues,
                      isFormSaved: this._isFormSaved,
                      eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
                  }
                  await this.formDetail.eventsHandler(data, 'DONEBUTTONCLICK', this.formDetail);
                }
              }
            } else {
              if (this.formDetail && this.formDetail.eventsHandler && this._validateCurrentFormValue()) {
                this.dynamicFormsService.okCRMapper = this._currentFormStringValues;
                let data = {
                    formValue: this._currentFormValue,
                    formStringValue: this._currentFormStringValues,
                    isFormSaved: this._isFormSaved,
                    eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
                }
                await this.formDetail.eventsHandler(data, 'DONEBUTTONCLICK', this.formDetail);
              }
            }
          // non auto-populated data flow
          } else {
            if (this.formDetail && this.formDetail.eventsHandler && this._validateCurrentFormValue()) {
              if (this._currentFormValue && !isEmpty(this.formDetail.formEntityObject) && this.formDetail.formEntityObject['indskr_mdm']) {
                this._currentFormValue['indskr_mdm'] = this.formDetail.formEntityObject['indskr_mdm'];
              }
              this.dynamicFormsService.okCRMapper = this._currentFormStringValues;
              let formValue = cloneDeep(this._currentFormValue);
              if (this.TYPE == 'SANOFI_CHINA') {
                if (this.isWorkCardAdded) {
                  formValue.attachment1 = {
                    base64str: this.workCardBase64str,
                    filename: this.workCardTitle
                  }
                }
                if (this.isPracticeCertificateAdded) {
                  formValue.attachment2 = {
                    base64str: this.practiceCertificateBase64str,
                    filename: this.practiceCertificateTitle
                  }
                }
              }
              let data = {
                formValue: formValue,
                formStringValue: this._currentFormStringValues,
                isFormSaved: this._isFormSaved,
                eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
              }
              await this.formDetail.eventsHandler(data, 'DONEBUTTONCLICK', this.formDetail);
            }
          }
          if (this._isFormSaved) {
            this._isFormDirty = false;
            this.initFormPageTitleAndButtons(true);
          }
        // CREATE_MODE
        } else {
          if (this.formDetail && this.formDetail.eventsHandler && this._validateCurrentFormValue()) {
            if (this._currentFormValue && !isEmpty(this.formDetail.formEntityObject) && this.formDetail.formEntityObject['indskr_mdm']) {
              this._currentFormValue['indskr_mdm'] = this.formDetail.formEntityObject['indskr_mdm'];
            }
            this.dynamicFormsService.okCRMapper = this._currentFormStringValues;
            let data = {
              formValue: this._currentFormValue,
              formStringValue: this._currentFormStringValues,
              customFormValue: this._customFormValue,
              isSelectedFromSearch: this.isSelectedFromSearch,
              isFormSaved: this._isFormSaved,
              eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
            }
            await this.formDetail.eventsHandler(data, 'DONEBUTTONCLICK', this.formDetail);
          }
        }
        break;
      case 'DONEMEDICALINQUIRY':
        if (this.formDetail?.eventsHandler) {
          const data = {
            formValue: this._currentFormValue,
            formStringValue: this._currentFormStringValues,
            customFormValue: this._customFormValue,
            isFormSaved: this._isFormSaved,
            eventsHandler: (d: any, eventName: string) => this.callbackFromParentComponent(d, eventName),
          };
          this.formDetail.eventsHandler(data, 'DONEMEDICALINQUIRY', this.formDetail);
        }
        break;
      case 'SUBMITMEDICALINQUIRY':
        if (this.formDetail?.eventsHandler) {
          const data = {
            formValue: this._currentFormValue,
            formStringValue: this._currentFormStringValues,
            customFormValue: this._customFormValue,
            isFormSaved: this._isFormSaved,
            eventsHandler: (d: any, eventName: string) => this.callbackFromParentComponent(d, eventName),
          };
          this.formDetail.eventsHandler(data, 'SUBMITMEDICALINQUIRY', this.formDetail);
        }
        break;
      case 'SCRAPMEDICALINQUIRY':
        if (this.formDetail?.eventsHandler) {
          const data = {
            formValue: this._currentFormValue,
            formStringValue: this._currentFormStringValues,
            customFormValue: this._customFormValue,
            eventsHandler: (d: any, eventName: string) => this.callbackFromParentComponent(d, eventName),
          };
          this.formDetail.eventsHandler(data, 'SCRAPMEDICALINQUIRY', this.formDetail);
        }
        break;
      default:
        console.log('Unhandled switch case statement');
        console.log("Handling kitbooking save, submit and scrap here");
        if (this._mode == 'EDIT_MODE') {
          this._isFormDirty = false;
          this.initFormPageTitleAndButtons(true);
          if (this.formDetail?.eventsHandler && this.formDetail?.LookupEntitySetName === 'indskr_medicalinquiries') {
            this.formDetail.eventsHandler(
              { isDirty: this._isFormDirty, formValue: this._currentFormValue, formStringValue: this._currentFormStringValues },
              'ISFORMDIRTY'
            );
          }
          if (this.formDetail && this.formDetail.eventsHandler && this._validateCurrentFormValue()) {
            if (this._currentFormValue && !isEmpty(this.formDetail.formEntityObject) && this.formDetail.formEntityObject['indskr_mdm']) {
              this._currentFormValue['indskr_mdm'] = this.formDetail.formEntityObject['indskr_mdm'];
            }
            this.dynamicFormsService.okCRMapper = this._currentFormStringValues;
            let formValue = cloneDeep(this._currentFormValue);
            if (this.TYPE == 'SANOFI_CHINA') {
              if (this.isWorkCardAdded) {
                formValue.attachment1 = {
                  base64str: this.workCardBase64str,
                  filename: this.workCardTitle
                }
              }
              if (this.isPracticeCertificateAdded) {
                formValue.attachment2 = {
                  base64str: this.practiceCertificateBase64str,
                  filename: this.practiceCertificateTitle
                }
              }
            }
            let data = {
              formValue: formValue,
              formStringValue: this._currentFormStringValues,
              isFormSaved: this._isFormSaved,
              eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
            }
            await this.formDetail.eventsHandler(data, id, this.formDetail);
          }
        } else {
          if (this.formDetail && this.formDetail.eventsHandler && this._validateCurrentFormValue()) {
            if (this._currentFormValue && !isEmpty(this.formDetail.formEntityObject) && this.formDetail.formEntityObject['indskr_mdm']) {
              this._currentFormValue['indskr_mdm'] = this.formDetail.formEntityObject['indskr_mdm'];
            }
            this.dynamicFormsService.okCRMapper = this._currentFormStringValues;
            let data = {
              formValue: this._currentFormValue,
              formStringValue: this._currentFormStringValues,
              customFormValue: this._customFormValue,
              isSelectedFromSearch: this.isSelectedFromSearch,
              isFormSaved: this._isFormSaved,
              eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
            }
            if(this.layoverViewPushedFrom)
              data["layoverViewPushedFrom"] = this.layoverViewPushedFrom;
            await this.formDetail.eventsHandler(data, id, this.formDetail);
          }
        }
        break;
    }
    } finally {
      if (shouldPreventDuplicateRequest) this._isPageTitleRequestInProgress = false;
    }
  }

  private _isPageTitleRequestButton(id: string): boolean {
    return id == 'done' || id == 'SAVEKITBOOKING' || id == 'SUBMITKITBOOKING';
  }

  /**
   * Re-runs form validation and updates button states (header + footer).
   * Call from parent when view is restored (e.g. after navigating back) so Save/Submit reflect current validity.
   */
  public refreshFormStateAndButtons(): void {
    this._initViewData();
  }

  private _validateCurrentFormValue(): boolean {
    let flag = true;
    if (this._dynamicForm && this._dynamicForm.metadata && this._dynamicForm.metadata.length > 0) {
      for (let i = 0; i < this._dynamicForm.metadata.length; i++) {
        if (flag == false) {
          break;
        }
        const tab = this._dynamicForm.metadata[i];
        if (tab && tab.controls && tab.controls.length > 0) {
          for (let j = 0; j < tab.controls.length; j++) {
            const control = tab.controls[j];
            if (control.dataType == ControlDataType.StringType && control.format && control.format == 'Email' 
              && this.formDetail && (this.formDetail?.LookupEntitySetName == 'indskr_email_addresses' || this.formDetail?.LookupEntitySetName == 'indskr_emailaddresscrs')) {
              if (this._currentFormValue && this._currentFormValue[control.attributeName]) {
                const emailValue = this._currentFormValue[control.attributeName];
                const isValid = isValidEmailAddress(emailValue);
                
                if (emailValue.length <= 0) {
                  flag = false;
                  this.notificationService.notify(this.translate.instant('CONSENT_EMAIL_CANT_EMPTY'), 'dynamic-form-component', 'top', ToastStyle.DANGER);
                  break;
                } else if (!isValid) {
                  flag = false;
                  this.notificationService.notify(this.translate.instant('CONTACT_INVALID_EMAIL_ADDRS'), 'dynamic-form-component', 'top', ToastStyle.DANGER);
                  break;
                }
                // Detect Email Duplication
                if(this.dynamicFormsService.storedLinkedEntityValues && this.dynamicFormsService.storedLinkedEntityValues.length>0) {
                  this.dynamicFormsService.storedLinkedEntityValues.forEach((value) => {
                    if(value.primaryText && emailValue && value.primaryText.toLowerCase() == emailValue.toLowerCase()) {
                      flag = false;
                      this.notificationService.notify(this.translate.instant('DUPLICATE_DETECTED'), 'DynamicFormComponent', 'top', ToastStyle.DANGER, 3000);
                    }
                  });
                }
                if (this.formDetail && this.formDetail.linkedEntityValue && this.formDetail.linkedEntityValue.length>0) {
                  const enteredEmailAddress = emailValue.toLowerCase();
                  if(this.editConfig == EditConfig.ADD_NEW) {
                    this.formDetail.linkedEntityValue.forEach((value) => {
                      if(emailValue &&
                        ((value['indskr_email_address.indskr_emailaddress'] && value['indskr_email_address.indskr_emailaddress'].toLowerCase() == enteredEmailAddress)
                        || (value['primaryText'] && value['primaryText'].toLowerCase() == enteredEmailAddress))) {
                        flag = false;
                        this.notificationService.notify(this.translate.instant('DUPLICATE_DETECTED'), 'DynamicFormComponent', 'top', ToastStyle.DANGER, 3000);
                      }
                    })
                  } else {
                    let isEditFromExistingData: boolean = true;
                     if(this.formDetail.formEntityObject) {
                       if(this.formDetail.formEntityObject.formValue) {
                       isEditFromExistingData = this.formDetail.formEntityObject.formValue['indskr_emailaddress'] && emailValue && this.formDetail.formEntityObject.formValue['indskr_emailaddress'].toLowerCase() == enteredEmailAddress ? true : false;
                     } else if(this.formDetail.formEntityObject['indskr_email_address.indskr_emailaddress']) {
                       isEditFromExistingData = this.formDetail.formEntityObject['indskr_email_address.indskr_emailaddress'] && emailValue && this.formDetail.formEntityObject['indskr_email_address.indskr_emailaddress'].toLowerCase() == enteredEmailAddress ? true : false;
                     }
                    }
                    this.formDetail.linkedEntityValue.forEach((value) => {
                      if(this.formDetail.isEditFormWithLinkedData) {
                        if(value.linkedEntityExistingDataId != this.formDetail.linkedEntityExistingDataId || !isEditFromExistingData) {
                          if(value.primaryText && emailValue && value.primaryText.toLowerCase() == enteredEmailAddress) {
                            flag = false;
                            this.notificationService.notify(this.translate.instant('DUPLICATE_DETECTED'), 'DynamicFormComponent', 'top', ToastStyle.DANGER, 3000);
                          }
                        }
                      } else {
                        if(value.primaryText && emailValue && value.primaryText.toLowerCase() == enteredEmailAddress) {
                          flag = false;
                          this.notificationService.notify(this.translate.instant('DUPLICATE_DETECTED'), 'DynamicFormComponent', 'top', ToastStyle.DANGER, 3000);
                        }
                      }
                    })
                  }
                  break;
                }
                if(this.dynamicFormsService.storedLinkedEntityValues && this.dynamicFormsService.storedLinkedEntityValues.length>0) {
                  this.dynamicFormsService.storedLinkedEntityValues.forEach((value) => {
                    if(value.primaryText == emailValue) {
                      flag = false;
                      this.notificationService.notify(this.translate.instant('DUPLICATE_DETECTED'), 'DynamicFormComponent', 'top', ToastStyle.DANGER, 3000);
                    }
                  });
                }
              }
            } else if (control.dataType == ControlDataType.DoubleType || control.dataType == ControlDataType.IntegerType || control.dataType == ControlDataType.DecimalType) {
              if (this._currentFormValue && this._currentFormValue[control.attributeName] && (this._currentFormValue[control.attributeName] < control.minValue || this._currentFormValue[control.attributeName] > control.maxValue)) {
                flag = false;
                let labelText: string = this._getDisplayText(control.displayNames, control.isCustom);
                this.notificationService.notify(this.translate.instant('DYNAMIC_FORM_INVALID_NUMBER_VALUE', { fieldname: labelText, maxvalue: control.maxValue, minvalue: control.minValue }), 'dynamic-form-component', 'top', ToastStyle.DANGER);
                break;
              }
            }
          }
        }
      }
    }
    return flag;
  }

  public callbackFromParentComponent(data: any, eventName: string) {
    if (data && eventName) {
      if (eventName == 'NEWDATACREATED') {
        this.formDetail.mainEntityObjectId = data;
        this._isFormSaved = true;
        this._isFormDirty = false;
        this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
        // Merge so response data (e.g. indskr_title from API) overwrites form value and form fields update
        this._currentFormValue = {
          ...this._currentFormValue,
          ...data
        };
        if(this.MODE == 'CREATE_MODE' && this.formDetail && this.formDetail.formMetadata && this.formDetail.formMetadata.entityName == 'indskr_setbooking'){
          try {
            this.formDetail.rightHeaderBtnText = undefined;
            this.formDetail.rightHeaderImgSrcArray= ['assets/imgs/header_save.svg', 'assets/imgs/submit_white.svg'];
            this.formDetail.rightHeaderBtnTextArray = [this.translate.instant('Save'), this.translate.instant('Submit')];
            this.formDetail.rightHeaderBtnIdsArray = ['SAVEKITBOOKING','SUBMITKITBOOKING'];
            this.initFormPageTitleAndButtons(true);
          } catch (error) {}
        }
        if(this.MODE == 'CREATE_MODE' && this.formDetail && this.formDetail.formMetadata && this.formDetail.formMetadata.entityName == 'indskr_medicalinquiry'){
          try {
            this.formDetail.rightHeaderBtnText = undefined;
            this.formDetail.rightHeaderImgSrcArray= ['assets/imgs/header_save.svg', 'assets/imgs/submit_white.svg'];
            this.formDetail.rightHeaderBtnTextArray = [this.translate.instant('Save'), this.translate.instant('SUBMIT')];
            this.formDetail.rightHeaderBtnIdsArray = ['SAVEMEDICALINQUIRY','SUBMITMEDICALINQUIRY'];
            this.initFormPageTitleAndButtons(true);
          } catch (error) {}
        }
        this._initViewData();
      } else if (eventName == 'NEWDATAUPDATED') {
        this._isFormDirty = data == "ERROR";
        this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
        // Merge server-returned fields (e.g. auto-generated indskr_title) into internal form state
        // so field values reflect what Dynamics persisted, same as NEWDATACREATED does.
        if (data && typeof data === 'object' && data !== 'ERROR') {
          this._currentFormValue = {
            ...this._currentFormValue,
            ...data,
          };
          // Sync the page header title with the returned indskr_title so initFormPageTitleAndButtons
          // picks up the server-generated value without requiring the parent to hold a formDetail ref.
          if (typeof data.indskr_title === 'string' && data.indskr_title.trim() &&
              this.formDetail?.formMetadata?.entityName === 'indskr_medicalinquiry') {
            this.formDetail.title = data.indskr_title.trim();
          }
        }
        if(this.MODE == 'EDIT_MODE' && this.formDetail && this.formDetail.formMetadata && this.formDetail.formMetadata.entityName == 'indskr_setbooking'){
          this._parseRawObjectDataToValuesLinkedEntity();
          this._initViewData();
        } else {
          this._initViewData();
        }
      } else if (eventName === 'LINKEDENTITYIDUPDATE') {
        if (data?.addedNewDataId && data?.linkedEntityId) {
          for (const key of Object.keys(this.linkedEntityValues || {})) {
            const entries = this.linkedEntityValues[key];
            if (Array.isArray(entries)) {
              const entry = entries.find(e => e.linkedEntityAddedNewDataId === data.addedNewDataId);
              if (entry) {
                entry.linkedEntityExistingDataId = data.linkedEntityId;
                entry.linkedEntityAddedNewDataId = '';
                if (entry.rawObjData?.formValue) {
                  entry.rawObjData.formValue.guid = data.linkedEntityId;
                }
                break;
              }
            }
          }
        }
      } else if(eventName === 'DISABLEFORM') {
        this.disableForm = true;
        this._isFormDirty = false;
        this._isFormSaved = true;
        this.isViewFromEditFormToAccordionForm = true;
        if (this.EDIT_FLOW == 'business_contact_cr_email_address_cr') {
          this._setDisabeEditArrow('indskr_emailaddresscrs');
        }
        if (!isEmpty(data?.indskr_hcponeid)) {
          this._currentFormValue.indskr_hcponeid = data.indskr_hcponeid
          this.initFooter();
        }
        this._initViewData();
      } else if (eventName === 'SUBMITFAILED') {
        this.disableForm = false;
        this._isFormSaved = false;
        this._isFormDirty = true;
        this.isViewFromEditFormToAccordionForm = false;
        this._initViewData();
      } else if(eventName == 'ENABLEFORM') {
        this._isFormSaved = false;
        this._isFormDirty = true;
        this.dynamicFormsService.linkedEntityFormIsDirtyTracker = true;
        this._initViewData();
      }
    }
  }

  public async onSectionHeaderControlClick(id: string, data?: any) {
    let targetControl: Control;
    if (id) {
      for (let tabIdx = 0; tabIdx < this._dynamicForm.metadata.length; tabIdx++) {
        const tab = this._dynamicForm.metadata[tabIdx];
        if (tab && tab.controls && tab.controls.length > 0) {
          let foundControl = tab.controls.find(c => {
            if (!c.dataType) {
              const targetId = c.attributeName + '_' + 'ADD';
              return id == targetId;
            }
          });
          if (foundControl) {
            targetControl = foundControl;
            break;
          } else {
            foundControl = tab.controls.find(c => {
              if (!c.dataType) {
                const formattedId = id.toLowerCase();
                const formattedAttributName = c.attributeName.toLowerCase();
                return formattedId.includes(formattedAttributName);
              }
            });
            if (foundControl) {
              targetControl = foundControl;
              break;
            }
          }
          if(!targetControl) {
            let headerLabel: string = this.localizationService.getTranslatedString(this._getDisplayText(tab.displayNames), EntityNameForTranslation.MobileAppForm);
            if(id == `${headerLabel}-collapsible`) this._expandCollapseLinkedEntitySection(id, data, true);
          }
        }
      };
      if (targetControl) {
        if (this.editConfig == EditConfig.UPDATE_EXISTING) return;
        if (id.includes('_SELECT')) {
        } else if (id.includes('_ADD')) {
          if (this.formDetail.formMetadata.entityName == 'account') {
            this.trackingService.tracking('AddSelected', TrackingEventNames.ACCOUNT_EDIT, true);
          } else if (this.formDetail.formMetadata.entityName == 'contact') {
            this.trackingService.tracking('AddSelected', TrackingEventNames.CONTACT_EDIT, true);
          }
          if (targetControl.subgrid) {
            if (targetControl.subgrid.targetEntityType) {
              let foundForm;
              let formType;
              const targetAttributeName: string = targetControl.attributeName;
              if (this.formDetail.dynamicFormType == DynamicFormType.CONFIGUREDFORM) {
                foundForm = await this.dynamicFormsService.getFormDefinitionForEntity(targetControl.subgrid.targetEntityType, FormType.CREATEFORM);
                formType = DynamicFormType.CONFIGUREDFORM;
              } else if (this.formDetail.dynamicFormType == DynamicFormType.DEFAULTFORM) {
                let ff = SHARED_CREATE_FORM.find(f => f.indskr_entityname == targetControl.subgrid.targetEntityType)
                if (ff) {
                  foundForm = new DynamicForm(ff)
                  formType = DynamicFormType.DEFAULTFORM;
                };
              }

              if (foundForm) {

                let rawFormEntityObject = null;
                //Account to Contact Affiliation - Prefill Account and make Contact as required field
                if (this.formDetail.formMetadata.entityName == 'account' && targetControl.subgrid.targetEntityType == 'indskr_accountcontactaffiliation') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, "omnione_role", "indskr_contactrole");
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundAccountControlIdx = itab.controls.findIndex(c => c.attributeName == 'indskr_accountid');
                      if (foundAccountControlIdx >= 0) {
                        itab.controls[foundAccountControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundAccountControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundAccountControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //Account to Contact Affiliation change request - Prefill Account change request and make Contact as required field
                if (this.formDetail.formMetadata.entityName == 'indskr_accountcr' && targetControl.subgrid.targetEntityType == 'indskr_accountcontactaffiliationcr') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, "indskr_affiliationrole", "indskr_contactrole");
                    if (itab && itab.controls && itab.controls.length > 0) {
                      rawFormEntityObject = this.getFieldsToDisplayForContactAccountAff(itab, rawFormEntityObject, 'indskr_accountcr', 'indskr_contactid');
                    }
                  };
                }

                //Contact to Account Affiliation - Prefill Contact and make Account as required field
                if (this.formDetail.formMetadata.entityName == 'contact' && targetControl.subgrid.targetEntityType == 'indskr_accountcontactaffiliation') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, "omnione_role", "indskr_contactrole");
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == 'indskr_contactid');
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //Contact to Account Affiliation change request - Prefill Contact change request and make Account as required field
                if (this.formDetail.formMetadata.entityName == 'indskr_contactcr' && targetControl.subgrid.targetEntityType == 'indskr_accountcontactaffiliationcr') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, "indskr_affiliationrole", "indskr_contactrole");
                    if (itab && itab.controls && itab.controls.length > 0) {
                      rawFormEntityObject = this.getFieldsToDisplayForContactAccountAff(itab, rawFormEntityObject, 'indskr_contactcr', 'indskr_accountid');
                    }
                  };
                }

                //Hide CustomerAddress
                if (targetControl.subgrid.targetEntityType == 'indskr_indskr_customeraddress_v2') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIndex = itab.controls.findIndex(c => c.attributeName == 'indskr_address');
                      if (foundControlIndex >= 0) {
                        itab.controls[foundControlIndex].forceHide = true;
                        break;
                      }
                    }
                  };
                }

                //Hide CustomerAddress ChangeRequest
                if (targetControl.subgrid.targetEntityType == 'indskr_customeraddresscr') {
                  this.dynamicFormsService.hasCityDataBasedOnCountry = false;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    if (itab && itab.controls && itab.controls.length > 0) {
                      itab.controls.filter(c => c.attributeName == 'indskr_addresscr' || c.lookupEntitySetName == 'indskr_addresses' ||
                        c.lookupEntitySetName == 'indskr_contactcrs'
                        || c.lookupEntitySetName == 'indskr_accountcrs'
                        || c.lookupEntitySetName?.startsWith('indskr_lu_')).forEach(c => {
                          if (c.lookupEntitySetName == this.formDetail.LookupEntitySetName) {
                            rawFormEntityObject = {
                              ['_' + c.attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                              ['_' + c.attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                            };
                          }
                          c.forceHide = true;
                        })
                    }
                  };
                }

                //Hide EmailAddress ChangeRequest "indskr_accountcrs", "indskr_contactcrs"
                if (targetControl.subgrid.targetEntityType == 'indskr_emailaddresscr') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIndex = itab.controls.findIndex(c => c.lookupEntitySetName == this.formDetail.LookupEntitySetName);
                      if (this.formDetail.LookupEntitySetName == 'indskr_accountcrs') {
                        const controlIndexToHide = itab.controls.findIndex(c => c.lookupEntitySetName == 'indskr_contactcrs');
                        if (controlIndexToHide >= 0) {
                          itab.controls[controlIndexToHide].forceHide = true;
                        }
                      }
                      if (this.formDetail.LookupEntitySetName == 'indskr_contactcrs') {
                        const controlIndexToHide = itab.controls.findIndex(c => c.lookupEntitySetName == 'indskr_accountcrs');
                        if (controlIndexToHide >= 0) {
                          itab.controls[controlIndexToHide].forceHide = true;
                        }
                      }
                      if (foundControlIndex >= 0) {
                        itab.controls[foundControlIndex].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIndex].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIndex].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                      }
                    }
                  };
                }

                //Account to Account Affiliation - Prefill Contact and make Account as required field
                if (this.formDetail.formMetadata.entityName == 'account' && targetControl.subgrid.targetEntityType == 'indskr_accountaccountaffiliation') {
                  let attribName = targetControl.subgrid.referencingAttribute;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, 'omnione_relationship', 'indskr_type');
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == attribName);
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //Account to Account Affiliation Change request - Prefill Account From and make Account To as required field
                if (this.formDetail.formMetadata.entityName == 'indskr_accountcr' && targetControl.subgrid.targetEntityType == 'indskr_accountaccountaffiliationcr') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, 'indskr_affiliationtype', 'indskr_type');
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == 'indskr_affiliatedfrom');
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //Contact to Contact Affiliation - Prefill Parent Contact and make Child contact as required field
                if ((this.formDetail.formMetadata.entityName == 'contact' && targetControl.subgrid.targetEntityType == 'indskr_contactrelationship')
                  || (this.formDetail.formMetadata.entityName == 'indskr_contactcr' && targetControl.subgrid.targetEntityType == 'indskr_contactrelationshipcr')) {
                  let attribName = targetControl.subgrid.referencingAttribute;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, "omnione_relationship", this.formDetail.formMetadata.entityName == 'contact' ? "indskr_relationship" : "indskr_relationshiptype");
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == attribName);
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //Set Booking to Product Association - Prefill Set Booking Guid
                if (this.formDetail.formMetadata.entityName == 'indskr_setbooking' && targetControl.subgrid.targetEntityType == 'indskr_setbookingproduct') {
                  let attribName = targetControl.subgrid.referencingAttribute;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == attribName);
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                  let surgeonaccountzsurValue = this._getAttributeValue('indskr_surgeonaccountzsur');
                  if(surgeonaccountzsurValue){
                    if(rawFormEntityObject){
                      rawFormEntityObject['surgeonaccountzsurValue'] = surgeonaccountzsurValue;
                    }else{
                      rawFormEntityObject = {
                        surgeonaccountzsurValue: surgeonaccountzsurValue,
                      };
                    }
                  }
                }

                //Set Booking to Team Member Association - Prefill Set Booking Guid
                if (this.formDetail.formMetadata.entityName == 'indskr_setbooking' && targetControl.subgrid.targetEntityType == 'indskr_setbookingteammember') {
                  let attribName = targetControl.subgrid.referencingAttribute;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == attribName);
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //linked entity values for checking the duplicate data
                const checkDuplicateDataInLookupFields = ["indskr_accountcontactaffiliation", "indskr_accountcontactaffiliationcr", "indskr_customerspecialty", "indskr_customerspecialtychangerequest", "indskr_accountaccountaffiliation", "indskr_accountaccountaffiliationcr", "indskr_contactrelationship", "indskr_contactrelationshipcr"];
                if (!isEmpty(this.linkedEntityValues)) {
                  if (targetControl.subgrid.targetEntityType == 'indskr_email_address') {
                    this.dynamicFormsService.storedLinkedEntityValues = this.linkedEntityValues.EMAIL ? this.linkedEntityValues.EMAIL : this.linkedEntityValues.Email ? this.linkedEntityValues.Email : this.linkedEntityValues.sgEmail ? this.linkedEntityValues.sgEmail : [];
                  } else if (checkDuplicateDataInLookupFields.includes(targetControl.subgrid.targetEntityType)) {
                    this.dynamicFormsService.storedLinkedEntityValues = this.linkedEntityValues[targetAttributeName] ? this.linkedEntityValues[targetAttributeName] : [];
                  }
                }
                let displayName: any = this._getDisplayText(targetControl.displayNames);
                let formDetailEntityName = this.formDetail.formMetadata.entityName;
                let referencingEntityName = targetControl.subgrid.referencingEntity;
                const enableSearch = targetControl.subgrid.referencingEntity == 'indskr_indskr_customeraddress_v2' || targetControl.subgrid.referencingEntity == 'indskr_customeraddresscr'
                  || (this.accountService.isOneKeyChangeRequest && formDetailEntityName == 'indskr_accountcr' && referencingEntityName == 'indskr_accountaccountaffiliationcr' && this.MODE == 'EDIT_MODE')
                  || (this.contactService.isOneKeyChangeRequest && formDetailEntityName == 'indskr_contactcr' && referencingEntityName == 'indskr_accountcontactaffiliationcr' && this.MODE == 'EDIT_MODE');
                let existingLinkedEntityValues = [];
                if (this.editConfig == EditConfig.ADD_NEW) {
                  existingLinkedEntityValues = this.formDetail.linkedEntityValue ? this.formDetail.linkedEntityValue : [];
                } else {
                  existingLinkedEntityValues = this.linkedEntityValues ? this.linkedEntityValues[targetControl.attributeName] ? this.linkedEntityValues[targetControl.attributeName] : [] : [];
                }
                let formDetail: DynamicFormComponentModel = {
                  title: startCase(displayName.toLowerCase()),
                  showLeftHeaderButton: true,
                  showSearchBar: enableSearch,
                  leftHeaderBtnText: this.translate.instant('CANCEL'),
                  LookupEntitySetName: foundForm.entitySetName,
                  showRightHeaderButton: true,
                  showClearButton: true,
                  linkedEntityAddedNewDataId: targetControl.attributeName + '_' + Math.random().toString(36).substring(7),
                  rightHeaderImgSrc: 'assets/imgs/header_complete.svg',
                  rightHeaderBtnText: this.translate.instant('DONE'),
                  formMetadata: foundForm,
                  formEntityObject: rawFormEntityObject,
                  mainEntityObjectId: null,
                  linkedEntityParentData: this.getLinkEntityParentData(foundForm.entitySetName, targetControl),
                  customFields: await this._getCustomFields(targetControl.subgrid.referencingEntity),
                  dynamicFormType: formType,
                  navOptions: { animate: false },
                  linkedEntityValue: existingLinkedEntityValues,
                  eventsHandler: (data: any, eventTarget: string, refData: DynamicFormComponentModel) => this._handleDynamicFormComponentEvent(data, eventTarget, refData),
                };
                this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
                if (this.formDetail.formMetadata.entityName == 'indskr_setbooking' && targetControl.subgrid.targetEntityType == 'indskr_setbookingproduct'){
                  this._fetchSetBookingProduct(formDetail);
                } else if (this.formDetail.formMetadata.entityName == 'indskr_medicalinquiry' && targetControl.subgrid.targetEntityType == 'indskr_medicalinquiryproduct'){
                  this._fetchMedicalInquiryProduct(formDetail);
                } else {
                  this.navService.pushChildNavPageWithPageTracking(PageName.DynamicFormComponent, PageName.DynamicFormComponent, this.navService.getCurrentMasterPageName(), {
                    MODE: 'CREATE_MODE',
                    PREVIOUS_MODE: this._previousMode == 'EDIT_MODE' ? 'EDIT_MODE' : 'CREATE_MODE',
                    FORM_DETAIL: formDetail,
                    TYPE: this.TYPE ? this.TYPE : null,
                    EDIT_FLOW: this.EDIT_FLOW
                  });
                }
              }
            }
          }
        } else if (id.includes('collapsible')) {
          this._expandCollapseLinkedEntitySection(id, data);
        } else if (id.includes('SCRAP')) {
          this.alertService.showAlert({
            title: this.translate.instant('SCRAP'),
            message: this.translate.instant('LINKED_ENTITY_R_U_WANT_SCRAP_FROM_LIST', {linkedEntityName: this.localizationService.getTranslatedString(this._getDisplayText(targetControl.displayNames), EntityNameForTranslation.MobileAppForm)})
          }, this.translate.instant('SCRAP')
          ).then(res => {
            if (res.role == 'ok') {
              if (this.linkedEntityValues && this.linkedEntityValues[targetControl.attributeName]) {
                // Remove selected linked entities
                this.linkedEntityValues[targetControl.attributeName].forEach(x => {
                  if(x.isCheckedForScrap) {
                    x.isDeactivate = true;
                    let values;
                    if (this.changeRequest && this.EDIT_FLOW == 'change_request_category_flow') {
                      // Build the contact CR lookupfield here and add it to values
                      values = {
                        contactCRLookupField: {
                          "name": targetControl.subgrid?.referencingEntityNavigationPropertyName,
                          "entity": "indskr_contactcrs"
                        }
                      };
                    } else {
                      values = {
                        guid: x.linkedEntityExistingDataId || x.linkedEntityAddedNewDataId || x.linkedEntityExistingDataAddressId,
                        statecode: 1,
                        statuscode: 2
                      }
                    }
                    this.linkedEntityValues[targetControl.attributeName] = this.linkedEntityValues[targetControl.attributeName].filter(x=>x.isDeactivate != true);
                    if (this.formDetail && this.formDetail.eventsHandler) {
                      let dataReq = {
                        eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName), //ind-dynamic-form:3349
                        displayConfirmation: this._isFormDirty,
                        linkedEntityExistingDataId: x.linkedEntityExistingDataId || '',
                        linkedEntityAddedNewDataId: x.linkedEntityAddedNewDataId || '',
                        linkedEntityExistingDataAddressId: x.linkedEntityExistingDataAddressId || '',
                        "entity": targetControl.lookupEntitySetName,
                        "values": values,
                      }
                      this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
                      this.formDetail.eventsHandler(dataReq, 'SCRAPLINKEDENTITY');
                      this._isFormDirty = true;
                    }
                  }
                })
                this._initViewData();
              }
            }
          })
        }
      } else if (id.includes('_CLEAR')) {
        if (this.formDetail.linkedEntityParentData.entity && this.dynamicFormsService.okLookUpMapper) {
          if (!isEmpty(this._currentFormValue) && this._currentFormValue['lookupfields']) {
            this._currentFormValue['lookupfields'].forEach(field => { if (field && field.id) this.dynamicFormsService.clearMappedLookupOnekeyWithId(field.id); });
          }
          if (!isEmpty(this._customFormValue) && this._customFormValue['lookupfields']) {
            this._customFormValue['lookupfields'].forEach(field => { if (field && field.id) this.dynamicFormsService.clearMappedLookupOnekeyWithId(field.id); });
          }
        }
        this._currentFormValue = { lookupfields: [this.formDetail.linkedEntityParentData] };
        this._currentFormStringValues = {};
        this._customFormValue = {};
        this._isFormDirty = false;
        this._initViewData();
        this.isSelectedFromSearch = false;
        this.dynamicFormsService.hasCityDataBasedOnCountry = false;
      } else if (id == 'attach_work_cards' || id =='attach_practice_certificate') {
        this.handleNoteAttachment(id);
      }
    }
  }

  private _expandCollapseLinkedEntitySection(id, data, isDefaultSection = false) {
    let viewField = this.currentFormView.find(a => a.id == data.id);
    if (isDefaultSection) {
      this.currentFormView.forEach(view => {
        if(view.type == 'form-field' && view.section == data.id) view.isCollapsed = !view.isCollapsed;        
      })
    }
    if (data && viewField) {
      viewField.isCollapsed = !data.isCollapsed;
      if(viewField.view && !isEmpty(viewField.view.controls)) {
        if(viewField.view.controls.length==1) viewField.view.controls[0].icon = viewField.isCollapsed ? 'assets/imgs/down-arrow.svg' : 'assets/imgs/up-arrow.svg';
        else if(viewField.view.controls.length>1) {
          let idx = viewField.view.controls.findIndex(ctrl => ctrl.id.includes('collapsible'));
          if(idx>-1) viewField.view.controls[idx].icon = viewField.isCollapsed ? 'assets/imgs/down-arrow.svg' : 'assets/imgs/up-arrow.svg';
        }
      }
    }
  }

  private getLinkEntityParentData(lookupEntitySetName: string, targetControl: Control): any {
    if(lookupEntitySetName == "indskr_accountaccountaffiliationcrs") {
      return { name: 'indskr_AffiliatedFrom', entity: this._dynamicForm.entitySetName, id: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]] }
    }
    return { name: targetControl.subgrid.referencingEntityNavigationPropertyName, entity: this._dynamicForm.entitySetName, id: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]] };
  }

  private getFieldsToDisplayForContactAccountAff(itab: any, rawFormEntityObject: any, attributeToPrefill: string, attributeToDisplay: string) {
    itab.controls.filter(c => (c.attributeName == 'indskr_contactcr' || c.attributeName == 'indskr_accountcr' || c.attributeName == 'indskr_contactid' || c.attributeName == 'indskr_accountid'))
      .forEach(control => {
        if (control.attributeName == attributeToPrefill) {
          control.forceHide = true;
          rawFormEntityObject = {
            ['_' + control.attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
            ['_' + control.attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
          };
        } else if (control.attributeName == attributeToDisplay) {
          control.forceHide = false;
          control.isRequired = true;
        } else {
          control.forceHide = true;
          control.isRequired = false;
        }
      });
    return rawFormEntityObject;
  }

  private removeOldOptionSetIfLookupIsPresent(itab: any, foundForm: any, i: number, newLookUpAttribute: string, oldOptionSetAttribute: string) {
    const affRoleIndex = itab.controls.findIndex(control => control.attributeName == newLookUpAttribute);
    if (affRoleIndex >= 0) {
      const roleIndex = itab.controls.findIndex(control => control.attributeName == oldOptionSetAttribute);
      if (roleIndex >= 0) {
        itab.controls.splice(roleIndex, 1);
        foundForm.metadata[i] = itab;
      }
    }
  }
  private async checkValidityOfLinkedEntities(data, entityName, parentId, refData?: DynamicFormComponentModel):Promise<boolean>{
    let isTempValid:boolean = true;
    let linkEntity = {
      "parentID": parentId,
      "entity": entityName,
      "values": data['formValue'],
    }
    
    // Check for duplicates for all entity types
    if (!isEmpty(this.linkedEntityValues)) {
      const foundControl = this._getTargetControlbyLookupEtity(entityName);
      
      if (foundControl && this.linkedEntityValues[foundControl.attributeName]) {
        const existingLinkedEntities = this.linkedEntityValues[foundControl.attributeName];
        const entityId = refData?.linkedEntityExistingDataId || data['formValue']?.guid;
        
        // Check for duplicates by comparing IDs first (for existing entities)
        let isDuplicate = false;
        if (entityId) {
          isDuplicate = existingLinkedEntities.some((value) => {
            // Skip if this is the same entity being edited
            if (refData?.linkedEntityExistingDataId && value.linkedEntityExistingDataId && 
                refData.linkedEntityExistingDataId === value.linkedEntityExistingDataId) {
              return false;
            }
            return value.linkedEntityExistingDataId === entityId || 
                   value.rawObjData?.formValue?.guid === entityId || 
                   value.rawObjData?.customFormValue?.guid === entityId;
          });
        }
        
        // If no duplicate found by ID, check by form values (for new entities without guid)
        if (!isDuplicate) {
          isDuplicate = this._checkForDuplicateLinkedEntity(data, entityName, existingLinkedEntities, refData);
        }
        
        if (isDuplicate) {
          this.notificationService.notify('Duplicate Detected: This ' + (refData?.title || 'linked entity') + ' has already been added', 'DynamicFormComponent', 'top', ToastStyle.INFO, 3000);
          isTempValid = false;
          return isTempValid;
        }
      }
    }
    
    // Special handling for team members (existing logic)
    if(linkEntity.entity=="indskr_setbookingteammembers" && !isEmpty(this.linkedEntityValues) && linkEntity["values"] && linkEntity['values'].lookupfields && !linkEntity["values"].hasOwnProperty('statecode')) {
      let memberId = linkEntity['values'].lookupfields.find(f => f.name == 'indskr_member')?.id;
      if(memberId) {
        const foundControl = this._getTargetControlbyLookupEtity('indskr_setbookingteammembers');
        this.linkedEntityValues[foundControl?.attributeName]?.forEach((value) => {
          if(value.rawObjData && (value.rawObjData['indskr_setbookingteammember.indskr_member'] && value.rawObjData['indskr_setbookingteammember.indskr_member']== memberId)
                || (value.rawObjData.formValue && value.rawObjData.formValue.lookupfields && value.rawObjData.formValue.lookupfields.find(f => f.name == 'indskr_member')?.id == memberId)) {
            this.notificationService.notify(this.translate.instant('TEAM_MEMBER_DUPLICATE'), 'New Activity', 'top', ToastStyle.DANGER);
            isTempValid = false;
            return;
          }
        })
      }      
    }
    
    return isTempValid;
  }

  private _checkForDuplicateLinkedEntity(data: any, entityName: string, existingLinkedEntities: Array<OmniAccordionViewDataModel>, refData?: DynamicFormComponentModel): boolean {
    const prefixMatch = entityName.match(/^(exe_|indskr_)/);
    const prefix = prefixMatch ? prefixMatch[1] : '';
    const baseEntityName = entityName.replace(/changerequests?$/i, '');
    
    let keyFieldName = '';
    let lookupFieldName = '';
    let stateFieldName = ''; // For license, we need to track state field separately
    
    if (baseEntityName.includes('degree')) {
      keyFieldName = 'degree';
      lookupFieldName = prefix === 'exe_' ? 'exe_Degree' : prefix === 'indskr_' ? 'indskr_degree' : 'Degree';
    } else if (baseEntityName.includes('specialty')) {
      keyFieldName = 'specialty';
      lookupFieldName = prefix === 'exe_' ? 'exe_Specialty' : prefix === 'indskr_' ? 'indskr_specialty' : 'Specialty';
    } else if (baseEntityName.includes('license')) {
      keyFieldName = 'sln_new';
      lookupFieldName = prefix === 'exe_' ? 'exe_State_New' : prefix === 'indskr_' ? 'indskr_state_new' : 'State_New';
      stateFieldName = prefix === 'exe_' ? 'exe_state_new' : prefix === 'indskr_' ? 'indskr_state_new' : 'state_new';
    } else {
      const parts = baseEntityName.split(prefix).filter(p => p);
      if (parts.length > 0) {
        const lastPart = parts[parts.length - 1].replace(/customer|contact|account/gi, '');
        if (lastPart) {
          keyFieldName = lastPart.toLowerCase();
          const capitalizedField = lastPart.charAt(0).toUpperCase() + lastPart.slice(1).toLowerCase();
          lookupFieldName = prefix ? `${prefix}${capitalizedField}` : capitalizedField;
        }
      }
    }
    
    if (!keyFieldName || !prefix) {
      const newFormValue = data['formValue'] || {};
      const newFormStringValue = data['formStringValue'] || {};
      
      return existingLinkedEntities.some((value) => {
        const existingFormValue = value.rawObjData?.formValue || {};
        const existingFormStringValue = value.rawObjData?.formStringValue || {};
        const existingCustomFormValue = value.rawObjData?.customFormValue || {};
        
        const keysToCompare = Object.keys(newFormValue).filter(k => 
          k !== 'guid' && k !== 'lookupfields' && newFormValue[k] != null && newFormValue[k] !== ''
        );
        
        return keysToCompare.some(key => {
          const newVal = newFormValue[key] || newFormStringValue[key];
          const existingVal = existingFormValue[key] || existingFormStringValue[key] || existingCustomFormValue[key];
          return newVal && existingVal && newVal === existingVal;
        });
      });
    }
    
    const fieldName = `${prefix}${keyFieldName}`;
    const capitalizedField = keyFieldName.charAt(0).toUpperCase() + keyFieldName.slice(1);
    
    const lookupField = data['formValue']?.lookupfields?.find((lf: any) => 
      lf.name === lookupFieldName || 
      lf.name === `${prefix}${capitalizedField}` ||
      lf.name === `exe_${capitalizedField}_New` ||
      lf.name === `indskr_${capitalizedField}_New` ||
      lf.name === `exe_${capitalizedField}` ||
      lf.name === `indskr_${capitalizedField}` ||
      lf.name.toLowerCase() === `${prefix}${keyFieldName}`.toLowerCase() ||
      lf.name.toLowerCase() === `exe_${keyFieldName}`.toLowerCase() ||
      lf.name.toLowerCase() === `indskr_${keyFieldName}`.toLowerCase() ||
      lf.name.toLowerCase().includes(keyFieldName.toLowerCase())
    );
    const newEntityId = lookupField?.id;
    
    const fieldNameVariations = [
      fieldName,
      `exe_${keyFieldName}_new`,
      `indskr_${keyFieldName}_new`,
      `exe_${keyFieldName}`,
      `indskr_${keyFieldName}`
    ];
    
    if (baseEntityName.includes('license')) {
      fieldNameVariations.unshift('exe_sln_new', 'indskr_sln_new', 'exe_sln', 'indskr_sln');
    }
    
    let newEntityValue = null;
    for (const variation of fieldNameVariations) {
      newEntityValue = data['formStringValue']?.[variation] || data['formValue']?.[variation];
      if (newEntityValue) break;
    }
    
    // For license, also get the state value
    let newStateValue = null;
    if (baseEntityName.includes('license') && stateFieldName) {
      const stateLookupField = data['formValue']?.lookupfields?.find((lf: any) => 
        lf.name === lookupFieldName || 
        lf.name === `exe_State_New` ||
        lf.name === `indskr_state_new` ||
        lf.name.toLowerCase().includes('state')
      );
      newStateValue = stateLookupField?.id || 
                     data['formStringValue']?.[stateFieldName] || 
                     data['formValue']?.[stateFieldName];
    }
    
    return existingLinkedEntities.some((value, index) => {
      // Skip comparison if this is the same entity being edited
      if (refData?.linkedEntityExistingDataId && value.linkedEntityExistingDataId && 
          refData.linkedEntityExistingDataId === value.linkedEntityExistingDataId) {
        return false;
      }
      
      if (value.linkedEntityExistingDataId && newEntityId && value.linkedEntityExistingDataId === newEntityId) {
        return true;
      }
      
      // For license, check BOTH SLN AND state
      if (baseEntityName.includes('license')) {
        // Get existing SLN value
        let existingSLN = null;
        if (value.linkedEntityExistingDataId) {
          existingSLN = String(value.linkedEntityExistingDataId);
        } else {
          // Try to get SLN from rawObjData
          const existingSLNFromForm = value.rawObjData?.formValue?.['exe_sln_new'] || 
                                     value.rawObjData?.formValue?.['indskr_sln_new'] ||
                                     value.rawObjData?.formStringValue?.['exe_sln_new'] ||
                                     value.rawObjData?.formStringValue?.['indskr_sln_new'];
          existingSLN = existingSLNFromForm || value.primaryText;
        }
        
        // Get existing state value - check lookupfields first, then form values
        let existingState = null;
        const existingStateLookup = value.rawObjData?.formValue?.lookupfields?.find((lf: any) => 
          lf.name === lookupFieldName || 
          lf.name === `exe_State_New` ||
          lf.name === `indskr_state_new` ||
          lf.name === `exe_State` ||
          lf.name === `indskr_state` ||
          lf.name.toLowerCase().includes('state')
        );
        existingState = existingStateLookup?.id || 
                       value.rawObjData?.formStringValue?.[stateFieldName] || 
                       value.rawObjData?.formStringValue?.['exe_state_new'] ||
                       value.rawObjData?.formStringValue?.['indskr_state_new'] ||
                       value.rawObjData?.formValue?.[stateFieldName] ||
                       value.rawObjData?.formValue?.['exe_state_new'] ||
                       value.rawObjData?.formValue?.['indskr_state_new'];
        
        // For license, BOTH SLN and state must match - no fallback to SLN-only
        if (newEntityValue && newStateValue) {
          const slnMatch = existingSLN && String(newEntityValue) === String(existingSLN);
          const stateMatch = existingState && String(newStateValue) === String(existingState);
          
          if (slnMatch && stateMatch) {
            return true;
          }
        }
        
        return false;
      }
      
      const existingDataId = value.linkedEntityExistingDataId;
      const existingLookup = value.rawObjData?.formValue?.lookupfields?.find((lf: any) => 
        lf.name === lookupFieldName || 
        lf.name === `${prefix}${capitalizedField}` ||
        lf.name === `exe_${capitalizedField}_New` ||
        lf.name === `indskr_${capitalizedField}_New` ||
        lf.name === `exe_${capitalizedField}` ||
        lf.name === `indskr_${capitalizedField}` ||
        lf.name.toLowerCase() === `${prefix}${keyFieldName}`.toLowerCase() ||
        lf.name.toLowerCase() === `exe_${keyFieldName}`.toLowerCase() ||
        lf.name.toLowerCase() === `indskr_${keyFieldName}`.toLowerCase() ||
        lf.name.toLowerCase().includes(keyFieldName.toLowerCase())
      );
      const existingEntityId = existingLookup?.id;
      
      let existingEntityValue = null;
      for (const variation of fieldNameVariations) {
        existingEntityValue = value.rawObjData?.formStringValue?.[variation] || 
                            value.rawObjData?.formValue?.[variation];
        if (existingEntityValue) break;
      }
      
      const existingPrimaryText = value.primaryText;
      const existingLookupFieldValue = value.lookupFieldActualValue;
      
      const matchById = newEntityId && (
        (existingEntityId && newEntityId === existingEntityId) ||
        (existingDataId && newEntityId === existingDataId) ||
        (existingLookupFieldValue && newEntityId === existingLookupFieldValue)
      );
      
      const matchByValue = newEntityValue && (
        (existingEntityValue && newEntityValue === existingEntityValue) ||
        (existingPrimaryText && newEntityValue === existingPrimaryText)
      );
      
      return matchById || matchByValue;
    });
  }

  private async _handleDynamicFormComponentEvent(data, eventTarget, refData: DynamicFormComponentModel) {
    if (eventTarget) {
      if (eventTarget == 'DONEBUTTONCLICK' && refData) {

        await this.uiService.displayLoader();
        if (data.customFormValue && !isEmpty(data.customFormValue) && !data.isSelectedFromSearch || this.dynamicFormsService.isSelectedDataFromAddressOneKey) {
          let { logicalCollectionName, logicalName, schemaName } = this.getAddressEntity();
          this.dynamicFormsService.okAddressMapper.custom = data['customFormValue'];
          this.dynamicFormsService.okAddressMapper.formatted = data['formStringValue'];
          if (!refData.isEditFormWithLinkedData) {
            //For contact cr, no need to create address
            if (!(refData.LookupEntitySetName == "indskr_customeraddresscrs" && refData.linkedEntityParentData.entity == "indskr_contactcrs")) {
              let res = await this.dynamicFormsService.createLinkedEntity(data['customFormValue'], logicalCollectionName);
              if (res) {
                data['formValue'].lookupfields.push({
                  entity: logicalCollectionName,
                  id: res['guid'],
                  name: schemaName,
                });
              } else {
                return;
              }
            }
          } else if (refData.isEditFormWithLinkedData && logicalName == "indskr_address") {
            if (refData.linkedEntityExistingDataAddressId) {
              data['customFormValue']['guid'] = refData.linkedEntityExistingDataAddressId;
            }
            let res = await this.dynamicFormsService.createLinkedEntity(data['customFormValue'], logicalCollectionName);
            if (res) {
              data['formValue'].lookupfields.push({
                entity: logicalCollectionName,
                id: res['guid'],
                name: schemaName,
              });
            } else {
              return;
            }
          }

          this.dynamicFormsService.isSelectedDataFromAddressOneKey = false;
          this.dynamicFormsService.isSearchedAddress = true;
        }
        if (refData.linkedEntityParentData) {
          let isValid = true;
          Promise.all([
            isValid = await this.checkValidityOfLinkedEntities(data, refData.LookupEntitySetName, refData.linkedEntityParentData.id, refData)
          ]).then(async () => {
            try {
              if(isValid) {
                // Onekey
                if (this.changeRequest && !(this.TYPE == "OMNIPRESENCE" && this.MODE == 'EDIT_MODE')) {
                  let dataReq = {
                    "entity": refData.LookupEntitySetName,
                    "values": [data['formValue']],
                    linkedEntityExistingDataAddressId: refData.linkedEntityExistingDataAddressId || '',
                    linkedEntityExistingDataId: refData.linkedEntityExistingDataId || '',
                    linkedEntityAddedNewDataId: refData.linkedEntityAddedNewDataId || '',
                    eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName)
                  }
                  this._isFormDirty = true;
                  this._isFormSaved = false;
                  this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
                  // check added linked data and store it - related to auto-populated
                  if (this._mode == "EDIT_MODE" && this.isAutoPopulatedLinkedDataFlow) {
                    let addressAttrName = this.dynamicFormsService.addressAttributeName || '';
                    let accountAffiliationAttrName = this.dynamicFormsService.accountAffiliationAttributeName || '';
                    // Add Account-Contact Affiliation in Contact CR
                    if (refData.linkedEntityParentData.entity == 'indskr_contactcrs' && refData.LookupEntitySetName == 'indskr_accountcontactaffiliationcrs') {
                      this.addedNewACAffiliation = true;
                      if (accountAffiliationAttrName && !isEmpty(this.linkedEntityValues) && !isEmpty(this.linkedEntityValues[accountAffiliationAttrName])) {
                        delete this.linkedEntityValues[accountAffiliationAttrName]; //delete previous existing account view data
                        this.mdmService.deleteLinkEntities(dataReq.entity); //delete stored data in linkEntitiesReqPayload
                      }
                      if (addressAttrName && !isEmpty(this.linkedEntityValues) && !isEmpty(this.linkedEntityValues[addressAttrName])) {
                        delete this.linkedEntityValues[addressAttrName]; //delete previous existing address view data
                        this.mdmService.deleteLinkEntities(dataReq.entity); //delete stored data in linkEntitiesReqPayload
                      }
                      // update address along with changed account if there is address linked entity field
                      if (addressAttrName) {
                        await this.autoPopulatedLinkedData('contactAddress', true, data).then(() => {
                          this.formDetail.eventsHandler(dataReq, 'ADDEDLINKEDENTITY', this.formDetail);
                        });
                      } else {
                        this.formDetail.eventsHandler(dataReq, 'ADDEDLINKEDENTITY', this.formDetail);
                      }
                    // Add address in Account CR
                    } else if (refData.linkedEntityParentData.entity == 'indskr_accountcrs' && refData.LookupEntitySetName == 'indskr_customeraddresscrs') {
                      this.addedNewAddressForAccountCR = true;
                      if (addressAttrName && !isEmpty(this.linkedEntityValues) && !isEmpty(this.linkedEntityValues[addressAttrName])) {
                        delete this.linkedEntityValues[addressAttrName]; //delete previous existing address view data
                        this.mdmService.deleteLinkEntities(dataReq.entity); //delete stored data in linkEntitiesReqPayload
                      }
                      this.isViewFromEditFormToAccordionForm = true;
                      this.dynamicFormsService.isSelectedCountry = false;
                      this.formDetail.eventsHandler(dataReq, 'ADDEDLINKEDENTITY', this.formDetail);
                    // the other linked entities flow
                    } else {
                      this.formDetail.eventsHandler(dataReq, 'ADDEDLINKEDENTITY', this.formDetail);
                    }
                  // non auto-populated data flow
                  } else {
                    this.formDetail.eventsHandler(dataReq, 'ADDEDLINKEDENTITY', this.formDetail);
                  }
                // Business
                } else {
                    if (this.formDetail && this.formDetail.eventsHandler) {
                      if (refData.linkedEntityExistingDataId) data['formValue']['guid'] = refData.linkedEntityExistingDataId;

                      let dataReq = {
                        formValue: this._currentFormValue,
                        formStringValue: this._currentFormStringValues,
                        customFormValue: this._customFormValue,
                        eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
                        displayConfirmation: this._isFormDirty,
                        linkedEntityExistingDataId: refData.linkedEntityExistingDataId || '',
                        linkedEntityAddedNewDataId: refData.linkedEntityAddedNewDataId || '',
                        "entity": refData.LookupEntitySetName,
                        "values": data['formValue'],
                        linkedEntityFormStringValue: data['formStringValue'],
                      }

                      if (refData.LookupEntitySetName == 'indskr_emailaddresscrs' && this.TYPE == 'OMNIPRESENCE' && this.MODE == 'EDIT_MODE' 
                        && this.changeRequest && this.editConfig == EditConfig.UPDATE_EXISTING) {
                        // Update primary flag - Email CR form dose not include primary flag field
                        if (data['formValue'] && !data['formValue'].hasOwnProperty('indskr_isprimary') && this.formDetail.linkedEntityValue && this.formDetail.linkedEntityValue.length > 0) { 
                          if (data['formValue']?.guid) {
                            const emailAddressId = data['formValue'].guid;
                            const foundData = this.formDetail.linkedEntityValue.find(le => le['indskr_email_address.indskr_email_addressid'] == emailAddressId);
                            if (foundData && foundData['indskr_email_address.indskr_isprimary']) {
                              data['formValue']['indskr_isprimary'] = true;
                            }
                          }
                        }
                        dataReq['values'] = [data['formValue']];
                      }

                      // OMNI-20325/27081: the original workaround deleted isprimary/isprimaryaccount when false.
                      // Email addresses have their own primary-flag handling above (lines ~3761-3773).
                      // For all other linked entities (specialty, affiliation, etc.) false is a valid value
                      // and must reach Dynamics so users can explicitly unset the primary flag.
                      this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
                      this.formDetail.eventsHandler(dataReq, 'ADDEDLINKEDENTITY', this.formDetail);
                      this._isFormDirty = true;
                    }
                }

                if (data) {
                  let foundControl: Control;
                  for (let i = 0; i < this._dynamicForm.metadata.length; i++) {
                    const tab = this._dynamicForm.metadata[i];
                    if (tab && tab.controls && tab.controls.length > 0) {
                      for (let j = 0; j < tab.controls.length; j++) {
                        const control = tab.controls[j];
                        if (!control.dataType && control.subgrid && control.subgrid.targetEntityType == refData.formMetadata.entityName) {
                          if (control.subgrid.targetEntityType == "indskr_accountaccountaffiliation") {
                            if(control.subgrid.referencingAttribute == refData.linkedEntityParentData.name) {
                              foundControl = control;
                              break;
                            }
                          } else {
                            foundControl = control;
                            break;
                          }
                        }
                      }
                      if (foundControl) {
                        break;
                      }
                    }
                  }
                  if (foundControl) {
                    try {
                      let accordionView: OmniAccordionViewDataModel;
                      let childItems: Array<any> = [];
                      let formattedPrimaryText: string = '';
                      const referencingEntity = foundControl.subgrid.referencingEntity;
                      const referencingAttribute = foundControl.subgrid.referencingAttribute;
                      const lookupData = data && data.formValue && data.formValue.lookupfields ? data.formValue.lookupfields : '';
                      const lookupFieldActualValue: string = this._getLookupFieldActualValue(lookupData, referencingEntity, referencingAttribute, false);
                      let abilityToRemoveRecords = foundControl.linkedEntityConfig && foundControl.linkedEntityConfig.abilityToRemoveRecords == '548910000';

                      //For Address Update, Display Address name as primary text
                      if (this.changeRequest && this._dynamicForm.entityName == 'indskr_contactcr' && this._dynamicForm.metadata[0].controls.some(c => c.lookupEntitySetName === "indskr_addresscrs")) {
                        // Reorder subgridLayout to put 'exe_address_new' first
                        if (foundControl.subgrid && foundControl.subgrid.subgridLayout) {
                          const addressIndex = foundControl.subgrid.subgridLayout.findIndex(attrib => {
                            const attribName = attrib.attribute.indexOf('.') !== -1
                              ? attrib.attribute.slice(attrib.attribute.indexOf('.') + 1)
                              : attrib.attribute;
                            return attribName === 'exe_address_new';
                          });
                          if (addressIndex > 0) {
                            const addressItem = foundControl.subgrid.subgridLayout.splice(addressIndex, 1)[0];
                            foundControl.subgrid.subgridLayout.unshift(addressItem);
                          }
                        }
                      }
                      foundControl.subgrid.subgridLayout.forEach(attrib => {
                        let attribName;
                        let index = attrib.attribute.indexOf('.');
                        if (index !== -1) {
                          attribName = attrib.attribute.slice(index + 1);
                        } else {
                          attribName = attrib.attribute;
                        }
                        if(attribName == 'exe_address_new') {
                          attribName = "exe_address";
                        }
                        const _fvHas = data.formValue && data.formValue.hasOwnProperty(attribName) && data.formValue[attribName] !== null && data.formValue[attribName] !== undefined;
                        if (attribName && ((data.formStringValue && data.formStringValue[attribName]) || _fvHas || (data.customFormValue && data.customFormValue[attribName]))) {
                          if (accordionView) {
                            let displayName: string = this._getDisplayText(attrib.displayNames);
                            let value = (data.formStringValue && data.formStringValue[attribName])
                              ? data.formStringValue[attribName]
                              : _fvHas
                                ? (typeof data.formValue[attribName] === 'boolean' ? (data.formValue[attribName] ? this.translate.instant('YES') : this.translate.instant('NO')) : data.formValue[attribName])
                                : data.customFormValue?.[attribName];
                            if ("exe_type" === attribName) {
                              value = value == 791060000 ? this.translate.instant('CREATE') : value == 791060001 ? this.translate.instant('UPDATE') : value == 791060002 ? this.translate.instant('REMOVE') : value;
                            }
                            childItems.push({
                              id: foundControl.attributeName + '_' + attribName,
                              label: displayName ? displayName : '',
                              value: value,
                            });
                            accordionView.showExpandIcon = true;
                            accordionView.showCollapseIcon = true;
                            accordionView.lookupFieldActualValue = lookupFieldActualValue;
                          } else {
                            accordionView = {
                              displayType: 'Accordion',
                              id: foundControl.attributeName + '_' + attribName + Math.random().toString(36).substring(7),
                              linkedEntityExistingDataId: refData.linkedEntityExistingDataId || '',
                              linkedEntityExistingDataAddressId: refData.linkedEntityExistingDataAddressId || '',
                              linkedEntityAddedNewDataId: refData.linkedEntityAddedNewDataId || '',
                              primaryText: ((data.formStringValue && data.formStringValue[attribName]) ? data.formStringValue[attribName] : (_fvHas ? (typeof data.formValue[attribName] === 'boolean' ? (data.formValue[attribName] ? this.translate.instant('YES') : this.translate.instant('NO')) : data.formValue[attribName]) : data.customFormValue?.[attribName])),
                              lookupFieldActualValue: lookupFieldActualValue,
                              showExpandIcon: false,
                              showCollapseIcon: false,
                              isExpanded: false,
                              childItems: [],
                              rawObjData: data,
                              isUpdatedFormData: true,
                              isDeactivate: false,
                              scrapFromList: abilityToRemoveRecords,
                              clickHandler: (id, event, specificTarget, dataRef) => this.handleAccordionView(event, foundControl, specificTarget, dataRef),
                              showRightIcon: false,
                              disableEditArrow: false
                            }
                            // Enable edit arrow for customer license and specialty change requests
                            if (foundControl.subgrid.referencingEntity == 'exe_customerlicensechangerequest' || foundControl.subgrid.referencingEntity == 'indskr_addresscr') {
                              accordionView.showRightIcon = true;
                              accordionView.rightIconName = 'chevron-forward-outline';
                            }
                          }
                        }
                      });
                      // set primary text value - Primary text in editable auto populated data does not have accordionView.
                      if (refData.isEditFormWithLinkedData || this.editConfig == EditConfig.BOTH || this.dynamicFormsService.isSelectedDataFromSearch) {
                        switch(foundControl.subgrid.referencingEntity) {
                          case 'indskr_email_address':
                          case 'indskr_emailaddresscr':
                            if (data.formValue && data.formValue.hasOwnProperty('indskr_emailaddress')) {
                              formattedPrimaryText = data.formValue.indskr_emailaddress;
                            }
                            break;
                          case 'indskr_indskr_customeraddress_v2':
                            if (data.formValue && data.formValue.hasOwnProperty('indskr_name')) {
                              formattedPrimaryText = data.formValue.indskr_name;
                            }
                            break;
                          case 'indskr_customerspecialty':
                            if (data.formStringValue && data.formStringValue.hasOwnProperty('indskr_specialtyid')) {
                              formattedPrimaryText = data.formStringValue.indskr_specialtyid;
                            }
                            break;
                          case 'indskr_contactrelationship':
                            if (data.formStringValue && data.formStringValue.hasOwnProperty('indskr_relatedcontactid')) {
                              formattedPrimaryText = data.formStringValue.indskr_relatedcontactid;
                            }
                            break;
                          case 'indskr_accountcontactaffiliation':
                            if (foundControl.subgrid.referencingAttribute == 'indskr_contactid') {
                              if (data.formStringValue && data.formStringValue.hasOwnProperty('indskr_accountid')) {
                                formattedPrimaryText = data.formStringValue.indskr_accountid;
                              }
                            } else if (foundControl.subgrid.referencingAttribute == 'indskr_accountid') {
                              if (data.formStringValue && data.formStringValue.hasOwnProperty('indskr_contactid')) {
                              formattedPrimaryText = data.formStringValue.indskr_contactid;
                              }
                            }
                            break;
                          case 'indskr_accountaccountaffiliation':
                            if (foundControl.subgrid.referencingAttribute == 'indskr_affiliatedtoaccountid') {
                              if (data.formStringValue && data.formStringValue.hasOwnProperty('indskr_affiliatedfromaccountid')) {
                                formattedPrimaryText = data.formStringValue.indskr_affiliatedfromaccountid;
                              }
                            } else if (foundControl.subgrid.referencingAttribute == 'indskr_affiliatedfromaccountid') {
                              if (data.formStringValue && data.formStringValue.hasOwnProperty('indskr_affiliatedtoaccountid')) {
                                formattedPrimaryText = data.formStringValue.indskr_affiliatedtoaccountid || '';
                              }
                            }
                            break;
                          case 'indskr_customerposition':
                            if (data.formStringValue && data.formStringValue.hasOwnProperty('indskr_customerposition')) {
                              formattedPrimaryText = data.formStringValue.indskr_customerposition;
                            }
                            break;
                          case 'indskr_accountcontactaffiliationcr':
                            if (foundControl.subgrid.referencingAttribute == 'indskr_contactcr') {
                              if (data.formStringValue && data.formStringValue.hasOwnProperty('indskr_accountid')) {
                                formattedPrimaryText = data.formStringValue.indskr_accountid;
                              }
                            } else if (foundControl.subgrid.referencingAttribute == 'indskr_accountcr') {
                              if (data.formStringValue && data.formStringValue.hasOwnProperty('indskr_contactid')) {
                              formattedPrimaryText = data.formStringValue.indskr_contactid;
                              }
                            }
                            break;
                          default:
                            formattedPrimaryText = '';
                            break;
                        }
                      }
                      if (this.dynamicFormsService.isSelectedDataFromSearch && !accordionView && formattedPrimaryText) {
                        accordionView = {
                          displayType: 'Accordion',
                          id: foundControl.attributeName + '_' + foundControl.subgrid.referencingEntity + Math.random().toString(36).substring(7),
                          linkedEntityExistingDataId: refData.linkedEntityExistingDataId || '',
                          linkedEntityExistingDataAddressId: refData.linkedEntityExistingDataAddressId || '',
                          linkedEntityAddedNewDataId: refData.linkedEntityAddedNewDataId || '',
                          primaryText: formattedPrimaryText,
                          showExpandIcon: false,
                          showCollapseIcon: false,
                          isExpanded: false,
                          childItems: [],
                          rawObjData: data,
                          isUpdatedFormData: true,
                          isDeactivate: false,
                          scrapFromList: abilityToRemoveRecords,
                          clickHandler: (id, event, specificTarget, dataRef) => this.handleAccordionView(event, foundControl, specificTarget, dataRef),
                          showRightIcon: false,
                          disableEditArrow: false
                        }
                        if (foundControl.subgrid.referencingEntity == 'exe_customerlicensechangerequest') {
                          accordionView.showRightIcon = true;
                          accordionView.rightIconName = 'chevron-forward-outline';
                        }
                      }
                      if (accordionView) {
                        if (formattedPrimaryText && this.editConfig !=EditConfig.ADD_NEW) accordionView.primaryText = formattedPrimaryText;
                        accordionView.childItems = childItems;
                        if (foundControl.subgrid.referencingEntity == 'exe_customerlicensechangerequest' && !accordionView.showRightIcon) {
                          accordionView.showRightIcon = true;
                          accordionView.rightIconName = 'chevron-forward-outline';
                        }
                        if (this.linkedEntityValues && this.linkedEntityValues[foundControl.attributeName]) {
                          if (refData.linkedEntityExistingDataId) {
                            let index = this.linkedEntityValues[foundControl.attributeName].findIndex(x => x.linkedEntityExistingDataId == refData.linkedEntityExistingDataId);
                            if (index != -1) {
                              this.linkedEntityValues[foundControl.attributeName][index] = accordionView;
                            } else {
                              this.linkedEntityValues[foundControl.attributeName].push(accordionView);
                            }
                          } else if (refData.linkedEntityExistingDataAddressId) {
                            let index = this.linkedEntityValues[foundControl.attributeName].findIndex(x => x.linkedEntityExistingDataAddressId == refData.linkedEntityExistingDataAddressId);
                            if (index != -1) {
                              this.linkedEntityValues[foundControl.attributeName][index] = accordionView;
                            } else {
                              this.linkedEntityValues[foundControl.attributeName].push(accordionView);
                            }
                          } else {
                            let index = this.linkedEntityValues[foundControl.attributeName].findIndex(x => x.linkedEntityAddedNewDataId == refData.linkedEntityAddedNewDataId);
                            if (index != -1) {
                              this.linkedEntityValues[foundControl.attributeName][index] = accordionView;
                            } else {
                              this.linkedEntityValues[foundControl.attributeName].push(accordionView);
                            }
                          }
                        } else if (this.linkedEntityValues) {
                          this.linkedEntityValues[foundControl.attributeName] = [accordionView];
                        } else {
                          this.linkedEntityValues = {
                            [foundControl.attributeName]: [accordionView]
                          };
                          this.linkedEntityValues[foundControl.attributeName] = this.linkedEntityValues[foundControl.attributeName].filter(x=>x.isDeactivate == false);
                        }
                        this._initViewData();
                      }
                      this.uiService.dismissLoader();
                    } catch (error) {
                      this.uiService.dismissLoader();
                      console.log(error);
                    }
                  }
                } else {
                  await this.uiService.dismissLoader();
                  this._closepage();
                  return;
                }
              } else {
              }
              this._closepage();
            } catch (error) {
              if (error.error.errorCode == 'ERR_IO_500') {
                this.notificationService.notify('Duplicate Detected: This ' + refData.title + ' has already been added', 'DynamicFormComponent', 'top', ToastStyle.INFO, 3000);
              }
  
              await this.uiService.dismissLoader();
            }
          })
        }
        await this.uiService.dismissLoader();

      } else if (eventTarget == 'CANCELBUTTONCLICK') {
        if (this.dynamicFormsService.linkedEntityFormIsDirtyTracker) {
          let cancelText = this.translate.instant("CANCEL");
          if(this.translate.currentLang == 'it') {
            cancelText = this.translate.instant("CANCEL_BUTTON_DISCARD_CHANGE");
          }
          this.alertService.showAlert({
            title: this.translate.instant('DISCARD_CHANGES'),
            message: this.translate.instant('CONTACT_R_U_WANT_CANCEL_LOSE_CHANGES')
          }, this.translate.instant('DISCARD'), cancelText
          ).then(res => {
            if (res.role == 'ok') {
              //clear onekey code lookup data
              const currentMetaData = refData.formMetadata.metadata;
              for (let tabIdx = 0; tabIdx < currentMetaData.length; tabIdx++) {
                const tab = currentMetaData[tabIdx];
                if (tab && tab.controls && tab.controls.length > 0) {
                  const foundControl = tab.controls.find(c => c.dataType == ControlDataType.LookupType && c.lookupEntityPrimaryId == "omnione_onekeycodeslabelsid");
                  if (foundControl) {
                    const schemaName = foundControl.schemaName || '';
                    if (data && data.formValue.hasOwnProperty('lookupfields')) {
                      const idx = data.formValue['lookupfields'].findIndex(a => a.name == schemaName);
                      if (idx >= 0) {
                        const prevGuid = data.formValue['lookupfields'][idx].id || '';
                        if(prevGuid && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.clearMappedLookupOnekeyWithId(prevGuid);
                      }
                    }
                  }
                }
              }
              this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
              this._closepage();
            }
          });
        } else {
          //clear onekey code lookup data
          const currentMetaData = refData.formMetadata.metadata;
          for (let tabIdx = 0; tabIdx < currentMetaData.length; tabIdx++) {
            const tab = currentMetaData[tabIdx];
            if (tab && tab.controls && tab.controls.length > 0) {
              const foundControl = tab.controls.find(c => c.dataType == ControlDataType.LookupType && c.lookupEntityPrimaryId == "omnione_onekeycodeslabelsid");
              if (foundControl) {
                const schemaName = foundControl.schemaName || '';
                if (data && data.formValue.hasOwnProperty('lookupfields')) {
                  const idx = data.formValue['lookupfields'].findIndex(a => a.name == schemaName);
                  if (idx >= 0) {
                    const prevGuid = data.formValue['lookupfields'][idx].id || '';
                    if(prevGuid && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.clearMappedLookupOnekeyWithId(prevGuid);
                  }
                }
              }
            }
          }
          this._closepage();
        }
      } else if(eventTarget == 'SCARPBUTTONCLICK') {
        let foundControl: Control;
        for (let i = 0; i < this._dynamicForm.metadata.length; i++) {
          const tab = this._dynamicForm.metadata[i];
          if (tab && tab.controls && tab.controls.length > 0) {
            for (let j = 0; j < tab.controls.length; j++) {
              const control = tab.controls[j];
              if (!control.dataType && control.subgrid && control.subgrid.targetEntityType == refData.formMetadata.entityName) {
                if (control.subgrid.targetEntityType == "indskr_accountaccountaffiliation") {
                  if(control.subgrid.referencingAttribute == refData.linkedEntityParentData.name) {
                    foundControl = control;
                    break;
                  }
                } else {
                  foundControl = control;
                  break;
                }
              }
            }
            if (foundControl) {
              break;
            }
          }
        }
        // check the min number of linked entity before scrap the data
        let isValidMinNumber: boolean = true;
        if (foundControl.linkedEntityConfig && foundControl.linkedEntityConfig.minNumber) {
          if (this.linkedEntityValues && this.linkedEntityValues[foundControl.attributeName]) {
            isValidMinNumber = this.linkedEntityValues[foundControl.attributeName].length <= foundControl.linkedEntityConfig.minNumber ? false : true;
          }
        }
        if (isValidMinNumber) {
          let foundlinkedEntityName = this.getDisplayEntityNameInScrapMessage(foundControl);
          this.alertService.showAlert({
            title: this.translate.instant('LINKED_ENTITY_SCRAP', {linkedEntityName: foundlinkedEntityName}),
            message: this.translate.instant('LINKED_ENTITY_R_U_WANT_SCRAP', {linkedEntityName: foundlinkedEntityName})
          }, this.translate.instant('SCRAP')
          ).then(res => {
            if (res.role == 'ok') {
              let index;
              if(refData.LookupEntitySetName == 'indskr_setbookingproducts' && refData.linkedEntityAddedNewDataId) {
                index = this.linkedEntityValues[refData.targetControlAttribName].findIndex(x => x.linkedEntityAddedNewDataId == refData.linkedEntityAddedNewDataId);
              } else {
                index = this.linkedEntityValues[refData.targetControlAttribName].findIndex(x => x.linkedEntityExistingDataId == refData.linkedEntityExistingDataId);
              }
              if (index != -1) {
                this.linkedEntityValues[refData.targetControlAttribName][index].isDeactivate = true;
              }
              if (data['formValue']) {
                let tempFormValue = data['formValue'].lookupfields[0];
                delete data['formValue'];
                data['formValue'] = { lookupfields: [tempFormValue] };
              }
              if (refData.linkedEntityExistingDataId) {
                data['formValue'] = { ...data['formValue'],
                  guid: refData.linkedEntityExistingDataId,
                  statecode: 1,
                  statuscode: 2
                };
              } else if(refData.LookupEntitySetName == 'indskr_setbookingproducts' && refData.linkedEntityAddedNewDataId) {
                data['formValue'] = { ...data['formValue'],
                  guid: refData.linkedEntityAddedNewDataId,
                  statecode: 1,
                  statuscode: 2
                };
              }
              this.linkedEntityValues[refData.targetControlAttribName] = this.linkedEntityValues[refData.targetControlAttribName].filter(x=>x.isDeactivate != true);
              if (this.formDetail && this.formDetail.eventsHandler) {
                let dataReq = {
                  eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName),
                  displayConfirmation: this._isFormDirty,
                  linkedEntityExistingDataId: refData.linkedEntityExistingDataId || '',
                  linkedEntityAddedNewDataId: refData.linkedEntityAddedNewDataId || '',
                  "entity": refData.LookupEntitySetName,
                  "values": data['formValue'],
                }
                this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
                this.formDetail.eventsHandler(dataReq, 'SCRAPLINKEDENTITY', this.formDetail);
                this._isFormDirty = true;
              }
              this._initViewData();
              this._closepage();
            }
          });
        } else {
          let formEntityName = this.formDetail.formMetadata.entityName;
          formEntityName = formEntityName == 'indskr_setbooking' ? this.translate.instant('KIT_BOOKING') : formEntityName;
          this.notificationService.notify(this.translate.instant('LINKED_ENTITY_SCRAP_ERROR_MESSAGE', {entityName: formEntityName}), 'DynamicFormComponent', 'top', ToastStyle.DANGER, 3000);
          this._closepage();
        }
      }
    }
  }

  // private _handleLinkedEntityExpandClick(id,event,eventName,refData:MainCardViewDataModel){

  private _handleFormFieldEvent(id, event, eventName, dataRef?) {
    let targetControl: Control = this._getTargetControl(id);
    if (targetControl) {
      switch (targetControl.dataType) {
        case ControlDataType.MoneyType:
        case ControlDataType.DecimalType:
        case ControlDataType.DoubleType:
        case ControlDataType.IntegerType:
        case ControlDataType.StringType:
        case ControlDataType.MemoType:
          this._handleInlineInputFormField(id, event, eventName, targetControl);
          this._isClicked[targetControl.attributeName] = true;
          break;
        case ControlDataType.LookupType:
          if ((targetControl.lookupEntityPrimaryId == 'accountid' && targetControl.attributeName != 'indskr_surgeonaccountzsur' && targetControl.attributeName != 'indskr_phmcaccount') || targetControl.lookupEntityPrimaryId == 'contactid' || targetControl.lookupEntityPrimaryId == 'productid') {
            this._handleNewPageSelectFieldLookup(targetControl);
          } else if (targetControl.viewType && targetControl.viewType == ViewType.LISTVIEW_UI && targetControl.attributeName != 'indskr_surgeonaccountzsur' && targetControl.attributeName != 'indskr_phmcaccount') {
            this._handleNewPageSelectFieldLookup(targetControl);
          } else {
            this._displayLookupSearchPopover(id, event, eventName, targetControl);
          }
          this._isClicked[targetControl.attributeName] = true;
          break;
        case ControlDataType.BooleanType:
          this._handleBooleanFormField(id, event, eventName, targetControl);
          this._isClicked[targetControl.attributeName] = true;
          break;
        case ControlDataType.PicklistType:
          this._handleDropdownListFormField(id, event, eventName, targetControl);
          this._isClicked[targetControl.attributeName] = true;
          break;
        case ControlDataType.DateTimeType:
          if (targetControl.attributeName != 'indskr_enddate') {
            this.openStartDatePicker(id, event, eventName, targetControl);
            this._isClicked[targetControl.attributeName] = true;
          } else if (targetControl.attributeName == 'indskr_enddate') {
            this.openEndDatePicker(id, event, eventName, targetControl);
            this._isClicked[targetControl.attributeName] = true;
          }
          break;
        case ControlDataType.MultiSelectPicklistType:
          this._handleDropdownMultiSelectListFormField(id, event, eventName, targetControl);
          this._isClicked[targetControl.attributeName] = true;
          break;
      }
    }

  }
  // handler for address edit form - Account CR
  private _handleEditAddressFormFieldEvent(id, event, eventName) {
    let targetControl: Control;
    for (let tabIdx = 0; tabIdx < this._dynamicFormForAddressEdit.metadata.length; tabIdx++) {
      const tab = this._dynamicFormForAddressEdit.metadata[tabIdx];
      if (tab && tab.controls && tab.controls.length > 0) {
        let foundControl = tab.controls.find(c => c.attributeName == id);
        if (foundControl) {
          targetControl = foundControl;
          break;
        }
      }
    };
    // address edit form has type of _handleInlineInputFormField and _displayLookupSearchPopover. if the address form is changed, it should be updated.
    if (targetControl) {
      this.isHandleEditAddressFormField = true;
      switch (targetControl.dataType) {
        case ControlDataType.MoneyType:
        case ControlDataType.DecimalType:
        case ControlDataType.DoubleType:
        case ControlDataType.IntegerType:
        case ControlDataType.StringType:
        case ControlDataType.MemoType:
          this._handleInlineInputFormField(id, event, eventName, targetControl);
          break;
        case ControlDataType.LookupType:
          this._displayLookupSearchPopover(id, event, eventName, targetControl);
          break;
        case ControlDataType.BooleanType:
          break;
        case ControlDataType.PicklistType:
          break;
        case ControlDataType.DateTimeType:
          break;
        case ControlDataType.MultiSelectPicklistType:
          break;
      }
    }

  }

  private _handleInlineInputFormField(id, event, eventName, control: Control) {
    if (eventName == 'input_value_confirm' && control) {
      let value;
      if (event.value) {
        value = event.value;
      } else if (event.target) {
        value = event.target.value;
      }
      if (control.dataType == ControlDataType.IntegerType) {
        value = parseInt(value);
      } else if (control.dataType == ControlDataType.MoneyType || control.dataType == ControlDataType.DoubleType || control.dataType == ControlDataType.DecimalType) {
        value = roundToPrecision(parseFloat(value), control.precision);
      }
      if (!this.isHandleEditAddressFormField) {
        this._setAttributeValue(control, value, false);
      } else this._setExistingAttributeValue(control, value);
    }
    this.isHandleEditAddressFormField = false;
  }

  /**
   * Returns the selected contact id from the current form value (lookupfields for contact lookup), or null if none.
   */
  private _getSelectedContactIdFromForm(): string | null {
    const formValue = this._currentFormValue || this._customFormValue;
    if (!formValue?.lookupfields?.length) return null;
    if (!this._dynamicForm?.metadata?.length) return null;
    let contactAttributeName: string | null = null;
    for (const tab of this._dynamicForm.metadata) {
      if (!tab.controls?.length) continue;
      const contactControl = tab.controls.find(
        (c: Control) => c.lookupEntityPrimaryId === 'contactid' || c.attributeName === 'indskr_contact'
      );
      if (contactControl) {
        contactAttributeName = contactControl.attributeName || contactControl.schemaName;
        break;
      }
    }
    if (!contactAttributeName) return null;
    const entry = formValue.lookupfields.find(
      (lf: any) => (lf.name === contactAttributeName || lf.name === 'indskr_Contact') && !lf.isDeleted
    );
    return entry?.id ?? null;
  }

  /**
   * For medical inquiry form: when contact has exactly one address, auto-populate the address field.
   */
  private async _autoPopulateAddressIfSingle(contactId: string, addressControl: Control): Promise<void> {
    const localAddresses = await this.contactService.getAddressesForContactFromLocal(contactId);
    if (localAddresses.length === 1 && addressControl) {
      this._setAttributeStringValue(addressControl.attributeName, localAddresses[0].compositeAdd);
      this._setAttributeValue(addressControl, localAddresses[0].addressId, false);
      this._initViewData();
    }
  }

  private async _displayLookupSearchPopover(id, event, eventName, targetControl: Control) {
    this._initLookupSearchList(targetControl);

    const isAddressLookup =
      targetControl.attributeName === 'indskr_address' ||
      targetControl.lookupEntityPrimaryId === 'indskr_addressid';
    if (this.formDetail?.loadAddressFromLocal && isAddressLookup) {
      const contactId = this._getSelectedContactIdFromForm();
      if (!contactId) {
        this.notificationService.notify(
          this.translate.instant('SELECT_CONTACT_FIRST') || 'Select a contact first',
          'DynamicFormComponent',
          'top',
          ToastStyle.INFO,
          3000
        );
        return;
      }
      const localAddresses = await this.contactService.getAddressesForContactFromLocal(contactId);
      if (!localAddresses.length) {
        this.notificationService.notify(
          this.translate.instant('NO_ADDRESSES_FOR_CONTACT') || 'No addresses found for this contact',
          'DynamicFormComponent',
          'top',
          ToastStyle.INFO,
          3000
        );
        return;
      }
      const addressControl = targetControl;
      this._activeLookupSearchControl = addressControl;
      const selectedAddressId = this._getAttributeValue(addressControl.attributeName) || '';
      const popover = await this.popoverCtrl.create({
        component: PopoverComponent,
        componentProps: {
          field: 'mi-local-address',
          samplingAddressList: localAddresses,
          selectedAddressId,
        },
        event,
      });
      popover.onDidDismiss().then(async (dismissData: any) => {
        const data = dismissData?.data;
        this._activeLookupSearchControl = undefined;
        if (data?.contactAddress && addressControl) {
          this._setAttributeStringValue(addressControl.attributeName, data.contactAddress.compositeAdd);
          this._setAttributeValue(addressControl, data.contactAddress.addressId, false);
          this._initViewData();
        }
      });
      await popover.present();
      return;
    }

    const comparisonValue = !this.isHandleEditAddressFormField ? (targetControl.isCustom ? this._customFormValue : this._currentFormValue) : (targetControl.isCustom ? this._existingCustomFormValue : this._existingFormValue);
    const objName = targetControl.isCustom ? targetControl.schemaName : (targetControl.isCustomAttribute ? targetControl.schemaName : targetControl.attributeName);
    let selectedValue = '';
    if (comparisonValue && comparisonValue.hasOwnProperty('lookupfields')) {
      let idx = comparisonValue['lookupfields'].findIndex(a => a.name == objName && !(a['isDeleted'] && a['isDeleted'] === true));
      if (idx >= 0) {
        selectedValue = comparisonValue['lookupfields'][idx].id;
      }
    }
    let labelText: string = this._getDisplayText(targetControl.displayNames, targetControl.isCustom);
    let filter;
    if (targetControl.dependsOn) {
      if (!this.isHandleEditAddressFormField) {
        if (this._customFormValue && this._customFormValue.hasOwnProperty('lookupfields')) {
          filter = this._customFormValue['lookupfields'].find(x => x.name == targetControl.dependsOn).id || '';
        }
      } else {
        if (this._existingCustomFormValue && this._existingCustomFormValue.hasOwnProperty('lookupfields')) {
          filter = this._existingCustomFormValue['lookupfields'].find(x => x.name == targetControl.dependsOn).id || '';
        }
      }
      if (this.changeRequest && targetControl.lookupEntityPrimaryId == "indskr_lu_districtid") {
        filter = this._stateIdBasedOnCity ? this._stateIdBasedOnCity : '';
      }
    }
    if (this.changeRequest && targetControl.lookupEntityPrimaryId == 'indskr_lu_cityid') {
      let idx;
      if (!this.isHandleEditAddressFormField) {
        if (this._customFormValue && this._customFormValue.hasOwnProperty('lookupfields')) {
          idx = this._customFormValue['lookupfields'].findIndex(a => a.name == "indskr_Country_LU");
          if (idx == -1) this.dynamicFormsService.hasCityDataBasedOnCountry = false;
        } else this.dynamicFormsService.hasCityDataBasedOnCountry = false;
      } else {
        if (this._existingCustomFormValue && this._existingCustomFormValue.hasOwnProperty('lookupfields')) {
          idx = this._existingCustomFormValue['lookupfields'].findIndex(a => a.name == "indskr_Country_LU");
          if (idx == -1) this.dynamicFormsService.hasCityDataBasedOnCountry = false;
        } else this.dynamicFormsService.hasCityDataBasedOnCountry = false;
      }
    }
    if(targetControl.dataType == ControlDataType.LookupType && targetControl.filterby && targetControl.filterFieldTargetLookupEntity){
      let selectedFilterBy;
      if (this._currentFormValue && this._currentFormValue.hasOwnProperty('lookupfields')) {
        let idx = this._currentFormValue['lookupfields'].findIndex(a => a.name?.toLowerCase() === targetControl.filterby?.toLowerCase() && !(a['isDeleted'] && a['isDeleted'] === true));
        if (idx >= 0) {
          selectedFilterBy = this._currentFormValue['lookupfields'][idx].id;
        }
      }
      // else if(this._currentFormValue){
      // MI: for existing records the product may not be in lookupfields yet; fall back to formEntityObject
      if (!selectedFilterBy &&
          this.formDetail?.formMetadata?.entityName === 'indskr_medicalinquiry' &&
          targetControl.attributeName === 'omp_topic') {
        selectedFilterBy = this.formDetail?.formEntityObject?.['_omp_product_value'] as string;
      }
      if(selectedFilterBy){
        filter = `<filter type="and">
        <condition attribute="${targetControl.filterFieldTargetLookupEntity}" operator="eq" value="${selectedFilterBy}"/>
        </filter>`
      }
    }

    let popoverListDetail: IndDynamicFormLookupListDetailModel = {
      id: 'lookup_search_popover',
      title: labelText,
      targetControl: targetControl,
      searchFilter: filter,
      isSearchEnabled: true,
      selectedValue: selectedValue,
      searchInputPlaceholder: this.translate.instant('SEARCH'),
      showUnselectOption: true,
      unselectOptionText: this.translate.instant('SELECT'),
      isOneKeyChangeRequest: this.changeRequest,
      callbackEvent: (data: any) => this._handleLookupComponentCallback(data),
    };
    let cssClassName = 'lookup-popover-list-view';
    if (this.device.isNativeApp) {
      cssClassName = 'native-lookup-popover-list-view';
    }
    this._lookupPopover = await this.popoverCtrl.create({
      component: DynamicFormLookupPopoverComponent,
      componentProps: { viewData: popoverListDetail },
      cssClass: cssClassName,
      backdropDismiss: true,
    });
    this._activeLookupSearchControl = targetControl;
    this._lookupPopover.onDidDismiss().then(async (data) => {
      if(targetControl.isRequired && this.dynamicFormsService.getFormFieldType(targetControl) !== FormFieldType.INLINE_INPUT){
        const comparisonValue = !this.isHandleEditAddressFormField ? (targetControl.isCustom ? this._customFormValue : this._currentFormValue) : (targetControl.isCustom ? this._existingCustomFormValue : this._existingFormValue);
        const objName = targetControl.isCustom ? targetControl.schemaName : (targetControl.isCustomAttribute ? targetControl.schemaName : targetControl.attributeName);
        let newSelectedValue = '';
        if (comparisonValue && comparisonValue.hasOwnProperty('lookupfields')) {
          let idx = comparisonValue['lookupfields'].findIndex(a => a.name == objName);
          if (idx >= 0) {
            newSelectedValue = comparisonValue['lookupfields'][idx].id;
          }
        }
        this._validateMandatoryField(id,null,{value: newSelectedValue},false);
      }
      this._lookupPopover = undefined;
      this._activeLookupSearchControl = undefined;
      this.dynamicFormsService.lookupSearchData = [];
      this.dynamicFormsService.lookupSearchInProgress = false;
    });
    // On native iOS/Android (WKWebView/Cordova), the synthesized click from the opening tap
    // can hit the backdrop immediately after it appears, causing instant dismissal.
    // A short delay lets the ghost tap fire on the underlying element before the popover renders.
    if (this.device.isNativeApp && !this.device.deviceFlags.electron) {
      await new Promise<void>(resolve => setTimeout(resolve, 100));
    }
    this._lookupPopover.present();
  }

  private async _handleLookupComponentCallback(data) {
    if (data && data.selectedItem && this._activeLookupSearchControl) {
      const activeLookupSearchControl = this._activeLookupSearchControl;
      const comparisonValue = !this.isHandleEditAddressFormField ? (this._activeLookupSearchControl.isCustom ? this._customFormValue : this._currentFormValue) : (this._activeLookupSearchControl.isCustom ? this._existingCustomFormValue : this._existingFormValue);
      const objName = this._activeLookupSearchControl.isCustom ? this._activeLookupSearchControl.schemaName : (this._activeLookupSearchControl.isCustomAttribute ? this._activeLookupSearchControl.schemaName : this._activeLookupSearchControl.attributeName);
      const schemaName = this._activeLookupSearchControl.isCustomAttribute ? this._activeLookupSearchControl.schemaName : this._activeLookupSearchControl.attributeName;

      // The synthetic 'Other' option is not a real record. Clear the lookup, show
      // 'Other' as its display value, and reveal the control's free-text field.
      if ((data.selectedItem.isOtherOption || data.selectedItem.id === OTHER_LOOKUP_OPTION_ID)
        && this._activeLookupSearchControl.otherOptionField) {
        this._clearAttributeValue(this._activeLookupSearchControl);
        // Drop any real record the lookup was holding so 'Other' is not submitted
        // alongside a stale id.
        if (this._currentFormValue && Array.isArray(this._currentFormValue['lookupfields'])) {
          const idx = this._currentFormValue['lookupfields'].findIndex(a => a.name === objName);
          if (idx >= 0) {
            this._currentFormValue['lookupfields'].splice(idx, 1);
          }
        }
        this._setAttributeStringValue(this._activeLookupSearchControl.attributeName, data.selectedItem.name);
        this._toggleOtherOptionField(this._activeLookupSearchControl, true);
        await this._initViewData();
        this._activeLookupSearchControl = undefined;
        this.isHandleEditAddressFormField = false;
        return;
      }

      let codIdOnekey: string = data && data.selectedItem && data.selectedItem.codIdOnekey ? data.selectedItem.codIdOnekey || '' : '';
      if(schemaName == 'indskr_district') codIdOnekey = data && data.selectedItem && data.selectedItem.countyCode ? data.selectedItem.countyCode || '' : '';
      let selectedValue = '';
      let isDuplicateData: boolean = false;
      if (comparisonValue && comparisonValue.hasOwnProperty('lookupfields')) {
        let idx = comparisonValue['lookupfields'].findIndex(a => a.name == objName && !(a['isDeleted'] && a['isDeleted'] == true));
        if (idx >= 0) {
          selectedValue = comparisonValue['lookupfields'][idx].id;
        }
      }
      if (!(comparisonValue && selectedValue == data.selectedItem.id)) {
        // Keeping this clearing dependOn control part for custom control only for now but can be extended to all controls once dependsOn is implemented for configured controls
        if (this._activeLookupSearchControl.isCustom) {
          if (!this.isHandleEditAddressFormField) {
            this._clearAttributeValue(this._activeLookupSearchControl);
          } else this._clearEditAddressFormAttributeValue(this._activeLookupSearchControl);
        }
        //If the filterby field is reset, then clear the lookup fields depending on it
        if (this._currentFormValue && this._currentFormValue['lookupfields']) {
          this._currentFormValue['lookupfields'].forEach(lookup => {
            if(!(lookup['isDeleted'] && lookup['isDeleted']==true)){
              let lookupControl: Control = this._getTargetControl(lookup.name);
              if(!lookupControl)
                lookupControl = this._getTargetControlbySchemaName(lookup.name);
              if(lookupControl && lookupControl.filterby && lookupControl.filterby.toLowerCase() == objName.toLowerCase()){
                this._clearAttributeValue(lookupControl);
              }
            }
          });
        }

        // When contact changes and form loads address from local, clear address so user picks from the new contact's addresses
        const isContactControl = this._activeLookupSearchControl.lookupEntityPrimaryId === 'contactid' ||
          this._activeLookupSearchControl.attributeName === 'indskr_contact';
        if (isContactControl && this.formDetail?.loadAddressFromLocal) {
          let addressControl = this._getTargetControl('indskr_address');
          if (!addressControl && this._dynamicForm?.metadata) {
            for (const tab of this._dynamicForm.metadata) {
              if (!tab.controls?.length) continue;
              const found = tab.controls.find(
                (c: Control) => c.attributeName === 'indskr_address' || c.lookupEntityPrimaryId === 'indskr_addressid'
              );
              if (found) {
                addressControl = found;
                break;
              }
            }
          }
          if (addressControl) {
            this._clearAttributeValue(addressControl);
            // Medical inquiry only: auto-populate address when contact has exactly one address
            if (this.formDetail?.formMetadata?.entityName === 'indskr_medicalinquiry') {
              void this._autoPopulateAddressIfSingle(data.selectedItem.id, addressControl);
            }
          }
        }

        if (isContactControl) {
          this._runConfiguredFieldRules('indskr_contact', data.selectedItem.id);
        }

        if (this.dynamicFormsService.storedLinkedEntityValues.length == 0) {
          if (!this.isHandleEditAddressFormField) {
            this._setAttributeStringValue(this._activeLookupSearchControl.attributeName, data.selectedItem.name);
            if (this.changeRequest && this.EDIT_FLOW == "change_request_category_flow" && this._activeLookupSearchControl.lookupEntityPrimaryId == "indskr_addressid") {
            this._setAttributeValue(this._activeLookupSearchControl, data.selectedItem['indskr_addressid'], false, codIdOnekey, true, data.selectedItem.otherFieldsToInclude);
              //Set Old field values and add new fields to the form
              this._dynamicForm.metadata.forEach(metaData => {
                metaData.controls.forEach(control => {
                  if (control.attributeName && data.selectedItem) {
                    // First check for exact match (for regular fields)
                    if (data.selectedItem.hasOwnProperty(control.attributeName)) {
                      // Handle regular fields (StringType, IntegerType, etc.)
                      if (control.dataType !== ControlDataType.LookupType) {
                        const value = data.selectedItem[control.attributeName];
                        if (value !== null && value !== undefined) {
                          this._setAttributeValue(control, value, false);
                        }
                      }
                    }
                    // Check if any key in data.selectedItem contains control.attributeName
                    else {
                      // Get the mapped attribute name (e.g., 'indskr_address.indskr_line1')
                      const mappedAttributeName = this.getCustomerAddressCRAttributeName(control.attributeName);
                      // Extract the part after the dot if present, otherwise use the mapped name or original attributeName
                      let searchKey = control.attributeName;
                      if (mappedAttributeName) {
                        // If mapped name contains a dot, extract the part after the dot
                        const dotIndex = mappedAttributeName.indexOf('.');
                        searchKey = dotIndex >= 0 ? mappedAttributeName.substring(dotIndex + 1) : mappedAttributeName;
                      }
                      
                      // Find keys that contain the searchKey (e.g., 'indskr_line1' from 'indskr_address.indskr_line1')
                      const matchingKeys = Object.keys(data.selectedItem).filter(key =>
                        key.includes(searchKey)
                      );

                      if (matchingKeys.length > 0) {
                        // Handle lookup fields
                        if (control.dataType === ControlDataType.LookupType) {
                          // Look for the lookup value key (format: _attributeName_value)
                          const lookupValueKeyPattern = '_' + searchKey + '_value';
                          const lookupValueKey = matchingKeys.find(key =>
                            key === lookupValueKeyPattern ||
                            (key.startsWith(lookupValueKeyPattern) && !key.includes('@') && !key.endsWith('_Formatted'))
                          );

                          // Look for the formatted value key (multiple possible formats)
                          const lookupFormattedKey = matchingKeys.find(key =>
                            key === lookupValueKeyPattern + '@OData.Community.Display.V1.FormattedValue' ||
                            key === lookupValueKeyPattern + '_Formatted' ||
                            key.includes(lookupValueKeyPattern + '@OData.Community.Display.V1.FormattedValue') ||
                            key.includes(lookupValueKeyPattern + '_Formatted')
                          );

                          if (lookupValueKey && data.selectedItem[lookupValueKey]) {
                            const lookupValue = data.selectedItem[lookupValueKey];
                            const formattedValue = lookupFormattedKey ? (data.selectedItem[lookupFormattedKey] || '') : '';

                            if (lookupValue) {
                              this._setAttributeValue(control, lookupValue, false, '', true, data.selectedItem.otherFieldsToInclude);
                              if (formattedValue) {
                                this._setAttributeStringValue(control.attributeName, formattedValue);
                              }
                            }
                          }
                        }
                        // Handle regular fields where key contains searchKey (e.g., 'indskr_line1')
                        else {
                          // Try to find the exact searchKey match first, or a key that starts with searchKey
                          const exactKey = matchingKeys.find(key => key === searchKey);
                          const valueKey = exactKey || matchingKeys.find(key =>
                            key.startsWith(searchKey) &&
                            !key.includes('_value') &&
                            !key.includes('@OData')
                          );

                          if (valueKey && data.selectedItem[valueKey] !== null && data.selectedItem[valueKey] !== undefined) {
                            this._setAttributeValue(control, data.selectedItem[valueKey], false);
                          }
                        }
                      }
                    }
                    
                  }
                });
              });
            } else {
              this._setAttributeValue(this._activeLookupSearchControl, data.selectedItem.id, false, codIdOnekey, true, data.selectedItem.otherFieldsToInclude, data.selectedItem);
            }
            if (Array.isArray(data.afterActions)) {
              for (const afterAction of data.afterActions) {
                if (afterAction.action === 'CLEAR' && afterAction.targetFieldName) {
                  this._clearField(afterAction.targetFieldName);
                }
              }
            }
            await this._initViewData();
            if (
              this.formDetail?.formMetadata?.entityName === 'indskr_medicalinquiry' &&
              this._activeLookupSearchControl?.attributeName === 'omp_product' &&
              data.selectedItem?.id
            ) {
              await this._handleMITopicAutoSelect(data.selectedItem.id);
            }
          } else {
            this._setExistingAttributeStringValue(this._activeLookupSearchControl.attributeName, data.selectedItem.name);
            this._setExistingAttributeValue(this._activeLookupSearchControl, data.selectedItem.id, codIdOnekey);
          }
          if (this.EDIT_FLOW !== "change_request_category_flow") {
            // Auto-populated Country and State based on the selected City
            if (this.changeRequest && activeLookupSearchControl.lookupEntityPrimaryId == 'indskr_lu_cityid') {
              this._setAddressWithSelectedCity(data.selectedItem);
              await this._initViewData();
              // To store city data based on selected country id when Country is selected
            } else if (this.changeRequest && activeLookupSearchControl.lookupEntityPrimaryId == 'indskr_lu_countryid') {
              let targetControl: Control = activeLookupSearchControl;
              let countryId = data.selectedItem.countryId || '';
              if (countryId) {
                this.dynamicFormsService.isSelectedCountry = true; // for checking mandatory field
                this.dynamicFormsService.getLookupResultsForCityBasedOnCountry(countryId, targetControl);
              }
            }
          }
        } else {
          // check the duplicate data with stored linked entity values
          const formLookupEntitySetName = this.formDetail.LookupEntitySetName.toLowerCase() || '';
          const linkedEntityParentName = this.formDetail.linkedEntityParentData?.entity.toLowerCase() || '';
          const controlSchemaName = this._activeLookupSearchControl.schemaName.toLowerCase() || '';
          if(this.dynamicFormsService.storedLinkedEntityValues && this.dynamicFormsService.storedLinkedEntityValues.length > 0) {
            isDuplicateData = this._checkDuplicatData(linkedEntityParentName, formLookupEntitySetName, this.dynamicFormsService.storedLinkedEntityValues, data.selectedItem.id);
          }
          if(isDuplicateData){
            let displayName = this._getDisplayText(this._activeLookupSearchControl.displayNames).toLowerCase();
            if(controlSchemaName.includes('account')) {
              displayName = this.translate.instant('ACCOUNT').toLowerCase();
            } else if(controlSchemaName.includes('contact')) {
              displayName = this.translate.instant('CONTACT_FORM').toLowerCase();
            } else if(controlSchemaName.includes('role')) {
              displayName = this.translate.instant('AFFILIATION_ROLE').toLowerCase();
            } else if(controlSchemaName.includes('special')) {
              displayName = this.translate.instant('SPECIALITY').toLowerCase();
            }
            let notificationText = this.translate.instant('DUPLICATED_DETECTED_MESSAGE_LOOKUPFIELD', {lookupFieldName: displayName});
            this.notificationService.notify(notificationText,'ind-dynamic-form','top',ToastStyle.DANGER);
            if (this._activeLookupSearchControl.isCustom) {
              if (!this.isHandleEditAddressFormField) {
                this._clearAttributeValue(this._activeLookupSearchControl);
              } else this._clearEditAddressFormAttributeValue(this._activeLookupSearchControl);
            }
          } else {
            if (!this.isHandleEditAddressFormField) {
              this._setAttributeStringValue(this._activeLookupSearchControl.attributeName, data.selectedItem.name);
              this._setAttributeValue(this._activeLookupSearchControl, data.selectedItem.id, false, codIdOnekey);
              await this._initViewData();
            } else {
              this._setExistingAttributeStringValue(this._activeLookupSearchControl.attributeName, data.selectedItem.name);
              this._setExistingAttributeValue(this._activeLookupSearchControl, data.selectedItem.id, codIdOnekey);
            }
          }
        }
      }
    } else if (data && data.clearValue) {
      const objName = this._activeLookupSearchControl.isCustom
        ? this._activeLookupSearchControl.schemaName
        : (this._activeLookupSearchControl.isCustomAttribute
            ? this._activeLookupSearchControl.schemaName
            : this._activeLookupSearchControl.attributeName);
      if (this._activeLookupSearchControl.isCustom) {
        if (!this.isHandleEditAddressFormField) {
          this._clearAttributeValue(this._activeLookupSearchControl);
        } else this._clearEditAddressFormAttributeValue(this._activeLookupSearchControl);
      }else{
        this._clearAttributeValue(this._activeLookupSearchControl);
      }

      if (this._currentFormValue && this._currentFormValue['lookupfields']) {
        this._currentFormValue['lookupfields'].forEach(lookup => {
          if(!(lookup['isDeleted'] && lookup['isDeleted']==true)){
            let lookupControl: Control = this._getTargetControl(lookup.name);
            if(!lookupControl)
              lookupControl = this._getTargetControlbySchemaName(lookup.name);
            if(lookupControl && lookupControl.filterby && lookupControl.filterby.toLowerCase() == objName.toLowerCase()){
              this._clearAttributeValue(lookupControl);
            }
          }
        });
      }

      if (Array.isArray(data.afterActions)) {
        for (const afterAction of data.afterActions) {
          if (afterAction.action === 'CLEAR' && afterAction.targetFieldName) {
            this._clearField(afterAction.targetFieldName);
          }
        }
      }

      await this._initViewData();
    }
    // Selecting a real record (or clearing the field) on an 'Other'-enabled lookup
    // hides its free-text field. The 'Other' option is handled in its own
    // early-return branch above and never reaches here.
    if (this._activeLookupSearchControl?.otherOptionField) {
      this._toggleOtherOptionField(this._activeLookupSearchControl, false);
      await this._initViewData();
    }
    this._activeLookupSearchControl = undefined;
    this.isHandleEditAddressFormField = false;
  }

  private _clearField(attributeName: string) {
    if (this._currentFormStringValues && this._currentFormStringValues[attributeName]) {
      delete this._currentFormStringValues[attributeName];
      const idxToDel = this._currentFormValue?.lookupfields?.findIndex(i => i.name?.toLowerCase() === attributeName.toLowerCase());
      if (idxToDel >= 0) {
        this._currentFormValue.lookupfields.splice(idxToDel, 1);
      }
    }
  }

  private _initLookupSearchList(targetControl: Control) {
    /*************Edit business information in offline - Non-OneKey contacts*************/
    let query = '';
    if (targetControl && targetControl.lookupQueries) {
      try {
        let filter;
        if (targetControl.dependsOn) {
          if (!this.isHandleEditAddressFormField) {
            if (this._customFormValue && this._customFormValue.hasOwnProperty('lookupfields')) {
              filter = this._customFormValue['lookupfields'].find(x => x.name == targetControl.dependsOn).id || '';
            }
          } else {
            if (this._existingCustomFormValue && this._existingCustomFormValue.hasOwnProperty('lookupfields')) {
              filter = this._existingCustomFormValue['lookupfields'].find(x => x.name == targetControl.dependsOn).id || '';
            }
          }
          if (this.changeRequest && targetControl.lookupEntityPrimaryId == "indskr_lu_districtid") {
            filter = this._stateIdBasedOnCity ? this._stateIdBasedOnCity : '';
          }
        }
        if (this.changeRequest && targetControl.lookupEntityPrimaryId == 'indskr_lu_cityid') {
          let idx;
          if (!this.isHandleEditAddressFormField) {
            if (this._customFormValue && this._customFormValue.hasOwnProperty('lookupfields')) {
              idx = this._customFormValue['lookupfields'].findIndex(a => a.name == "indskr_Country_LU");
              if (idx == -1) this.dynamicFormsService.hasCityDataBasedOnCountry = false;
            } else this.dynamicFormsService.hasCityDataBasedOnCountry = false;
          } else {
            if (this._existingCustomFormValue && this._existingCustomFormValue.hasOwnProperty('lookupfields')) {
              idx = this._existingCustomFormValue['lookupfields'].findIndex(a => a.name == "indskr_Country_LU");
              if (idx == -1) this.dynamicFormsService.hasCityDataBasedOnCountry = false;
            } else this.dynamicFormsService.hasCityDataBasedOnCountry = false;
          }
        }
        if(targetControl.dataType == ControlDataType.LookupType && targetControl.filterby && targetControl.filterFieldTargetLookupEntity){
          let selectedFilterBy;
          if (this._currentFormValue && this._currentFormValue.hasOwnProperty('lookupfields')) {
            let idx = this._currentFormValue['lookupfields'].findIndex(a => a.name?.toLowerCase() === targetControl.filterby?.toLowerCase() && !(a['isDeleted'] && a['isDeleted'] === true));
            if (idx >= 0) {
              selectedFilterBy = this._currentFormValue['lookupfields'][idx].id;
            }
          }
          // else if(this._currentFormValue){
          // MI: for existing records the product may not be in lookupfields yet; fall back to formEntityObject
          if (!selectedFilterBy &&
              this.formDetail?.formMetadata?.entityName === 'indskr_medicalinquiry' &&
              targetControl.attributeName === 'omp_topic') {
            selectedFilterBy = this.formDetail?.formEntityObject?.['_omp_product_value'] as string;
          }
          if(selectedFilterBy){
            filter = `<filter type="and">
            <condition attribute="${targetControl.filterFieldTargetLookupEntity}" operator="eq" value="${selectedFilterBy}"/>
            </filter>`
          }
        } else if (targetControl.dataType == ControlDataType.LookupType && targetControl.filterby && targetControl.targetEntityAttribute) {
          let selectedFilterBy;

          if (this._currentFormValue?.hasOwnProperty('lookupfields')) {
            let idx = this._currentFormValue['lookupfields'].findIndex(a => a.name.toLowerCase() == targetControl.filterby.toLowerCase());
            if (idx >= 0 && this._currentFormValue['lookupfields'][idx].otherFieldsToInclude) {
              selectedFilterBy = this._currentFormValue['lookupfields'][idx].otherFieldsToInclude[targetControl.targetEntityAttribute];
            }
          }
          if (selectedFilterBy) {
            filter = `<filter type="and">
            <condition attribute="${targetControl.targetEntityAttribute}" operator="${targetControl.filterOperator && targetControl.filterOperator === FieldConfigFilterOperatorType.IN ? 'in' : 'eq'}" value="${selectedFilterBy}"/>
            </filter>`;
          }
        }

         if (!this.device.isOffline) {
          this.dynamicFormsService.getLookupResults(query, targetControl, filter, this.changeRequest);
         }
         /*************Edit business information in offline - Non-OneKey contacts*************/
         else {
          const isMIForm = this.formDetail?.formMetadata?.entityName === 'indskr_medicalinquiry';
          const miLookupCache = this.dynamicFormsService.getMIFormLookupFields();
          const miCached = isMIForm && miLookupCache[targetControl.attributeName] && !isEmpty(miLookupCache[targetControl.attributeName]);
          if (miCached) {
            this.dynamicFormsService.lookupSearchData = miLookupCache[targetControl.attributeName];
          } else if (this.dynamicFormsService.allLookUpFieldsForOfflineEdit.hasOwnProperty(targetControl.attributeName)
            && !isEmpty(this.dynamicFormsService.allLookUpFieldsForOfflineEdit[targetControl.attributeName])) {
            this.dynamicFormsService.lookupSearchData = this.dynamicFormsService.allLookUpFieldsForOfflineEdit[targetControl.attributeName];
          } else {
            this.dynamicFormsService.lookupSearchData = [];
          }
         }
        /*************Edit business information in offline - Non-OneKey contacts*************/
      }
      catch (err) {
        console.error(`Error occured while searching lookup results: ${err}`);
      }
    }
    /*************Edit business information in offline - Non-OneKey contacts*************/
  }

  private _getFieldNamesToIncludeInSelectionData(curControl: Control) {
    let fieldNamesToIncludeInSelectionData = [];
    // Get all controls but current one
    // Map for "targetEntityAttribute" field
    if (Array.isArray(this.formDetail.formMetadata.metadata)) {
      for (const formTab of this.formDetail.formMetadata.metadata) {
        if (Array.isArray(formTab.controls)) {
          for (const control of formTab.controls) {
            // Filter for the ones trying to filter by current control value
            if (
              control.filterby && control.targetEntityAttribute
              && control.filterby === curControl.attributeName && control.attributeName !== curControl.attributeName
            ) {
              fieldNamesToIncludeInSelectionData.push(control.targetEntityAttribute);
            }
          }
        }
      }
    }
    return fieldNamesToIncludeInSelectionData.length > 0 ? fieldNamesToIncludeInSelectionData : null;
  }

  private _handleNewPageSelectFieldLookup(control: Control) {
    this._activeLookupSearchControl = control;
    const comparisonValue = control.isCustom ? this._customFormValue : this._currentFormValue;
    const objName = control.isCustom ? control.schemaName : (control.isCustomAttribute ? control.schemaName : control.attributeName);
    let selectedValue = '';
    this.accountService.isOneKeyAffiliatedToAccount = false;
    this.contactService.isOneKeyAffiliatedToContact = false;
    if (comparisonValue && comparisonValue.hasOwnProperty('lookupfields')) {
      let idx = comparisonValue['lookupfields'].findIndex(a => a.name == objName && !(a['isDeleted'] && a['isDeleted'] === true));
      if (idx >= 0) {
        selectedValue = comparisonValue['lookupfields'][idx].id;
      }
    }
    if (control.lookupEntityPrimaryId == 'accountid') {
      this.accountService.selectedFor = AccountSelectedFor.GENERAL_SINGLE_SELECTION;
      this.accountService.accessedAccountListFrom = PageName.DynamicFormComponent;
      if(this.accountService.isOneKeyChangeRequest && (control.attributeName === 'indskr_affiliatedtoaccountid' || control.attributeName === 'indskr_accountid')) {
        this.accountService.isOneKeyAffiliatedToAccount = true;
      }

      // Configs for selections
      let selectionConfigs: SelectionConfig;
      let fieldNamesToIncludeInSelectionData = this._getFieldNamesToIncludeInSelectionData(control);
      if (fieldNamesToIncludeInSelectionData) {
        selectionConfigs = {
          fieldNamesToInclude: fieldNamesToIncludeInSelectionData,
        }

        // Custom logic for Vx MDM flow.
        // TODO: It needs to be enhanced to get this configurations from dynamics
        if (this._DCR_isVxMDMFlow) {
          selectionConfigs.afterActions = [
            {
              selectionType: 'OK',
              action: 'CLEAR',
              targetFieldName: 'indskr_specialty',
            }
          ];
        }
      }

      this.navService.pushWithPageTracking(
        PageName.AccountPageComponent,
        PageName.AccountPageComponent,
        {
          'listMode': ComponentViewMode.ADDNEW,
          type: 'PushedAccountSelectionView',
          selectedAccountId: selectedValue,
          accountIdfromIndDynamic: comparisonValue ? comparisonValue.accountid : "",
          selectionConfigs,
          callbackEvent: (data: any) => this._handleLookupComponentCallback(data)
        },
        PageName.DynamicFormComponent, { animate: false }, this.formDetail.modalNavCtrl || null);
    } else if (control.lookupEntityPrimaryId == 'contactid') {
      this.contactService.contactPageMode = ComponentViewMode.SELECTION;
      this.contactService.accessedContactListFrom = PageName.DynamicFormComponent;
      if(this.contactService.isOneKeyChangeRequest && (control.attributeName === 'indskr_contactid' || control.attributeName === 'indskr_relatedcontactid')) {
        this.contactService.isOneKeyAffiliatedToContact = true;
      }
      if (this.formDetail.modalNavCtrl) {
        this._stretchHostModalForInModalNav();
      }
      this.navService.pushWithPageTracking(PageName.ContactPageComponent, PageName.ContactPageComponent, { type: 'PushedContactSelectionView', selectedContactId: selectedValue, callbackEvent: (data: any) => this._handleLookupComponentCallback(data) }, PageName.DynamicFormComponent, { animate: false }, this.formDetail.modalNavCtrl || null);
    } else if (control.lookupEntityPrimaryId == 'productid') {
      this._activeProductSelectControl = control;
      this._handleProductSelect(selectedValue);
    }
    else if(control.dataType == ControlDataType.LookupType && control.viewType){
      this._activeMainTemplateLookupSelectControl = control;
      this._handleMainTemplateSelectWithFilter(control, selectedValue);
    }
    this._isClicked[control.attributeName] = true;
  }

  private async getProductByLookupQueries(fetchXml) {
    let setBookingProducts = [];
    let maximumCount = 5000;
    fetchXml = fetchXml.replace(`count="{0}"`, `count="`+maximumCount+`"`);
    try {
      this.uiService.displayLoader();
      let data = await this.dynamics.executeFetchQueryWithPageNumber('products', fetchXml, 0);
      if(data) {
        data = data?.value ? data.value : data;
        data.map((rawJSON , index) => {
          let brand = new Brand(rawJSON , index);
          setBookingProducts.push(brand); //indexed because the data from the backend does not assign priorities / sequence!!!
        });
        this.uiService.dismissLoader();
      } else {
        console.error('No response from getProductByLookupQueries');
        this.uiService.dismissLoader();
      }
    } catch (error) {
      this.uiService.dismissLoader();
      console.error(error);
    }
    return setBookingProducts;
  }

   private async getSelectedSetBookingProduct() {
    let selectedProducts: MainCardViewDataModel[] = [];
    const foundControl = this._getTargetControlbyLookupEtity('indskr_setbookingproducts');
    if(this.linkedEntityValues && this.linkedEntityValues[foundControl.attributeName]) {
      let productId: string[] = [];
      let fetchXml = fetchQueries.setBooking.fetchSelectedKitBookingProducts;
      this.linkedEntityValues[foundControl.attributeName].forEach((brand) => {
        let id = '';
        if(brand.rawObjData) {
          if(brand.rawObjData['indskr_setbookingproduct.indskr_product']) id = brand.rawObjData['indskr_setbookingproduct.indskr_product'];
          else if(brand.rawObjData['formStringValue'] && brand.rawObjData['formValue']['lookupfields']) {
            id = brand.rawObjData['formValue']['lookupfields'].find(field => field.entity=='products')?.id;
          }
        }
        productId.push(id);
      })
      let productIDValues = ''
      productId.forEach(p => { productIDValues += '<value>' + p + '</value>' })
      fetchXml = fetchXml.replace('{productIDs}', productIDValues);
      let selectedProductsRaw = await this.getProductByLookupQueries(fetchXml);
      if(selectedProductsRaw && selectedProductsRaw.length>0) {
        selectedProductsRaw.forEach(raw => {
          let qty = 1;
          let isSelected: boolean = false;
          let selectedProduct
          if(this.linkedEntityValues && this.linkedEntityValues[foundControl.attributeName]) { 
            selectedProduct = this.linkedEntityValues[foundControl.attributeName].find(sp => {
              if(sp.rawObjData && sp.rawObjData['indskr_setbookingproduct.indskr_product'] == raw.ID) {
                qty = sp.rawObjData['indskr_setbookingproduct.indskr_quantity'] ?? 1;
                return sp;
              }
              else if(sp.rawObjData && sp.rawObjData['formValue'] && sp.rawObjData['formValue']['lookupfields']) {
                let data = sp.rawObjData['formValue']['lookupfields'].find((lf) => lf.entity == 'products');
                if(data && data.id == raw.ID) {
                  qty = sp.rawObjData['formValue']['indskr_quantity'] ?? 1;
                  return sp;
                }
              }
            });
            isSelected = !!selectedProduct;
          }
          let viewData: MainCardViewDataModel = {
            id: raw.ID,
            primaryTextLeft: '',
            secondaryTextLeft: '',
            showEndIcon: true,
            mainItemCssClass: 'selector-item',
            isItemSelectedForSelectionView: isSelected,
            endIconType: isSelected ? 'indegene-selectors-checkmark-icon' : 'indegene-selectors-add-icon',
            endIconCssClass: isSelected ? 'checkmark-icon' : 'add-icon',
            primaryTextRight: raw.name,
            showArrow: false,
            arrowType: '',
            isQtyControl: true,
            qty: qty
          }
          if(selectedProduct.linkedEntityExistingDataId) viewData['linkedEntityExistingDataId'] = selectedProduct.linkedEntityExistingDataId;
          if(selectedProduct.linkedEntityAddedNewDataId) viewData['linkedEntityAddedNewDataId'] = selectedProduct.linkedEntityAddedNewDataId;
          let secInfoParams = [];
          if(raw.productnumber) secInfoParams.push(`${raw.productnumber}`);
          if(raw.indskr_recordtypeoption != null && raw.indskr_recordtypeoption != undefined) {
            let type = '';
            switch(raw.indskr_recordtypeoption) {
              case ProductRecordType.BILL_OF_MATERIAL:
                type = 'Bill Of Material';
                break;
              case ProductRecordType.SURGEON_PREFERENCE:
                type = 'Surgeon Preference';
                break;
              default:
                type = ''
                break;
            }
            secInfoParams.push(`${type}`);
          }
          if(raw.itemCount) secInfoParams.push("Line items - "+raw.itemCount);
          if(raw.indskr_organisationcode) secInfoParams.push(`Org Code - ${raw.indskr_organisationcode}`);
          viewData.secondaryTextRight = secInfoParams.join(", ");
          selectedProducts.push(viewData);
        })
      }
    }
    
    return selectedProducts;
  }

  private async getSelectedMedicalInquiryProduct(): Promise<MainCardViewDataModel[]> {
    const selectedProducts: MainCardViewDataModel[] = [];
    const foundControl = this._getTargetControlbyLookupEtity('indskr_medicalinquiryproducts');
    if (!foundControl || !this.linkedEntityValues || !this.linkedEntityValues[foundControl.attributeName]) {
      return [];
    }
    const productId: string[] = [];
    this.linkedEntityValues[foundControl.attributeName].forEach((brand) => {
      let id = '';
      if (brand.rawObjData) {
        if (brand.rawObjData['indskr_medicalinquiryproduct.indskr_product']) id = brand.rawObjData['indskr_medicalinquiryproduct.indskr_product'];
        else if (brand.rawObjData['formValue'] && brand.rawObjData['formValue']['lookupfields']) {
          id = brand.rawObjData['formValue']['lookupfields'].find((f) => f.entity === 'products')?.id ?? '';
        }
      }
      if (id) productId.push(id);
    });
    if (productId.length === 0) {
      return [];
    }
    const productIDValues = productId.map((p) => '<value>' + p + '</value>').join('');
    let fetchXml = fetchQueries.medicalInquiry.fetchSelectedMedicalInquiryProducts.replace('{productIDs}', productIDValues);
    const selectedProductsRaw = await this.getProductByLookupQueries(fetchXml);
    if (selectedProductsRaw && selectedProductsRaw.length > 0) {
      selectedProductsRaw.forEach((raw) => {
        let qty = 1;
        let selectedProduct;
        this.linkedEntityValues[foundControl.attributeName].find((sp) => {
          if (sp.rawObjData && sp.rawObjData['indskr_medicalinquiryproduct.indskr_product'] == raw.ID) {
            qty = sp.rawObjData['indskr_medicalinquiryproduct.indskr_quantity'] ?? 1;
            selectedProduct = sp;
            return true;
          }
          if (sp.rawObjData && sp.rawObjData['formValue'] && sp.rawObjData['formValue']['lookupfields']) {
            const data = sp.rawObjData['formValue']['lookupfields'].find((lf) => lf.entity === 'products');
            if (data && data.id == raw.ID) {
              qty = sp.rawObjData['formValue']['indskr_quantity'] ?? 1;
              selectedProduct = sp;
              return true;
            }
          }
          return false;
        });
        const isSelected = !!selectedProduct;
        const viewData: MainCardViewDataModel = {
          id: raw.ID,
          primaryTextLeft: '',
          secondaryTextLeft: '',
          showEndIcon: true,
          mainItemCssClass: 'selector-item',
          isItemSelectedForSelectionView: isSelected,
          endIconType: isSelected ? 'indegene-selectors-checkmark-icon' : 'indegene-selectors-add-icon',
          endIconCssClass: isSelected ? 'checkmark-icon' : 'add-icon',
          primaryTextRight: raw.name,
          showArrow: false,
          arrowType: '',
          isQtyControl: false,
          qty: 1
        };
        if (selectedProduct && selectedProduct.linkedEntityExistingDataId) viewData['linkedEntityExistingDataId'] = selectedProduct.linkedEntityExistingDataId;
        if (selectedProduct && selectedProduct.linkedEntityAddedNewDataId) viewData['linkedEntityAddedNewDataId'] = selectedProduct.linkedEntityAddedNewDataId;
        const secInfoParams = [];
        if (raw.productnumber) secInfoParams.push(`${raw.productnumber}`);
        if (raw.indskr_recordtypeoption != null && raw.indskr_recordtypeoption != undefined) {
          let type = '';
          switch (raw.indskr_recordtypeoption) {
            case ProductRecordType.BILL_OF_MATERIAL: type = 'Bill Of Material'; break;
            case ProductRecordType.SURGEON_PREFERENCE: type = 'Surgeon Preference'; break;
            default: type = ''; break;
          }
          secInfoParams.push(`${type}`);
        }
        if (raw.itemCount) secInfoParams.push('Line items - ' + raw.itemCount);
        if (raw.indskr_organisationcode) secInfoParams.push(`Org Code - ${raw.indskr_organisationcode}`);
        viewData.secondaryTextRight = secInfoParams.join(', ');
        selectedProducts.push(viewData);
      });
    }
    return selectedProducts;
  }

  private async _getAllSetBookingProducts(productFetchXml, isBOM:boolean = false, searchKeyWord) {
    if(!productFetchXml) return;
    let allBrandProducts = this.brandService.brands;
    if(isBOM || searchKeyWord) {
      let filter = `<filter type="and">
          {bomFilter}
          {searchFilter}
        </filter>`;
      let bomFilter = `<condition attribute="indskr_recordtypeoption" operator="eq" value="548910000" />`
      let searchFilter = `
        <filter type="or">
          <condition attribute="name" operator="like" value="%${searchKeyWord}%" />
          <condition attribute="productnumber" operator="like" value="%${searchKeyWord}%" />
        </filter>
      `
      filter = isBOM ? filter.replace('{bomFilter}', bomFilter) : filter.replace('{bomFilter}', '');
      filter = searchKeyWord ? filter.replace('{searchFilter}', searchFilter) : filter.replace('{searchFilter}', '');
      const entityOpenTagIndex = productFetchXml.indexOf('<entity');
      const entityCloseTagIndex = productFetchXml.indexOf('>', entityOpenTagIndex);
      if (entityOpenTagIndex > -1) {
        const entityCloseTagIndex = productFetchXml.indexOf('>', entityOpenTagIndex);
        if (entityCloseTagIndex > -1) {
          productFetchXml = productFetchXml.slice(0, entityCloseTagIndex + 1) + filter + productFetchXml.slice(entityCloseTagIndex + 1);
        }
      }
    }   
    allBrandProducts = await this.getProductByLookupQueries(productFetchXml);
    return allBrandProducts;
  }

  private async _getSurgeonAccountPrefProducts(surgeonaccountzsurValue, searchKeyWord) {
    let onlySurgeonProducts: Brand[] = [];
    if(surgeonaccountzsurValue) {
      let fetchXml = fetchQueries.setBooking.fetchAllProductsForProductTypeOnlySurgeon;
      let filter = `<filter type="and">
            <condition attribute="indskr_recordtypeoption" operator="eq" value="548910001" />
            <condition attribute='indskr_account' operator="eq" value='${surgeonaccountzsurValue}'/>
            {searchFilter}
            </filter>`;
      let searchFilter = `
        <filter type="or">
          <condition attribute="name" operator="like" value="%${searchKeyWord}%" />
          <condition attribute="productnumber" operator="like" value="%${searchKeyWord}%" />
        </filter>
      `
      filter = searchKeyWord ? filter.replace('{searchFilter}', searchFilter) : filter.replace('{searchFilter}', '');
      const entityOpenTagIndex = fetchXml.indexOf('<entity');
      const entityCloseTagIndex = fetchXml.indexOf('>', entityOpenTagIndex);
      if (entityOpenTagIndex > -1) {
        const entityCloseTagIndex = fetchXml.indexOf('>', entityOpenTagIndex);
        if (entityCloseTagIndex > -1) {
          fetchXml = fetchXml.slice(0, entityCloseTagIndex + 1) + filter + fetchXml.slice(entityCloseTagIndex + 1);
        }
      }
      onlySurgeonProducts = await this.getProductByLookupQueries(fetchXml);
    }
    return onlySurgeonProducts;
  }

  private async _fetchSetBookingProduct(setBookingProductformDetail) {
    let allBrandProducts = this.brandService.brands;
    this.selectedFilterFromMainToolTemplate = '';
    this.searchKeyWordFromMainToolTemplate = '';
    let productDynamicForm: DynamicForm = setBookingProductformDetail.formMetadata;
    if (productDynamicForm) {
      const productControl = this._getTargetControl('indskr_product', productDynamicForm);
      this._activeProductSelectControl = productControl;
    }
      let popoverDataSetBookingProduct: { text: string; value: string; items: any; handler: (selectedItem: any, item: any, itemRef: any, keyword: string) => void; }[] = [];
      const productTypeControl = this._getTargetControl('indskr_producttype', productDynamicForm);
      let dropdownListDetail: IndDropdownListDetailModel = this.dynamicFormsService.getDropdownListViewFromOptionSet(productTypeControl.optionSet, '', this._activeLanguageCode);
      if(dropdownListDetail && dropdownListDetail.data && dropdownListDetail.data.length>0) {
        const values = Object.values(SetBookingProductFilter);
        dropdownListDetail.data = dropdownListDetail.data.map(item => {
          if(values.some(value => item.title.toLowerCase().includes(value.toLowerCase()))) return item;
        })        
      }
      dropdownListDetail.data = dropdownListDetail.data.filter(item => !isEmpty(item));
      popoverDataSetBookingProduct = [{
          text: '',
          value: '',
          items: dropdownListDetail.data.map((item) => {
            let option = {
              text: item.title,
              value: item.id
            }
            return option;
          }),
          handler: async (selectedItem, item, itemRef, keyword) => {
            this.searchKeyWordFromMainToolTemplate = keyword;
            itemRef.parent.items[0].value = '';
            item.value =
              item.value === selectedItem.value ? '' : selectedItem.value;
            if (item.value != '') {
              this.selectedFilterFromMainToolTemplate = item.value;
              
              await this._handleKitBookingComponentSearch(this.searchKeyWordFromMainToolTemplate, popoverDataSetBookingProduct, setBookingProductformDetail);;
            }
          },
        }
      ]
      let listDetail = await this._getListDefailForSetBookingProduct(allBrandProducts, popoverDataSetBookingProduct, setBookingProductformDetail);
      this.navService.pushWithPageTracking(PageName.MainToolTemplateComponent, PageName.NothingSelectedView, { viewData: listDetail, formData: setBookingProductformDetail }, PageName.MainToolTemplateComponent);
  }

  private async _fetchMedicalInquiryProduct(medicalInquiryProductformDetail) {
    this.selectedFilterFromMainToolTemplate = '';
    this.searchKeyWordFromMainToolTemplate = '';
    const productDynamicForm: DynamicForm = medicalInquiryProductformDetail.formMetadata;
    if (productDynamicForm) {
      const productControl = this._getTargetControl('indskr_product', productDynamicForm);
      this._activeProductSelectControl = productControl;
    }
    if (this.formDetail.modalNavCtrl) {
      this._stretchHostModalForInModalNav();
    }
    const allBrands = this.brandService.brands || [];
    const allBrandProducts = allBrands.filter(b => b.producttype !== 268890001 && b.indskr_producttype !== 268890001);
    const listDetail = await this._getListDetailForMedicalInquiryProduct(allBrandProducts, medicalInquiryProductformDetail);
    const navParams: Record<string, unknown> = { viewData: listDetail, formData: medicalInquiryProductformDetail };
    if (this.formDetail.modalNavCtrl) {
      navParams['isNavWithinModalView'] = true;
      navParams['navWithinModalRef'] = this.formDetail.modalNavCtrl;
    }
    this.navService.pushWithPageTracking(PageName.MainToolTemplateComponent, PageName.NothingSelectedView, navParams, PageName.MainToolTemplateComponent, { animate: false }, this.formDetail.modalNavCtrl || null);
  }

  private _handleMedicalInquiryProductComponentSearch(keyword: string, medicalInquiryProductformDetail) {
    this.searchKeyWordFromMainToolTemplate = keyword;
    const allBrands = (this.brandService.brands || []).filter(b => b.producttype !== 268890001 && b.indskr_producttype !== 268890001);
    const filteredBrandProducts = keyword.trim()
      ? allBrands.filter(brand =>
          (brand.name && brand.name.trim().toLowerCase().includes(keyword.trim().toLowerCase())) ||
          (brand.productnumber && brand.productnumber.toString().trim().toLowerCase().includes(keyword.trim().toLowerCase()))
        )
      : allBrands;
    this._getListDetailForMedicalInquiryProduct(filteredBrandProducts, medicalInquiryProductformDetail, true).then(updatedListDetail => {
      this.events.publish('updateMainToolTemplateList', updatedListDetail);
    });
  }

  private async _getListDetailForMedicalInquiryProduct(allBrandProducts: Brand[], medicalInquiryProductformDetail, isFilter = false): Promise<MainToolTemplateDetail> {
    const selectedProducts: MainCardViewDataModel[] = allBrandProducts.map((brand: Brand) => {
      let isSelected = false;
      let selectedProduct;
      let qty = 1;
      const foundControl = this._getTargetControlbyLookupEtity('indskr_medicalinquiryproducts');
      if (foundControl && this.linkedEntityValues && this.linkedEntityValues[foundControl.attributeName]) {
        selectedProduct = this.linkedEntityValues[foundControl.attributeName].find(sp => {
          if (sp.rawObjData && sp.rawObjData['indskr_medicalinquiryproduct.indskr_product'] == brand.ID) {
            qty = sp.rawObjData['indskr_medicalinquiryproduct.indskr_quantity'] ?? 1;
            return sp;
          }
          if (sp.rawObjData && sp.rawObjData['formValue'] && sp.rawObjData['formValue']['lookupfields']) {
            const data = sp.rawObjData['formValue']['lookupfields'].find((lf) => lf.entity == 'products');
            if (data && data.id == brand.ID) {
              qty = sp.rawObjData['formValue']['indskr_quantity'] ?? 1;
              return sp;
            }
          }
        });
        isSelected = !!selectedProduct;
      }
      const viewData: MainCardViewDataModel = {
        id: brand.ID,
        primaryTextLeft: '',
        secondaryTextLeft: '',
        showEndIcon: true,
        mainItemCssClass: 'selector-item',
        isItemSelectedForSelectionView: isSelected,
        endIconType: isSelected ? 'indegene-selectors-checkmark-icon' : 'indegene-selectors-add-icon',
        endIconCssClass: isSelected ? 'checkmark-icon' : 'add-icon',
        primaryTextRight: brand.name,
        showArrow: false,
        arrowType: '',
        isQtyControl: false,
        qty: 1
      };
      if (selectedProduct && selectedProduct.linkedEntityExistingDataId) viewData['linkedEntityExistingDataId'] = selectedProduct.linkedEntityExistingDataId;
      if (selectedProduct && selectedProduct.linkedEntityAddedNewDataId) viewData['linkedEntityAddedNewDataId'] = selectedProduct.linkedEntityAddedNewDataId;
      const secInfoParams = [];
      if (brand.productnumber) secInfoParams.push(`${brand.productnumber}`);
      if (brand.indskr_recordtypeoption != null && brand.indskr_recordtypeoption != undefined) {
        let type = '';
        switch (brand.indskr_recordtypeoption) {
          case ProductRecordType.BILL_OF_MATERIAL: type = 'Bill Of Material'; break;
          case ProductRecordType.SURGEON_PREFERENCE: type = 'Surgeon Preference'; break;
          default: type = ''; break;
        }
        secInfoParams.push(`${type}`);
      }
      if (brand.itemCount) secInfoParams.push('Line items - ' + brand.itemCount);
      if (brand.indskr_organisationcode) secInfoParams.push(`Org Code - ${brand.indskr_organisationcode}`);
      viewData.secondaryTextRight = secInfoParams.join(', ');
      return viewData;
    });
    const listForMedicalInquiryProduct: MainToolTemplateDetail = {
      title: this.translate.instant('PRODUCTS'),
      dividerTitle: isFilter ? this.translate.instant('RESULTS_CAP') : this.translate.instant('ALL_PRODUCTS_CAP'),
      isSearchEnabled: true,
      showLeftHeaderButton: true,
      leftHeaderBtnImgSrc: 'assets/imgs/header_cancel.svg',
      leftHeaderBtnText: this.translate.instant('CANCEL'),
      showRightHeaderButton: true,
      rightHeaderBtnImgSrc: 'assets/imgs/header_complete.svg',
      rightHeaderBtnText: this.translate.instant('DONE'),
      orderByPropertyName: 'primaryTextRight',
      searchTitle: '',
      isListSelectionEnabled: true,
      listSelectionType: MainToolTemplateListSelectionType.MULTIPLESELECTION,
      passOverLabelCssToMainCard: 'kitBookingSelection',
      isFilterPopoverActive: false,
      navOptions: { animate: false },
      filterPopoverData: [],
      isSelectedSectionCollapsible: true,
      isDetailPageEnabled: true,
      detailPageFetchingQuery: fetchQueries.medicalInquiry.fetchMedicalInquiryProductDetails,
      isFor: 'medicalInquiryProducts',
      enableKeyControlArea: true,
      eventsHandler: (data: any, eventTarget: string, refData: MainToolTemplateDetail, formDetail: DynamicFormComponentModel) =>
        this._handleMedicalInquiryProductComponentEvent(data, eventTarget, refData, medicalInquiryProductformDetail),
      searchButtonHandler: (text: string) => this._handleMedicalInquiryProductComponentSearch(text, medicalInquiryProductformDetail),
      data: selectedProducts
    };
    return listForMedicalInquiryProduct;
  }

  private async _handleKitBookingComponentSearch(keyword, popoverDataSetBookingProduct, setBookingProductformDetail) {
    this.searchKeyWordFromMainToolTemplate = keyword;
    let filteredBrandProducts = [];
    let productDynamicForm: DynamicForm = setBookingProductformDetail.formMetadata;
    let surgeonaccountzsurValue = setBookingProductformDetail.formEntityObject && setBookingProductformDetail.formEntityObject['surgeonaccountzsurValue'] ? setBookingProductformDetail.formEntityObject['surgeonaccountzsurValue'] : '';
    let productFetchXml = '';
    if (productDynamicForm) {
      const productControl = this._getTargetControl('indskr_product', productDynamicForm);
      this._activeProductSelectControl = productControl;
      if(!isEmpty(productControl) && productControl.lookupQueries && productControl.lookupQueries['fetchXml']) {
        productFetchXml = productControl.lookupQueries['fetchXml'];
      }
    }
    if(this.selectedFilterFromMainToolTemplate == 548910000) {
      if(productFetchXml) filteredBrandProducts = await this._getAllSetBookingProducts(productFetchXml, true, keyword);
      else this.notificationService.notify('Product Condition is Not Set. Please contact the system administrator', 'DynamicFormComponent', 'top', ToastStyle.INFO, 3000);
    }
    else if(this.selectedFilterFromMainToolTemplate == 548910001) {
      if(!surgeonaccountzsurValue) this.notificationService.notify('Please select surgeon account', 'DynamicFormComponent', 'top', ToastStyle.INFO, 3000);
      else filteredBrandProducts = await this._getSurgeonAccountPrefProducts(surgeonaccountzsurValue, keyword);
    }
    else if(this.selectedFilterFromMainToolTemplate == 548910002 || (!this.selectedFilterFromMainToolTemplate && keyword)) {
      if(productFetchXml) filteredBrandProducts = await this._getAllSetBookingProducts(productFetchXml, false, keyword);
      else this.notificationService.notify('Product Condition is Not Set. Please contact the system administrator', 'DynamicFormComponent', 'top', ToastStyle.INFO, 3000);
    }
    await this._getListDefailForSetBookingProduct(filteredBrandProducts, popoverDataSetBookingProduct, setBookingProductformDetail, true).then((updatedListDetail) => {
      this.events.publish('updateMainToolTemplateList', updatedListDetail);
    });
  }

  private async _getListDefailForSetBookingProduct(allBrandProducts, popoverDataSetBookingProduct, setBookingProductformDetail, isFilter:boolean=false): Promise<MainToolTemplateDetail> {
    let selectedProducts:MainCardViewDataModel[] = []
    if(isFilter) {
      selectedProducts = allBrandProducts.map((brand: Brand) => {
          let isSelected = false;
          let selectedProduct;
          let qty = 1;
          const foundControl = this._getTargetControlbyLookupEtity('indskr_setbookingproducts');
          if(this.linkedEntityValues && this.linkedEntityValues[foundControl.attributeName]) {
            selectedProduct = this.linkedEntityValues[foundControl.attributeName].find(sp => {
              if(sp.rawObjData && sp.rawObjData['indskr_setbookingproduct.indskr_product'] == brand.ID) {
                qty = sp.rawObjData['indskr_setbookingproduct.indskr_quantity'] ?? 1;
                return sp;
              }
              else if(sp.rawObjData && sp.rawObjData['formValue'] && sp.rawObjData['formValue']['lookupfields']) {
                let data = sp.rawObjData['formValue']['lookupfields'].find((lf) => lf.entity == 'products');
                if(data && data.id == brand.ID) {
                  qty = sp.rawObjData['formValue']['indskr_quantity'] ?? 1;
                  return sp;
                }
              }
            });
            isSelected = !!selectedProduct;
          }
          let viewData: MainCardViewDataModel = {
            id: brand.ID,
            primaryTextLeft: '',
            secondaryTextLeft: '',
            showEndIcon: true,
            mainItemCssClass: 'selector-item',
            isItemSelectedForSelectionView: isSelected,
            endIconType: isSelected ? 'indegene-selectors-checkmark-icon' : 'indegene-selectors-add-icon',
            endIconCssClass: isSelected ? 'checkmark-icon' : 'add-icon',
            primaryTextRight: brand.name,
            showArrow: false,
            arrowType: '',
            isQtyControl: true,
            qty: qty
          }
          if(selectedProduct && selectedProduct.linkedEntityExistingDataId) viewData['linkedEntityExistingDataId'] = selectedProduct.linkedEntityExistingDataId;
          if(selectedProduct && selectedProduct.linkedEntityAddedNewDataId) viewData['linkedEntityAddedNewDataId'] = selectedProduct.linkedEntityAddedNewDataId;
          let secInfoParams = [];
          if(brand.productnumber) secInfoParams.push(`${brand.productnumber}`);
          if(brand.indskr_recordtypeoption != null && brand.indskr_recordtypeoption != undefined) {
            let type = '';
            switch(brand.indskr_recordtypeoption) {
              case ProductRecordType.BILL_OF_MATERIAL:
                type = 'Bill Of Material';
                break;
              case ProductRecordType.SURGEON_PREFERENCE:
                type = 'Surgeon Preference';
                break;
              default:
                type = ''
                break;
            }
            secInfoParams.push(`${type}`);
          }
          if(brand.itemCount) secInfoParams.push("Line items - "+brand.itemCount);
          if(brand.indskr_organisationcode) secInfoParams.push(`Org Code - ${brand.indskr_organisationcode}`);
          viewData.secondaryTextRight = secInfoParams.join(", ");
          return viewData;
        })
    } else selectedProducts = await this.getSelectedSetBookingProduct();
    let listForSetBookingProduct: MainToolTemplateDetail = {
      title: this.translate.instant('PRODUCTS'),
      dividerTitle: isFilter ? this.translate.instant('RESULTS_CAP') : this.translate.instant('ALL_PRODUCTS_CAP'),
      isSearchEnabled: true,
      showLeftHeaderButton: true,
      leftHeaderBtnImgSrc: 'assets/imgs/header_cancel.svg',
      leftHeaderBtnText: this.translate.instant('CANCEL'),
      showRightHeaderButton: true,
      rightHeaderBtnImgSrc: 'assets/imgs/header_complete.svg',
      rightHeaderBtnText: this.translate.instant('DONE'),
      orderByPropertyName: 'primaryTextRight',
      searchTitle: "",
      isListSelectionEnabled: true,
      listSelectionType: MainToolTemplateListSelectionType.MULTIPLESELECTION,
      passOverLabelCssToMainCard: 'kitBookingSelection',
      isFilterPopoverActive: true,
      navOptions: { animate: false },
      filterPopoverData: popoverDataSetBookingProduct,
      isSelectedSectionCollapsible: true,
      isDetailPageEnabled: true,
      detailPageFetchingQuery: fetchQueries.setBooking.fetchSetBookingProductDetails,
      isFor: 'setBookingProducts',
      enableKeyControlArea: true,
      eventsHandler: (data: any, eventTarget: string, refData: MainToolTemplateDetail, formDetail: DynamicFormComponentModel) => this._handleSetBookingProductComponentEvent(data, eventTarget, refData, setBookingProductformDetail),
      searchButtonHandler: (text: string) => this._handleKitBookingComponentSearch(text, popoverDataSetBookingProduct, setBookingProductformDetail),
      data: selectedProducts
    };
    return listForSetBookingProduct;
  }

  private async _handleProductSelect(selectedId: string) {
    if (this.brandService.brands && this.brandService.brands.length != 0) {
      let allBrandProducts = this.brandService.brands;
      if (this.formDetail && this.formDetail.LookupEntitySetName == 'indskr_setbookingproducts' && this.formDetail.formMetadata && this.formDetail.formMetadata.metadata) {
        const productControl = this._getTargetControl('indskr_product');
        if(!isEmpty(productControl) && productControl.lookupQueries && productControl.lookupQueries['fetchXml']) {
          let fetchXml = productControl.lookupQueries['fetchXml'];
          let surgeonaccountzsurValue;
          let isValid: boolean = true;
          if((this.formDetail.formEntityObject && this.formDetail.formEntityObject['indskr_setbookingproduct.indskr_producttype'] && this.formDetail.formEntityObject['indskr_setbookingproduct.indskr_producttype'] != 548910003)
            || (this._currentFormStringValues && this._currentFormStringValues['indskr_producttype'] && this._currentFormStringValues['indskr_producttype'] != 'All Products')) {
              let filter = `<filter type="and">
              <condition attribute="indskr_recordtypeoption" operator="eq" value={attrValue} />
              {accountCondition}
              </filter>`;
              if(this.formDetail && this.formDetail.formEntityObject && this.formDetail.formEntityObject['surgeonaccountzsurValue']){
                surgeonaccountzsurValue = this.formDetail.formEntityObject['surgeonaccountzsurValue'];
              }
              // Do not shorten, or merge the if conditions. It is written based on order.
              // Eg. Even though the form has the already saved value (case 4~6), it should fall into case 1~3 if the user selects the new value.
              // If it is "only Surgeon", Ignore dynamics query, but Fetching all products and add the filter
              if(this._currentFormStringValues && this._currentFormStringValues['indskr_producttype'] == 'All Products') {
                // Case1: if selected product type is All
                filter = '';
              } else if(this._currentFormStringValues && this._currentFormStringValues['indskr_producttype'] == 'Only BOM') {
                // Case2: if selected product type is ONLY BOM
                filter = filter.replace(`{attrValue}`, '"548910000"').replace(`{accountCondition}`, '');
              } else if(this._currentFormStringValues && this._currentFormStringValues['indskr_producttype'] == 'Only Surgeon Preferences') {
                // Case3: if selected product type is ONLY Surgeon Preferences
                if(!surgeonaccountzsurValue) isValid = false;
                fetchXml = fetchQueries.setBooking.fetchAllProductsForProductTypeOnlySurgeon;
                filter = filter.replace(`{attrValue}`,'"548910001"');
                filter = surgeonaccountzsurValue ? filter.replace(`{accountCondition}`, `<condition attribute='indskr_account' operator="eq" value='${surgeonaccountzsurValue}'/>`)
                            : filter.replace(`{accountCondition}`, '');
              } else if(this.formDetail.formEntityObject['indskr_setbookingproduct.indskr_producttype'] == 548910002) {
                // Case4: if already saved product type is All
                filter = '';
              } else if(this.formDetail.formEntityObject['indskr_setbookingproduct.indskr_producttype'] == 548910000) {
                // Case5: if already saved product type is Only BOM
                filter = filter.replace(`{attrValue}`,'"548910000"').replace(`{accountCondition}`, '');
              } else if (this.formDetail.formEntityObject['indskr_setbookingproduct.indskr_producttype'] == 548910001) {
                // Case6: if already saved product type is ONLY Surgeon Preferences
                if(!surgeonaccountzsurValue) isValid = false;
                fetchXml = fetchQueries.setBooking.fetchAllProductsForProductTypeOnlySurgeon;
                filter = filter.replace(`{attrValue}`,'"548910001"');
                filter = surgeonaccountzsurValue ? filter.replace(`{accountCondition}`, `<condition attribute='indskr_account' operator="eq" value='${surgeonaccountzsurValue}'/>`)
                : filter.replace(`{accountCondition}`, '');
              }
              const entityOpenTagIndex = fetchXml.indexOf('<entity');
              const entityCloseTagIndex = fetchXml.indexOf('>', entityOpenTagIndex);
              if (entityOpenTagIndex > -1) {
                const entityCloseTagIndex = fetchXml.indexOf('>', entityOpenTagIndex);
                if (entityCloseTagIndex > -1) {
                  fetchXml = fetchXml.slice(0, entityCloseTagIndex + 1) + filter + fetchXml.slice(entityCloseTagIndex + 1);
                }
              }
            }
          if(isValid) allBrandProducts = await this.getProductByLookupQueries(fetchXml);
          else allBrandProducts = [];
        }
      }
      if (this.formDetail?.formMetadata?.entityName === 'indskr_medicalinquiry') {
        allBrandProducts = allBrandProducts.filter(b => b.producttype !== 268890001 && b.indskr_producttype !== 268890001);
      }
      let popoverDataSetBookingProduct: { text: string; value: string; items: any; handler: (selectedItem: any, item: any, itemRef: any) => void; }[] = [];
      const productTypeControl = this._getTargetControl('indskr_producttype');
      if (productTypeControl?.optionSet) {
        let dropdownListDetail: IndDropdownListDetailModel = this.dynamicFormsService.getDropdownListViewFromOptionSet(productTypeControl.optionSet, '', this._activeLanguageCode);
        popoverDataSetBookingProduct = [{
            text: '',
            value: '',
            items: dropdownListDetail.data.map((item) => {
              let option = {
                text: item.title,
                value: item.id
              }
              return option;
            }),
            handler: (selectedItem, item, itemRef) => {
            },
          }
        ]
      }
      let listDetail: MainToolTemplateDetail = {
        title: this.translate.instant('PRODUCTS'),
        dividerTitle: this.translate.instant('ALL_PRODUCTS_CAP'),
        isSearchEnabled: true,
        showLeftHeaderButton: true,
        leftHeaderBtnImgSrc: 'assets/imgs/header_cancel.svg',
        leftHeaderBtnText: this.translate.instant('CANCEL'),
        showRightHeaderButton: true,
        rightHeaderBtnImgSrc: 'assets/imgs/header_complete.svg',
        rightHeaderBtnText: this.translate.instant('DONE'),
        orderByPropertyName: 'primaryTextRight',
        searchTitle: this.formDetail && this.formDetail.LookupEntitySetName == 'indskr_setbookingproducts'? "" :this.translate.instant('SEARCH_PRODUCT'),
        isListSelectionEnabled: true,
        listSelectionType: this.formDetail && this.formDetail.LookupEntitySetName == 'indskr_setbookingproducts'? MainToolTemplateListSelectionType.MULTIPLESELECTION : MainToolTemplateListSelectionType.SINGLESELECTION,
        passOverLabelCssToMainCard: 'kitBookingSelection',
        isFilterPopoverActive: this.formDetail && this.formDetail.LookupEntitySetName == 'indskr_setbookingproducts' && popoverDataSetBookingProduct.length > 0,
        navOptions: { animate: false },
        filterPopoverData: this.formDetail && this.formDetail.LookupEntitySetName == 'indskr_setbookingproducts' ? popoverDataSetBookingProduct : [],
        eventsHandler: (data: any, eventTarget: string, refData: MainToolTemplateDetail) => this._handleProductComponentEvent(data, eventTarget, refData),
        searchHandler: (text: string) => this._handleProductComponentSearch(text, allBrandProducts),
        data: allBrandProducts.map((brand: Brand) => {
          let isSelected = false;
          if (selectedId && brand.ID == selectedId) {
            isSelected = true;
          }
          let viewData: MainCardViewDataModel = {
            id: brand.ID,
            primaryTextLeft: '',
            secondaryTextLeft: '',
            showEndIcon: true,
            mainItemCssClass: 'selector-item',
            isItemSelectedForSelectionView: isSelected,
            endIconType: isSelected ? 'indegene-selectors-checkmark-icon' : 'indegene-selectors-add-icon',
            endIconCssClass: isSelected ? 'checkmark-icon' : 'add-icon',
            primaryTextRight: brand.name,
            showArrow: false,
            arrowType: '',
            isQtyControl: this.formDetail && this.formDetail.LookupEntitySetName == 'indskr_setbookingproducts',
            qty: brand.itemCount ?? 1
          }
          let secInfoParams = [];
          if(brand.productnumber) secInfoParams.push(`${brand.productnumber}`);
          if(brand.indskr_recordtypeoption != null && brand.indskr_recordtypeoption != undefined) {
            let type = '';
            switch(brand.indskr_recordtypeoption) {
              case ProductRecordType.BILL_OF_MATERIAL:
                type = 'Bill Of Material';
                break;
              case ProductRecordType.SURGEON_PREFERENCE:
                type = 'Surgeon Preference';
                break;
              default:
                type = ''
                break;
            }
            secInfoParams.push(`${type}`);
          }
          if(brand.itemCount) secInfoParams.push("Line items - "+brand.itemCount)
          viewData.secondaryTextRight = secInfoParams.join(", ");
          return viewData;
        }),
      };
      // Inline product lookups are reached from inside the in-meeting modal too, where the default
      // nav would render the picker in the master pane behind the half-width modal. Same treatment
      // as the subgrid picker in _fetchMedicalInquiryProduct; modalNavCtrl is only set by hosts that
      // render the form inside a modal, so non-modal callers are unaffected.
      const productNavParams: Record<string, unknown> = { viewData: listDetail };
      if (this.formDetail?.modalNavCtrl) {
        // Resolve the lazy picker chunk before stretching. Stretching first leaves a full-screen
        // empty modal on screen for however long the dynamic import takes, which reads as a white flash.
        await getComponent(PageName.MainToolTemplateComponent)?.resolve();
        this._stretchHostModalForInModalNav();
        productNavParams['isNavWithinModalView'] = true;
        productNavParams['navWithinModalRef'] = this.formDetail.modalNavCtrl;
      }
      this.navService.pushWithPageTracking(PageName.MainToolTemplateComponent, PageName.NothingSelectedView, productNavParams, PageName.MainToolTemplateComponent, { animate: false }, this.formDetail?.modalNavCtrl || null);
    }
  }

  /**
   * The in-meeting modal is half-width on the home screen; a pushed picker needs the full stretch.
   * MainToolTemplateComponent removes the class again when it pops (isNavWithinModalView branch).
   */
  private _stretchHostModalForInModalNav(): void {
    const modal = document.getElementsByTagName('ion-modal')[0];
    if (modal && !modal.classList.contains('fullStretchView')) {
      setTimeout(() => {
        modal.classList.add('fullStretchView');
      });
    }
  }

  private async _handleMainTemplateSelectWithFilter(targetControl: Control, selectedId: string) {
    //based on configured viewType, any lookup search opens in mainTemplate with details view instead of popover
    //and the search results are also filtered based on configuration
    let allLookupSearchData;
    if(!isEmpty(targetControl) && targetControl.lookupQueries && targetControl.lookupQueries['fetchXml']) {
      let filter;
      let query = '';
      try{
        if (targetControl.dependsOn) {
            if (!this.isHandleEditAddressFormField) {
              if (this._customFormValue && this._customFormValue.hasOwnProperty('lookupfields')) {
                filter = this._customFormValue['lookupfields'].find(x => x.name == targetControl.dependsOn).id || '';
              }
            } else {
              if (this._existingCustomFormValue && this._existingCustomFormValue.hasOwnProperty('lookupfields')) {
                filter = this._existingCustomFormValue['lookupfields'].find(x => x.name == targetControl.dependsOn).id || '';
              }
            }
            if (this.changeRequest && targetControl.lookupEntityPrimaryId == "indskr_lu_districtid") {
              filter = this._stateIdBasedOnCity ? this._stateIdBasedOnCity : '';
            }
        }
        if (this.changeRequest && targetControl.lookupEntityPrimaryId == 'indskr_lu_cityid') {
            let idx;
            if (!this.isHandleEditAddressFormField) {
              if (this._customFormValue && this._customFormValue.hasOwnProperty('lookupfields')) {
                idx = this._customFormValue['lookupfields'].findIndex(a => a.name == "indskr_Country_LU");
                if (idx == -1) this.dynamicFormsService.hasCityDataBasedOnCountry = false;
              } else this.dynamicFormsService.hasCityDataBasedOnCountry = false;
            } else {
              if (this._existingCustomFormValue && this._existingCustomFormValue.hasOwnProperty('lookupfields')) {
                idx = this._existingCustomFormValue['lookupfields'].findIndex(a => a.name == "indskr_Country_LU");
                if (idx == -1) this.dynamicFormsService.hasCityDataBasedOnCountry = false;
              } else this.dynamicFormsService.hasCityDataBasedOnCountry = false;
            }
        }
        if(targetControl.dataType == ControlDataType.LookupType && targetControl.filterby && targetControl.filterFieldTargetLookupEntity){
            let selectedFilterBy;
            if (this._currentFormValue && this._currentFormValue.hasOwnProperty('lookupfields')) {
              let idx = this._currentFormValue['lookupfields'].findIndex(a => a.name == targetControl.filterby && !(a['isDeleted'] && a['isDeleted'] === true));
              if (idx >= 0) {
                selectedFilterBy = this._currentFormValue['lookupfields'][idx].id;
              }
            }
            // else if(this._currentFormValue){
            if(selectedFilterBy){
              filter = `<filter type="and">
              <condition attribute="${targetControl.filterFieldTargetLookupEntity}" operator="eq" value="${selectedFilterBy}"/>
              </filter>`
            }
          } else if (targetControl.dataType == ControlDataType.LookupType && targetControl.filterby && targetControl.targetEntityAttribute) {
            let selectedFilterBy;

            if (this._currentFormValue?.hasOwnProperty('lookupfields')) {
              let idx = this._currentFormValue['lookupfields'].findIndex(a => a.name.toLowerCase() == targetControl.filterby.toLowerCase());
              if (idx >= 0 && this._currentFormValue['lookupfields'][idx].otherFieldsToInclude) {
                selectedFilterBy = this._currentFormValue['lookupfields'][idx].otherFieldsToInclude[targetControl.targetEntityAttribute];
              }
            }
            if (selectedFilterBy) {
              if (targetControl.filterOperator === FieldConfigFilterOperatorType.CONTAIN_VALUES) {
                filter = `<filter type="and">
                <condition attribute="${targetControl.targetEntityAttribute}" operator="contain-values" >
                  <value>${selectedFilterBy}</value>
                </condition>
                </filter>`;
              } else {
                filter = `<filter type="and">
                <condition attribute="${targetControl.targetEntityAttribute}" operator="${targetControl.filterOperator && targetControl.filterOperator === FieldConfigFilterOperatorType.IN ? 'in' : 'eq'}" value="${selectedFilterBy}"/>
                </filter>`;
              }
            }
          }
        if (!this.device.isOffline) {
          await this.uiService.displayLoader();
            allLookupSearchData = await this.dynamicFormsService.getLookupResults(query, targetControl, filter, this.changeRequest);
          await this.uiService.dismissLoader();
        }
      }
      catch(err){
          console.error(`Error occured while searching lookup results: ${err}`);
      }
    }
    let labelText: string = this._getDisplayText(targetControl.displayNames, targetControl.isCustom);
    let listDetail: MainToolTemplateDetail = {
        title: labelText,
        dividerTitle: this.translate.instant('ALL_CAP') + ' ' + labelText,
        isSearchEnabled: true,
        showLeftHeaderButton: true,
        leftHeaderBtnImgSrc: 'assets/imgs/header_cancel.svg',
        leftHeaderBtnText: this.translate.instant('CANCEL'),
        showRightHeaderButton: true,
        rightHeaderBtnImgSrc: 'assets/imgs/header_complete.svg',
        rightHeaderBtnText: this.translate.instant('DONE'),
        orderByPropertyName: 'primaryTextRight',
        searchTitle: "",
        isListSelectionEnabled: true,
        listSelectionType: MainToolTemplateListSelectionType.SINGLESELECTION,
        navOptions: { animate: false },
        eventsHandler: (data: any, eventTarget: string, refData: MainToolTemplateDetail) => this._handleMainTemplateSelectEvent(data, eventTarget, refData),
        searchHandler: (text: string) => this._handleMainTemplateSearch(text, allLookupSearchData),
        data: allLookupSearchData.map((lookupData: LookupSearchResult) => {
          let isSelected = false;
          if (selectedId && lookupData.id == selectedId) {
            isSelected = true;
          }
          let viewData: MainCardViewDataModel = {
            id: lookupData.id,
            primaryTextLeft: '',
            secondaryTextLeft: '',
            showEndIcon: true,
            mainItemCssClass: 'selector-item',
            isItemSelectedForSelectionView: isSelected,
            endIconType: isSelected ? 'indegene-selectors-checkmark-icon' : 'indegene-selectors-add-icon',
            endIconCssClass: isSelected ? 'checkmark-icon' : 'add-icon',
            primaryTextRight: lookupData.name,
            showArrow: false,
            arrowType: '',
          }
          let secInfoParams = [];
          return viewData;
        }),
    };
    this.navService.pushWithPageTracking(PageName.MainToolTemplateComponent, PageName.NothingSelectedView, { viewData: listDetail }, PageName.MainToolTemplateComponent);
  }

  private _handleProductComponentSearch(text: string, products: Brand[]): string[] {
    let ids: Array<string> = [];
    if (text.length >= 1) {
      ids = products.filter(brand => {
        return brand.name.trim().toLowerCase().includes(text.trim().toLowerCase()) || (brand.productnumber && brand.productnumber.toString().trim().toLowerCase().includes(text.trim().toLowerCase()));
      }).map(brand => brand.ID);
    } else {
      ids = products.map(brand => brand.ID);
    }
    return ids;
  }

  private _handleProductComponentEvent(data: any, eventTarget: string, refData: MainToolTemplateDetail) {
    if (eventTarget && eventTarget == 'RightHeaderButtonClick') {
      if (data && data.isDone && this._activeProductSelectControl) {
        const comparisonValue = this._activeProductSelectControl.isCustom ? this._customFormValue : this._currentFormValue;
        const objName = this._activeProductSelectControl.isCustom ? this._activeProductSelectControl.schemaName : (this._activeProductSelectControl.isCustomAttribute ? this._activeProductSelectControl.schemaName : this._activeProductSelectControl.attributeName);
        let selectedValue = '';
        if (comparisonValue && comparisonValue.hasOwnProperty('lookupfields')) {
          let idx = comparisonValue['lookupfields'].findIndex(a => a.name == objName);
          if (idx >= 0) {
            selectedValue = comparisonValue['lookupfields'][idx].id;
          }
        }
        if (data.removedItems && Array.isArray(data.removedItems) && data.removedItems, length >= 0) {
          data.removedItems.forEach(item => {
            // Remove product
            this._clearAttributeValue(this._activeLookupSearchControl);
          });
        }
        if (data.selectedItems && Array.isArray(data.selectedItems) && data.selectedItems, length >= 0) {
          data.selectedItems.forEach(item => {
            // Select product
            if (!(comparisonValue && selectedValue == item.id)) {
              this._setAttributeStringValue(this._activeProductSelectControl.attributeName, item.primaryTextRight);
              this._setAttributeValue(this._activeProductSelectControl, item.id);
              if (
                this.formDetail?.formMetadata?.entityName === 'indskr_medicalinquiry' &&
                this._activeProductSelectControl?.attributeName === 'omp_product'
              ) {
                const topicControl = this._getTargetControl('omp_topic');
                if (topicControl) {
                  this._clearAttributeValue(topicControl);
                }
                void this._handleMITopicAutoSelect(item.id);
              }
            }
          });
        }
      }
    }
    if (eventTarget && (eventTarget == 'RightHeaderButtonClick' || eventTarget == 'LeftHeaderButtonClick')) {
      this._activeProductSelectControl = null;
    }
  }

  private _createCurrentFormValueForSetBookingProduct(attributeName:string) {
    let _currentFormValueForSetBooking = [];
    if(this.linkedEntityValues && this.linkedEntityValues[attributeName]) {
      this.linkedEntityValues[attributeName].forEach(sp => {
        if(sp.rawObjData && sp.rawObjData.formValue) {
          let productId = '';
          if(sp.rawObjData.formValue.lookupfields) productId = sp.rawObjData.formValue.lookupfields.find(field => field.entity == 'products')?.id ?? '';
          _currentFormValueForSetBooking[productId] = sp.rawObjData?.formValue ;
        } else {
          let productId = sp.rawObjData['indskr_setbookingproduct.indskr_product'];
          let _formValue = {
            "guid": sp.linkedEntityExistingDataId,
            "indskr_quantity": sp.rawObjData['indskr_setbookingproduct.indskr_quantity'],
            "lookupfields": [
              {
                  "name": "indskr_setBooking",
                  "entity": "indskr_setbookings",
                  "id": sp.rawObjData['indskr_setbookingid']
              },
              {
                  "name": "indskr_product",
                  "entity": "products",
                  "id": sp.rawObjData['indskr_setbookingproduct.indskr_product'] ?? ''
              }
            ]
          }
          if(sp.rawObjData['indskr_setbookingproduct.indskr_producttype']) _formValue['indskr_producttype'] = sp.rawObjData['indskr_setbookingproduct.indskr_producttype'];
          _currentFormValueForSetBooking[productId] = _formValue;
        }
      })
    }
    return _currentFormValueForSetBooking;
  }

  private _handleSetBookingProductComponentEvent(data: any, eventTarget: string, refData: MainToolTemplateDetail, formDetail: DynamicFormComponentModel) {
    if (eventTarget && eventTarget == 'RightHeaderButtonClick') {
      const foundControl = this._getTargetControlbyLookupEtity('indskr_setbookingproducts');
      if (data && data.isDone && this._activeProductSelectControl) {
        let _currentFormValueForSetBooking = this._createCurrentFormValueForSetBookingProduct(foundControl.attributeName);
        // Remove Unselected products
        if (data.removedItems && Array.isArray(data.removedItems) && data.removedItems, length >= 0) {
          data.removedItems.forEach(item => {
            if(_currentFormValueForSetBooking && _currentFormValueForSetBooking[item.id]){
              let index;
              if(item.linkedEntityAddedNewDataId) {
                index = this.linkedEntityValues[foundControl.attributeName].findIndex(x => x.linkedEntityAddedNewDataId == item.linkedEntityAddedNewDataId);
              } else {
                index = this.linkedEntityValues[foundControl.attributeName].findIndex(x => x.linkedEntityExistingDataId == item.linkedEntityExistingDataId);
              }
              if (index != -1) {
                this.linkedEntityValues[foundControl.attributeName][index].isDeactivate = true;
              }
              if (_currentFormValueForSetBooking[item.id]) {
                let tempFormValue = _currentFormValueForSetBooking[item.id].lookupfields[0];
                delete _currentFormValueForSetBooking[item.id];
                _currentFormValueForSetBooking[item.id] = { lookupfields: [tempFormValue] };
              }
              if (item.linkedEntityExistingDataId) {
                _currentFormValueForSetBooking[item.id] = { ..._currentFormValueForSetBooking[item.id],
                  guid: item.linkedEntityExistingDataId,
                  statecode: 1,
                  statuscode: 2
                };
              } else if(item.linkedEntityAddedNewDataId) {
                _currentFormValueForSetBooking[item.id] = { ..._currentFormValueForSetBooking[item.id],
                  guid: item.linkedEntityAddedNewDataId,
                  statecode: 1,
                  statuscode: 2
                };
              }
              this.linkedEntityValues[foundControl.attributeName] = this.linkedEntityValues[foundControl.attributeName].filter(x=>x.isDeactivate != true);
              if (this.formDetail && this.formDetail.eventsHandler) {
                let dataReq = {
                  eventsHandler: (data: any, eventName: string) => this.callbackFromParentComponent(data, eventName), //ind-dynamic-form:3349
                  displayConfirmation: this._isFormDirty,
                  linkedEntityExistingDataId: item.linkedEntityExistingDataId || '',
                  linkedEntityAddedNewDataId: item.linkedEntityAddedNewDataId || '',
                  "entity": 'indskr_setbookingproducts',
                  "values": _currentFormValueForSetBooking[item.id],
                }
                this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
                this.formDetail.eventsHandler(dataReq, 'SCRAPLINKEDENTITY', formDetail);
                this._isFormDirty = true;
              }
            }
          });
        }

        //Add Selected Products
        if (data.selectedItems && Array.isArray(data.selectedItems) && data.selectedItems, length >= 0) {
          let setBookingId = formDetail && formDetail.linkedEntityParentData && formDetail.linkedEntityParentData.entity == 'indskr_setbookings' ? formDetail.linkedEntityParentData.id : '';
          data.selectedItems.forEach(item => {
            this._setAttributeValueForSetBookingProduct(this._activeProductSelectControl, item, false, '', _currentFormValueForSetBooking, setBookingId);
          });
        }
        if (formDetail.linkedEntityParentData) {
          try {
            if (this.formDetail && this.formDetail.eventsHandler) {
              data.selectedItems.forEach(item => {
                if (!item.linkedEntityExistingDataId && !item.linkedEntityAddedNewDataId) item.linkedEntityAddedNewDataId = 'indskr_product_' + Math.random().toString(36).substring(7)
                let dataReq = {
                  linkedEntityExistingDataId: item.linkedEntityExistingDataId || '',
                  linkedEntityAddedNewDataId: item.linkedEntityAddedNewDataId || '',
                  "entity": formDetail.LookupEntitySetName,
                  "values": _currentFormValueForSetBooking[item.id],
                }
                this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
                this.formDetail.eventsHandler(dataReq, 'ADDEDLINKEDENTITY', formDetail);
                this._isFormDirty = true;
              })
            }

            if (data) {
              if (foundControl) {
                let abilityToRemoveRecords = foundControl.linkedEntityConfig && foundControl.linkedEntityConfig.abilityToRemoveRecords == '548910000'
                try {
                  if (data.removedItems && Array.isArray(data.removedItems) && data.removedItems.length > 0) {
                    data.removedItems.forEach(item => {
                      if(this.linkedEntityValues[foundControl.attributeName]) delete this.linkedEntityValues[foundControl.attributeName];
                    });
                  }
                  data.selectedItems.forEach(item => {
                    let accordionView: OmniAccordionViewDataModel;
                    let childItems: Array<any> = [];
                    let formattedPrimaryText: string = '';
                    let raw = {
                      "formValue":_currentFormValueForSetBooking[item.id],
                      "formStringValue": {
                          "indskr_product": item.primaryTextRight,
                      },
                      "isSelectedFromSearch": false,
                      "isFormSaved": false
                    }
                    foundControl.subgrid.subgridLayout.forEach(attrib => {
                      let attribName;
                      let index = attrib.attribute.indexOf('.');
                      if (index !== -1) {
                        attribName = attrib.attribute.slice(index + 1);
                      } else {
                        attribName = attrib.attribute;
                      }
                      if (attribName && item) {
                        if (accordionView) {
                          let displayName: string = this._getDisplayText(attrib.displayNames);

                          childItems.push({
                            id: foundControl.attributeName + '_' + attribName,
                            label: displayName ? displayName : '',
                            value: attribName == 'indskr_quantity' ? item.qty : (attribName == 'indskr_name' ? item.primaryTextRight: (attribName == 'indskr_name' ? '' : (attribName == 'indskr_product' ? item.id : ''))),
                          });
                          accordionView.showExpandIcon = true;
                          accordionView.showCollapseIcon = true;
                          accordionView.lookupFieldActualValue = '';
                        } else {
                          accordionView = {
                            displayType: 'Accordion',
                            id: foundControl.attributeName + '_' + attribName + Math.random().toString(36).substring(7),
                            linkedEntityExistingDataId: item.linkedEntityExistingDataId || '',
                            linkedEntityExistingDataAddressId: item.linkedEntityExistingDataAddressId || '',
                            linkedEntityAddedNewDataId: item.linkedEntityAddedNewDataId || '',
                            primaryText: item.primaryTextRight ? `${item.primaryTextRight} | ${this.translate.instant('Quantity')} - ${item.qty}` : '',
                            lookupFieldActualValue: '',
                            showExpandIcon: false,
                            showCollapseIcon: false,
                            isExpanded: false,
                            childItems: [],
                            rawObjData: raw,
                            isUpdatedFormData: true,
                            isDeactivate: false,
                            scrapFromList: abilityToRemoveRecords
                          }
                          if(foundControl.lookupEntitySetName == 'indskr_setbookingproducts') {
                            let ID: string = '';
                            if(item.secondaryTextRight && item.secondaryTextRight.length>0) {
                              let endIndex = item.secondaryTextRight.indexOf(',') > -1 ? item.secondaryTextRight.indexOf(',') : item.secondaryTextRight.length;
                              ID = item.secondaryTextRight.substring(0, endIndex);
                              accordionView.primaryText = `${item.primaryTextRight} | ${ID} | ${this.translate.instant('Quantity')} - ${item.qty}`
                            }
                            accordionView.disableEditArrow = true;
                          }
                        }
                      }
                    });
                    formattedPrimaryText = '';
                    if (accordionView) {
                      if (formattedPrimaryText && this.editConfig !=EditConfig.ADD_NEW) accordionView.primaryText = formattedPrimaryText;
                      accordionView.childItems = childItems;
                      if (this.linkedEntityValues && this.linkedEntityValues[foundControl.attributeName]) {
                        if (item.linkedEntityExistingDataId) {
                          let index = this.linkedEntityValues[foundControl.attributeName].findIndex(x => x.linkedEntityExistingDataId == item.linkedEntityExistingDataId);
                          if (index != -1) {
                            this.linkedEntityValues[foundControl.attributeName][index] = accordionView;
                          } else {
                            this.linkedEntityValues[foundControl.attributeName].push(accordionView);
                          }
                        } else {
                          let index = this.linkedEntityValues[foundControl.attributeName].findIndex(x => x.linkedEntityAddedNewDataId == item.linkedEntityAddedNewDataId);
                          if (index != -1) {
                            this.linkedEntityValues[foundControl.attributeName][index] = accordionView;
                          } else {
                            this.linkedEntityValues[foundControl.attributeName].push(accordionView);
                          }
                        }
                      } else if (this.linkedEntityValues) {
                        this.linkedEntityValues[foundControl.attributeName] = [accordionView];
                      } else {
                        this.linkedEntityValues = {
                          [foundControl.attributeName]: [accordionView]
                        };
                        this.linkedEntityValues[foundControl.attributeName] = this.linkedEntityValues[foundControl.attributeName].filter(x=>x.isDeactivate == false);
                      }

                    }
                  });
                  this.uiService.dismissLoader();
                } catch (error) {
                  this.uiService.dismissLoader();
                  console.log(error);
                }
              }
              this._initViewData();
            }
          } catch (error) {
            console.log(error);
            if (error.error.errorCode == 'ERR_IO_500') {
              this.notificationService.notify('Duplicate Detected: This ' + refData.title + ' has already been added', 'DynamicFormComponent', 'top', ToastStyle.INFO, 3000);
            }
          }
        }
      }
    }
    if (eventTarget && (eventTarget == 'RightHeaderButtonClick' || eventTarget == 'LeftHeaderButtonClick')) {
      this._activeProductSelectControl = null;
    }
  }

  private _createCurrentFormValueForMedicalInquiryProduct(attributeName: string) {
    const _currentFormValueForMI: Record<string, any> = {};
    if (this.linkedEntityValues && this.linkedEntityValues[attributeName]) {
      this.linkedEntityValues[attributeName].forEach(sp => {
        if (sp.rawObjData && sp.rawObjData.formValue) {
          const productId = sp.rawObjData.formValue.lookupfields?.find((f: any) => f.entity === 'products')?.id ?? '';
          _currentFormValueForMI[productId] = sp.rawObjData?.formValue;
        } else {
          const productId = sp.rawObjData['indskr_medicalinquiryproduct.indskr_product'];
          _currentFormValueForMI[productId] = {
            guid: sp.linkedEntityExistingDataId,
            lookupfields: [
              { name: 'indskr_medicalinquiry', entity: 'indskr_medicalinquiries', id: sp.rawObjData['indskr_medicalinquiryid'] },
              { name: 'indskr_product', entity: 'products', id: sp.rawObjData['indskr_medicalinquiryproduct.indskr_product'] ?? '' }
            ]
          };
        }
      });
    }
    return _currentFormValueForMI;
  }

  private _handleMedicalInquiryProductComponentEvent(data: any, eventTarget: string, refData: MainToolTemplateDetail, formDetail: DynamicFormComponentModel) {
    if (eventTarget && eventTarget === 'RightHeaderButtonClick') {
      const foundControl = this._getTargetControlbyLookupEtity('indskr_medicalinquiryproducts');
      if (data && data.isDone && this._activeProductSelectControl && foundControl) {
        const _currentFormValueForMI = this._createCurrentFormValueForMedicalInquiryProduct(foundControl.attributeName);
        if (data.removedItems && Array.isArray(data.removedItems) && data.removedItems.length >= 0) {
          data.removedItems.forEach(item => {
            if (_currentFormValueForMI && _currentFormValueForMI[item.id]) {
              const idx = item.linkedEntityAddedNewDataId
                ? this.linkedEntityValues[foundControl.attributeName].findIndex(x => x.linkedEntityAddedNewDataId === item.linkedEntityAddedNewDataId)
                : this.linkedEntityValues[foundControl.attributeName].findIndex(x => x.linkedEntityExistingDataId === item.linkedEntityExistingDataId);
              if (idx !== -1) this.linkedEntityValues[foundControl.attributeName][idx].isDeactivate = true;
              // const tempFormValue = _currentFormValueForMI[item.id].lookupfields?.[0];
              delete _currentFormValueForMI[item.id];
              // _currentFormValueForMI[item.id] = { lookupfields: tempFormValue ? [tempFormValue] : [] };
              if (item.linkedEntityExistingDataId) {
                _currentFormValueForMI[item.id] = { guid: item.linkedEntityExistingDataId, statecode: 1, statuscode: 2 };
              } else if (item.linkedEntityAddedNewDataId) {
                _currentFormValueForMI[item.id] = { guid: item.linkedEntityAddedNewDataId, statecode: 1, statuscode: 2 };
              }
              this.linkedEntityValues[foundControl.attributeName] = this.linkedEntityValues[foundControl.attributeName].filter(x => x.isDeactivate !== true);
              if (this.formDetail?.eventsHandler) {
                this.formDetail.eventsHandler({
                  eventsHandler: (d: any, eventName: string) => this.callbackFromParentComponent(d, eventName),
                  displayConfirmation: this._isFormDirty,
                  linkedEntityExistingDataId: item.linkedEntityExistingDataId || '',
                  linkedEntityAddedNewDataId: item.linkedEntityAddedNewDataId || '',
                  entity: 'indskr_medicalinquiryproducts',
                  values: _currentFormValueForMI[item.id]
                }, 'SCRAPLINKEDENTITY', formDetail);
                this._isFormDirty = true;
              }
            }
          });
        }
        if (data.selectedItems && Array.isArray(data.selectedItems) && data.selectedItems.length >= 0) {
          const medicalInquiryId = formDetail?.linkedEntityParentData?.entity === 'indskr_medicalinquiries' ? formDetail.linkedEntityParentData.id : '';
          data.selectedItems.forEach(item => {
            this._setAttributeValueForMedicalInquiryProduct(this._activeProductSelectControl, item, false, '', _currentFormValueForMI, medicalInquiryId);
          });
        }
        if (formDetail?.linkedEntityParentData && this.formDetail?.eventsHandler) {
          try {
            data.selectedItems.forEach(item => {
              if (!item.linkedEntityExistingDataId && !item.linkedEntityAddedNewDataId) item.linkedEntityAddedNewDataId = 'indskr_product_' + Math.random().toString(36).substring(7);
              this.formDetail.eventsHandler({
                linkedEntityExistingDataId: item.linkedEntityExistingDataId || '',
                linkedEntityAddedNewDataId: item.linkedEntityAddedNewDataId || '',
                entity: foundControl?.lookupEntitySetName,
                values: _currentFormValueForMI[item.id],
                linkedEntityFormStringValue: { indskr_product: item.primaryTextRight || '' },
              }, 'ADDEDLINKEDENTITY', formDetail);
              this._isFormDirty = true;
            });
            if (foundControl) {
              const abilityToRemoveRecords = foundControl.linkedEntityConfig?.abilityToRemoveRecords == '548910000'; 
              data.selectedItems.forEach(item => {
                const raw = {
                  formValue: _currentFormValueForMI[item.id],
                  formStringValue: { indskr_product: item.primaryTextRight },
                  isSelectedFromSearch: false,
                  isFormSaved: false
                };
                let accordionView: OmniAccordionViewDataModel;
                const childItems: any[] = [];
                foundControl.subgrid.subgridLayout.forEach(attrib => {
                  const attribName = attrib.attribute.indexOf('.') !== -1 ? attrib.attribute.slice(attrib.attribute.indexOf('.') + 1) : attrib.attribute;
                  if (attribName === 'indskr_quantity') return;
                  if (attribName && item) {
                    if (accordionView) {
                      childItems.push({
                        id: foundControl.attributeName + '_' + attribName,
                        label: this._getDisplayText(attrib.displayNames) || '',
                        value: attribName === 'indskr_product' ? item.id : item.primaryTextRight
                      });
                      accordionView.showExpandIcon = true;
                      accordionView.showCollapseIcon = true;
                    } else {
                      accordionView = {
                        displayType: 'Accordion',
                        id: foundControl.attributeName + '_' + attribName + Math.random().toString(36).substring(7),
                        linkedEntityExistingDataId: item.linkedEntityExistingDataId || '',
                        linkedEntityExistingDataAddressId: item.linkedEntityExistingDataAddressId || '',
                        linkedEntityAddedNewDataId: item.linkedEntityAddedNewDataId || '',
                        primaryText: item.primaryTextRight || '',
                        lookupFieldActualValue: '',
                        showExpandIcon: false,
                        showCollapseIcon: false,
                        isExpanded: false,
                        childItems: [],
                        rawObjData: raw,
                        isUpdatedFormData: true,
                        isDeactivate: false,
                        scrapFromList: abilityToRemoveRecords
                      };
                      if (foundControl.lookupEntitySetName === 'indskr_medicalinquiryproducts' || foundControl.lookupEntitySetName === 'indskr_medicalinquiryproduct') {
                        accordionView.disableEditArrow = true;
                      }
                    }
                  }
                });
                if (accordionView) {
                  accordionView.childItems = childItems;
                  if (!this.linkedEntityValues) this.linkedEntityValues = {};
                  if (!this.linkedEntityValues[foundControl.attributeName]) this.linkedEntityValues[foundControl.attributeName] = [];
                  const existingIdx = this.linkedEntityValues[foundControl.attributeName].findIndex(
                    x => (x.linkedEntityExistingDataId && x.linkedEntityExistingDataId === item.linkedEntityExistingDataId) ||
                      (x.linkedEntityAddedNewDataId && x.linkedEntityAddedNewDataId === item.linkedEntityAddedNewDataId)
                  );
                  if (existingIdx !== -1) {
                    this.linkedEntityValues[foundControl.attributeName][existingIdx] = accordionView;
                  } else {
                    this.linkedEntityValues[foundControl.attributeName].push(accordionView);
                  }
                }
              });
              this._initViewData();
            }
          } catch (err) {
            if (err?.error?.errorCode === 'ERR_IO_500') {
              this.notificationService.notify('Duplicate Detected: This ' + refData.title + ' has already been added', 'DynamicFormComponent', 'top', ToastStyle.INFO, 3000);
            }
          }
        }
      }
    }
    if (eventTarget && (eventTarget === 'RightHeaderButtonClick' || eventTarget === 'LeftHeaderButtonClick')) {
      this._activeProductSelectControl = null;
    }
  }

  // Config-driven field rules (IO Config: FORM_FIELD_RULES_<ENTITY>). Drives show/hide, required, and
  // auto-population of a target field from a related entity (e.g. Contact) based on a trigger field's
  // selected value — e.g. Medical Inquiry's Response Preference showing/requiring/populating Email or
  // Phone number. Config-absence is a no-op, so this has zero effect on entities without a matching config.
  private _loadConfiguredFieldRules(): void {
    this._configuredFieldRules = [];
    const entityName = this.formDetail?.formMetadata?.entityName;
    if (!entityName) return;
    const configKey = `FORM_FIELD_RULES_${entityName.toUpperCase()}`;
    const config = this.authService.user.ioConfigurations?.find(
      o => o.featureCode === configKey || o.configName === configKey
    );
    if (!config?.configValue) return;
    try {
      const parsed = JSON.parse(config.configValue);
      if (parsed?.entity === entityName && Array.isArray(parsed.rules)) {
        this._configuredFieldRules = parsed.rules;
      }
    } catch (error) {
      console.error('Error parsing configured field rules:', error);
    }
  }

  private _runConfiguredFieldRules(changedFieldName: string, explicitValue?: any, skipPopulate: boolean = false): void {
    if (this._configuredFieldRules === undefined) {
      this._loadConfiguredFieldRules();
    }
    if (!this._configuredFieldRules?.length || !changedFieldName) return;
    this._configuredFieldRules
      .filter(rule => rule?.reevaluateOn?.includes(changedFieldName))
      .forEach(rule => this._applyConfiguredFieldRule(rule, changedFieldName, explicitValue, skipPopulate));
  }

  private _applyConfiguredFieldRule(rule: any, changedFieldName?: string, explicitValue?: any, skipPopulate: boolean = false): void {
    const mappings = rule.mappings || {};
    const triggerValue = (rule.triggerField === changedFieldName && explicitValue !== undefined)
      ? explicitValue
      : this._getAttributeValue(rule.triggerField);
    const activeMapping = mappings[String(triggerValue)];

    // Show+require the active mapping's field, hide+un-require every other mapped field.
    // No Business Rule can be relied on for this today, so this owns visibility outright.
    Object.keys(mappings).forEach(optionValue => {
      const mapping = mappings[optionValue];
      const control = this._getTargetControl(mapping.targetField);
      if (!control) return;
      const isActive = mapping === activeMapping;
      control.forceHide = !isActive;
      if (mapping.required) {
        this._setIsRequired(isActive ? 'required' : 'none', mapping.targetField);
      }
    });

    if (activeMapping && !skipPopulate) {
      const targetControl = this._getTargetControl(activeMapping.targetField);
      if (targetControl) {
        const refValue = (rule.refField === changedFieldName && explicitValue !== undefined)
          ? explicitValue
          : this._getAttributeValue(rule.refField);
        this._populateConfiguredField(rule, activeMapping, targetControl, refValue);
      }
    }
    this._initViewData();
  }

  private _populateConfiguredField(rule: any, mapping: any, targetControl: Control, refValue: any): void {
    const record = refValue ? this._resolveConfiguredRefEntity(rule.refEntity, refValue) : null;
    const value = record ? this._extractConfiguredSourceValue(record, mapping.sources) : null;
    // Always write, even when nothing was found — a stale value from a previously selected
    // contact must not survive a contact change just because the new contact has no data.
    this._setAttributeStringValue(targetControl.attributeName, value || '');
    this._setAttributeValue(targetControl, value || null, false, '', false);
  }

  private _resolveConfiguredRefEntity(refEntity: string, id: string): any {
    switch (refEntity) {
      case 'contact':
        return this.contactService.getContactByID(id);
      default:
        return undefined;
    }
  }

  private _extractConfiguredSourceValue(record: any, sources: any[]): string | null {
    if (!Array.isArray(sources)) return null;
    for (const source of sources) {
      let value: any = null;
      if (source.kind === 'field') {
        value = record?.raw?.[source.attribute] ?? null;
      } else if (source.kind === 'list') {
        const list = record?.[source.listProperty] || [];
        const match = list.find(item => item[source.matchAttribute] === source.matchValue);
        value = match?.[source.valueAttribute] ?? null;
      }
      if (value) return value;
    }
    return null;
  }

  // Dynamics visibility rules hide fields but never clear their values — clear them here so stale values don't reach the payload.
  private _clearHiddenPreferredContactFields(): void {
    if (this.formDetail?.formMetadata?.entityName !== 'indskr_medicalinquiry') return;
    ['indskr_phonenumber', 'indskr_emailaddress', 'indskr_faxnumber'].forEach(attributeName => {
      const control = this._getTargetControl(attributeName);
      if (control && control.forceHide) {
        this._setAttributeValue(control, null, false, '', false);
      }
    });
  }

  private _updateMITopicVisibility(): void {
    if (this.formDetail?.formMetadata?.entityName !== 'indskr_medicalinquiry') return;
    const topicControl = this._getTargetControl('omp_topic');
    if (!topicControl) return;
    // omp_product is a direct LookupType field (not a subgrid) on the MI entity.
    // _currentFormStringValues['omp_product'] is set when the user selects or clears the lookup in the
    // current session. On the very first _initViewData call it may be undefined (not yet processed),
    // so fall back to formEntityObject which carries the pre-existing server value.
    const productStrValue = this._currentFormStringValues?.['omp_product'];
    const hasProduct = productStrValue !== undefined
      ? !!productStrValue
      : !!(this.formDetail?.formEntityObject?.['_omp_product_value'] || this.formDetail?.formEntityObject?.['omp_product']);
    topicControl.forceHide = !hasProduct;
  }

  private async _handleMITopicAutoSelect(productId: string): Promise<void> {
    const topicControl = this._getTargetControl('omp_topic');
    if (!topicControl) return;
    // Only fill in when config is absent, same guard the CRM-config-driven setup blocks use -
    // this control may already carry a different org's own configured filterby/target (e.g.
    // 'omp_brand'/'omp_brandref'), which must not be stomped with the indskr_product default.
    if (!topicControl.filterby) topicControl.filterby = 'omp_product';
    if (!topicControl.filterFieldTargetLookupEntity) topicControl.filterFieldTargetLookupEntity = 'indskr_product';
    const targetAttribute = topicControl.filterFieldTargetLookupEntity;
    let results: any[];
    if (this.device.isOffline) {
      const allTopics = this.dynamicFormsService.getMIFormLookupFields()?.['omp_topic'] || [];
      results = allTopics.filter(t => t.filterFieldValue === productId);
    } else {
      const filterXml = `<filter type="and"><condition attribute="${targetAttribute}" operator="eq" value="${productId}"/></filter>`;
      const fetched = await this.dynamicFormsService.getLookupResults('', topicControl, filterXml, false);
      results = Array.isArray(fetched) ? fetched : [];
    }
    if (results.length !== 1) return;
    const topic = results[0];
    this._setAttributeStringValue('omp_topic', topic.name);
    this._setAttributeValue(topicControl, topic.id, false);
    this._initViewData();
  }

  private _setAttributeValueForMedicalInquiryProduct(control: Control, value: any, initViewData = true, codIdOnekey = '', _formValue: Record<string, any>, medicalInquiryId: string) {
    const objName = control.isCustomAttribute ? control.schemaName : control.attributeName;
    const cfvObj = { name: objName, entity: control.lookupEntitySetName, id: value.id };
    if (_formValue && _formValue[value.id]) {
      const selectedFormValue = _formValue[value.id];
      if (selectedFormValue.lookupfields) {
        const idx = selectedFormValue.lookupfields.findIndex((a: any) => a.name === objName);
        if (idx >= 0) {
          selectedFormValue.lookupfields[idx] = cfvObj;
        } else {
          selectedFormValue.lookupfields.push(cfvObj);
        }
      } else {
        selectedFormValue.lookupfields = [cfvObj];
      }
    } else {
      _formValue[value.id] = {
        lookupfields: [
          { name: 'indskr_medicalinquiry', entity: 'indskr_medicalinquiries', id: medicalInquiryId },
          { name: 'indskr_product', entity: 'products', id: value.id ?? '' }
        ]
      };
      if (value.linkedEntityExistingDataId) _formValue[value.id].guid = value.linkedEntityExistingDataId;
      else if (value.linkedEntityAddedNewDataId) _formValue[value.id].guid = value.linkedEntityAddedNewDataId;
    }
    this._isFormDirty = true;
    this.dynamicFormsService.linkedEntityFormIsDirtyTracker = true;
    if (this.formDetail?.eventsHandler) {
      const payload = this.formDetail.LookupEntitySetName === 'indskr_medicalinquiries'
        ? { isDirty: this._isFormDirty, formValue: this._currentFormValue, formStringValue: this._currentFormStringValues }
        : true;
      this.formDetail.eventsHandler(payload, 'ISFORMDIRTY');
    }
    if (initViewData) this._initViewData();
    else this._targetControlViewData(control);
  }

  private _handleMainTemplateSearch(text: string, allLookupSearchData: LookupSearchResult[]): string[] {
    let ids: Array<string> = [];
    if (text.length >= 1) {
      ids = allLookupSearchData.filter(lookupItem => {
        return lookupItem.name.trim().toLowerCase().includes(text.trim().toLowerCase());
      }).map(lookupItem => lookupItem.id);
    } else {
      ids = allLookupSearchData.map(lookupItem => lookupItem.id);
    }
    return ids;
  }

  private async _handleMainTemplateSelectEvent(data: any, eventTarget: string, refData: MainToolTemplateDetail) {
    if (eventTarget && eventTarget == 'RightHeaderButtonClick') {
      if (data && data.isDone && this._activeMainTemplateLookupSelectControl) {
        const comparisonValue = this._activeMainTemplateLookupSelectControl.isCustom ? this._customFormValue : this._currentFormValue;
        const objName = this._activeMainTemplateLookupSelectControl.isCustom ? this._activeMainTemplateLookupSelectControl.schemaName : (this._activeMainTemplateLookupSelectControl.isCustomAttribute ? this._activeMainTemplateLookupSelectControl.schemaName : this._activeMainTemplateLookupSelectControl.attributeName);
        let selectedValue = '';
        if (comparisonValue && comparisonValue.hasOwnProperty('lookupfields')) {
          let idx = comparisonValue['lookupfields'].findIndex(a => a.name == objName && !(a['isDeleted'] && a['isDeleted'] === true));
          if (idx >= 0) {
            selectedValue = comparisonValue['lookupfields'][idx].id;
          }
        }
        if (data.removedItems && Array.isArray(data.removedItems) && data.removedItems, length >= 0) {
          data.removedItems.forEach(item => {
            // Remove product
            this._clearAttributeValue(this._activeLookupSearchControl);
          });
        }
        if (data.selectedItems && Array.isArray(data.selectedItems) && data.selectedItems, length >= 0) {
          data.selectedItems.forEach(item => {
            // Select product
            if (!(comparisonValue && selectedValue == item.id)) {
              //If the filterby field is reset, then clear the lookup fields depending on it
              if (this._currentFormValue && this._currentFormValue['lookupfields']) {
                this._currentFormValue['lookupfields'].forEach(lookup => {
                  if(!(lookup['isDeleted'] && lookup['isDeleted']==true)){
                    let lookupControl: Control = this._getTargetControl(lookup.name);
                    if(!lookupControl)
                      lookupControl = this._getTargetControlbySchemaName(lookup.name);
                    if(lookupControl && lookupControl.filterby && lookupControl.filterby == objName){
                      this._clearAttributeValue(lookupControl);
                    }
                  }
                });
              }
              this._setAttributeStringValue(this._activeMainTemplateLookupSelectControl.attributeName, item.primaryTextRight);
              this._setAttributeValue(this._activeMainTemplateLookupSelectControl, item.id);
            }
          });
        }
      }
    }
    if (eventTarget && (eventTarget == 'RightHeaderButtonClick' || eventTarget == 'LeftHeaderButtonClick')) {
      this._activeMainTemplateLookupSelectControl = null;
    }
    // else if (eventTarget && eventTarget === 'LeftHeaderButtonClick') {
    if (eventTarget && eventTarget === 'MainItemEvents-mainItem') {
      if(data && data.id && this._activeLookupSearchControl && this._activeLookupSearchControl.lookupEntitySetName) {
        //getFormDefinitionForEntity could have been used as well
        let fetchXML = MOBILE_FORMS_DISPLAY_ENTITY_FILTER;
        fetchXML = fetchXML.replace('{entityName}', `${this._activeLookupSearchControl.lookupEntitySetName.slice(0,-1)}`);
        try{
          this.uiService.displayLoader();
          await this.dynamics.executeFetchQuery("indskr_mobileappforms", fetchXML).then(async (res)=>{
            if(!isEmpty(res) && res[0] != undefined){
              let lookupEnityDisplayForm =new DynamicForm(res[0]);
              let fetchXMLForLookupEntity = `
              <fetch distinct="true" mapping="logical" output-format="xml-platform" version="1.0" >
                <entity name="${this._activeLookupSearchControl.lookupEntitySetName.slice(0,-1)}">
                  <all-attributes />
                  <filter type="and">
                  <condition attribute="${this._activeLookupSearchControl.lookupEntityPrimaryId}" value="${data.id}" operator="eq"/>
                  </filter>
                </entity>
              </fetch>`
              await this.dynamics.executeFetchQuery(this._activeLookupSearchControl.lookupEntitySetName, fetchXMLForLookupEntity).then((rawData)=>{
                if(!isEmpty(rawData) && rawData[0] != undefined){
                  let detailViewHeaderData;
                  detailViewHeaderData = {
                    showLeftHeaderButton: this.device.isMobileDevice,
                    leftHeaderBtnIcon: 'chevron-back-outline',
                  }
                  this.navService.pushChildNavPageWithPageTracking(PageName.MainToolTemplateDetailsComponent, PageName.MainToolTemplateDetailsComponent, PageName.MainToolTemplateComponent, { formMetadata: lookupEnityDisplayForm, rawData: rawData[0] , isEditEnabled: false, for: "displayForm", viewData: detailViewHeaderData});
                  this.navService.setChildNavRightPaneView(true);
                  this.uiService.showRightPane = true;
                }
              })
            }
          });
          this.uiService.dismissLoader();
        } catch(e){
          this.uiService.dismissLoader();
          console.error("Error in fetching display form for lookup entity: " + e);
          this.notificationService.notify(this.translate.instant("SOMETHING_REALLY_BAD_HAPPENED"), 'Ind Dynamic Form', 'top', ToastStyle.DANGER);
          return;
        }
      }
    }
  }

  private async _handleBooleanFormField(id, event, eventName, control: Control) {
    let dropdownListDetail: IndDropdownListDetailModel = {
      id: 'dynamic-form-boolean-field-select',
      showClearAllBtn: true,
      clearAllBtnText: this.translate.instant('CLEAR'),
      data: [
        {
          title: this.translate.instant('YES'),
          id: 'Yes',
          isSelected: (this._currentFormValue && this._currentFormValue[id] == true) ? true : false,
        },
        {
          title: this.translate.instant('NO'),
          id: 'No',
          isSelected: (this._currentFormValue && this._currentFormValue[id] == false) ? true : false,
        }
      ],
    };
    this._dropdownPopover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: { viewData: dropdownListDetail },
      cssClass: 'dropdown-list-view',
      event: event
    });
    this._dropdownPopover.onDidDismiss().then(async (data: any) => {
      let newSelectedValue = ((this._currentFormValue && this._currentFormValue[id] == true) || (this._currentFormValue && this._currentFormValue[id] == false))?'yes':null;
      if (data.data) data = data.data;
      let isNoSeeFlagYes = false;
      if (data && data.selectedItems && data.selectedItems.length == 1) {
        if (data.selectedItems[0].id == 'Yes') {
          this._setAttributeStringValue(control.attributeName, this.translate.instant('YES'));
          this._setAttributeValue(control, true, false);
          isNoSeeFlagYes = true;
        } else if (data.selectedItems[0].id == 'No') {
          this._setAttributeStringValue(control.attributeName, this.translate.instant('NO'));
          this._setAttributeValue(control, false, false);
          isNoSeeFlagYes = false;
        }
        newSelectedValue = 'yes';
      } else if (data && data.selectedItems && data.selectedItems.length == 0) {
        newSelectedValue = null;
        this._clearAttributeValue(control);
        isNoSeeFlagYes = false;
      }else{
        if(control.isRequired && this.dynamicFormsService.getFormFieldType(control) !== FormFieldType.INLINE_INPUT){
          this._validateMandatoryField(id,null,{value:newSelectedValue},false);
        }
      }

      // Show/hide exe_deletereason_new based on exe_noseeflag_new value
      if (control.attributeName === 'exe_noseeflag_new' && this._dynamicForm?.formId?.includes("Exeltis Delete CR Form")) {
        this._toggleExeltisDeleteReasonVisibility(isNoSeeFlagYes);
        // Rebuild the view to reflect the forceHide change
        this._initViewData();
      }

      this._dropdownPopover = undefined;
    })
    this._dropdownPopover.present();
  }

  private async _handleDropdownMultiSelectListFormField(id, event, eventName, targetControl: Control) {
    let selectedValue = [];
    if (this._currentFormValue && this._currentFormValue.hasOwnProperty(targetControl.attributeName)) {
      selectedValue = this._currentFormValue[targetControl.attributeName].split(',');
    }
    let dropdownListDetail: IndDropdownListDetailModel = this.dynamicFormsService.getDropdownListViewFromOptionSet(targetControl.optionSet, selectedValue, this._activeLanguageCode);
    dropdownListDetail.showCancelandDoneBtn = true;
    dropdownListDetail.pageTitle = this._getDisplayText(targetControl.displayNames, targetControl.isCustom);
    dropdownListDetail.isMultipleSelectionEnabled = true;
    this._dropdownPopover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: { viewData: dropdownListDetail },
      cssClass: 'dropdown-list-view',
      event: event
    });
    let newSelectedValue:any = selectedValue;
    this._dropdownPopover.onDidDismiss().then(async (data: any) => {
      data = data.data;
      if (data && !data.isDone) {
        this._dropdownPopover.dismiss();
      } else if (data && data.selectedItems && data.selectedItems.length == 1) {
        if (!(this._currentFormValue && this._currentFormValue.hasOwnProperty(targetControl.attributeName) && this._currentFormValue[targetControl.attributeName] == data.selectedItems[0].id)) {
          this._setAttributeStringValue(targetControl.attributeName, data.selectedItems[0].title);
          this._setAttributeValue(targetControl, data.selectedItems[0].id, false);
          newSelectedValue = data.selectedItems[0].id;
        }
      } else if (data && data.selectedItems && data.selectedItems.length > 1) {
        data.selectedItems = data.selectedItems.sort((a,b) => {
          return (a.title > b.title) ? 1: -1;
        })
        let concatString = '';
        let concatID = '';
        for(let i = 0; i<data.selectedItems.length; i++){
          concatString += data.selectedItems[i].title;
          concatID += data.selectedItems[i].id;
          if(i<data.selectedItems.length-1) {
            concatString += ', ';
            concatID += ', ';
          }
        }
        this._setAttributeStringValue(targetControl.attributeName, concatString);
        this._setAttributeValue(targetControl, concatID, false);
        newSelectedValue = concatID;
      } else if (data && data.selectedItems && data.selectedItems.length == 0) {
        this._clearAttributeValue(targetControl);
        newSelectedValue = null;
      }
      if(targetControl.isRequired && this.dynamicFormsService.getFormFieldType(targetControl) !== FormFieldType.INLINE_INPUT){
        this._validateMandatoryField(id,null,{value:newSelectedValue},false);
      }
      this._dropdownPopover = undefined;
    });
    this._dropdownPopover.present();
  }

  private async _handleDropdownListFormField(id, event, eventName, targetControl: Control) {
    let selectedValue = '';
    if (this._currentFormValue && this._currentFormValue.hasOwnProperty(targetControl.attributeName)) {
      selectedValue = this._currentFormValue[targetControl.attributeName];
    }
    let dropdownListDetail: IndDropdownListDetailModel = this.dynamicFormsService.getDropdownListViewFromOptionSet(targetControl.optionSet, selectedValue, this._activeLanguageCode);
    dropdownListDetail.showClearAllBtn = targetControl.attributeName =='indskr_producttype' ? false : true;
    dropdownListDetail.clearAllBtnText = this.translate.instant('CLEAR');
    // Cascading option sets for Kit Booking Operation Type/Operation Sub-Type/Assisted Technology
    if(targetControl && targetControl.attributeName == 'indskr_operationsubtype') {
      if(!(this._currentFormValue && this._currentFormValue['indskr_operationtype'])) {
        this.notificationService.notify('Please select Operation Type','ind-dynamic-form','top',ToastStyle.DANGER);
        return;
      }
      let typeControl: Control = this._getTargetControl('indskr_operationtype');
      let dropdownTypeListDetail: IndDropdownListDetailModel = this.dynamicFormsService.getDropdownListViewFromOptionSet(typeControl.optionSet, '', this._activeLanguageCode);
      let foundTypeOption = dropdownTypeListDetail.data.find(option => option.id ==  this._currentFormValue['indskr_operationtype']);
      let typeConfig =  this.authService.user.ioConfigurations?.find(o=>o.configName=="KitBooking.OperationTypes.SubTypes.Relation");
      if(typeConfig && typeConfig.configValue && foundTypeOption) {
        let selectedTypeConfig = JSON.parse(typeConfig.configValue).find(o=> o["operationType"].toLowerCase().trim() == foundTypeOption.title.toLowerCase().trim());
        if(selectedTypeConfig && selectedTypeConfig['operationSubTypes'] && dropdownListDetail && dropdownListDetail.data) {
          dropdownListDetail.data.forEach(d => {
            if(!selectedTypeConfig['operationSubTypes'].some(subtype => subtype.toLowerCase().trim() == d.title.toLowerCase().trim())) d.isForcehide = true;
          })
        } else {
          this.notificationService.notify('No Operation Sub-Type is available for the Selected Operation Type','ind-dynamic-form','top',ToastStyle.DANGER);
          return;
        }
      }
    } else if (targetControl && targetControl.attributeName == 'indskr_assistedtechnology') {
      if(!(this._currentFormValue && this._currentFormValue['indskr_operationsubtype'])) {
        this.notificationService.notify('Please select Operation Sub-Type','ind-dynamic-form','top',ToastStyle.DANGER);
        return;
      }
      let subTypeControl: Control = this._getTargetControl('indskr_operationsubtype');
      let dropdownSubTypeListDetail: IndDropdownListDetailModel = this.dynamicFormsService.getDropdownListViewFromOptionSet(subTypeControl.optionSet, '', this._activeLanguageCode);
      let foundSubTypeOption = dropdownSubTypeListDetail.data.find(option => option.id ==  this._currentFormValue['indskr_operationsubtype']);
      let techConfig =  this.authService.user.ioConfigurations?.find(o=>o.configName=="KitBooking.OperationSubTypes.Technology.Relation");
      if(techConfig && techConfig.configValue && foundSubTypeOption) {
        let selectedSubTypeConfig = JSON.parse(techConfig.configValue).find(o=> o["operationSubType"].toLowerCase().trim() == foundSubTypeOption.title.toLowerCase().trim());
        if(selectedSubTypeConfig && selectedSubTypeConfig['assistedTechnologies'] && dropdownListDetail && dropdownListDetail.data) {
          dropdownListDetail.data.forEach(d => {
            if(!selectedSubTypeConfig['assistedTechnologies'].some(tech => tech.toLowerCase().trim() == d.title.toLowerCase().trim())) d.isForcehide = true;
          })
        } else {
          this.notificationService.notify('No Assisted Technology is available for the Selected Operation Sub-Type','ind-dynamic-form','top',ToastStyle.DANGER);
          return;
        }
      }
    } else if (targetControl) {
      if (this._configuredFieldRules === undefined) {
        this._loadConfiguredFieldRules();
      }
      const rule = this._configuredFieldRules?.find(r => r.triggerField === targetControl.attributeName);
      if (rule?.allowedValues?.length && dropdownListDetail?.data) {
        dropdownListDetail.data.forEach(d => {
          if (!rule.allowedValues.some(v => String(v) === String(d.id))) d.isForcehide = true;
        });
      }
    }
    this._dropdownPopover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: { viewData: dropdownListDetail },
      cssClass: 'dropdown-list-view',
      event: event
    });
    this._dropdownPopover.onDidDismiss().then(async (data: any) => {
      data = data.data;
      let newSelectedValue = selectedValue;
      if (data && data.selectedItems && data.selectedItems.length == 1) {
        if (!(this._currentFormValue && this._currentFormValue.hasOwnProperty(targetControl.attributeName) && this._currentFormValue[targetControl.attributeName] == data.selectedItems[0].id)) {
          this._setAttributeStringValue(targetControl.attributeName, data.selectedItems[0].title);
          this._setAttributeValue(targetControl, data.selectedItems[0].id, false);
          if (targetControl.attributeName == 'indskr_rolepharma'
          || targetControl.attributeName == 'indskr_rolevaccine'
          || targetControl.attributeName == 'indskr_departmentvaccine'
          || targetControl.attributeName == 'indskr_positionretail'
          || targetControl.attributeName == 'indskr_titleretail'
          || targetControl.attributeName == 'indskr_titlepharma') {
            let selectedOption = targetControl.optionSet.filter(o => o.value == data.selectedItems[0].id);
            if (selectedOption && selectedOption.length) {
              this._currentFormStringValues[targetControl.attributeName + '_Desc'] = selectedOption[0].descriptions[0].description;
            }
          }
          if (targetControl.attributeName == 'indskr_preferredmodeofcontact') {
            this._runConfiguredFieldRules(targetControl.attributeName, data.selectedItems[0].id);
            this._clearHiddenPreferredContactFields();
          }
          newSelectedValue =data.selectedItems[0].id;
        }
      } else if (data && data.selectedItems && data.selectedItems.length == 0) {
        this._clearAttributeValue(targetControl);
        this._runBusinessRulesLogic(); //for every dropdown clear in every entity we re-run business rule, eg: to show/hide dependent fields
        if (targetControl.attributeName == 'indskr_preferredmodeofcontact') {
          // _clearAttributeValue (called above) already ran _runConfiguredFieldRules for this field.
          this._clearHiddenPreferredContactFields();
        }
        newSelectedValue = null;
      }
      if(targetControl.isRequired && this.dynamicFormsService.getFormFieldType(targetControl) !== FormFieldType.INLINE_INPUT){
        this._validateMandatoryField(id,null,{value:newSelectedValue},false);
      }
      this._dropdownPopover = undefined;
    });
    this._dropdownPopover.present();
  }

  private _handleDateTimeFormField(id, event, eventName, targetControl: Control) {
    if (targetControl && this.dynamicFormDateTimePicker) {
      if (targetControl.dataType == ControlDataType.DateTimeType) {
        this._dateTimePickerActiveControl = undefined;
        if (targetControl.dateFormat == DateFormat.DateAndTime) {
          if (this._currentFormValue && this._currentFormValue.hasOwnProperty(targetControl.attributeName) && this._currentFormValue[targetControl.attributeName]) {
            const date = new Date(this._currentFormValue[targetControl.attributeName]);
            var date_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), 0);
            this.dynamicFormDateTimePicker.value = (new Date(date_utc).toISOString());
          } else {
            const date = new Date();
            var date_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), 0);
            this.dynamicFormDateTimePicker.value = (new Date(date_utc).toISOString());
          }
        } else if (targetControl.dateFormat == DateFormat.DateOnly) {
          if (this._currentFormValue && this._currentFormValue.hasOwnProperty(targetControl.attributeName) && this._currentFormValue[targetControl.attributeName]) {
            const date = new Date(this._currentFormValue[targetControl.attributeName]);
            var date_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
            this.dynamicFormDateTimePicker.value = (new Date(date_utc).toISOString());
          } else {
            const date = new Date();
            var date_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
            this.dynamicFormDateTimePicker.value = (new Date(date_utc).toISOString());
          }
          //provision to select future years, setting upto next 50 years[OMNI-16297]
          this.dynamicFormDateTimePicker.max = (new Date().getFullYear() + 50).toString();
        }
        if (id == 'omnione_yearofbirth') {
        } else if (id == 'omnione_dayandmonthofbirth') {
        } else {
        }
        setTimeout(() => {
          this._dateTimePickerActiveControl = targetControl;
        }, 50);
      }
    }
  }

  public updateFormDate(event) {
    if (event && event.value && this._dateTimePickerActiveControl) {
      if (this._dateTimePickerActiveControl.dataType == ControlDataType.DateTimeType) {
        let valueDate = new Date(event.value);
        if (this._dateTimePickerActiveControl.dateFormat == DateFormat.DateAndTime) {
          this._setAttributeValueDate(this._dateTimePickerActiveControl, valueDate);
        } else if (this._dateTimePickerActiveControl.dateFormat == DateFormat.DateOnly) {
          valueDate.setHours(0, 0, 0, 0);
          if (this._dateTimePickerActiveControl && this._dateTimePickerActiveControl.attributeName == 'omnione_yearofbirth') {
            const targetControl: Control = this._dateTimePickerActiveControl;
            const isUserLocal: boolean = targetControl.dateBehavior == 'UserLocal';
            if (this._currentFormStringValues && this._currentFormStringValues['omnione_dayandmonthofbirth']) {
              const dateOfBirth: Date = new Date(this._currentFormStringValues['omnione_dayandmonthofbirth']);
              const dayAndMonthOfBirth: string = this.dateTimeFormatsService.formatDate(dateOfBirth, 'MM/DD');
              const selectedYear: string = this.dateTimeFormatsService.formatDate(valueDate, 'YYYY');
              const combinedYearMonthDay: string = selectedYear + '/' + dayAndMonthOfBirth;
              valueDate = new Date(combinedYearMonthDay);
              const selectedDateUTC = new Date(valueDate).toISOString();
              const formattedDate = selectedDateUTC;
              const formattedDateValue = isUserLocal ? formattedDate : valueDate;
              this._setAttributeValueDate(targetControl, formattedDateValue);
              const targetControlDayAndMonth: Control = this._getTargetControl('omnione_dayandmonthofbirth');
              this._setAttributeValueDate(targetControlDayAndMonth, formattedDateValue);
            } else {
              const selectedDateUTC = new Date(valueDate).toISOString();
              const formattedDate = selectedDateUTC;
              const formattedDateValue = isUserLocal ? formattedDate : valueDate;
              this._setAttributeValueDate(targetControl, formattedDateValue);
            }
          } else if (this._dateTimePickerActiveControl && this._dateTimePickerActiveControl.attributeName == 'omnione_dayandmonthofbirth') {
            const targetControl: Control = this._dateTimePickerActiveControl;
            const isUserLocal: boolean = targetControl.dateBehavior == 'UserLocal';
            if (this._currentFormStringValues && this._currentFormStringValues['omnione_yearofbirth']) {
              const dateOfBirth: Date = new Date(this._currentFormStringValues['omnione_yearofbirth']);
              const yearOfBirth: string = this.dateTimeFormatsService.formatDate(dateOfBirth, 'YYYY');
              const selectedDayAndMonthOfBirth: string = this.dateTimeFormatsService.formatDate(valueDate, 'MM/DD');
              const combinedYearMonthDay: string = yearOfBirth + '/' + selectedDayAndMonthOfBirth;
              valueDate = new Date(combinedYearMonthDay);
              const selectedDateUTC = new Date(valueDate).toISOString();
              const formattedDate = selectedDateUTC;
              const formattedDateValue = isUserLocal ? formattedDate : valueDate;
              this._setAttributeValueDate(targetControl, formattedDateValue);
              const targetControlYear: Control = this._getTargetControl('omnione_yearofbirth');
              this._setAttributeValueDate(targetControlYear, formattedDateValue);
            } else {
              const selectedDateUTC = new Date(valueDate).toISOString();
              const formattedDate = selectedDateUTC;
              const formattedDateValue = isUserLocal ? formattedDate : valueDate;
              this._setAttributeValueDate(targetControl, formattedDateValue);
            }
          } else {
            const targetControl: Control = this._dateTimePickerActiveControl;
            const isUserLocal: boolean = targetControl.dateBehavior == 'UserLocal';
            const selectedDateUTC = new Date(valueDate).toISOString();
            const formattedDateValue = isUserLocal ? selectedDateUTC : valueDate;
            this._setAttributeValueDate(targetControl, formattedDateValue);
          }
        }
      }
    }
    if(this._dateTimePickerActiveControl && this._dateTimePickerActiveControl.isRequired){
      let value;
      try {
        value = this._currentFormValue[this._dateTimePickerActiveControl.attributeName];
      } catch (error) {

      }
      this._validateMandatoryField(this._dateTimePickerActiveControl.attributeName,null,{value:value},false)
    }
  }

  private _setAttributeStringValue(attributeName: string, value: any) {
    if (this._currentFormStringValues) {
      if (attributeName === 'statecode' || attributeName === 'statuscode') {
        this._currentFormStringValues[attributeName] = this.dynamicFormsService.translatedValue(value);
      } else {
        this._currentFormStringValues[attributeName] = value;
      }
    } else {
      this._currentFormStringValues = {
        [attributeName]: value,
      }
    }
  }

  private _setAttributeValue(control: Control, value: any, initViewData: boolean = true, codIdOnekey: string = '', runBusinessRulesLogic:Boolean = true, otherFieldsToInclude?: any, selectedItem?: any) {
    if (control.isCustom) {
      this._setCustomAttributeValue(control, value, initViewData, codIdOnekey, selectedItem);
      return;
    }
    let isSetValue: boolean = false;
    let objName = control.isCustomAttribute ? control.schemaName : control.attributeName;
    let cfvObj: any = {
      name: objName,
      entity: control.lookupEntitySetName,
      id: value
    };
    if (otherFieldsToInclude) {
      cfvObj.otherFieldsToInclude = otherFieldsToInclude;
    }
    if (this._currentFormValue) {
      if (control.dataType == ControlDataType.LookupType) {
        let crLookUp;
        if(codIdOnekey) {
          const entityName = control.isCustomAttribute ? control.schemaName : control.attributeName;
          crLookUp = {
            entity: entityName,
            codIdOnekey: codIdOnekey,
            guid: value
          };
        }
        if (this._currentFormValue.hasOwnProperty('lookupfields')) {
          const idx = this._currentFormValue['lookupfields'].findIndex(a => a.name == objName);
          if (idx >= 0) {
            const prevGuid = this._currentFormValue['lookupfields'][idx].id || '';
            this._currentFormValue['lookupfields'][idx] = cfvObj;
            if (prevGuid && codIdOnekey && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.addLookupOnekeyData(prevGuid, crLookUp);
          } else {
            this._currentFormValue['lookupfields'].push(cfvObj);
            if (codIdOnekey) this.dynamicFormsService.okLookUpMapper.push(crLookUp);
          }
        } else {
          this._currentFormValue['lookupfields'] = [cfvObj];
          if (codIdOnekey) this.dynamicFormsService.okLookUpMapper = [crLookUp];
        }
        if (cfvObj?.name == 'exe_StateProvince_new' && selectedItem && selectedItem.countryId) {
          this._currentFormValue['lookupfields'].push({
            "entity": "indskr_lu_countries",
            "id": selectedItem.countryId,
            "name": "exe_Country_New"
          });
          if (this._currentFormStringValues) {
            this._currentFormStringValues["exe_country_new"] = selectedItem.countryName;
          } else {
            this._currentFormStringValues = {
              ["exe_country_new"]: selectedItem.countryName,
            }
          }
        }
        
        // Add contact to recent contacts when a contact lookup field is set (e.g., kit booking surgeon contact)
        if (control.lookupEntityPrimaryId == 'contactid' && value) {
          const contact = this.contactService.getContactByID(value);
          if (contact) {
            this.contactService.addToRecentContacts(contact);
          }
        }
        
        if (!this._isInNgOnInit) {
          isSetValue = true;
        }
      } else {
        if ((value === '' || value == undefined || value == null) && control.isRequired) {
          delete this._currentFormValue[control.attributeName];
        } else {
          this._currentFormValue[control.attributeName] = (control.dataType === ControlDataType.PicklistType && typeof value === 'string' && value !== '' && !isNaN(Number(value)))
            ? Number(value)
            : value;
          if (this.formDetail.LookupEntitySetName == 'indskr_customeraddresscrs' && control.attributeName == 'indskr_name') {
            if (this._customFormValue) {
              this._customFormValue[control.attributeName] = value;
            } else {
              this._customFormValue = { [control.attributeName]: value, }
            }
          }
          if (!this._isInNgOnInit) {
            isSetValue = true;
          }
        }
      }
    } else {

      if (control.dataType == ControlDataType.LookupType) {
        this._currentFormValue = { lookupfields: [cfvObj] };
        
        // Add contact to recent contacts when a contact lookup field is set (e.g., kit booking surgeon contact)
        if (control.lookupEntityPrimaryId == 'contactid' && value) {
          const contact = this.contactService.getContactByID(value);
          if (contact) {
            this.contactService.addToRecentContacts(contact);
          }
        }
        
        if (!this._isInNgOnInit) {
          isSetValue = true;
        }
      } else {
        if ((value === '' || value == undefined || value == null) && control.isRequired) return;
        this._currentFormValue = {
          [control.attributeName]: value,
        }
        if (!this._isInNgOnInit) {
          isSetValue = true;
        }
      }
    }
    if(isSetValue && !this._isApplyingDefaultValue) {
      this._isFormDirty = true;
      if (this.formDetail?.LookupEntitySetName !== 'indskr_medicalinquiries') {
        this.dynamicFormsService.linkedEntityFormIsDirtyTracker = true;
      }
      if (this.formDetail && this.formDetail.eventsHandler) {
        const payload = this.formDetail.LookupEntitySetName === 'indskr_medicalinquiries'
          ? { isDirty: this._isFormDirty, formValue: this._currentFormValue, formStringValue: this._currentFormStringValues }
          : true;
        this.formDetail.eventsHandler(payload, 'ISFORMDIRTY');
      }
    }
    if(runBusinessRulesLogic){
      this._runBusinessRulesLogic();
    }
    if (initViewData) {
      this._initViewData();
    } else {
      this._targetControlViewData(control);
    }
  }

  private _setAttributeValueForSetBookingProduct(control: Control, value: any, initViewData: boolean = true, codIdOnekey: string = '', _formValue, setBookingId) {
    let isSetValue: boolean = false;
    let objName = control.isCustomAttribute ? control.schemaName : control.attributeName;
    let cfvObj = {
      name: objName,
      entity: control.lookupEntitySetName,
      id: value.id
    }

    if (_formValue && _formValue[value.id]) {
      let selectedFormValue = _formValue[value.id];
      // update Product
      let crLookUp;
      if (selectedFormValue.hasOwnProperty('lookupfields')) {
        const idx = selectedFormValue['lookupfields'].findIndex(a => a.name == objName);
        if (idx >= 0) {
          const prevGuid = selectedFormValue['lookupfields'][idx].id || '';
          selectedFormValue['lookupfields'][idx] = cfvObj;
          if(prevGuid && codIdOnekey && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.addLookupOnekeyData(prevGuid, crLookUp);
        } else {
          selectedFormValue['lookupfields'].push(cfvObj);
          if(codIdOnekey) this.dynamicFormsService.okLookUpMapper.push(crLookUp);
        }
      } else {
        selectedFormValue['lookupfields'] = [cfvObj];
        if(codIdOnekey) this.dynamicFormsService.okLookUpMapper = [crLookUp];
      }

      // update quantity and product type
      // selectedFormValue['indskr_producttype'] = '';
      selectedFormValue['indskr_quantity'] = value.qty ?? 1;
      isSetValue = true;
    } else {
      let _form = {
        // 'indskr_producttype': '',
        'indskr_quantity': value.qty ?? 1,
        "lookupfields": [
          {
              "name": "indskr_setBooking",
              "entity": "indskr_setbookings",
              "id": setBookingId
          },
          {
              "name": "indskr_product",
              "entity": "products",
              "id": value.id ?? ''
          }
        ]
      }
      if(value.linkedEntityExistingDataId) _form["guid"] = value.linkedEntityExistingDataId;
      else if(value.linkedEntityAddedNewDataId) _form["guid"] = value.linkedEntityAddedNewDataId;
      _formValue[value.id] = _form;
      isSetValue = true;
    }
    if(isSetValue) {
      this._isFormDirty = true;
      this.dynamicFormsService.linkedEntityFormIsDirtyTracker = true;
      if (this.formDetail && this.formDetail.eventsHandler) {
        const payload = this.formDetail.LookupEntitySetName === 'indskr_medicalinquiries'
          ? { isDirty: this._isFormDirty, formValue: this._currentFormValue, formStringValue: this._currentFormStringValues }
          : true;
        this.formDetail.eventsHandler(payload, 'ISFORMDIRTY');
      }
    }
  }

  private _clearAttributeValue(control: Control) {
    let recursiveControl: Control;
    this._isFormDirty = true;
    let controlsToReset : Control[]=[];
    if (control.dataType == ControlDataType.BooleanType) {
      if (control.isCustom) {
        if (this._customFormValue && this._customFormValue.hasOwnProperty(control.attributeName)) {
          // delete this._customFormValue[control.attributeName];
          this._customFormValue[control.attributeName] = null;
        }
      } else {
        if (this._currentFormValue && this._currentFormValue.hasOwnProperty(control.attributeName)) {
          // delete this._currentFormValue[control.attributeName];
          this._currentFormValue[control.attributeName] = null;
        }
      }
      if (this.formDetail?.eventsHandler && this.formDetail?.LookupEntitySetName === 'indskr_medicalinquiries') {
        const payload = { isDirty: this._isFormDirty, formValue: this._currentFormValue, formStringValue: this._currentFormStringValues };
        this.formDetail.eventsHandler(payload, 'ISFORMDIRTY');
      }
    } else if (control.dataType == ControlDataType.PicklistType || control.dataType == ControlDataType.MultiSelectPicklistType) {
      if (control.isCustom) {
        if (this._customFormValue && this._customFormValue[control.attributeName]) {
          // delete this._customFormValue[control.attributeName];
          this._customFormValue[control.attributeName] = null;
        }
      } else {
        if (this._currentFormValue && this._currentFormValue[control.attributeName]) {
          // delete this._currentFormValue[control.attributeName];
          this._currentFormValue[control.attributeName] = null;
        }
        if (this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) {
          delete this._currentFormStringValues[control.attributeName]
        }
        this._runConfiguredFieldRules(control.attributeName, null);
      }
    } else if (control.dataType == ControlDataType.LookupType) {
      let objName = control.isCustomAttribute ? control.schemaName : control.attributeName;
      if (control.isCustom) {
        objName = control.schemaName;
        if (this._customFormValue && this._customFormValue.hasOwnProperty('lookupfields')) {
          let idx = this._customFormValue['lookupfields'].findIndex(a => a.name == objName);
          if (idx >= 0) {
            const prevGuid = this._customFormValue['lookupfields'][idx].id || '';
            this._customFormValue['lookupfields'][idx]['isDeleted'] = true;
            if(prevGuid && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.clearMappedLookupOnekeyWithId(prevGuid);
          }
          for (let i = 0; i < this._dynamicForm.metadata.length && !recursiveControl; i++) {
            const tab = this._dynamicForm.metadata[i];
            if (tab && tab.controls && tab.controls.length > 0) {
              for (let j = 0; j < tab.controls.length && !recursiveControl; j++) {
                const foundControl = tab.controls[j];
                if (foundControl && foundControl.dependsOn == control.schemaName) {
                  recursiveControl = foundControl;
                }
              }
            }
          }
          //Clear fields which are related to address because dependsOn is hard coded for onekey configured form
          //Selected Country,County/District,Postal Code,CityState are deleted When a city is selected
          if (this.changeRequest && control.lookupEntityPrimaryId == "indskr_lu_cityid") {
            idx = this._customFormValue['lookupfields'].findIndex(a => a.name == "indskr_Country_LU");
            if (idx >= 0) {
              this._customFormValue['lookupfields'][idx]['isDeleted'] = true;
              if (this._currentFormStringValues && this._currentFormStringValues.hasOwnProperty('indskr_country_lu')) {
                delete this._currentFormStringValues['indskr_country_lu'];
              }
            }
            idx = this._customFormValue['lookupfields'].findIndex(a => a.name == "indskr_district");
            if (idx >= 0) {
              const prevGuid = this._customFormValue['lookupfields'][idx].id || '';
              this._customFormValue['lookupfields'][idx]['isDeleted'] = true;
              if(prevGuid && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.clearMappedLookupOnekeyWithId(prevGuid);
              if (this._currentFormStringValues && this._currentFormStringValues.hasOwnProperty('indskr_district')) {
                delete this._currentFormStringValues['indskr_district'];
              }
            }
            idx = this._customFormValue['lookupfields'].findIndex(a => a.name == "indskr_postalcode_lu");
            if (idx >= 0) {
              this._customFormValue['lookupfields'][idx]['isDeleted'] = true;
              if (this._currentFormStringValues && this._currentFormStringValues.hasOwnProperty('indskr_postalcode_lu')) {
                delete this._currentFormStringValues['indskr_postalcode_lu'];
              }
            }
            if (this._customFormValue && this._customFormValue.hasOwnProperty('indskr_compositecitystate')) {
              // delete this._customFormValue['indskr_compositecitystate'];
              this._customFormValue['indskr_compositecitystate'] = null;
            }
          }
        }
      } else {
        if (this._currentFormValue && this._currentFormValue.hasOwnProperty('lookupfields')) {
          let idx = this._currentFormValue['lookupfields'].findIndex(a => a.name == objName);
          if (idx >= 0) {
            const prevGuid = this._currentFormValue['lookupfields'][idx].id || '';
            this._currentFormValue['lookupfields'][idx]['isDeleted'] = true;
            if(prevGuid && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.clearMappedLookupOnekeyWithId(prevGuid);
          }
          //we need to clear the lookup fields that are configured to be dependent on the deselected lookupfield
          this._currentFormValue['lookupfields'].forEach(lookup => {
            if(!(lookup['isDeleted'] && lookup['isDeleted']==true)){
              let lookupControl: Control = this._getTargetControl(lookup.name);
              if(!lookupControl)
                lookupControl = this._getTargetControlbySchemaName(lookup.name);
              if(lookupControl && lookupControl.filterby && lookupControl.filterby == objName){
                controlsToReset.push(lookupControl);
              }
            }
          });

          // Medical Inquiry only: when contact is removed, clear address as well.
          const isMedicalInquiry = this.formDetail?.formMetadata?.entityName === 'indskr_medicalinquiry';
          const isContactControl = control.lookupEntityPrimaryId === 'contactid' || control.attributeName === 'indskr_contact';
          if (isMedicalInquiry && isContactControl && this.formDetail?.loadAddressFromLocal) {
            let addressControl = this._getTargetControl('indskr_address');
            if (!addressControl && this._dynamicForm?.metadata) {
              for (const tab of this._dynamicForm.metadata) {
                if (!tab.controls?.length) continue;
                const found = tab.controls.find(
                  (c: Control) => c.attributeName === 'indskr_address' || c.lookupEntityPrimaryId === 'indskr_addressid'
                );
                if (found) {
                  addressControl = found;
                  break;
                }
              }
            }
            if (addressControl) {
              controlsToReset.push(addressControl);
            }
          }
          if (isContactControl) {
            this._runConfiguredFieldRules(control.attributeName, null);
          }
        }
      }
      if (this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) {
        delete this._currentFormStringValues[control.attributeName];
      }
      if (this._activeLookupSearchControl.lookupEntityPrimaryId == "indskr_lu_countryid") {
        this.dynamicFormsService.hasCityDataBasedOnCountry = false;
      }
    }
    if (recursiveControl) {
      this._clearAttributeValue(recursiveControl);
    } else if(controlsToReset.length > 0){
      controlsToReset.forEach(control => {
        this._clearAttributeValue(control);
      });
    } else {
      this._initViewData();
    }
  }
  private _clearEditAddressFormAttributeValue(control: Control) {
    let recursiveControl: Control;
    if (control.dataType == ControlDataType.BooleanType) {
      if (control.isCustom) {
        if (this._existingCustomFormValue && this._existingCustomFormValue.hasOwnProperty(control.attributeName)) {
          // delete this._existingCustomFormValue[control.attributeName];
          this._existingCustomFormValue[control.attributeName] = null;
        }
      } else {
        if (this._existingFormValue && this._existingFormValue.hasOwnProperty(control.attributeName)) {
          // delete this._existingFormValue[control.attributeName];
          this._existingFormValue[control.attributeName] = null;
        }
      }
    } else if (control.dataType == ControlDataType.PicklistType || control.dataType == ControlDataType.MultiSelectPicklistType) {
      if (control.isCustom) {
        if (this._existingCustomFormValue && this._existingCustomFormValue[control.attributeName]) {
          // delete this._existingCustomFormValue[control.attributeName];
          this._existingCustomFormValue[control.attributeName] = null;
        }
      } else {
        if (this._existingFormValue && this._existingFormValue.hasOwnProperty(control.attributeName)) {
          // delete this._existingFormValue[control.attributeName];
          this._existingFormValue[control.attributeName] = null;
        }
      }
    } else if (control.dataType == ControlDataType.LookupType) {
      let objName = control.isCustomAttribute ? control.schemaName : control.attributeName;
      if (control.isCustom) {
        objName = control.schemaName;
        if (this._existingCustomFormValue && this._existingCustomFormValue.hasOwnProperty('lookupfields')) {
          let idx = this._existingCustomFormValue['lookupfields'].findIndex(a => a.name == objName);
          if (idx >= 0) {
            const prevGuid = this._existingCustomFormValue['lookupfields'][idx].id || '';
            this._existingCustomFormValue['lookupfields'][idx]['isDeleted'] = true;
            if(prevGuid && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.clearMappedLookupOnekeyWithId(prevGuid);
          }
          for (let i = 0; i < this._dynamicForm.metadata.length && !recursiveControl; i++) {
            const tab = this._dynamicForm.metadata[i];
            if (tab && tab.controls && tab.controls.length > 0) {
              for (let j = 0; j < tab.controls.length && !recursiveControl; j++) {
                const foundControl = tab.controls[j];
                if (foundControl && foundControl.dependsOn == control.schemaName) {
                  recursiveControl = foundControl;
                }
              }
            }
          }
          //Clear fields which are related to address because dependsOn is hard coded for onekey configured form
          //Selected Country,County/District,Postal Code,CityState are deleted When a city is selected
          if (this.changeRequest && control.lookupEntityPrimaryId == "indskr_lu_cityid") {
            idx = this._existingCustomFormValue['lookupfields'].findIndex(a => a.name == "indskr_Country_LU");
            if (idx >= 0) {
              this._existingCustomFormValue['lookupfields'][idx]['isDeleted'] = true;
              if (this._existingFormStringValues && this._existingFormStringValues.hasOwnProperty('indskr_country_lu')) {
                delete this._existingFormStringValues['indskr_country_lu'];
              }
            }
            idx = this._existingCustomFormValue['lookupfields'].findIndex(a => a.name == "indskr_district");
            if (idx >= 0) {
              const prevGuid = this._existingCustomFormValue['lookupfields'][idx].id || '';
              this._existingCustomFormValue['lookupfields'][idx]['isDeleted'] = true;
              if(prevGuid && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.clearMappedLookupOnekeyWithId(prevGuid);
              if (this._existingFormStringValues && this._existingFormStringValues.hasOwnProperty('indskr_district')) {
                delete this._existingFormStringValues['indskr_district'];
              }
            }
            idx = this._existingCustomFormValue['lookupfields'].findIndex(a => a.name == "indskr_postalcode_lu");
            if (idx >= 0) {
              this._existingCustomFormValue['lookupfields'][idx]['isDeleted'] = true;
              if (this._existingFormStringValues && this._existingFormStringValues.hasOwnProperty('indskr_postalcode_lu')) {
                delete this._existingFormStringValues['indskr_postalcode_lu'];
              }
            }
            if (this._existingFormStringValues && this._existingCustomFormValue.hasOwnProperty('indskr_compositecitystate')) {
              // delete this._existingCustomFormValue['indskr_compositecitystate'];
              this._existingCustomFormValue['indskr_compositecitystate'] = true;
            }
          }
        }
      } else {
        if (this._existingFormValue && this._existingFormValue.hasOwnProperty('lookupfields')) {
          let idx = this._existingFormValue['lookupfields'].findIndex(a => a.name == objName);
          if (idx >= 0) {
            const prevGuid = this._existingFormValue['lookupfields'][idx].id || '';
            this._existingFormValue['lookupfields'][idx]['isDeleted'] = true;
            if(prevGuid && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.clearMappedLookupOnekeyWithId(prevGuid);
          }
        }
      }
      if (this._existingFormStringValues && this._existingFormStringValues[control.attributeName]) {
        delete this._existingFormStringValues[control.attributeName];
      }
      if (this._activeLookupSearchControl.lookupEntityPrimaryId == "indskr_lu_countryid") {
        this.dynamicFormsService.hasCityDataBasedOnCountry = false;
      }
    }
    if (recursiveControl) {
      this._clearEditAddressFormAttributeValue(recursiveControl);
    } else {
      this._initViewEditFormData();
    }
  }

  //#region methods for Custom Fields
  private _setCustomAttributeValue(control: Control, value: any, initViewData: boolean = true, codIdOnekey: string = '', selectedItem?: any) {
    let cfvObj = {
      name: control.schemaName,
      entity: control.lookupEntitySetName,
      id: value
    };

    if (this._customFormValue) {
      let crLookUp;
      if (control.dataType == ControlDataType.LookupType) {
        if(codIdOnekey) {
          const entityName = control.isCustomAttribute ? control.schemaName : control.attributeName;
          crLookUp = {
            entity: entityName,
            codIdOnekey: codIdOnekey,
            guid: value
          };
        }
        if (this._customFormValue.hasOwnProperty('lookupfields')) {
          const idx = this._customFormValue['lookupfields'].findIndex(a => a.name == control.schemaName);
          if (idx >= 0) {
            const prevGuid = this._customFormValue['lookupfields'][idx].id || '';
            this._customFormValue['lookupfields'][idx] = cfvObj;
            if(prevGuid && codIdOnekey && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.addLookupOnekeyData(prevGuid, crLookUp);
          } else {
            this._customFormValue['lookupfields'].push(cfvObj);
            if(codIdOnekey) this.dynamicFormsService.okLookUpMapper.push(crLookUp);
          }
        } else {
          this._customFormValue['lookupfields'] = [cfvObj];
          if(codIdOnekey) this.dynamicFormsService.okLookUpMapper = [crLookUp];
        }
      } else {
        this._customFormValue[control.attributeName] = value;
      }
    } else {

      if (control.dataType == ControlDataType.LookupType) {
        this._customFormValue = { lookupfields: [cfvObj] };
      } else {
        this._customFormValue = {
          [control.attributeName]: value,
        }
      }
    }
    if (cfvObj?.name == 'indskr_State_lu' && selectedItem && selectedItem.countryId) {
      if (!this._customFormValue) {
        this._customFormValue = { lookupfields: [] };
      }
      if (!this._customFormValue['lookupfields']) {
        this._customFormValue['lookupfields'] = [];
      }
      this._customFormValue['lookupfields'] = this._customFormValue['lookupfields']
        .filter((lf: any) => lf.name !== 'indskr_Country_LU');
      this._customFormValue['lookupfields'].push({
        entity: 'indskr_lu_countries',
        id: selectedItem.countryId,
        name: 'indskr_Country_LU',
      });
      if (this._currentFormStringValues) {
        this._currentFormStringValues['indskr_country_lu'] = selectedItem.countryName;
      } else {
        this._currentFormStringValues = {
          ['indskr_country_lu']: selectedItem.countryName,
        };
      }
    }
    this._isFormDirty = true;
    if (this.formDetail?.LookupEntitySetName !== 'indskr_medicalinquiries') {
      this.dynamicFormsService.linkedEntityFormIsDirtyTracker = true;
    }
    if (initViewData) {
      this._initViewData();
    } else {
      this._targetControlViewData(control);
    }
  }

  private async _getCustomFields(referencingEntity: string) {
    let controls: Control[] = [];
    if (referencingEntity == 'indskr_indskr_customeraddress_v2') {
      CUSTOM_ADDRESS_FIELDS.forEach(con => controls.push(new Control(con)));
    } else if (referencingEntity == 'indskr_customeraddresscr') {
      const addressForm = await this.dynamicFormsService.getFormDefinitionForEntity('indskr_addresscr', FormType.CREATEFORM);
      if (addressForm && addressForm.metadata && addressForm.metadata.length == 1 && addressForm.metadata[0].controls) {
        addressForm.metadata[0].controls.map(control => control.isCustom = true);
        const index = addressForm.metadata[0].controls.findIndex(control => control.attributeName == "indskr_name");
        if (index >= 0) {
          addressForm.metadata[0].controls.splice(index, 1);
        }
        controls = [...addressForm.metadata[0].controls];
      }
    } else if (referencingEntity === 'indskr_accountaccountaffiliationcr') {
      const aaaForm = await this.dynamicFormsService.getFormDefinitionForEntity('indskr_accountaccountaffiliationcr', FormType.CREATEFORM);
      if (aaaForm && aaaForm.metadata && aaaForm.metadata.length == 1 && aaaForm.metadata[0].controls) {
        aaaForm.metadata[0].controls.map(control => control.isCustom = true);
        const index = aaaForm.metadata[0].controls.findIndex(control => control.attributeName == "indskr_name");
        if (index >= 0) {
          aaaForm.metadata[0].controls.splice(index, 1);
        }
        controls = [...aaaForm.metadata[0].controls];
      }
    } else if (referencingEntity === 'indskr_accountcontactaffiliationcr') {
      const acaForm = await this.dynamicFormsService.getFormDefinitionForEntity('indskr_accountcontactaffiliationcr', FormType.CREATEFORM);
      if (acaForm && acaForm.metadata && acaForm.metadata.length == 1 && acaForm.metadata[0].controls) {
        acaForm.metadata[0].controls.map(control => control.isCustom = true);
        const index = acaForm.metadata[0].controls.findIndex(control => control.attributeName == "indskr_name");
        if (index >= 0) {
          acaForm.metadata[0].controls.splice(index, 1);
        }
        controls = [...acaForm.metadata[0].controls];
      }
    } else {
      controls = null;
    }
    return controls;
  }

  //#endregion methods for custom fields

  //#region Search Bar
  public searchAddressGlobally(searchParams) {
    try {
      if (searchParams.length === 0) return;
      this.addressService.getGlobalAddresses(searchParams).then((result) => {
        this.searchPopoverOptions = this.addressService.mapAddress(result);
      }).catch(err => {
        console.log('Error searching: ', err);
      });
    } catch (error) {
      console.error(error);
    }
  }

  private async searchAddressForOneKey(searchParams) {
    try {
      if(searchParams.length === 0) return;
      let fetchXml = CONTACT_FETCH_QUERIES.searchAllAddressesForOneKey;
      // Remove omnione_account attribute from fetchXML as this is present in One Key env only
      if(this.TYPE == "OMNIPRESENCE"){
        fetchXml = fetchXml.replace('<attribute name="omnione_account" />',"")
        fetchXml = fetchXml.replace('{{linked-entities}}', '').split("{{query}}").join(searchParams);
      }else if(this.PREVIOUS_MODE === 'CREATE_MODE') {
        fetchXml = fetchXml.replace('{{linked-entities}}', '').split("{{query}}").join(searchParams);
      } else if(this.PREVIOUS_MODE === 'EDIT_MODE') {
        let mdmId = (this.dynamicFormsService.mdmId) ? this.dynamicFormsService.mdmId : '';
        if(this.formDetail.linkedEntityParentData.entity == 'indskr_accountcrs') {
          fetchXml = fetchXml.replace('{{linked-entities}}', CONTACT_FETCH_QUERIES.customerLinkedEntitiesAccountCR);
        } else {
          fetchXml = fetchXml.replace('{{linked-entities}}', CONTACT_FETCH_QUERIES.customerLinkedEntitiesContactCR);
        }
        fetchXml = fetchXml.split("{{query}}").join(searchParams).split("{mdmid}").join(mdmId);
      }
      let data = (await this.dynamics.executeFetchQuery('indskr_addresses', fetchXml));
      data = data?.value ? data.value : data;
      this.searchPopoverOptions = [];
      if (!isEmpty(data)) {
        this.searchPopoverOptions = this.dynamicFormsService.mapAddressOneKey(data);
      }
    } catch (error) {
      console.error(error);
    }
  }
  private async searchAccountAccountAffiliations(searchParams) {
    try {
      if(searchParams.length === 0) return;
      let fetchXml = CONTACT_FETCH_QUERIES.searchAccountAccountAffiliations;
      let accountId = this.accountService.selected.id;
      fetchXml = fetchXml.split("{{query}}").join(searchParams).split("{accountid}").join(accountId);
      let searchedData = (await this.dynamics.executeFetchQuery('indskr_accountaccountaffiliations', fetchXml));
      searchedData = searchedData?.value ? searchedData.value : searchedData;
      let searchedDataMap = []
      searchedData.forEach(sData => { searchedDataMap.push(sData); });
      this.searchPopoverOptions = searchedDataMap;
    } catch (error) {
      console.error(error);
    }
  }
  private async searchAccountContactAffiliations(searchParams) {
    try {
      if(searchParams.length === 0) return;
      let fetchXml = CONTACT_FETCH_QUERIES.searchAccountContactAffiliations;
      let contactId = this.contactService.contactInformation.ID;
      fetchXml = fetchXml.split("{{query}}").join(searchParams).split("{contactid}").join(contactId);
      let searchedData = (await this.dynamics.executeFetchQuery('indskr_accountcontactaffiliations', fetchXml));
      searchedData = searchedData?.value ? searchedData.value : searchedData;
      let searchedDataMap = []
      searchedData.forEach(sData => { searchedDataMap.push(sData); });
      this.searchPopoverOptions = searchedDataMap;
    } catch (error) {
      console.error(error);
    }
  }
  public onSearchInput(event) {
    let query = '';
    if (event && event.value) {
      query = event.value.trim();
    }
    if (query.length > 2) {
      this.isSearchPopoverActive = true;

      switch (this._dynamicForm.entitySetName) {
        case 'indskr_accountaccountaffiliationcrs':
          this.isAccountAccountAffiliationPopover = true;
          this.isAccountContactAffiliationPopover = false;
          this.isAddressOneKeyPopover = false;
          this.isAddressPopover = false;
          this.searchAccountAccountAffiliations(query);
          break;
        case 'indskr_accountcontactaffiliationcrs':
          this.isAccountAccountAffiliationPopover = false;
          this.isAccountContactAffiliationPopover = true;
          this.isAddressOneKeyPopover = false;
          this.isAddressPopover = false;
          this.searchAccountContactAffiliations(query);
          break;
        case 'indskr_customeraddresscrs':
          this.isAccountAccountAffiliationPopover = false;
          this.isAccountContactAffiliationPopover = false;
          this.isAddressOneKeyPopover = true;
          this.isAddressPopover = false;
          this.searchAddressForOneKey(query);
          break;
        default:
          this.isAccountAccountAffiliationPopover = false;
          this.isAccountContactAffiliationPopover = false;
          this.isAddressOneKeyPopover = false;
          this.isAddressPopover = true;
          this.searchAddressGlobally(query);
          break;
      }
    } else {
      this.isSearchPopoverActive = false;
      this.isAccountAccountAffiliationPopover = false;
      this.isAccountContactAffiliationPopover = false;
      this.isAddressOneKeyPopover = false;
      this.isAddressPopover = false;
      this.searchPopoverOptions = [];
    }
  }


  // data set for address-onekey from search results
  public setSearchedDataForAddressOneKey() {
    this.dynamicFormsService.isSelectedDataFromAddressOneKey = true;
    this._dynamicForm.metadata[0].controls.forEach(async control => {
      if (control.dataType == ControlDataType.LookupType) {
        const schemaFieldName = control.isCustomAttribute ? control.schemaName : control.attributeName;
        let countyCodeOneKey = '';
        const foundLookupId = this.selectedSearchOption ? this.selectedSearchOption[control.attributeName + '_value'] || '' : '';
        const foundName = this.selectedSearchOption ? this.selectedSearchOption[control.attributeName + '_value_Formatted'] || '' : '';
        this.dynamicFormsService.clearMappedLookupOnekeyWithName('indskr_district');
        if(schemaFieldName.toLowerCase() == 'indskr_district' && foundLookupId) {
          countyCodeOneKey = await this.dynamicFormsService.getLookupCountyCodeOneKey(control.lookupEntitySetName, foundLookupId) || '';
        } else if(schemaFieldName.toLowerCase() == 'indskr_city_lu' && foundLookupId) {
          this._stateIdBasedOnCity = await this.dynamicFormsService.getLookupStateIdBasedOnCity(control.lookupEntitySetName, foundLookupId) || '';
        }
        if (foundName) this._setAttributeStringValue(control.attributeName, foundName);
        if (foundLookupId) this._setAttributeValue(control, foundLookupId, true, countyCodeOneKey);
      } else if (control.dataType == "StringType" || control.dataType == "MemoType") {
        let foundName = this.selectedSearchOption ? this.selectedSearchOption[control.attributeName] || '' : '';
        if (control.attributeName == 'indskr_composite' || control.attributeName == 'indskr_compositecitystate') {
          // remove next line and make one space
          if (foundName) {
            foundName = foundName.replace(/(\r\n|\n|\r)/gm, "");
            foundName = foundName.split(',').join(', ').replace(/\s\s+/g, ' ');
          }
        }
        if (foundName) this._setAttributeValue(control, foundName);
      }
    });
  }

  // data set for existing data selected from search results
  public async setSearchedDataToView() {
    let referenceControls = this._dynamicForm.metadata[0].controls;
    referenceControls.forEach(async control => {
      switch (control.dataType) {
        case ControlDataType.MoneyType:
        case ControlDataType.IntegerType:
        case ControlDataType.DecimalType:
        case ControlDataType.DoubleType:
        case ControlDataType.MemoType:
        case ControlDataType.StringType:
          if (this.selectedSearchOption && this.selectedSearchOption[control.attributeName]) {
            if (control.isVisible && control.isRequired && !control.forceHide) {
              this._setAttributeValue(control, this.selectedSearchOption[control.attributeName]);
            }
          }
          break;
        case ControlDataType.LookupType:
          if (this.selectedSearchOption && this.selectedSearchOption['_' + control.attributeName + '_value']) {
            if (control.isVisible && control.isRequired && !control.forceHide) {
              if(control.lookupEntityPrimaryId && control.lookupEntityPrimaryId == "omnione_onekeycodeslabelsid"){
                if(this.selectedSearchOption['_' + control.attributeName  + '_value'] && this.localizationService.multiLingualFieldsData && this.localizationService.multiLingualFieldsData.length > 0){
                  let foundRecord = this.localizationService.multiLingualFieldsData.find(a=> a['omnione_onekeycodeslabelsid'] == this.selectedSearchOption['_' + control.attributeName  + '_value']);
                  let translatedLang: string = '';
                  let key = this.localizationService.getOneKeyTableAttributes();
                  if(foundRecord) translatedLang = foundRecord[key] ? foundRecord[key] || '' : foundRecord['omnione_en_long_label'] || '';
                  if(foundRecord && foundRecord['omnione_onekeycodeslabelsid'] && translatedLang){
                    const schemaFieldName = foundRecord['omnione_schemafieldname'] || '';
                    const onekeyCodesLabelsId = foundRecord['omnione_onekeycodeslabelsid'] || '';
                    const codIdOneKey = await this.dynamicFormsService.getLookupCodIdOnekey(schemaFieldName, onekeyCodesLabelsId) || '';
                    this._setAttributeValue(control, onekeyCodesLabelsId, true, codIdOneKey);
                    this._setAttributeStringValue(control.attributeName, translatedLang);
                  }
                }
              }else{
                this._setAttributeValue(control, this.selectedSearchOption['_' + control.attributeName + '_value']);
                this._setAttributeStringValue(control.attributeName, this.selectedSearchOption['_' + control.attributeName + '_value@OData.Community.Display.V1.FormattedValue']);
              }
            }
          }
          break;
        case ControlDataType.BooleanType:
          if (this.selectedSearchOption && this.selectedSearchOption.hasOwnProperty(control.attributeName)) {
            if (control.isVisible && control.isRequired && !control.forceHide) {
              (this.selectedSearchOption[control.attributeName]) ? this._setAttributeValue(control, true) : this._setAttributeValue(control, false);
            }
          }
          break;
        case ControlDataType.MultiSelectPicklistType:
          if (this.selectedSearchOption && this.selectedSearchOption[control.attributeName]) {
            this._setAttributeValue(control, this.selectedSearchOption[control.attributeName]);
            let str = this.selectedSearchOption[control.attributeName+'@OData.Community.Display.V1.FormattedValue'].replace(/;/g, ',');
            if (control.isVisible && control.isRequired && !control.forceHide) {
              this._setAttributeStringValue(control.attributeName,str);
            }
          }
          break;
        case ControlDataType.PicklistType:
          if (this.selectedSearchOption && this.selectedSearchOption[control.attributeName]) {
            if (control.isVisible && control.isRequired && !control.forceHide) {
              this._setAttributeValue(control, this.selectedSearchOption[control.attributeName]);
              this._setAttributeStringValue(control.attributeName, this.selectedSearchOption[control.attributeName + '@OData.Community.Display.V1.FormattedValue']);
            }
          }
          break;
        default:
          break;
      }
    });
  }

  public setSelectedSearchPopoverValue(option) {
    if (option) {
      this.selectedSearchOption = option;
      this.isSearchPopoverActive = false;
      this.searchPopoverOptions = [];
      this.isSelectedFromSearch = true;
      this.searchText = '';

      this._customFormValue = {
        lookupfields: [],
      }
      // Selected data from AccountAccount/AccountContact affiliation
      if (this.isAccountAccountAffiliationPopover || this.isAccountContactAffiliationPopover) {
        this.dynamicFormsService.isSelectedDataFromSearch = true;
        this.setSearchedDataToView();
      }
      // Selected data from Address-OneKey search
      if (this.isAddressOneKeyPopover) {
        this.setSearchedDataForAddressOneKey();
        this.dynamicFormsService.isSelectedDataFromSearch = true;
        if (this.formDetail.LookupEntitySetName == "indskr_customeraddresscrs" && this.formDetail.linkedEntityParentData.entity == "indskr_contactcrs") {
          let { logicalCollectionName, logicalName, schemaName } = this.getAddressEntity();
          let obj = {
            entity: logicalCollectionName,
            id: this.selectedSearchOption.indskr_addressid,
            name: schemaName,
          }
          if (this._currentFormValue['lookupfields']) {
            let idx = this._currentFormValue['lookupfields'].findIndex(a => a.name == schemaName);
            if (idx >= 0) {
              this._currentFormValue['lookupfields'][idx] = obj;
            } else {
              this._currentFormValue['lookupfields'].push(obj);
            }
          } else {
            this._currentFormValue['lookupfields'] = [obj];
          }
        }
      }
      // Selected data from Address search
      if (this.isAddressPopover) {
        for (let con of CUSTOM_ADDRESS_FIELDS) {
          if (con.DataType == ControlDataType.LookupType) {
            this._customFormValue['lookupfields'].push({
              entity: con.LookupEntitySetName,
              id: this.selectedSearchOption[con.AttributeName],
              name: con.SchemaName
            });
            if (this._currentFormStringValues) {
              this._currentFormStringValues[con.AttributeName] = this.selectedSearchOption[con.AttributeName + '_value'];
            } else {
              this._currentFormStringValues = {
                [con.AttributeName]: this.selectedSearchOption[con.AttributeName + '_value']
              }
            }
          } else {
            this._customFormValue[con.AttributeName] = this.selectedSearchOption[con.AttributeName];
          }
        }
        let { logicalCollectionName, logicalName, schemaName } = this.getAddressEntity();
        let fv = this.currentFormView.find(x => x.id == logicalName)
        if (fv) {
          this._setAttributeStringValue(fv.id, this.selectedSearchOption.indskr_name);
          this._setAttributeValue(fv.control, this.selectedSearchOption.indskr_addressid);
        } else {
          let obj = {
            entity: logicalCollectionName,
            id: this.selectedSearchOption.indskr_addressid,
            name: schemaName,
          }
          if (this._currentFormValue) {
            if (this._currentFormValue['lookupfields']) {
              let idx = this._currentFormValue['lookupfields'].findIndex(a => a.name == schemaName);
              if (idx >= 0) {
                this._currentFormValue['lookupfields'][idx] = obj;
              } else {
                this._currentFormValue['lookupfields'].push(obj);
              }
            } else {
              this._currentFormValue['lookupfields'] = [obj];
            }
          } else {
            this._currentFormValue = {
              lookupfields: [obj],
            }
          }
          if (this._currentFormStringValues) {
            this._currentFormStringValues[logicalName] = this.selectedSearchOption.indskr_name;
          } else {
            this._currentFormStringValues = {
              [logicalName]: this.selectedSearchOption.indskr_name,
            }
          }
        }
        this.dynamicFormsService.isSearchedAddress = true;
      }

      this._isFormDirty = true;
      this._initViewData();
    }
  }

  private getAddressEntity() {
    let logicalName = 'indskr_address';
    let schemaName = 'indskr_Address';
    let logicalCollectionName = 'indskr_addresses';
    //For contact change request, we will associate address from account affiliated no need to create address change request
    if (this.changeRequest) {
      if ((this.formDetail.LookupEntitySetName == 'indskr_contactcrs' || this.formDetail.linkedEntityParentData?.entity == 'indskr_contactcrs')) {
        schemaName = 'indskr_Addressv2';
      } else {
        logicalName = 'indskr_addresscr';
        schemaName = 'indskr_AddressCR';
        logicalCollectionName = 'indskr_addresscrs';
      }
    }
    return { logicalCollectionName, logicalName, schemaName };
  }
  //#endregion Search Bar

  private _closepage(): void {
    this.dynamicFormsService.isSelectedDataFromSearch = false;
    this.dynamicFormsService.storedLinkedEntityValues = [];
    this.dynamicFormsService.hasCityDataBasedOnCountry = false;
    this.dynamicFormsService.isSelectedCountry = false;
    this.dynamicFormsService.isSelectedDataFromAddressOneKey = false;
    this.navService.popChildNavPageWithPageTracking().then(success => {
      if (this.navService.getActiveChildNavViewPageName() == PageName.NothingSelectedView) {
        this.navService.setChildNavRightPaneView(false);
      }
    });
  }

  // Auto-populated Existing Linked Data flow - #start
  private async autoPopulatedLinkedData(targetExistingLinkedData: string, isAdd: boolean, optionData?: any) {
    let result = false;
    let targetControl;
    if (this._dynamicForm && this._dynamicForm.metadata && this._dynamicForm.metadata.length > 0) {
      this._dynamicForm.metadata.forEach(tab => {
        if (tab && tab.controls && tab.controls.length > 0) {
          tab.controls.forEach( async control => {
            if (control.isVisible && !control.dataType && control.subgrid) {
              if (control.subgrid.referencingAttribute == "indskr_contactcr" && control.lookupEntityPrimaryId == "indskr_accountcontactaffiliationcrid" && control.isVisible) {
                if (targetExistingLinkedData == 'accountContactAffiliation') targetControl = control;
              } else if (control.subgrid.referencingAttribute == "indskr_contactcr" && control.lookupEntityPrimaryId == "indskr_customeraddresscrid" && control.isVisible) {
                if (targetExistingLinkedData == 'contactAddress') targetControl = control;
              } else if (control.subgrid.referencingAttribute == "indskr_accountcr" && control.lookupEntityPrimaryId == "indskr_customeraddresscrid" && control.isVisible) {
                if (targetExistingLinkedData == 'accountAddress') targetControl = control;
              }
            }
          });
        }
      });
    }
    if (targetControl) {
      switch (targetExistingLinkedData) {
        case 'accountContactAffiliation':
          this.dynamicFormsService.accountAffiliationAttributeName = targetControl.attributeName;
          await this._addExistingLinkedDataForACAffiliation(targetControl, isAdd);
          console.log("checked existing linked data - Account-Contact Affiliation");
          break;
        case 'contactAddress':
          this.dynamicFormsService.addressAttributeName = targetControl.attributeName;
          if (this.addedNewACAffiliation && optionData) {
            await this._addExistingLinkedDataForAddress(targetControl, isAdd, optionData);
            console.log("checked existing linked data - Contact-Address with new account affiliation");
          } else {
            await this._addExistingLinkedDataForAddress(targetControl, isAdd);
            console.log("checked existing linked data - Contact-Address");
          }
          break;
        case 'accountAddress':
          this.dynamicFormsService.addressAttributeName = targetControl.attributeName;
          await this._addExistingLinkedDataForAddress(targetControl, isAdd);
          console.log("checked existing linked data - Account-Address");
          break;
        default:
          break;
      }
      result = true;
    }
    return result;
  }
  // Add existing Linked Data for Account-Contact Affiliation in Contact CR
  private async _addExistingLinkedDataForACAffiliation(control: Control, isAdd: boolean) {
    let linkEntityData;
    let referenceControls: Control[];
    let dataReq;
    let foundForm;
    let dataReqEntity;
    if (control.subgrid.referencingAttribute == 'indskr_contactcr' && control.lookupEntityPrimaryId == 'indskr_accountcontactaffiliationcrid') {
      let filteredLEDataACAffiliation;
      let contactId = this.contactService.contactInformation.ID || '';
      if (contactId) {
        try {
          let fetchXml = CONTACT_FETCH_QUERIES.searchAccountContactAffiliations;
          fetchXml = fetchXml.split("{{query}}").join('').split("{contactid}").join(contactId);
          await this.dynamics.executeFetchQuery('indskr_accountcontactaffiliations', fetchXml).then((res) => {
            if (!isEmpty(res) && res[0] != undefined) {
              filteredLEDataACAffiliation = res;
            }}
          );
        } catch(error){
          console.log(error);
        }
        if (!isEmpty(filteredLEDataACAffiliation) && filteredLEDataACAffiliation[0] != undefined) {
          // filtered Account-Contact Affiliation Primary data
          let filteredACAffiliationPrimaryData = filteredLEDataACAffiliation.filter(x => x.hasOwnProperty('indskr_isprimaryaccount') && x['indskr_isprimaryaccount'] == true);
          // set linked Entity Data, if there is no primary Account-Contact Affiliation with OneKey, set non-primary Account-Contact Affiliation with OneKey
          linkEntityData = !isEmpty(filteredACAffiliationPrimaryData) ? filteredACAffiliationPrimaryData : filteredLEDataACAffiliation || '';
          if (!isEmpty(linkEntityData)) {
            this.isAutoPopulatedLinkedDataFlow = true;
            console.log("found existing OneKey linked data - Affiliated Account in Contact CR");
          }
        }
      }
    }
    // Common data set flow
    foundForm = this._foundFormForACAffiliationCR;
    if (foundForm && foundForm.metadata && foundForm.metadata[0].controls) {
      if (control.subgrid.referencingAttribute == 'indskr_contactcr' && control.lookupEntityPrimaryId == 'indskr_accountcontactaffiliationcrid') {
        let rawFormEntityObject = null;
        for (let i = 0; i < foundForm.metadata.length; i++) {
          const itab = foundForm.metadata[i];
          this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, "indskr_affiliationrole", "indskr_contactrole");
          if (itab && itab.controls && itab.controls.length > 0) {
            rawFormEntityObject = this.getFieldsToDisplayForContactAccountAff(itab, rawFormEntityObject, 'indskr_contactcr', 'indskr_accountid');
          }
        };
      }
      referenceControls = foundForm.metadata[0].controls;
    }
    dataReqEntity = foundForm.entitySetName;
    if (referenceControls && !isEmpty(linkEntityData)) {
      let setData = await this.setExistingACAffiliationData(control, referenceControls, linkEntityData);
      // Data is transferred when the save button is clicked (isAdd == true)
      if (setData && isAdd) {
        // Add linkEntities - push to linkEntitiesReqPayload through mdm service
        dataReq = {
          "entity": dataReqEntity,
          "values": [this._existingFormValue],
        }
        if (dataReq) {
          this._isFormSaved = false;
          this._isFormDirty = true;
          this.formDetail.eventsHandler(dataReq, 'ADDEDLINKEDENTITY', this.formDetail);
        }
      }
    }
    // Set accordionView data
    let data = {
      customFormValue: this._existingCustomFormValue,
      formValue: this._existingFormValue,
      formStringValue: this._existingFormStringValues,
    }
    if (!this.addedNewACAffiliation && (!isEmpty(this._existingCustomFormValue) || !isEmpty(this._existingFormValue) || !isEmpty(this._existingFormStringValues))) {
      let foundControl: Control;
      foundControl = control;
      if (foundControl) {
        try {
          let accordionView: OmniAccordionViewDataModel;
          let childItems: Array<any> = [];
          let abilityToRemoveRecords = foundControl.linkedEntityConfig && foundControl.linkedEntityConfig.abilityToRemoveRecords == '548910000'
          foundControl.subgrid.subgridLayout.forEach(attrib => {
            let attribName;
            let index = attrib.attribute.indexOf('.');
            if (index !== -1) {
              attribName = attrib.attribute.slice(index + 1);
            } else {
              attribName = attrib.attribute;
            }
            // A genuine boolean false (e.g. indskr_isprimaryaccount unticked) must still render -
            // the plain truthy checks below would otherwise silently drop the field,
            // indistinguishable from it being absent from all three value sources. Mirrors the
            // same fix already applied to ind-display-form.ts and the generic
            // editFormExistingDataViewCard loop elsewhere in this file.
            const isPresent = (obj) => obj && (obj[attribName] || typeof obj[attribName] === 'boolean');
            const source = isPresent(data.formStringValue) ? data.formStringValue
              : isPresent(data.formValue) ? data.formValue
              : isPresent(data.customFormValue) ? data.customFormValue
              : null;
            if (attribName && source) {
              const rawValue = source[attribName];
              const formattedValue = typeof rawValue === 'boolean' ? this.translate.instant(rawValue ? 'YES' : 'NO') : rawValue;
              if (accordionView) {
                let displayName: string = this._getDisplayText(attrib.displayNames);
                childItems.push({
                  id: foundControl.attributeName + '_' + attribName,
                  label: displayName ? displayName : '',
                  value: formattedValue,
                });
                accordionView.showExpandIcon = true;
                accordionView.showCollapseIcon = true;
              } else {
                accordionView = {
                  displayType: 'Accordion',
                  id: foundControl.attributeName + '_' + attribName + Math.random().toString(36).substring(7),
                  primaryText: formattedValue,
                  showExpandIcon: false,
                  showCollapseIcon: false,
                  isExpanded: false,
                  childItems: [],
                  scrapFromList: abilityToRemoveRecords,
                  clickHandler: (id, event, specificTarget, dataRef) => this.handleAccordionView(event, foundControl, specificTarget, dataRef)
                }
              }
            }
          });
          if (accordionView && !isAdd) {
            accordionView.childItems = childItems;
            if (this.linkedEntityValues && this.linkedEntityValues[foundControl.attributeName]) {
              this.linkedEntityValues[foundControl.attributeName].push(accordionView);
            } else if (this.linkedEntityValues) {
              this.linkedEntityValues[foundControl.attributeName] = [accordionView];
            } else {
              this.linkedEntityValues = {
                [foundControl.attributeName]: [accordionView]
              };
            }
          }
        } catch (error) {
          console.log(error);
        }
        this._initViewData();
      }
    }
  }
  // Add existing Linked Data for Address in Contact CR or Account CR
  private async _addExistingLinkedDataForAddress(control: Control, isAdd: boolean, optionData?: any) {
    let linkEntityData;
    let referenceControls: Control[];
    let dataReq;
    let foundForm;
    let dataReqEntity;
    // #1 Contact CR - address
    if (control.subgrid.referencingAttribute == 'indskr_contactcr' && control.lookupEntityPrimaryId == "indskr_customeraddresscrid") {
      let mdmId = this.dynamicFormsService.mdmId || '';
      let contactId = this.contactService.contactInformation.ID || '';
      let filteredRawLEDataAddress;
      let filteredLEDataACAffiliation;
      if (mdmId) {
        try {
          let fetchXml = CONTACT_FETCH_QUERIES.searchAllAddressesForOneKey;
          fetchXml = fetchXml.replace('{{linked-entities}}', CONTACT_FETCH_QUERIES.customerLinkedEntitiesContactCR);
          fetchXml = fetchXml.split("{{query}}").join('').split("{mdmid}").join(mdmId);
          await this.dynamics.executeFetchQuery('indskr_addresses', fetchXml).then((res)=> {
              if (!isEmpty(res) && res[0] != undefined) {
                filteredRawLEDataAddress = res;
              }}
          );
        } catch(error){
          console.log(error);
        }
      }
      if (contactId) {
        let foundAccountContactAffiliationData;
        try {
          let fetchXml = CONTACT_FETCH_QUERIES.searchAccountContactAffiliations;
          fetchXml = fetchXml.split("{{query}}").join('').split("{contactid}").join(contactId);
          await this.dynamics.executeFetchQuery('indskr_accountcontactaffiliations', fetchXml).then((res) => {
            if (!isEmpty(res) && res[0] != undefined) {
              filteredLEDataACAffiliation = res;
            }}
            );
        } catch(error){
          console.log(error);
        }
        if (!isEmpty(filteredLEDataACAffiliation) && filteredLEDataACAffiliation[0] != undefined) {
          let filteredACAffiliationPrimaryData = filteredLEDataACAffiliation.filter(x => x.hasOwnProperty('indskr_isprimaryaccount') && x['indskr_isprimaryaccount'] == true);
          // set found Account-Contact Affilidation, if there is no primary Account-Contact Affiliation with OneKey, set non-primary Account-Contact Affiliation with OneKey
          foundAccountContactAffiliationData = !isEmpty(filteredACAffiliationPrimaryData) ? filteredACAffiliationPrimaryData : filteredLEDataACAffiliation || '';
        }
        if (!isEmpty(foundAccountContactAffiliationData) && foundAccountContactAffiliationData[0].hasOwnProperty('_indskr_accountid_value') || this.addedNewACAffiliation) {
          let selectedAccountId;
          if (!this.addedNewACAffiliation) {
            selectedAccountId = foundAccountContactAffiliationData[0]['_indskr_accountid_value'] || '';
          } else {
            selectedAccountId = optionData ? optionData.formValue['lookupfields'].filter(x => x.name =='indskr_accountid')[0].id || '' : '';
          }
          if (!isEmpty(selectedAccountId) && !isEmpty(filteredRawLEDataAddress) && filteredRawLEDataAddress[0] != undefined) {
            let accountIdAttrName: string = '';
            for (const rawObj of filteredRawLEDataAddress) {
              accountIdAttrName = Object.keys(rawObj).find(key=>rawObj[key]===selectedAccountId);
            }
            // filtered address depends on selected Affiliated Account ID
            let filteredRawLEDataAddressByAccountId = filteredRawLEDataAddress.filter(x => x.hasOwnProperty(accountIdAttrName) && x[accountIdAttrName] == selectedAccountId);
            // filtered primary address
            let filteredAddressPrimaryData = filteredRawLEDataAddressByAccountId.filter(x => x.hasOwnProperty('ao.indskr_isprimary') && x['ao.indskr_isprimary'] == true);
            // set linked Entity Data, if there is no primary address with OneKey, set non-primary address with OneKey
            linkEntityData = !isEmpty(filteredAddressPrimaryData) ? filteredAddressPrimaryData : filteredRawLEDataAddressByAccountId || '';
            if (!isEmpty(linkEntityData)) {
              this.isAutoPopulatedLinkedDataFlow = true;
              console.log("found existing OneKey linked data - address in Contact CR");
            }
          }
        }
      }
    }
    // #2 Account CR - address
    else if (control.subgrid.referencingAttribute == "indskr_accountcr" && control.lookupEntityPrimaryId == "indskr_customeraddresscrid") {
      let mdmId = (this.dynamicFormsService.mdmId) ? this.dynamicFormsService.mdmId : '';
      if (mdmId) {
        let filteredRawLEDataAddress;
        try {
          let fetchXml = CONTACT_FETCH_QUERIES.searchAllAddressesForOneKey;
          fetchXml = fetchXml.replace('{{linked-entities}}', CONTACT_FETCH_QUERIES.customerLinkedEntitiesAccountCR);
          fetchXml = fetchXml.split("{{query}}").join('').split("{mdmid}").join(mdmId);
          await this.dynamics.executeFetchQuery('indskr_addresses', fetchXml).then((res)=> {
              if (!isEmpty(res) && res[0] != undefined) {
                filteredRawLEDataAddress = res;
              }}
          );
        } catch(error){
            console.log(error);
        }
        if (!isEmpty(filteredRawLEDataAddress) && filteredRawLEDataAddress[0] != undefined) {
          // filtered primary address
          let filteredAddressPrimaryData = filteredRawLEDataAddress.filter(x => x.hasOwnProperty('ao.indskr_isprimary') && x['ao.indskr_isprimary'] == true);
          // set linked Entity Data, if there is no primary address with OneKey, set non-primary address with OneKey
          linkEntityData = !isEmpty(filteredAddressPrimaryData) ? filteredAddressPrimaryData : filteredRawLEDataAddress || '';
          if (!isEmpty(linkEntityData)) {
            this.hasExistingLinkedDataForAddressAccountCR = true;
            this.isAutoPopulatedLinkedDataFlow = true;
            // indskr_composite/indskr_name come straight off the live indskr_address row
            // fetched above - Dynamics already computed these. Read them here directly
            // rather than relying on setExistingAddressData()'s form-control-driven copy
            // below, which only transfers fields that exist as a control on the
            // indskr_addresscr CREATE form - a composite-address field isn't one of them,
            // so it gets silently dropped and the label stays blank otherwise.
            this.labelForExistingAddress = linkEntityData[0]['indskr_composite'] || linkEntityData[0]['indskr_name'] || '';
            console.log("found existing OneKey linked data - address in Account CR");
          }
        }
      }
    }
    // Set Address Edit form field if there is existing linked data for address - Account CR
    if (control.subgrid.referencingAttribute == 'indskr_accountcr' && control.lookupEntityPrimaryId == "indskr_customeraddresscrid"
      && !isEmpty(linkEntityData) && !this.addedNewAddressForAccountCR) {
      let targetControl: Control;
      for (let tabIdx = 0; tabIdx < this._dynamicForm.metadata.length; tabIdx++) {
        const tab = this._dynamicForm.metadata[tabIdx];
        if (tab && tab.controls && tab.controls.length > 0) {
          let foundControl = tab.controls.find(c => !c.dataType && c.lookupEntityPrimaryId == "indskr_customeraddresscrid");
          if (foundControl) {
            targetControl = foundControl;
          break;
          }
        }
      };
      if (targetControl) {
        if (targetControl.subgrid) {
          if (targetControl.subgrid.targetEntityType) {
            let foundFormForAddress = await this.dynamicFormsService.getFormDefinitionForEntity(targetControl.subgrid.targetEntityType, FormType.CREATEFORM);
            let foundCustomField = await this._getCustomFields(targetControl.subgrid.referencingEntity)
            if (foundFormForAddress && foundCustomField) {
              let rawFormEntityObject = null;
               // Hide CustomerAddress ChangeRequest
               if (targetControl.subgrid.targetEntityType == 'indskr_customeraddresscr') {
                for (let i = 0; i < this._dynamicFormForAddressEdit.metadata.length; i++) {
                  const itab = this._dynamicFormForAddressEdit.metadata[i];
                  if (itab && itab.controls && itab.controls.length > 0) {
                    // Hide relationship fields that don't belong to indskr_customeraddresscr,
                    // including address-specific LU lookups (country, city, state, etc.) that
                    // may appear in the CRM form but belong to indskr_addresscr only.
                    itab.controls.filter(c => c.attributeName == 'indskr_addresscr' || c.lookupEntitySetName == 'indskr_contactcrs'
                      || c.lookupEntitySetName == 'indskr_accountcrs' || c.lookupEntitySetName == 'indskr_addresses'
                      || c.lookupEntitySetName?.startsWith('indskr_lu_')).forEach(c => c.forceHide = true);
                  }
                };
              }
              let displayName: any = this._getDisplayText(targetControl.displayNames);

              let formDetail: DynamicFormComponentModel = {
                title: startCase(displayName.toLowerCase()),
                showLeftHeaderButton: false,
                showSearchBar: false,
                leftHeaderBtnText: this.translate.instant('CANCEL'),
                LookupEntitySetName: foundFormForAddress.entitySetName,
                showRightHeaderButton: false,
                rightHeaderImgSrc: '',
                rightHeaderBtnText: '',
                formMetadata: foundFormForAddress,
                formEntityObject: rawFormEntityObject,
                mainEntityObjectId: null,
                linkedEntityParentData: this.getLinkEntityParentData(foundFormForAddress.entitySetName, targetControl),
                customFields: foundCustomField,
                dynamicFormType: DynamicFormType.CONFIGUREDFORM,
                navOptions: { animate: false },
                eventsHandler: (data: any, eventTarget: string, refData: DynamicFormComponentModel) => this._handleDynamicFormComponentEvent(data, eventTarget, refData),
              };
              this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
              if (formDetail) {
                this.formEditAddressDetail = formDetail;
              }
            }
          }
        }
      }
    }
    // Common data set flow
    foundForm = this._foundFormForAddressCR;
    if (foundForm && foundForm.metadata && foundForm.metadata[0].controls) {
      foundForm.metadata[0].controls.map(control => control.isCustom = true); // set as custom field
      const index = foundForm.metadata[0].controls.findIndex(control => control.attributeName == "indskr_name");
      if (index >= 0) {
        foundForm.metadata[0].controls.splice(index, 1);
      }
      referenceControls = [...foundForm.metadata[0].controls];
    }
    if (referenceControls && !isEmpty(linkEntityData)) {
      let setData;
      if (control.subgrid.referencingAttribute == "indskr_contactcr" || control.subgrid.referencingAttribute == "indskr_accountcr" && !isAdd) {
        setData = await this.setExistingAddressData(control, referenceControls, linkEntityData);
      }
      // Data is transferred when the save button is clicked (isAdd == true)
      if (isAdd && (control.subgrid.referencingAttribute == "indskr_contactcr" && setData || control.subgrid.referencingAttribute == "indskr_accountcr")) {
        let createLinkedEntity = await this.createLinkedEntityForAddress();
        if (createLinkedEntity) {
          this.dynamicFormsService.okAddressMapper.custom = this._existingCustomFormValue;
          this.dynamicFormsService.okAddressMapper.formatted = this._existingFormStringValues;
          // add linkEntities - push to linkEntitiesReqPayload through mdm service
          dataReqEntity = control.lookupEntitySetName;
          dataReq = {
          "entity": dataReqEntity,
          "values": [this._existingFormValue],
          }
          if (dataReq) {
            this._isFormSaved = false;
            this._isFormDirty = true;
            this.formDetail.eventsHandler(dataReq, 'ADDEDLINKEDENTITY', this.formDetail);
          }
        }
      }
    }

    // Set accordionView data
    let data = {
      customFormValue: this._existingCustomFormValue,
      formValue: this._existingFormValue,
      formStringValue: this._existingFormStringValues,
    }
    if (!isEmpty(linkEntityData) && (!isEmpty(this._existingCustomFormValue) || !isEmpty(this._existingFormValue) || !isEmpty(this._existingFormStringValues))) {
      let foundControl: Control;
      foundControl = control;
      if (foundControl) {
        try {
          let accordionView: OmniAccordionViewDataModel;
          let childItems: Array<any> = [];
          let abilityToRemoveRecords = foundControl.linkedEntityConfig && foundControl.linkedEntityConfig.abilityToRemoveRecords == '548910000'
          foundControl.subgrid.subgridLayout.forEach(attrib => {
            let attribName;
            let index = attrib.attribute.indexOf('.');
            if (index !== -1) {
              attribName = attrib.attribute.slice(index + 1);
            } else {
              attribName = attrib.attribute;
            }
            if (attribName && ((data.formStringValue && data.formStringValue[attribName]) || (data.formValue && data.formValue[attribName]) || (data.customFormValue && data.customFormValue[attribName]))) {
              if (accordionView) {
                let displayName: string = this._getDisplayText(attrib.displayNames);
                childItems.push({
                  id: foundControl.attributeName + '_' + attribName,
                  label: displayName ? displayName : '',
                  value: data.formStringValue && data.formStringValue[attribName] ? data.formStringValue[attribName] : (data.formValue && data.formValue[attribName]) || (data.customFormValue && data.customFormValue[attribName]),
                });
                accordionView.showExpandIcon = true;
                accordionView.showCollapseIcon = true;
              } else {
                accordionView = {
                  displayType: 'Accordion',
                  id: foundControl.attributeName + '_' + attribName + Math.random().toString(36).substring(7),
                  primaryText: data.formStringValue && data.formStringValue[attribName] ? data.formStringValue[attribName] : (data.formValue && data.formValue[attribName]) || (data.customFormValue && data.customFormValue[attribName]),
                  showExpandIcon: false,
                  showCollapseIcon: false,
                  isExpanded: false,
                  childItems: [],
                  scrapFromList: abilityToRemoveRecords,
                  clickHandler: (id, event, specificTarget, dataRef) => this.handleAccordionView(event, foundControl, specificTarget, dataRef)
                }
              }
            }
          });
          if (accordionView) {
            accordionView.childItems = childItems;
            if (this.linkedEntityValues && this.linkedEntityValues[foundControl.attributeName]) {
              if (foundControl.lookupEntitySetName == 'indskr_customeraddresscrs' && this.linkedEntityValues[foundControl.attributeName].length == 1) {
                delete this.linkedEntityValues[foundControl.attributeName] // delete duplicated data or update data
                this.linkedEntityValues[foundControl.attributeName] = [accordionView];
              } else this.linkedEntityValues[foundControl.attributeName].push(accordionView);
            } else if (this.linkedEntityValues) {
              this.linkedEntityValues[foundControl.attributeName] = [accordionView];
            } else {
              this.linkedEntityValues = {
                [foundControl.attributeName]: [accordionView]
              };
            }
          }
        } catch (error) {
          console.log(error);
        }
        this._initViewData(); // for updating add button
      }
    }
    if (!isAdd && control.subgrid.referencingAttribute == 'indskr_accountcr' && control.lookupEntityPrimaryId == "indskr_customeraddresscrid"
      && !isEmpty(linkEntityData) && !isEmpty(this.formEditAddressDetail)) {
        this._initViewEditFormData(true);
    }
    // Set label for editalbe existing address
    // omp_compositeaddress is a custom composite-address field used by some org's Address CR
    // form instead of the standard indskr_composite/indskr_name - check it too or the label
    // silently stays blank for those orgs even though the address data is fully populated.
    if (this._existingCustomFormValue && (this._existingCustomFormValue.indskr_composite || this._existingCustomFormValue.omp_compositeaddress || this._existingCustomFormValue.indskr_name)) {
      this.labelForExistingAddress = this._existingCustomFormValue.indskr_composite || this._existingCustomFormValue.omp_compositeaddress || this._existingCustomFormValue.indskr_name || '';
    } else if (this._existingFormValue && (this._existingFormValue.indskr_composite || this._existingFormValue.omp_compositeaddress || this._existingFormValue.indskr_name)) {
      this.labelForExistingAddress = this._existingFormValue.indskr_composite || this._existingFormValue.omp_compositeaddress || this._existingFormValue.indskr_name || '';
    }
  }
  // Set Existing data for Account-Contact Affiliation
  private async setExistingACAffiliationData(selectedControl: Control, referenceControls: Control[], linkedData: any) {
    this._existingFormValue = {};
    this._existingCustomFormValue = {};
    this._existingFormStringValues = {};
    let formValueObj = {};
    if (selectedControl.subgrid.referencingAttribute == 'indskr_contactcr') {
      formValueObj = {
        name: 'indskr_ContactCR',
        entity: 'indskr_contactcrs',
        id: ''
      }
    }
    this._existingFormValue['lookupfields'] = [formValueObj];
    // Set account contact affiliation values for contact CR: _existingFormValue
    if (selectedControl.lookupEntityPrimaryId == 'indskr_accountcontactaffiliationcrid') {
      // Array.forEach does not await its callback, so a plain forEach(async control => ...)
      // here returns (and this function resolves) before a control whose resolution needs an
      // extra await - e.g. Affiliation Role's OneKey codes-labels lookup below - has actually
      // finished writing its value. The caller then reads _existingFormValue/_existingFormStringValues
      // too early and that field's existing value is silently missing from the edit-form card.
      // A for-of with await genuinely waits for every control, including that one.
      for (const control of referenceControls) {
        switch (control.dataType) {
          case ControlDataType.MoneyType:
          case ControlDataType.IntegerType:
          case ControlDataType.DecimalType:
          case ControlDataType.DoubleType:
          case ControlDataType.MemoType:
          case ControlDataType.StringType:
            // Carrying over an existing value for display/edit must not depend on whether the
            // field happens to be marked Required on the create form - isRequired is a save-time
            // validation concept, not a "does this field have data to show" one. Gating on it
            // here silently dropped every optional field's existing value (e.g. Affiliation
            // Role, Is Primary Account below), even though the raw fetched record had it.
            if (linkedData[0][control.attributeName]) {
              if (control.isVisible && !control.forceHide) {
                this._setExistingAttributeValue(control, linkedData[0][control.attributeName]);
              }
            }
            break;
          case ControlDataType.LookupType:
            if (linkedData[0]['_' + control.attributeName + '_value']) {
              if (control.isVisible && !control.forceHide) {
                if(control.lookupEntityPrimaryId && control.lookupEntityPrimaryId == "omnione_onekeycodeslabelsid"){
                  if(linkedData[0]['_' + control.attributeName  + '_value'] && this.localizationService.multiLingualFieldsData && this.localizationService.multiLingualFieldsData.length > 0){
                    let foundRecord = this.localizationService.multiLingualFieldsData.find(a=> a['omnione_onekeycodeslabelsid'] == linkedData[0]['_' + control.attributeName  + '_value']);
                    let translatedLang: string = '';
                    let key = this.localizationService.getOneKeyTableAttributes();
                    if(foundRecord) translatedLang = foundRecord[key] ? foundRecord[key] || '' : foundRecord['omnione_en_long_label'] || '';
                    if(foundRecord && foundRecord['omnione_onekeycodeslabelsid'] && translatedLang){
                      const schemaFieldName = foundRecord['omnione_schemafieldname'] || '';
                      const onekeyCodesLabelsId = foundRecord['omnione_onekeycodeslabelsid'] || '';
                      const codIdOneKey = await this.dynamicFormsService.getLookupCodIdOnekey(schemaFieldName, onekeyCodesLabelsId) || '';
                      this._setExistingAttributeValue(control, onekeyCodesLabelsId, codIdOneKey);
                      this._setExistingAttributeStringValue(control.attributeName, translatedLang);
                    }
                  }
                }else{
                  this._setExistingAttributeValue(control, linkedData[0]['_' + control.attributeName + '_value']);
                  this._setExistingAttributeStringValue(control.attributeName, linkedData[0]['_' + control.attributeName + '_value@OData.Community.Display.V1.FormattedValue']);
                }
              }
            }
            break;
          case ControlDataType.BooleanType:
            if (linkedData[0] && linkedData[0].hasOwnProperty(control.attributeName)) {
              if (control.isVisible && !control.forceHide) {
                (linkedData[0][control.attributeName]) ? this._setExistingAttributeValue(control, true) : this._setExistingAttributeValue(control, false);
              }
            }
            break;
          case ControlDataType.MultiSelectPicklistType:
            if (linkedData[0][control.attributeName]) {
              this._setExistingAttributeValue(control, linkedData[0][control.attributeName]);
              let str = linkedData[0][control.attributeName+'@OData.Community.Display.V1.FormattedValue'].replace(/;/g, ',');
              if (control.isVisible && !control.forceHide) {
                this._setExistingAttributeStringValue(control.attributeName,str);
              }
            }
            break;
          case ControlDataType.PicklistType:
            if (linkedData[0][control.attributeName]) {
              if (control.isVisible && !control.forceHide) {
                this._setExistingAttributeValue(control, linkedData[0][control.attributeName]);
                this._setExistingAttributeStringValue(control.attributeName, linkedData[0][control.attributeName + '@OData.Community.Display.V1.FormattedValue']);
              }
            }
            break;
          default:
            break;
        }
        if (control.attributeName == 'indskr_name') {
          let getName = linkedData[0]['_indskr_accountid_value_Formatted'] || '';
          if (getName) this._setExistingAttributeValue(control, getName);
        }
      }
    }
    return true;
  }
  // Set existing Address data
  private async setExistingAddressData(selectedControl: Control, referenceControls: Control[], linkedData: any) {
    this._existingFormValue = {};
    this._existingCustomFormValue = {};
    this._existingFormStringValues = {};
    let formValueObj = {};
    if (selectedControl.subgrid.referencingAttribute == 'indskr_contactcr') {
      formValueObj = {
        name: 'indskr_ContactCR',
        entity: 'indskr_contactcrs',
        id: ''
      }
    } else if (selectedControl.subgrid.referencingAttribute == 'indskr_accountcr') {
      formValueObj = {
        name: 'indskr_AccountCR',
        entity: 'indskr_accountcrs',
        id: ''
      }
    }
    this._existingFormValue['lookupfields'] = [formValueObj];
    // Set address values for account CR / contact CR: _existingCustomFormValue
    if (selectedControl.lookupEntityPrimaryId == 'indskr_customeraddresscrid') {
      referenceControls.forEach(control => {
        if (control.dataType == ControlDataType.LookupType) {
          let foundLookupId = linkedData[0]['_' + control.attributeName + '_value'] || '';
          let foundName = linkedData[0]['_' + control.attributeName + '_value@OData.Community.Display.V1.FormattedValue'] || '';
          if (control.attributeName == 'indskr_country_lu') {
            if (foundLookupId) {
              this.dynamicFormsService.getLookupResultsForCityBasedOnCountry(foundLookupId, control);
            }
          }
          if (foundLookupId) this._setExistingAttributeValue(control, foundLookupId);
          if (foundName) this._setExistingAttributeStringValue(control.attributeName, foundName);
        } else if (control.dataType == "StringType" || control.dataType == "MemoType") {
          let foundName = linkedData[0][control.attributeName] || '';
          if (control.attributeName == "indskr_composite" || control.attributeName == "indskr_compositecitystate") {
            if (foundName) {
              foundName = foundName.replace(/(\r\n|\n|\r)/gm, "");
              foundName = foundName.split(',').join(', ').replace(/\s\s+/g, ' ');
            }
          }
          if (foundName) {
            this._setExistingAttributeValue(control, foundName);
            if (control.attributeName == "indskr_composite" && selectedControl.subgrid.subgridLayout && selectedControl.subgrid.subgridLayout.filter(x=>x.attribute == 'indskr_name').length == 1) {
              this._existingFormValue = {
                ['indskr_name']: foundName,
              }
            }
          }
        }
      });
    }
    return true;
  }
  // Create LinkedEntity for Address which is Custom Form
  private async createLinkedEntityForAddress() {
    let { logicalCollectionName, logicalName, schemaName } = this.getAddressEntity();
    if (this._existingCustomFormValue) {
      const res = await this.dynamicFormsService.createLinkedEntity(this._existingCustomFormValue, logicalCollectionName);
      if (res) {
        const obj = {
          entity: logicalCollectionName,
          id: res['guid'],
          name: schemaName,
        };
        if (this._existingFormValue && this._existingFormValue['lookupfields']) {
          const idx = this._existingFormValue['lookupfields'].findIndex(x => x.entity == logicalCollectionName);
          if (idx >=0) {
            delete this._existingFormValue.lookupfields[idx];
            this._existingFormValue.lookupfields[idx] = obj;
          } else {
            this._existingFormValue['lookupfields'].push(obj);
          }
        } else {
          this._existingFormValue = {
            lookupfields: [obj],
          }
        }
        return true;
      }
    }
  }
  // Set existing values for Attribute
  private _setExistingAttributeValue(control: Control, value: any, codIdOnekey: string = '') {
    if (control.isCustom) {
      this._setExistingCustomAttributeValue(control, value, codIdOnekey);
      return;
    }
    let objName = control.isCustomAttribute ? control.schemaName : control.attributeName;
    let cfvObj = {
      name: objName,
      entity: control.lookupEntitySetName,
      id: value
    }
    if (this._existingFormValue) {
      if (control.dataType == ControlDataType.LookupType) {
        let crLookUp;
        if(codIdOnekey) {
          const entityName = control.isCustomAttribute ? control.schemaName : control.attributeName;
          crLookUp = {
            entity: entityName,
            codIdOnekey: codIdOnekey,
            guid: value
          };
        }
        if (this._existingFormValue.hasOwnProperty('lookupfields')) {
          const idx = this._existingFormValue['lookupfields'].findIndex(a => a.name == objName);
          if (idx >= 0) {
            const prevGuid = this._existingFormValue['lookupfields'][idx].id || '';
            this._existingFormValue['lookupfields'][idx] = cfvObj;
            if(prevGuid && codIdOnekey && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.addLookupOnekeyData(prevGuid, crLookUp);
          } else {
            this._existingFormValue['lookupfields'].push(cfvObj);
            if(codIdOnekey) this.dynamicFormsService.okLookUpMapper.push(crLookUp);
          }
        } else {
          this._existingFormValue['lookupfields'] = [cfvObj];
          if(codIdOnekey) this.dynamicFormsService.okLookUpMapper = [crLookUp];
        }
      } else {
        if ((value === '' || value == undefined || value == null) && control.isRequired) {
          delete this._existingFormValue[control.attributeName];
        } else {
          this._existingFormValue[control.attributeName] = value;
        }
      }
    } else {
      if (control.dataType == ControlDataType.LookupType) {
        this._existingFormValue = { lookupfields: [cfvObj] };
      } else {
        if ((value === '' || value == undefined || value == null) && control.isRequired) return;
        this._existingFormValue = {
          [control.attributeName]: value,
        }
      }
    }
    if (!isEmpty(this.formEditAddressDetail)) {
      this._initViewEditFormData();
    }
    if (control.attributeName =='indskr_composite' || control.attributeName =='omp_compositeaddress' || control.attributeName =='indskr_name') {
      this.labelForExistingAddress = this._existingFormValue.indskr_composite || this._existingFormValue.omp_compositeaddress || this._existingFormValue.indskr_name || '';
    }
  }
  // Set existing values for Custom Attribute
  private _setExistingCustomAttributeValue(control: Control, value: any, codIdOnekey: string = '') {
    let cfvObj = {
      name: control.schemaName,
      entity: control.lookupEntitySetName,
      id: value
    };
    if (control.lookupEntitySetName == "indskr_lu_countries") {
      this.dynamicFormsService.selectedCountry = {};
      this.dynamicFormsService.selectedCountry = cfvObj;
    } else if (control.lookupEntitySetName == "indskr_lu_cities") {
      this.dynamicFormsService.selectedCity = {};
      this.dynamicFormsService.selectedCity = cfvObj;
    }
    if (this._existingCustomFormValue) {
      let crLookUp;
      if (control.dataType == ControlDataType.LookupType) {
        if(codIdOnekey) {
          const entityName = control.isCustomAttribute ? control.schemaName : control.attributeName;
          crLookUp = {
            entity: entityName,
            codIdOnekey: codIdOnekey,
            guid: value
          };
        }
        if (this._existingCustomFormValue.hasOwnProperty('lookupfields')) {
          const idx = this._existingCustomFormValue['lookupfields'].findIndex(a => a.name == control.schemaName);
          if (idx >= 0) {
            const prevGuid = this._existingCustomFormValue['lookupfields'][idx].id || '';
            this._existingCustomFormValue['lookupfields'][idx] = cfvObj;
            if(prevGuid && codIdOnekey && this.dynamicFormsService.okLookUpMapper) this.dynamicFormsService.addLookupOnekeyData(prevGuid, crLookUp);
          } else {
            this._existingCustomFormValue['lookupfields'].push(cfvObj);
            if(codIdOnekey) this.dynamicFormsService.okLookUpMapper.push(crLookUp);
          }
        } else {
          this._existingCustomFormValue['lookupfields'] = [cfvObj];
          if(codIdOnekey) this.dynamicFormsService.okLookUpMapper = [crLookUp];
        }
      } else {
        if ((value === '' || value == undefined || value == null) && control.isRequired) {
          delete this._existingCustomFormValue[control.attributeName];
        } else {
        this._existingCustomFormValue[control.attributeName] = value;
        // updated name on Dynamics
          if (control.attributeName == 'indskr_name') {
            this._existingFormValue['indskr_name'] = value;
          }
        }
      }
    } else {
      if (control.dataType == ControlDataType.LookupType) {
        this._existingCustomFormValue = { lookupfields: [cfvObj] };
      } else {
        this._existingCustomFormValue = {
          [control.attributeName]: value,
        }
      }
    }
    if (!isEmpty(this.formEditAddressDetail)) {
      this._initViewEditFormData();
    }
    if (control.attributeName =='indskr_composite' || control.attributeName =='omp_compositeaddress' || control.attributeName =='indskr_name') {
      this.labelForExistingAddress = this._existingCustomFormValue.indskr_composite || this._existingCustomFormValue.omp_compositeaddress || this._existingCustomFormValue.indskr_name || '';
    }
  }
  // Set existing values for Attribute String
  private _setExistingAttributeStringValue(attributeName: string, value: any) {
    if (this._existingFormStringValues) {
      if (attributeName === 'statecode' || attributeName === 'statuscode') {
        this._existingFormStringValues[attributeName] = this.dynamicFormsService.translatedValue(value);
      } else {
        this._existingFormStringValues[attributeName] = value;
      }
    } else {
      this._existingFormStringValues = {
        [attributeName]: value,
      }
    }
    if (!isEmpty(this.formEditAddressDetail)) {
      this._initViewEditFormData();
    }
  }
  private _setAddressWithSelectedCity(selectedItem: any) {
    let foundForm = this._foundFormForAddressCR;
    let referenceControls: Control[];
    this._stateIdBasedOnCity = selectedItem.stateId || '';
    if (foundForm && foundForm.metadata && foundForm.metadata[0].controls) {
      foundForm.metadata[0].controls.map(control => control.isCustom = true); // set as custom field
      const index = foundForm.metadata[0].controls.findIndex(control => control.attributeName == "indskr_name");
      if (index >= 0) {
        foundForm.metadata[0].controls.splice(index, 1);
      }
      referenceControls = [...foundForm.metadata[0].controls];
    }

    referenceControls.forEach(control => {
      if (control.lookupEntityPrimaryId == 'indskr_lu_countryid') {
        let countryId = selectedItem.countryId || '';
        let countryName = selectedItem.countryName || '';
        if (!this.isHandleEditAddressFormField) {
          if (countryId) this._setAttributeValue(control, countryId, false);
          if (countryName) {
            this._setAttributeStringValue(control.attributeName, countryName);
            this.dynamicFormsService.isSelectedCountry = true;
          }
        } else {
          if (countryId) this._setExistingAttributeValue(control, countryId);
          if (countryName) this._setExistingAttributeStringValue(control.attributeName, countryName);
        }
      }
      if (control.attributeName == 'indskr_compositecitystate') {
        let compositeCityState = selectedItem.stateName || '';
        if (!this.isHandleEditAddressFormField) {
          if (compositeCityState) this._setAttributeValue(control, compositeCityState);
        } else {
          if (compositeCityState) this._setExistingAttributeValue(control, compositeCityState);
        }
      }
    });
    if (!isEmpty(this.formEditAddressDetail)) {
      this._initViewEditFormData();
    }
  }
  // For address edit form view
  public expandChildItems(event,value){
    this.isExpandedCurrentEditFormView = value;
  }
  //Auto-populated Existing Linked Data flow - #end

  private _validateMandatoryField(id, value, event, isEditAddressForm?: boolean): boolean {
    let fieldValue = value;
    if ((fieldValue === undefined || fieldValue === null) && event) {
      fieldValue = event.target?.value ?? event.value;
    }
    const formViewList = !isEditAddressForm ? this.currentFormView : this.currentEditFormView;
    if (fieldValue === null || fieldValue === undefined) {
      formViewList.forEach(formView => {
        if(formView.id == id) {
          formView.view.isInvalid = true;
          formView.view.isEmptyRequiredField = true;
        }
      })
      this.errorMessage = this.translate.instant('THIS_IS_A_REQUIRED_FIELD');
      return false;
    } else {
      formViewList.forEach(formView => {
        if(formView.id == id) formView.view.isInvalid = false;
      })
      return true;
    }
  }

  // Edit - Bussiness - Linked Entity
  private async _initializeSubgridData(control: Control) {
    if (this.LINKED_ENTITY_DB_PREFIX) this.linkedEntityDBPrefix = this.LINKED_ENTITY_DB_PREFIX;
    if (this.RAW_DATA) this.rawData = this.RAW_DATA;
    if (this.REF_ENTITY_NAME) this.referencingEntityName = this.REF_ENTITY_NAME;
    let abilityToRemoveRecords = control.linkedEntityConfig && control.linkedEntityConfig.abilityToRemoveRecords == '548910000'
    const refEntityNamesAffiliations = [
      ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY,
      CONTACT_CONTACT_AFFILIATIONS_REF_ENTITY,
    ];
    const isThisControlAffiliations = refEntityNamesAffiliations.includes(control.subgrid.referencingEntity);
    let dbKey: string = isThisControlAffiliations ? control.subgrid.relationshipName : control.subgrid.referencingEntity;
    if (this.formDetail.formMetadata.entityName == 'indskr_contactcr' && dbKey == 'indskr_emailaddresscr') {
      dbKey = 'indskr_email_address';
    } else if(this.EDIT_FLOW == "change_request_category_flow") {
      if (dbKey == "exe_customerpositionchangerequests") {
        dbKey = 'indskr_customerposition';
      } else if (dbKey === 'indskr_addresscr' || dbKey === 'indskr_customeraddresscr') {
        dbKey = 'indskr_indskr_customeraddress_v2';
      } else if (dbKey === 'indskr_accountcontactaffiliationcr') {
        dbKey = 'indskr_accountcontactaffiliation';
      } else if (dbKey.startsWith('exe_') && dbKey.endsWith('changerequest')) {
        dbKey = 'indskr_' + dbKey.replace(/^exe_/, '').replace(/changerequest$/, '');
      } else if (dbKey.startsWith('indskr_') && dbKey.endsWith('changerequest')) {
        dbKey = dbKey.replace(/changerequest$/, '');
      }
    }

    let rawLEData = await this.disk.retrieve(this.linkedEntityDBPrefix + dbKey);
    if (this.rawData && this.rawData.hasOwnProperty('globalSearchedDataLinkEntities')) {
      let raw = this.rawData['globalSearchedDataLinkEntities'][this.linkedEntityDBPrefix + control.subgrid.referencingEntity]
              ?? this.rawData['globalSearchedDataLinkEntities'][this.linkedEntityDBPrefix + control.subgrid.relationshipName]
              ?? [];

      rawLEData = {
        raw
      };
    }

    let linkEntityData;
    if (rawLEData && rawLEData.raw) {
        linkEntityData = (rawLEData.raw).filter(x => x[this.referencingEntityName] == this.rawData[this.referencingEntityName] && (!x.hasOwnProperty(control.subgrid.referencingEntity + '.statecode') || (x.hasOwnProperty(control.subgrid.referencingEntity + '.statecode') && x[control.subgrid.referencingEntity + '.statecode'] == 0)));
    }
    if (linkEntityData) {
      /*************Remove Duplicates from Display form - Offline Edit*************/
      if(this.formDetail.formMetadata.entityName == 'contact'){
        if(dbKey === 'indskr_email_address') {
          linkEntityData = uniqBy(linkEntityData, function (e) {
            return  e['indskr_email_address.indskr_emailaddress'];
          });
        }
        else if(dbKey === 'indskr_accountcontactaffiliation') {
          linkEntityData = uniqBy(linkEntityData, function (e) {
            return  e['indskr_accountcontactaffiliation.indskr_accountid_Formatted'];
          });
        }
      }
      else if(this.formDetail.formMetadata.entityName == 'indskr_contactcr'){
        if(dbKey === 'indskr_emailaddresscr') {
          linkEntityData = uniqBy(linkEntityData, function (e) {
            return  e['indskr_emailaddresscr.indskr_name'];
          });
        }
        else if(dbKey === 'indskr_accountcontactaffiliationcr') {
          linkEntityData = uniqBy(linkEntityData, function (e) {
            return  e['indskr_accountcontactaffiliationcr.indskr_accountid_Formatted'];
          });
        }
        else if(dbKey === 'indskr_customerspecialtychangerequest') {
          linkEntityData = uniqBy(linkEntityData, function (e) {
            return  e['indskr_customerspecialtychangerequest.omnione_lu_specialties_value'];
          });
        } else if (dbKey === 'indskr_indskr_customeraddress_v2') {
          linkEntityData = uniqBy(linkEntityData, function (e) {
            return  e['indskr_address.indskr_composite'];
          });
        }
      }
      /*************Remove Duplicates from Display form - Offline Edit*************/

      // Filter out user's position for Exeltis Realignment CR Form
      if (this._dynamicForm?.formId?.includes("Exeltis Realignment CR Form") && 
          (control.subgrid.referencingEntity == 'exe_customerpositionchangerequest' || dbKey === 'indskr_customerposition') &&
          this.authService.user.positionID) {
        const filteredData = [];
        linkEntityData.forEach(leData => {
          const positionId = leData['indskr_customerposition.indskr_positionid'];
          if (positionId === this.authService.user.positionID) {
            this.dynamicFormsService.removedCustomerPositionForRealignment = leData['indskr_customerposition.indskr_positionid'];
          } else {
            filteredData.push(leData);
          }
        });
        linkEntityData = filteredData;
      }

      // START - sort
      const shouldAllowSorting: boolean = true;
      if (shouldAllowSorting) {
        let JSONQuery;
        let entityName: String = '';
        const sortOptions = [];
        XML2JS.parseString(control.subgrid.subgridQuery, (err, data) => {
          if (!err) {
            JSONQuery = data;
            if (JSONQuery) {
              entityName = JSONQuery.fetch.entity[0].$.name;
              if (JSONQuery.fetch.entity[0]['order'] && JSONQuery.fetch.entity[0]['order'].length) {
                JSONQuery.fetch.entity[0]['order'].forEach(sort => {
                  sortOptions.push(sort);
                });
              }
            }
          }
        });
        if (sortOptions.length) {
          let generatedSortingFields = [];
          sortOptions.forEach(field => {
            const fieldName = entityName + '.' + field.$.attribute;
            const formattedField = fieldName + '@OData.Community.Display.V1.FormattedValue';
            const hasFormattedField = (linkEntityData.filter(ret => ret[formattedField]).length > 0);
            generatedSortingFields.push(field.$.descending === 'true' ? (hasFormattedField ? '-' + formattedField : '-' + fieldName) : (hasFormattedField ? formattedField : fieldName));
          });
          linkEntityData.sort(compareBy(...generatedSortingFields));
        }
      }
      // END
      if (this.linkedEntityValues && this.linkedEntityValues[control.attributeName]) this.linkedEntityValues[control.attributeName] = [];
      linkEntityData.forEach(leData => {
        let editFormExistingDataViewCard: OmniAccordionViewDataModel;
        let childItems: Array<any> = [];
        let foundLinkedEntityIdAttribName: string;
        let foundAddressLinkedEntityIdAttribName: string;
        let formattedPrimaryText: string;
        let primaryTextindskrName: string;
        foundLinkedEntityIdAttribName = control.subgrid.referencingEntity + '.' + control.subgrid.referencingEntity + 'id';
        
        if (control.subgrid.referencingEntity == 'indskr_indskr_customeraddress_v2' || control.subgrid.referencingEntity === 'indskr_addresscr' || control.subgrid.referencingEntity === 'indskr_customeraddresscr') {
          foundAddressLinkedEntityIdAttribName = 'indskr_indskr_customeraddress_v2.indskr_address';
        }
        else if (control.subgrid.referencingEntity == 'indskr_emailaddresscr') {
          foundLinkedEntityIdAttribName = 'indskr_email_address.indskr_email_addressid';
        } else if (control.subgrid.referencingEntity == 'exe_customerlicensechangerequest') {
          foundLinkedEntityIdAttribName = 'indskr_customerlicense.indskr_licensenumber';
        } else if (control.subgrid.referencingEntity == 'indskr_customerspecialtychangerequest') {
          foundLinkedEntityIdAttribName = 'indskr_customerspecialty.indskr_specialtyid';
        } else if (control.subgrid.referencingEntity == 'exe_customerpositionchangerequest') {
          foundLinkedEntityIdAttribName = 'indskr_customerposition.indskr_positionid';
        } else if (control.subgrid.referencingEntity == 'exe_customerdegreechangerequest' || control.subgrid.referencingEntity == 'indskr_customerdegree') {
          foundLinkedEntityIdAttribName = 'indskr_customerdegree.indskr_degree';
        }
        // set primary text value
        switch(control.subgrid.referencingEntity) {
          case 'indskr_email_address':
          case 'indskr_emailaddresscr':
            formattedPrimaryText = leData['indskr_email_address.indskr_emailaddress'] || '';
            break;
          case 'indskr_addresscr':
          case 'indskr_customeraddresscr':
          case 'indskr_indskr_customeraddress_v2':
            // indskr_addresscr.* is the CR-mirror alias (Contact/Account CR "existing address"
            // subgrid); indskr_address.* / indskr_indskr_customeraddress_v2.* is the live
            // customer-address alias used when this same builder shows a real address record.
            // Both must be checked - using only the live alias left the CR flow's title blank.
            formattedPrimaryText = leData['indskr_addresscr.indskr_composite'] || leData['indskr_address.indskr_composite']
              || leData['indskr_addresscr.indskr_name'] || leData['indskr_indskr_customeraddress_v2.indskr_name'];
            break;
          case 'indskr_customerspecialty':
            formattedPrimaryText = leData['indskr_customerspecialty.indskr_specialtyid@OData.Community.Display.V1.FormattedValue'] || '';
            break;
          case 'indskr_contactrelationship':
              formattedPrimaryText = leData['indskr_contactrelationship.indskr_contactid@OData.Community.Display.V1.FormattedValue'] || '';
              break;
          case 'indskr_accountcontactaffiliation':
            if (control.subgrid.referencingAttribute == 'indskr_contactid') {
              formattedPrimaryText = leData['indskr_accountcontactaffiliation.indskr_accountid@OData.Community.Display.V1.FormattedValue'] || '';
            } else if (control.subgrid.referencingAttribute == 'indskr_accountid') {
              formattedPrimaryText = leData['indskr_accountcontactaffiliation.indskr_contactid@OData.Community.Display.V1.FormattedValue'] || '';
            }
            break;
          case 'indskr_accountaccountaffiliation':
            if (control.subgrid.referencingAttribute == 'indskr_affiliatedtoaccountid') {
              formattedPrimaryText = leData['indskr_accountaccountaffiliation.indskr_affiliatedfromaccountid@OData.Community.Display.V1.FormattedValue'] || '';
            } else if (control.subgrid.referencingAttribute == 'indskr_affiliatedfromaccountid')
            formattedPrimaryText = leData['indskr_accountaccountaffiliation.indskr_affiliatedtoaccountid@OData.Community.Display.V1.FormattedValue'] || '';
            break;
          case 'exe_customerpositionchangerequest':
          case 'indskr_customerposition':
            formattedPrimaryText = leData['indskr_customerposition.indskr_positionid@OData.Community.Display.V1.FormattedValue'] || '';
            break;
          case 'exe_customerdegreechangerequest':
          case 'indskr_customerdegree':
            formattedPrimaryText = leData['indskr_customerdegree.indskr_degree@OData.Community.Display.V1.FormattedValue'] || '';
            break;
          default:
            break;
        }
        control.subgrid.subgridLayout.forEach(attrib => {
          let attribName;
          let index = attrib.attribute.indexOf(".");
          if(control.subgrid.referencingEntity == 'indskr_addresscr') {
            attribName = this.getCustomerAddressCRAttributeName(attrib.attribute);
            attribName = leData[attribName + "@OData.Community.Display.V1.FormattedValue"] ?
            attribName + "@OData.Community.Display.V1.FormattedValue" : attribName;
          } else if(control.subgrid.referencingEntity == 'indskr_customeraddresscr') {
            // This CR's subgrid layout columns are already the real dotted source
            // keys (e.g. indskr_address.indskr_line1) present on the contact's
            // address row, so use them directly; prefer the formatted value for
            // lookups (city/state/country/postalcode).
            attribName = leData[attrib.attribute + "@OData.Community.Display.V1.FormattedValue"] ?
              attrib.attribute + "@OData.Community.Display.V1.FormattedValue" : attrib.attribute;
          } else if(this.EDIT_FLOW == "change_request_category_flow") {
            let mappedEntityName = control.subgrid.referencingEntity;
            if (mappedEntityName === 'indskr_accountcontactaffiliationcr') {
              mappedEntityName = 'indskr_accountcontactaffiliation';
            } else if (mappedEntityName.startsWith('exe_') && mappedEntityName.endsWith('changerequest')) {
              mappedEntityName = 'indskr_' + mappedEntityName.replace(/^exe_/, '').replace(/changerequest$/, '');
            } else if (mappedEntityName.startsWith('indskr_') && mappedEntityName.endsWith('changerequest')) {
              mappedEntityName = mappedEntityName.replace(/changerequest$/, '');
            }
            if(attrib.attribute === "exe_expdate_new") {
              attribName = mappedEntityName  + '.indskr_validuntil';
            } else if(attrib.attribute === 'exe_position_new') {
              attribName = mappedEntityName + '.indskr_positionid';
            } else if (attrib.attribute === 'exe_sln' || attrib.attribute === 'exe_sln_new') {
              attribName = mappedEntityName + '.indskr_licensenumber';
            } else if (attrib.attribute === 'exe_specialty_new') {
              attribName = mappedEntityName + '.indskr_specialtyid';
            } else if (attrib.attribute.startsWith('exe_') || attrib.attribute.endsWith('_new')) {
              let baseAttr = attrib.attribute.replace(/^exe_/, '').replace(/_new$/, '');
              attribName = mappedEntityName + '.indskr_' + baseAttr;
            } else {
              // Use the mapped source entity (e.g. indskr_customerspecialty), not
              // the CR mirror entity (indskr_customerspecialtychangerequest): the
              // row data is read from the source store and keyed by its name.
              attribName = mappedEntityName + "." + attrib.attribute;
            }
            attribName = leData[attribName + "@OData.Community.Display.V1.FormattedValue"] ?
              attribName + "@OData.Community.Display.V1.FormattedValue" : (leData[attribName + "_Formatted"] ? attribName + "_Formatted" : attribName);
          } else if (index !== -1) {
            attribName = leData[attrib.attribute + "@OData.Community.Display.V1.FormattedValue"] ?
              attrib.attribute + "@OData.Community.Display.V1.FormattedValue" : attrib.attribute;
          } else {
            attribName = control.subgrid.referencingEntity + "." + attrib.attribute;
            if (control.subgrid.referencingEntity == 'indskr_emailaddresscr') {
              attribName = 'indskr_email_address' + "." + attrib.attribute;
            }
            if(leData[attribName + "@OData.Community.Display.V1.FormattedValue"]) {
              attribName += "@OData.Community.Display.V1.FormattedValue";
            }else if(leData[attribName + "_value"]) {
              attribName += "_value";
            }
            if(control.subgrid.referencingEntity == "indskr_indskr_customeraddress_v2") {
              let addressAttribName = "indskr_address" + "." + attrib.attribute;
              if(leData[addressAttribName +"@OData.Community.Display.V1.FormattedValue"]){
                attribName = addressAttribName;
                attribName += "@OData.Community.Display.V1.FormattedValue";
              }
            }
          }
          //As new requirement, New Lookup should be displayed instead of Role option set.
          if (attribName && !leData[attribName]) {
            //If display form is not updated, but create/edit form is updated
            switch (attribName) {
              case "indskr_accountcontactaffiliation.indskr_contactrole":
                attrib.attribute = "omnione_role";
                break;
              case "indskr_accountcontactaffiliation.omnione_role":
                attrib.attribute = "indskr_contactrole";
                break;
              case "indskr_contactrelationship.indskr_relationship":
                attrib.attribute = "omnione_relationship";
                break;
              case "indskr_contactrelationship.omnione_relationship":
                attrib.attribute = "indskr_relationship";
                break;
              case "indskr_accountaccountaffiliation.indskr_type":
                attrib.attribute = "omnione_relationship";
                break;
              case "indskr_accountaccountaffiliation.omnione_relationship":
                attrib.attribute = "indskr_type";
                break;
            }
            attribName = control.subgrid.referencingEntity + "." + attrib.attribute;
            attribName += leData[attribName + "@OData.Community.Display.V1.FormattedValue"] ? "@OData.Community.Display.V1.FormattedValue" : "";
          }
          // A genuine boolean false (e.g. indskr_isprimaryaccount unticked) must still render —
          // the plain leData[attribName] truthy check below would otherwise silently drop the
          // row entirely, indistinguishable from the attribute being absent from the row data.
          // Mirrors the same fix in ind-display-form.ts (display-only) - this is the edit form's
          // existing-data accordion card, which was missed.
          if (attribName && (leData[attribName] || typeof leData[attribName] === 'boolean')) {
            if (editFormExistingDataViewCard) {
              this._setViewCardData(childItems, attrib, control, attribName, leData);
              if (attrib.attribute == "indskr_name" && leData[attribName]) {
                primaryTextindskrName = leData[attribName];
              }
            } else {
              if (attrib.attribute == "indskr_name" && leData[attribName]) {
                primaryTextindskrName = leData[attribName];
              }
              let existingDataId;
              let existingAddressDataId;
              if (foundLinkedEntityIdAttribName) {
                existingDataId = leData[foundLinkedEntityIdAttribName] || '';
              }
              if (foundAddressLinkedEntityIdAttribName) {
                existingAddressDataId = leData[foundAddressLinkedEntityIdAttribName] || '';
              }
              
              const referencingEntity = control.subgrid.referencingEntity;
              const referencingAttribute = control.subgrid.referencingAttribute;
              const lookupFieldActualValue: string = this._getLookupFieldActualValue(leData, referencingEntity, referencingAttribute, true);
              editFormExistingDataViewCard = {
                displayType: 'Accordion',
                id: control.attributeName + '_' + attribName + Math.random().toString(36).substring(7),
                linkedEntityExistingDataId: existingDataId,
                linkedEntityExistingDataAddressId: existingAddressDataId,
                primaryText: formattedPrimaryText ? formattedPrimaryText : primaryTextindskrName ? primaryTextindskrName : leData[attribName],
                lookupFieldActualValue: lookupFieldActualValue,
                showExpandIcon: false,
                showCollapseIcon: false,
                isExpanded: false,
                childItems: [],
                rawObjData: leData,
                isDeactivate: false,
                scrapFromList: abilityToRemoveRecords,
                clickHandler: (id, event, specificTarget, dataRef) => this.handleAccordionView(event, control, specificTarget, dataRef),
                showRightIcon: false,
                disableEditArrow: false
              };
              if(control.subgrid.referencingEntity=='indskr_setbookingproduct'){
                if(leData['indskr_setbookingproduct.indskr_productid']){
                  editFormExistingDataViewCard.primaryText += ' | '+leData['indskr_setbookingproduct.indskr_productid'];
                }
                editFormExistingDataViewCard.primaryText += ' | '+this.translate.instant('Quantity')+' - '+leData['indskr_setbookingproduct.indskr_quantity'];
                editFormExistingDataViewCard.disableEditArrow = true;
              } else if (control.subgrid.referencingEntity == 'indskr_medicalinquiryproduct') {
                editFormExistingDataViewCard.disableEditArrow = true;
              } else if (control.subgrid.referencingEntity == 'exe_customerlicensechangerequest' || control.subgrid.referencingEntity == 'indskr_addresscr' || control.subgrid.referencingEntity == 'indskr_customeraddresscr') {
                // Enable edit arrow for customer license / specialty change requests / address change requests
                editFormExistingDataViewCard.showRightIcon = true;
                editFormExistingDataViewCard.rightIconName = 'chevron-forward-outline';
                if ((control.subgrid.referencingEntity == 'indskr_addresscr' || control.subgrid.referencingEntity == 'indskr_customeraddresscr') && leData.hasOwnProperty('indskr_indskr_customeraddress_v2.indskr_customeraddresssourcetype') && leData['indskr_indskr_customeraddress_v2.indskr_customeraddresssourcetype'] != 548910000) {
                  //Enable Edit only for BusinessAddress
                  editFormExistingDataViewCard.isDeactivate = true;
                  editFormExistingDataViewCard.showRightIcon = false;
                  editFormExistingDataViewCard.scrapFromList = false;
                }
              }
            }
          }
        });
        if (editFormExistingDataViewCard) {
          editFormExistingDataViewCard.childItems = childItems;
          if (childItems && childItems.length > 0) {
            editFormExistingDataViewCard.showExpandIcon = true;
            editFormExistingDataViewCard.showCollapseIcon = true;
          }
          if (this.linkedEntityValues && this.linkedEntityValues[control.attributeName]) {
            this.linkedEntityValues[control.attributeName].push(editFormExistingDataViewCard);
          } else if (this.linkedEntityValues) {
            this.linkedEntityValues[control.attributeName] = [editFormExistingDataViewCard];
          } else {
            this.linkedEntityValues = {
              [control.attributeName]: [editFormExistingDataViewCard]
            };
          }
        }
      });
    }
    return this.linkedEntityValues;
  }

  private getCustomerAddressCRAttributeName(attrib: string): string {
    const mapping = this.addressCRAttributeMapping.get(attrib);
    return mapping ? mapping.sourceKey : undefined;
  }

  private _getLookupFieldActualValue(lookupData: any, referencingEntity: string, referencingAttribute: string, isExstingData: boolean): string {
    let actualValue: string = '';
    let targetName = [];
    if(referencingEntity.includes('accountcontact')) {
      if(referencingAttribute.includes('contact')) {
        targetName = ['indskr_accountid', 'accountid'];
      } else if(referencingAttribute.includes('account')) {
        targetName = ['indskr_contactid', 'contactid'];
      }
    } else if(referencingEntity.includes('special')) {
      targetName = ['omnione_lu_specialties', 'specialtyid'];
    } else if(referencingEntity.includes('contactrelation')) {
      targetName = ['indskr_relatedcontactid', 'relatedcontact'];
    } else if(referencingEntity.includes('accountaccount')) {
      if(referencingAttribute.includes('to')) {
        targetName = ['indskr_affiliatedfromaccountid', 'fromaccountid'];
      } else if(referencingAttribute.includes('from')) {
        targetName = ['indskr_affiliatedtoaccountid', 'toaccountid'];
      }
    }
    if(isExstingData) {
      actualValue = lookupData[referencingEntity + '.' + targetName[0]] || '';
      if(actualValue == '') actualValue = lookupData[referencingEntity + '.' + targetName[1]] || '';
    } else {
      let foundData = lookupData.find(ld=>ld.name == targetName[0]);
      if(foundData) {
        actualValue = foundData.id || '';
      } else {
        foundData = lookupData.find(ld=>ld.name.includes(targetName[1]));
        if(foundData) actualValue = foundData.id || '';
      }
    }
    return actualValue;
  }

  private _setViewCardData(childItems: any[], attrib: SubgridLayout, control: Control, attribName: string, leData: any) {
    let displayName: string = this._getDisplayText(attrib.displayNames);
    if (childItems.findIndex(item => item.id === control.attributeName + '_' + attribName) == -1) {
      const rawValue = leData[attribName];
      childItems.push({
        id: control.attributeName + '_' + attribName,
        label: displayName ? displayName : '',
        // A raw boolean (e.g. indskr_isprimaryaccount) must render as a translated Yes/No,
        // not the literal JS true/false value.
        value: typeof rawValue === 'boolean' ? this.translate.instant(rawValue ? 'YES' : 'NO') : rawValue,
      });
    }
  }

  public async openEditFormExistingData(ev, item) {
    let targetControl: Control;
    let id = item.id.toLowerCase();
    if (id) {
      for (let tabIdx = 0; tabIdx < this._dynamicForm.metadata.length; tabIdx++) {
        const tab = this._dynamicForm.metadata[tabIdx];
        if (tab && tab.controls && tab.controls.length > 0) {
          let foundControl = tab.controls.find(c => {
            if(!c.dataType) {
              const currAttributeName = c.attributeName.toLowerCase();
              const isAddress: boolean = currAttributeName.includes('address') && !currAttributeName.includes('email');
              if(!isAddress) {
                return id.includes(currAttributeName);
              }else {
                return id.includes(currAttributeName) && !id.includes('email');
              }
            }
          });
          if (foundControl) {
            targetControl = foundControl;
            break;
          } else {
            foundControl = tab.controls.find(c => {
              if(!c.dataType) {
                const currAttributeName = c.attributeName.toLowerCase();
                return id.includes(currAttributeName);
              }
            });
            if (foundControl) {
              targetControl = foundControl;
              break;
            }
          }
        }
      };
      if (targetControl) {
        if (this.editConfig == EditConfig.ADD_NEW && targetControl.lookupEntitySetName != 'indskr_setbookingproducts' && targetControl.subgrid?.referencingEntity != 'exe_customerlicensechangerequest' && targetControl.subgrid?.referencingEntity != 'indskr_addresscr') return;
        if (this.formDetail.formMetadata.entityName == 'account') {
          this.trackingService.tracking('EditSelected', TrackingEventNames.ACCOUNT_EDIT, true);
        } else if (this.formDetail.formMetadata.entityName == 'contact') {
          this.trackingService.tracking('EditSelected', TrackingEventNames.CONTACT_EDIT, true);
        }
        if (targetControl.subgrid) {
            if (targetControl.subgrid.targetEntityType) {
              let foundForm;
              let formType;
              if (this.formDetail.dynamicFormType == DynamicFormType.CONFIGUREDFORM) {
                if (this.TYPE == 'OMNIPRESENCE' && this.MODE == 'EDIT_MODE' 
                  && this._dynamicForm && this._dynamicForm?.formChangeRequestType == FormChangeRequestType.Update) {
                  foundForm = await this.dynamicFormsService.getFormDefinitionForEntity(targetControl.subgrid.targetEntityType, FormType.EDITFORM, BusinessProcessType.Omnipresence);  
                } else {
                  foundForm = await this.dynamicFormsService.getFormDefinitionForEntity(targetControl.subgrid.targetEntityType, FormType.CREATEFORM);
                }
                formType = DynamicFormType.CONFIGUREDFORM;
              } else if (this.formDetail.dynamicFormType == DynamicFormType.DEFAULTFORM) {
                let ff = SHARED_CREATE_FORM.find(f => f.indskr_entityname == targetControl.subgrid.targetEntityType)
                if (ff) {
                  foundForm = new DynamicForm(ff)
                  formType = DynamicFormType.DEFAULTFORM;
                };
              }

              if (foundForm) {
                const targetAttributeName: string = targetControl.attributeName;
                let rawFormEntityObject = null;
                //Account to Contact Affiliation - Prefill Account and make Contact as required field
                if (this.formDetail.formMetadata.entityName == 'account' && targetControl.subgrid.targetEntityType == 'indskr_accountcontactaffiliation') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, "omnione_role", "indskr_contactrole");
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundAccountControlIdx = itab.controls.findIndex(c => c.attributeName == 'indskr_accountid');
                      if (foundAccountControlIdx >= 0) {
                        itab.controls[foundAccountControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundAccountControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundAccountControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //Contact to Account Affiliation - Prefill Contact and make Account as required field
                if (this.formDetail.formMetadata.entityName == 'contact' && targetControl.subgrid.targetEntityType == 'indskr_accountcontactaffiliation') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, "omnione_role", "indskr_contactrole");
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == 'indskr_contactid');
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //Hide CustomerAddress
                if (targetControl.subgrid.targetEntityType == 'indskr_indskr_customeraddress_v2') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIndex = itab.controls.findIndex(c => c.attributeName == 'indskr_address');
                      if (foundControlIndex >= 0) {
                        itab.controls[foundControlIndex].forceHide = true;
                        break;
                      }
                    }
                  };
                }

                //Hide EmailAddress
                if (targetControl.subgrid.targetEntityType == 'indskr_email_address') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIndex = itab.controls.findIndex(c => c.lookupEntitySetName == this.formDetail.LookupEntitySetName);
                      if (foundControlIndex >= 0) {
                        itab.controls[foundControlIndex].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIndex].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIndex].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                      }
                    }
                  };
                }

                //Account to Account Affiliation - Prefill Contact and make Account as required field
                if (this.formDetail.formMetadata.entityName == 'account' && targetControl.subgrid.targetEntityType == 'indskr_accountaccountaffiliation') {
                  let attribName = targetControl.subgrid.referencingAttribute;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, 'omnione_relationship', 'indskr_type');
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == attribName);
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //Contact to Contact Affiliation - Prefill Parent Contact and make Child contact as required field
                if ((this.formDetail.formMetadata.entityName == 'contact' && targetControl.subgrid.targetEntityType == 'indskr_contactrelationship')
                || (this.formDetail.formMetadata.entityName == 'indskr_contactcr' && targetControl.subgrid.targetEntityType == 'indskr_contactrelationshipcr')) {
                  let attribName = targetControl.subgrid.referencingAttribute;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, "omnione_relationship", this.formDetail.formMetadata.entityName == 'contact' ? "indskr_relationship" : "indskr_relationshiptype");
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == attribName);
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //Customer Specialty
                if (targetControl.subgrid.targetEntityType == 'indskr_customerspecialty') {
                  let attribName = targetControl.subgrid.referencingAttribute;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == attribName);
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }
                //Check linked entity existing data address Id
                let foundAddressLinkedEntityId;
                if (targetControl.subgrid.targetEntityType == 'indskr_indskr_customeraddress_v2') {
                  if (item.rawObjData && item.rawObjData.formValue && item.rawObjData.formValue.lookupfields) {
                    let checkedEntity = item.rawObjData.formValue.lookupfields.filter(x=>x.entity == "indskr_addresses");
                    if (!isEmpty(checkedEntity)) {
                      foundAddressLinkedEntityId = checkedEntity[0].id || '';
                    }
                  }
                }

                //Contact to Account Affiliation change request - Prefill Contact change request and make Account as required field
                if (this.formDetail.formMetadata.entityName == 'indskr_contactcr' && targetControl.subgrid.targetEntityType == 'indskr_accountcontactaffiliationcr') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    this.removeOldOptionSetIfLookupIsPresent(itab, foundForm, i, "indskr_affiliationrole", "indskr_contactrole");
                    if (itab && itab.controls && itab.controls.length > 0) {
                      rawFormEntityObject = this.getFieldsToDisplayForContactAccountAff(itab, rawFormEntityObject, 'indskr_contactcr', 'indskr_accountid');
                    }
                  };
                }

                //Customer License Change Request - Map data from indskr_customerlicense to exe_customerlicensechangerequest form fields
                if (this.formDetail.formMetadata.entityName == 'indskr_contactcr' && targetControl.subgrid.targetEntityType == 'exe_customerlicensechangerequest') {
                  if (item.rawObjData) {
                    const entityName = targetControl.subgrid.targetEntityType; // 'exe_customerlicensechangerequest'
                    const sourceEntityName = 'indskr_customerlicense'; // Source entity name
                    const mappedData: any = {};
                    
                    // Iterate through form metadata to dynamically map all fields
                    for (let i = 0; i < foundForm.metadata.length; i++) {
                      const tab = foundForm.metadata[i];
                      if (tab && tab.controls && tab.controls.length > 0) {
                        tab.controls.forEach(control => {
                          if (control.attributeName && !control.forceHide) {
                            const targetAttr = control.attributeName;
                            let sourceAttr: string = '';
                            
                            // Handle special cases first (fields that don't follow common pattern)
                            if (targetAttr === 'exe_sln' || targetAttr == 'exe_sln_new') {
                              sourceAttr = 'indskr_licensenumber';
                            } else if (targetAttr === 'exe_expdate_new') {
                              sourceAttr = 'indskr_validuntil';
                            } else if (targetAttr.startsWith('exe_') && targetAttr.endsWith('_new')) {
                              const baseAttr = targetAttr.replace(/^exe_/, '').replace(/_new$/, '');
                              sourceAttr = 'indskr_' + baseAttr;
                            } else if (targetAttr.startsWith('exe_')) {
                              const baseAttr = targetAttr.replace(/^exe_/, '');
                              sourceAttr = 'indskr_' + baseAttr;
                            }
                            
                            if (sourceAttr) {
                              const sourceKey = sourceEntityName + '.' + sourceAttr;
                              const targetKey = entityName + '.' + targetAttr;
                              
                              if (item.rawObjData[sourceKey] !== undefined && item.rawObjData[sourceKey] !== null) {
                                mappedData[targetKey] = item.rawObjData[sourceKey];
                              }
                              
                              if (control.dataType == ControlDataType.LookupType) {
                                const formattedKey = sourceKey + '@OData.Community.Display.V1.FormattedValue';
                                const formattedKeyAlt = sourceKey + '_Formatted';
                                const targetFormattedKey = targetKey + '@OData.Community.Display.V1.FormattedValue';
                                
                                if (item.rawObjData[formattedKey]) {
                                  mappedData[targetFormattedKey] = item.rawObjData[formattedKey];
                                } else if (item.rawObjData[formattedKeyAlt]) {
                                  mappedData[targetFormattedKey] = item.rawObjData[formattedKeyAlt];
                                }
                              }
                            }
                          }
                        });
                      }
                    }
                    
                    // Merge mapped data with existing rawObjData
                    item.rawObjData = { ...item.rawObjData, ...mappedData };
                  }
                }

                //Hide CustomerAddress ChangeRequest
                if (targetControl.subgrid.targetEntityType == 'indskr_customeraddresscr') {
                  this.dynamicFormsService.hasCityDataBasedOnCountry = false;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    if (itab && itab.controls && itab.controls.length > 0) {
                      itab.controls.filter(c => c.attributeName == 'indskr_addresscr' || c.lookupEntitySetName == 'indskr_addresses' ||
                        c.lookupEntitySetName == 'indskr_contactcrs'
                        || c.lookupEntitySetName == 'indskr_accountcrs'
                        || c.lookupEntitySetName?.startsWith('indskr_lu_')).forEach(c => {
                          if (c.lookupEntitySetName == this.formDetail.LookupEntitySetName) {
                            rawFormEntityObject = {
                              ['_' + c.attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                              ['_' + c.attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                            };
                          }
                          c.forceHide = true;
                        })
                    }
                  };
                }

                //Hide EmailAddress ChangeRequest "indskr_accountcrs", "indskr_contactcrs"
                if (targetControl.subgrid.targetEntityType == 'indskr_emailaddresscr') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIndex = itab.controls.findIndex(c => c.lookupEntitySetName == this.formDetail.LookupEntitySetName);
                      if (this.formDetail.LookupEntitySetName == 'indskr_accountcrs') {
                        const controlIndexToHide = itab.controls.findIndex(c => c.lookupEntitySetName == 'indskr_contactcrs');
                        if (controlIndexToHide >= 0) {
                          itab.controls[controlIndexToHide].forceHide = true;
                        }
                      }
                      if (this.formDetail.LookupEntitySetName == 'indskr_contactcrs') {
                        const controlIndexToHide = itab.controls.findIndex(c => c.lookupEntitySetName == 'indskr_accountcrs');
                        if (controlIndexToHide >= 0) {
                          itab.controls[controlIndexToHide].forceHide = true;
                        }
                        if (this.TYPE == 'OMNIPRESENCE' && this.MODE == 'EDIT_MODE' 
                          && this._dynamicForm && this._dynamicForm?.formChangeRequestType == FormChangeRequestType.Update) {
                          const idxToHide = itab.controls.findIndex(c => c.attributeName == 'indskr_name');
                          itab.controls[idxToHide].forceHide = true;
                        }
                      }
                      if (foundControlIndex >= 0) {
                        itab.controls[foundControlIndex].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIndex].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIndex].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                      }
                    }
                  };
                }

                //Set Booking to Product Association - Prefill Set Booking Guid
                if (this.formDetail.formMetadata.entityName == 'indskr_setbooking' && targetControl.subgrid.targetEntityType == 'indskr_setbookingproduct') {
                  let attribName = targetControl.subgrid.referencingAttribute;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    const nonVisibleFormSection = this.setBookingDataService.formSectionConfigure?.filter(config => config['_indskr_mobileappform_value'] == this.formDetail.formMetadata.mobileFormId && !config['indskr_visibility']);
                    itab.controls.forEach(control => {
                      if (control.dataType && control.attributeName && !isEmpty(nonVisibleFormSection) && nonVisibleFormSection.some(sec => sec['indskr_name'].toLowerCase() == control.attributeName.toLowerCase())) {
                        control.isVisible = false;
                        control.forceHide = true;
                      } else if (!control.dataType && control.subgrid && !isEmpty(nonVisibleFormSection) && nonVisibleFormSection.some(sec => sec['indskr_name'].toLowerCase() == control.attributeName.toLowerCase())) {
                        control.isVisible = false;
                        control.forceHide = true;
                      }
                    });
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == attribName);
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                  let surgeonaccountzsurValue = this._getAttributeValue('indskr_surgeonaccountzsur');
                  if(surgeonaccountzsurValue){
                    if(item.rawObjData){
                      item.rawObjData['surgeonaccountzsurValue'] = surgeonaccountzsurValue;
                    }else{
                      item.rawObjData = {
                        surgeonaccountzsurValue: surgeonaccountzsurValue,
                      };
                    }
                  }
                }

                //Set Booking to Team Member Association - Prefill Set Booking Guid
                if (this.formDetail.formMetadata.entityName == 'indskr_setbooking' && targetControl.subgrid.targetEntityType == 'indskr_setbookingteammember') {
                  let attribName = targetControl.subgrid.referencingAttribute;
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    const nonVisibleFormSection = this.setBookingDataService.formSectionConfigure?.filter(config => config['_indskr_mobileappform_value'] == this.formDetail.formMetadata.mobileFormId && !config['indskr_visibility']);
                    itab.controls.forEach(control => {
                      if (control.dataType && control.attributeName && !isEmpty(nonVisibleFormSection) && nonVisibleFormSection.some(sec => sec['indskr_name'].toLowerCase() == control.attributeName.toLowerCase())) {
                        control.isVisible = false;
                        control.forceHide = true;
                      } else if (!control.dataType && control.subgrid && !isEmpty(nonVisibleFormSection) && nonVisibleFormSection.some(sec => sec['indskr_name'].toLowerCase() == control.attributeName.toLowerCase())) {
                        control.isVisible = false;
                        control.forceHide = true;
                      }
                    });
                    if (itab && itab.controls && itab.controls.length > 0) {
                      let foundControlIdx = itab.controls.findIndex(c => c.attributeName == attribName);
                      if (foundControlIdx >= 0) {
                        itab.controls[foundControlIdx].forceHide = true;
                        rawFormEntityObject = {
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value']: this.formDetail.mainEntityObjectId && this.formDetail.mainEntityObjectId[Object.keys(this.formDetail.mainEntityObjectId)[0]],
                          ['_' + itab.controls[foundControlIdx].attributeName + '_value@OData.Community.Display.V1.FormattedValue']: ''
                        };
                        break;
                      }
                    }
                  };
                }

                //For Category flow: Address CR Edit
                if (this.formDetail.formMetadata.entityName == 'indskr_contactcr' && targetControl.subgrid.targetEntityType == 'indskr_addresscr') {
                  for (let i = 0; i < foundForm.metadata.length; i++) {
                    const itab = foundForm.metadata[i];
                    itab.controls.forEach(control => {
                      const attributeName = control.attributeName;
                      const matchingKey = attributeName.startsWith('indskr') || attributeName == 'exe_address' || attributeName == 'exe_isprimary' || attributeName == 'exe_address_new' || attributeName == 'exe_address';
                      //Hide all old fields and display only new Fields with prepopulated data from rawObj
                      if (matchingKey) {
                        control.forceHide = true;
                        if (!item.rawObjData.hasOwnProperty(targetControl.subgrid.targetEntityType + '.' + attributeName)) {
                          item.rawObjData[targetControl.subgrid.targetEntityType + '.' + attributeName] = item.rawObjData['indskr_address.' + attributeName] ?? item.rawObjData['indskr_indskr_customeraddress_v2.' + attributeName];
                          const formattedValue = item.rawObjData['indskr_address.' + attributeName + '@OData.Community.Display.V1.FormattedValue'] ?? item.rawObjData['indskr_indskr_customeraddress_v2.' + attributeName + '@OData.Community.Display.V1.FormattedValue'];
                          if (formattedValue) {
                            item.rawObjData[targetControl.subgrid.targetEntityType + '.' + attributeName + '@OData.Community.Display.V1.FormattedValue'] = formattedValue;
                          }
                        }
                      }
                      this.mapAddressCRFields(attributeName, targetControl, item);
                    });
                  }
                }

                //linked entity values for checking the duplicate data
                const checkDuplicateDataInLookupFields = ["indskr_accountcontactaffiliation", "indskr_accountcontactaffiliationcr", "indskr_customerspecialty", "indskr_customerspecialtychangerequest", "indskr_accountaccountaffiliation", "indskr_accountaccountaffiliationcr", "indskr_contactrelationship", "indskr_contactrelationshipcr"];
                if(!isEmpty(this.linkedEntityValues)) {
                  if(targetControl.subgrid.targetEntityType == 'indskr_email_address') {
                    this.dynamicFormsService.storedLinkedEntityValues = this.linkedEntityValues.EMAIL ? this.linkedEntityValues.EMAIL : this.linkedEntityValues.Email ? this.linkedEntityValues.Email : this.linkedEntityValues.sgEmail ? this.linkedEntityValues.sgEmail : [];
                  } else if(checkDuplicateDataInLookupFields.includes(targetControl.subgrid.targetEntityType)) {
                    this.dynamicFormsService.storedLinkedEntityValues = this.linkedEntityValues[targetAttributeName] ? this.linkedEntityValues[targetAttributeName] : [];
                  }
                }
                //check Feature Action
                let accountInfoDeactivateEnabled: boolean = false;
                let contactInfoDeactivateEnabled: boolean = false;
                let setBookingInfoDeactivateEnabled: boolean = false;
                let isEmailAddressCREditFlow: boolean = false;

                if (!this.changeRequest && this._dynamicForm.entityName == "account" && targetControl.linkedEntityConfig && targetControl.linkedEntityConfig.abilityToRemoveRecords == '548910000') {
                  accountInfoDeactivateEnabled = true;
                } else if (!this.changeRequest && this._dynamicForm.entityName == "contact" && targetControl.linkedEntityConfig && targetControl.linkedEntityConfig.abilityToRemoveRecords == '548910000') {
                  contactInfoDeactivateEnabled = true;
                } else if (this._dynamicForm.entityName == "indskr_setbooking" && targetControl.linkedEntityConfig.abilityToRemoveRecords == '548910000') {
                  setBookingInfoDeactivateEnabled = true;
                }
                //Check email address change request flow
                if (this.changeRequest && this.TYPE == 'OMNIPRESENCE' && this.MODE == 'EDIT_MODE' 
                  && targetControl.subgrid.targetEntityType == 'indskr_emailaddresscr' && this.editConfig == EditConfig.UPDATE_EXISTING) {
                  isEmailAddressCREditFlow = true;
                }

                let displayName: any = this._getDisplayText(targetControl.displayNames);
                const isEditingExisting = this.formDetail.formMetadata.entityName == 'indskr_contactcr' && targetControl.subgrid.targetEntityType == 'indskr_addresscr' ? true : item.linkedEntityExistingDataId && !item.linkedEntityAddedNewDataId;
                const titlePrefix = isEditingExisting ? this.translate.instant('EDIT') + ' ' : this.translate.instant('NEW') + ' ';
                let formDetail: DynamicFormComponentModel = {
                  title: titlePrefix + startCase(displayName.toLowerCase()),
                  showLeftHeaderButton: true,
                  showSearchBar: false,
                  showClearButton: true,
                  linkedEntityExistingDataId: item.linkedEntityExistingDataId,
                  linkedEntityExistingDataAddressId: item.linkedEntityExistingDataAddressId || foundAddressLinkedEntityId,
                  linkedEntityAddedNewDataId: item.linkedEntityAddedNewDataId,
                  linkedEntityValue: this.linkedEntityValues ? this.linkedEntityValues[targetControl.attributeName] ? this.linkedEntityValues[targetControl.attributeName] : [] : [],
                  targetControlAttribName: targetControl.attributeName,
                  leftHeaderBtnText: (accountInfoDeactivateEnabled || contactInfoDeactivateEnabled || setBookingInfoDeactivateEnabled || (this.changeRequest && this.TYPE == "OMNIPRESENCE" && this.MODE == 'EDIT_MODE' && !isEmailAddressCREditFlow)) ? this.translate.instant('SCRAP') : '',
                  leftHeaderBtnIcon: 'chevron-back-outline',
                  LookupEntitySetName: foundForm.entitySetName,
                  showRightHeaderButton: true,
                  rightHeaderImgSrc: 'assets/imgs/header_complete.svg',
                  rightHeaderBtnText: this.translate.instant('DONE'),
                  formMetadata: foundForm,
                  formEntityObject: rawFormEntityObject ? { ...item.rawObjData, ...rawFormEntityObject } : item.rawObjData,
                  isEditFormWithLinkedData: true,
                  isUpdatedLinkedEnityFormData: item.isUpdatedFormData ? true : false,
                  mainEntityObjectId: null,
                  linkedEntityParentData: this.getLinkEntityParentData(foundForm.entitySetName, targetControl),
                  customFields: await this._getCustomFields(targetControl.subgrid.referencingEntity),
                  dynamicFormType: formType,
                  navOptions: { animate: false },
                  eventsHandler: (data: any, eventTarget: string, refData: DynamicFormComponentModel) => this._handleDynamicFormComponentEvent(data, eventTarget, refData),
                };
                this.dynamicFormsService.linkedEntityFormIsDirtyTracker = false;
                this.navService.pushChildNavPageWithPageTracking(PageName.DynamicFormComponent, PageName.DynamicFormComponent, this.navService.getCurrentMasterPageName(), {
                  MODE: 'CREATE_MODE',
                  EDIT_CONFIG: this.editConfig,
                  PREVIOUS_MODE: this._previousMode == 'EDIT_MODE' ? 'EDIT_MODE' : 'CREATE_MODE',
                  FORM_DETAIL: formDetail,
                  EDIT_FLOW: this.EDIT_FLOW,
                  TYPE: this.TYPE
                });
              }
            }
        }
      }
    }
  }
  private mapAddressCRFields(attributeName: any, targetControl: Control, item: any) {
    const mapping = this.addressCRAttributeMapping.get(attributeName);
    if (mapping) {
      const targetKey = targetControl.subgrid.targetEntityType + '.' + attributeName;
      item.rawObjData[targetKey] = item.rawObjData[mapping.sourceKey];
      if (mapping.copyFormattedValue) {
        item.rawObjData[targetKey + '@OData.Community.Display.V1.FormattedValue'] = item.rawObjData[mapping.sourceKey + '@OData.Community.Display.V1.FormattedValue'];
        item.rawObjData[targetControl.subgrid.targetEntityType + '.' + mapping.sourceKey + '@OData.Community.Display.V1.FormattedValue'] = item.rawObjData[mapping.sourceKey + '@OData.Community.Display.V1.FormattedValue'];
      }
    }
  }

  private getDisplayEntityNameInScrapMessage(foundControl: Control) {
    let refEntity = foundControl.subgrid.referencingEntity;
    let displayName: string;
    let foundlinkedEntityName = capitalize(foundControl.displayNames[0].description.split('(')[0].trimEnd().toLowerCase());
    switch(refEntity) {
      case 'indskr_email_address':
        displayName = "Email";
        break;
      case 'indskr_indskr_customeraddress_v2':
        displayName = "Customer address";
        break;
      case 'indskr_customerspecialty':
        displayName = "Customer specialty";
        break;
      case 'indskr_contactrelationship':
        displayName = "Contact relationship";
        break;
      case 'indskr_accountcontactaffiliation':
        displayName = "Account contact affiliation";
        break;
      case 'indskr_accountaccountaffiliation':
        displayName = "Account account affiliation";
        break;
      case 'indskr_customerposition':
        displayName = "Customer position";
        break;
      default:
        displayName = foundlinkedEntityName || 'Data';
        break;
    }
    return displayName;
  }
  // Start/End Date picker
  async openStartDatePicker(id, event, eventName, targetControl: Control) {
    this.activityService.dateTimePickerType = DateTimeFieldType.StartDateField;
    let currentStartDateTime;
    let currentEndDateTime;

    if (this._currentFormValue && this._currentFormValue.hasOwnProperty('indskr_enddate')) {
      currentEndDateTime = this._currentFormValue['indskr_enddate'];
    }
    if (this._currentFormValue && this._currentFormValue[targetControl.attributeName]) {
      currentStartDateTime = this._currentFormValue[targetControl.attributeName];
    }
    if (currentStartDateTime && !currentEndDateTime) {
      currentEndDateTime = currentStartDateTime;
    }

    let popover = await this.popoverCtrl.create(
      {
        component: IndDatetimeFormComponent,
        componentProps: {
          currentViewPage: this.formDetail?.formMetadata?.entityName == "indskr_setbooking"? CurViewPageType.NewKitBooking : CurViewPageType.ConfiguredForm,
          startDateTimeValue: currentStartDateTime ? new Date(currentStartDateTime).toISOString() : '',
          endDateTimeValue: currentEndDateTime ? new Date(currentEndDateTime).toISOString() : '',
          controlId: targetControl.attributeName,
        },
        cssClass: "datetime-popover"
      }
    );
    popover.onDidDismiss().then((data: any) => {
      if (data !== null && !isEmpty(data.data) && data.data.startTime !='' && targetControl) {
        if (this.startTime && this.startTime.hasOwnProperty(targetControl.attributeName)) {
          this.startTime[targetControl.attributeName] = data.data.startTime;
        } else {
          this.startTime = {
            [targetControl.attributeName]: data.data.startTime,
          }
        }
        this._updateFormDateModernDatePicker(data.data.startTime, false, targetControl);
        // auto calcuated enddate field
        if (targetControl.attributeName == 'indskr_startdate') {
          let startTime = this.startTime['indskr_startdate'];
          let endTime = this.endTime['indskr_enddate'];
          const diffInMin = this.dateTimeFormatsService.getDifferenceInMinutes(endTime, startTime);
          let secondaryTargetControl: Control = this._getTargetControl('indskr_enddate');
          if (this._dynamicForm.entityName == 'indskr_setbooking') {
            let kigBookingDuration = cloneDeep(this.authService.user.buSettings['indskr_kitbookingduration']);
            if(kigBookingDuration) {
              let endTime = this.dateTimeFormatsService.addMinutesToDate(new Date(startTime), kigBookingDuration);
              this.endTime['indskr_enddate'] = new Date(endTime).toISOString();
              this._updateFormDateModernDatePicker(this.endTime['indskr_enddate'], true, secondaryTargetControl);
            }
          } else if (secondaryTargetControl && diffInMin <= 0) {
            this._updateFormDateModernDatePicker(data.data.endTime, false, secondaryTargetControl);
          }
        }
      }
    });
    popover.present();
  }
  async openEndDatePicker(id, event, eventName, targetControl: Control) {
    this.activityService.dateTimePickerType = DateTimeFieldType.EndDateField;
    let currentStartDateTime;
    let currentEndDateTime;
    if (this._currentFormValue && this._currentFormValue.hasOwnProperty('indskr_startdate')) {
      currentStartDateTime = this._currentFormValue['indskr_startdate'];
    }
    if (this._currentFormValue && this._currentFormValue[targetControl.attributeName]) {
      currentEndDateTime = this._currentFormValue[targetControl.attributeName];
    }

    let popover = await this.popoverCtrl.create(
      {
        component: IndDatetimeFormComponent,
        componentProps: {
          currentViewPage: CurViewPageType.ConfiguredForm,
          startDateTimeValue: currentStartDateTime ? new Date(currentStartDateTime).toISOString() : '',
          endDateTimeValue: currentEndDateTime ? new Date(currentEndDateTime).toISOString() : '',
          controlId: targetControl.attributeName,
        },
        cssClass: "datetime-popover"
      }
    );
    popover.onDidDismiss().then((data: any) => {
      if (data !== null && !isEmpty(data.data) && data.data.endTime !='' && targetControl) {
        if (this.endTime && this.endTime.hasOwnProperty(targetControl.attributeName)) {
          this.endTime[targetControl.attributeName] = data.data.endTime;
        } else {
          this.endTime = {
            [targetControl.attributeName]: data.data.endTime,
          }
        }
        this._updateFormDateModernDatePicker(data.data.endTime, true, targetControl);
      }
    });
    popover.present();
  }
  private _updateFormDateModernDatePicker(dateData: any, isUpdatedEndDateOnly: boolean, targetControl?: Control) {
    if (dateData == false) return;
    let selectedDate = (dateData && dateData?.value) ? new Date(dateData.value) : new Date(dateData);
    if (targetControl && targetControl.dateFormat == DateFormat.DateAndTime) {
      //TODO: selected time value - combined with date
      let formattedDate = new Date(selectedDate).toISOString();
      this._setAttributeValueDate(targetControl, formattedDate);
      if (targetControl.attributeName === 'indskr_startdate') {
        const dateTime = {startDateTime: this.startTime['indskr_startdate'], endDateTime: this.endTime['indskr_enddate']};
        this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
      }
    } else if (targetControl && targetControl.dateFormat == DateFormat.DateOnly) {
      selectedDate.setHours(0, 0, 0, 0);
      let isTimeValid: boolean = true;
      let tempStartDate = (this.startDate) ? this.startDate : null;
      let tempEndDate = (this.endDate) ? this.endDate : null;
      if (this.formDetail.formMetadata.entityName == 'indskr_accountaccountaffiliationcr' || this.formDetail.formMetadata.entityName == 'indskr_accountcontactaffiliationcr' ) {
        if (targetControl.attributeName === 'indskr_startdate') {
          tempStartDate = selectedDate;
        } else if (targetControl.attributeName === 'indskr_enddate') {
          selectedDate.setHours(23, 59, 59, 59);
          tempEndDate = selectedDate;
          let currentDate = new Date().setHours(23,59,59,59);
          if (isUpdatedEndDateOnly && (new Date(tempEndDate).getTime() < new Date(currentDate).getTime())) {
            this.notificationService.notify(this.translate.instant('AFFILIATION_END_DATE_IN_FUTURE'),'ind-dynamic-form','top',ToastStyle.DANGER);
            isTimeValid = false;
          }
        }
        if(isUpdatedEndDateOnly && tempStartDate && tempEndDate) {
          if(new Date(tempStartDate).getTime() > new Date(tempEndDate).getTime()) {
            this.notificationService.notify(this.translate.instant('AFFILIATION_END_DATE_CAN_NOT_BEFORE_START_DATE'),'ind-dynamic-form','top',ToastStyle.DANGER);
            isTimeValid = false;
          }
        }
      }
      if(isTimeValid && targetControl) {
        this.startDate = (tempStartDate) ? tempStartDate : this.startDate;
        this.endDate = (tempEndDate) ? tempEndDate : this.endDate;
        const isUserLocal: boolean = targetControl.dateBehavior == 'UserLocal';
        const formattedDate = new Date(selectedDate).toISOString();
        const formattedDateValue = isUserLocal ? formattedDate : (dateData && dateData?.value) ? new Date(dateData.value) : new Date(dateData);
        this._setAttributeValueDate(targetControl, formattedDateValue);
        if (targetControl.attributeName === 'indskr_startdate') {
          const dateTime = {startDateTime: this.startTime['indskr_startdate'], endDateTime: this.endTime['indskr_enddate']};
          this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
        }
      }
    }
    if(targetControl && targetControl.isRequired){
      let value;
      try {
        value = this._currentFormValue[targetControl.attributeName];
      } catch (error) {

      }
      this._validateMandatoryField(targetControl.attributeName,null,{value:value},false);
    }
  }

  private handleStartDateTimeValue(targetControl: Control) {
    if (!isEmpty(targetControl)) {
      let parsedStartDate = new Date(this.startTime[targetControl.attributeName]);
      if (!this.dateTimeFormatsService.isValidDate(parsedStartDate)) {
        this.notificationService.notify(this.translate.instant('NEW_ACTIVITY_TOAST_INVALID_DATE'), 'Configured Form', 'top', ToastStyle.DANGER);
        this.startTime[targetControl.attributeName] = this.prevStartTime[targetControl.attributeName];
      } else {
        this.prevStartTime[targetControl.attributeName] = this.startTime[targetControl.attributeName];
        let selectedDate = this.startTime[targetControl.attributeName];
        let formattedDate = new Date(selectedDate).toISOString();
        this._setAttributeStringValue(targetControl.attributeName, formattedDate);
        this._setAttributeValue(targetControl, formattedDate);
        if (targetControl.attributeName == 'indskr_startdate' && this.endTime['indskr_enddate']) {
          let currentStartTime = new Date(this.startTime['indskr_startdate']).toISOString();
          let currentEndTime = new Date(this.endTime['indskr_enddate']).toISOString();
          const dateTime = {startDateTime: currentStartTime, endDateTime: currentEndTime};
          this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
        }
      }
    }
  }

  private handleEndDateTimeValue(targetControl: Control) {
    if (!isEmpty(targetControl)) {
      let parsedEndDate = new Date(this.endTime[targetControl.attributeName]);
      if (!this.dateTimeFormatsService.isValidDate(parsedEndDate)) {
        this.notificationService.notify(this.translate.instant('NEW_ACTIVITY_TOAST_INVALID_DATE'), 'Configured Form', 'top', ToastStyle.DANGER);
        this.endTime[targetControl.attributeName] = this.prevEndTime[targetControl.attributeName];
      } else {
        this.prevEndTime[targetControl.attributeName] = this.endTime[targetControl.attributeName];
        let selectedDate = this.endTime[targetControl.attributeName];
        let formattedDate = new Date(selectedDate).toISOString();
        this._setAttributeStringValue(targetControl.attributeName, formattedDate);
        this._setAttributeValue(targetControl, formattedDate);
      }
    }
  }

  private _getTargetControl(attrName: string, targetForm?: DynamicForm): Control {
    let targetControl: Control
    let form: DynamicForm = targetForm ? targetForm : this._dynamicForm
    for (let tabIdx = 0; tabIdx < form.metadata.length; tabIdx++) {
      const tab = form.metadata[tabIdx];
      if (tab && tab.controls && tab.controls.length > 0) {
        let foundControl = tab.controls.find(c => c.attributeName == attrName);
        if (foundControl) {
          targetControl = foundControl;
          break;
        }
      }
    };
    return targetControl;
  }

  private _getTargetControlbyLookupEtity(lookupEntitySetName: string, targetForm?: DynamicForm): Control {
    let targetControl: Control
    let form: DynamicForm = targetForm ? targetForm : this._dynamicForm
    for (let tabIdx = 0; tabIdx < form.metadata.length; tabIdx++) {
      const tab = form.metadata[tabIdx];
      if (tab && tab.controls && tab.controls.length > 0) {
        let foundControl = tab.controls.find(c => c.lookupEntitySetName == lookupEntitySetName);
        if (foundControl) {
          targetControl = foundControl;
          break;
        }
      }
    };
    return targetControl;
  }

  private _getTargetControlbySchemaName(schemaName: string, targetForm?: DynamicForm): Control {
    let targetControl: Control
    let form: DynamicForm = targetForm ? targetForm : this._dynamicForm
    for (let tabIdx = 0; tabIdx < form.metadata.length; tabIdx++) {
      const tab = form.metadata[tabIdx];
      if (tab && tab.controls && tab.controls.length > 0) {
        let foundControl = tab.controls.find(c => c.schemaName == schemaName);
        if (foundControl) {
          targetControl = foundControl;
          break;
        }
      }
    };
    return targetControl;
  }

  private _getTargetTabDisplayNamesByControl(attrName: string, targetForm?: DynamicForm): DisplayText[] {
    let headerLabel: DisplayText[];
    let form: DynamicForm = targetForm ? targetForm : this._dynamicForm
    for (let tabIdx = 0; tabIdx < form.metadata.length; tabIdx++) {
      const tab = form.metadata[tabIdx];
      if (tab && tab.controls && tab.controls.length > 0) {
        let foundControl = tab.controls.find(c => c.attributeName == attrName);
        if (foundControl) {
          if(!foundControl.dataType) {
            headerLabel = foundControl.displayNames;
          } else headerLabel = tab.displayNames;
          break;
        }
      }
    };
    return headerLabel;
  }

  /**
   * Returns true if this section should show checkbox list view (like Set Booking / Medical Inquiry products).
   * viewDataSectionKey is control.attributeName (viewData.data). Also matches by schemaName for form config variance.
   */
  public isCheckboxListViewSection(viewDataSectionKey: string): boolean {
    // console.log('edit config',this.editConfig, this.MODE, this.TYPE)
    if (!this.formDetail?.formMetadata?.metadata || !viewDataSectionKey) return false;
    const entity = this.formDetail.formMetadata.entityName;
    for (const tab of this.formDetail.formMetadata.metadata) {
      if (!tab?.controls?.length) continue;
      const control = tab.controls.find(c =>
        (c.attributeName === viewDataSectionKey || (c.schemaName && c.schemaName === viewDataSectionKey)) &&
        c.subgrid?.targetEntityType
      );
      if (!control) continue;
      if (entity === 'indskr_setbooking' && (control.lookupEntitySetName === 'indskr_setbookingproducts' || control.subgrid.targetEntityType === 'indskr_setbookingproduct')) return true;
      if (entity === 'indskr_medicalinquiry' && (control.lookupEntitySetName === 'indskr_medicalinquiryproducts' || control.lookupEntitySetName === 'indskr_medicalinquiryproduct' || control.subgrid.targetEntityType === 'indskr_medicalinquiryproduct')) return true;
    }
    return false;
  }

  /**
   * formatted date and time values are based on stored values in _currentFormStringValues
   * formatted raw data causes invalid date issue because some formats are not supported on iOS
   * set formatted date and time values in _getViewForControl()
  */
  private _setAttributeValueDate(targetControl: Control, dateValue: any) {
    if (targetControl.dateFormat === DateFormat.DateAndTime) {
      this._setAttributeStringValue(targetControl.attributeName, this.dateTimeFormatsService.formatDate(dateValue, 'YYYY/MM/DD HH:mm'));
      let dateValueStr = isString(dateValue) ? dateValue : dateValue.toISOString();
      this._setAttributeValue(targetControl, dateValueStr);
    } else if (targetControl.dateFormat === DateFormat.DateOnly) {
      this._setAttributeStringValue(targetControl.attributeName, this.dateTimeFormatsService.formatDate(dateValue, 'YYYY/MM/DD'));
      if (targetControl.dateBehavior == 'UserLocal') {
        let dateValueStr = isString(dateValue) ? dateValue : dateValue.toISOString();
        this._setAttributeValue(targetControl, dateValueStr);
      } else {
        this._setAttributeValue(targetControl, this.dateTimeFormatsService.formatDate(dateValue, 'YYYY-MM-DD'));
      }
    }
  }
  /**Check the duplicate data in the lookup field */
  private _checkDuplicatData(linkedEntityParentName: string, lookupEntitySetName: string, storedLinkedEntityValues: any[], selectedId: any): boolean {
    let isDuplicateData: boolean = false;
    storedLinkedEntityValues.forEach(le => {
      //account/contacts, account-contact affiliation: affiliation role makes an affiliation unique
      if(lookupEntitySetName == "indskr_accountcontactaffiliationcrs" || lookupEntitySetName == 'indskr_accountcontactaffiliations') {
        let existingAffiliationRoleId;
        let curFormSelAffiliationRoleId;
        let existingAccountId;
        let curFormSelAccountId;
        let existingContactId;
        let curFormSelContactId;
        const isAccountForm: boolean = linkedEntityParentName && linkedEntityParentName.includes('account');
        const isContactForm: boolean = linkedEntityParentName && linkedEntityParentName.includes('contact');
        //set existing account/contact id and affiliation role id
        if(le.rawObjData && le.rawObjData.formValue) {
          let foundAffiliationRole = le.rawObjData.formValue.lookupfields ? le.rawObjData.formValue.lookupfields.find(field=>field.name.toLowerCase() == 'omnione_lu_affiliationrole') || '' : '';
          if(foundAffiliationRole) existingAffiliationRoleId = foundAffiliationRole.id || '';
          let foundAccount = isContactForm && le.rawObjData.formValue.lookupfields ? le.rawObjData.formValue.lookupfields.find(field=>field.name.toLowerCase() == 'indskr_accountid') || '' : '';
          if(foundAccount) existingAccountId = foundAccount.id || '';
          let foundContact = isAccountForm && le.rawObjData.formValue.lookupfields ? le.rawObjData.formValue.lookupfields.find(field=>field.name.toLowerCase() == 'indskr_contactid') || '' : '';
          if(foundContact) existingContactId = foundContact.id || '';
        } else {
          existingAffiliationRoleId = le.rawObjData && le.rawObjData[this.formDetail.formMetadata.entityName + '.omnione_lu_affiliationrole'] || '';
          existingAccountId = isContactForm && le.rawObjData && le.rawObjData[this.formDetail.formMetadata.entityName + '.indskr_accountid'] || '';
          existingContactId = isAccountForm && le.rawObjData && le.rawObjData[this.formDetail.formMetadata.entityName + '.indskr_contactid'] || '';
        }
        //set current form selected account/contact id and affiliation role id
        if (this._currentFormValue && this._currentFormValue.lookupfields) {
          let foundCurFormAffiliationRole = this._currentFormValue && this._currentFormValue.lookupfields ? this._currentFormValue.lookupfields.find(x=>x.name.toLowerCase() == 'omnione_lu_affiliationrole') || '' : '';
          if(foundCurFormAffiliationRole) curFormSelAffiliationRoleId = foundCurFormAffiliationRole.id || '';
          let foundCurFormAccount = isContactForm && this._currentFormValue && this._currentFormValue.lookupfields ? this._currentFormValue.lookupfields.find(x=>x.name.toLowerCase() == 'indskr_accountid') || '' : '';
          if(foundCurFormAccount) curFormSelAccountId = foundCurFormAccount.id || '';
          let foundCurFormContact = isAccountForm && this._currentFormValue && this._currentFormValue.lookupfields ? this._currentFormValue.lookupfields.find(x=>x.name.toLowerCase() == 'indskr_contactid') || '' : '';
          if(foundCurFormContact) curFormSelContactId = foundCurFormContact.id || '';
        }
        // check the duplicate data
        if(le.lookupFieldActualValue === selectedId) {
          if(existingAffiliationRoleId === curFormSelAffiliationRoleId || (isEmpty(existingAffiliationRoleId) && isEmpty(curFormSelAffiliationRoleId))) {
            return isDuplicateData = true;
          }
        } else if(isContactForm && existingAccountId === curFormSelAccountId && existingAffiliationRoleId === selectedId) {
          return isDuplicateData = true;
        } else if(isAccountForm && existingContactId === curFormSelContactId && existingAffiliationRoleId === selectedId) {
          return isDuplicateData = true;
        }
      } else if(le.lookupFieldActualValue === selectedId) {
        return isDuplicateData = true;
      }
    });
    return isDuplicateData;
  }

  public initFooter() {
    this.footerService.updateButtons(['hopQrCode'], true);
  }

  /** Used by footer-toolbar: when formDetail.footerView is set (e.g. MedicalInquiryNew), show that view's buttons; else 'accounts'. */
  public get footerViewSelectedView(): string {
    return this.formDetail?.footerView || 'accounts';
  }

  public async onFooterButtonClicked(buttonId: string) {
    switch (buttonId) {
      case 'hopQrCode':
        if (!isEmpty(this._currentFormValue?.indskr_hcponeid)) {
          this.uiService.displayLoader();
          const qrResponse: any = await this.mdmService.getHopQrCode(this._currentFormValue?.indskr_hcponeid);
          this.uiService.dismissLoader();
          if (qrResponse?.status == 1000 && qrResponse?.data.url) {
            let popover = await this.popoverCtrl.create({
              component: HopQRCodeModal,
              componentProps: { qrCodeData: qrResponse?.data.url },
              cssClass: "hop-qr-code-modal",
              backdropDismiss: true
            });
            popover.present();
          }
        }
        break;
      case 'submitMedicalInquiry':
        if (this.formDetail?.eventsHandler && (this.formDetail?.footerView || this.formDetail?.rightHeaderBtnIdsArray?.includes('SUBMITMEDICALINQUIRY'))) {
          this.formDetail.eventsHandler({ formValue: this._currentFormValue }, 'SUBMITMEDICALINQUIRY');
        }
        break;
      default:
        break;
    }
  }

  async loadFileFromDevice(event, id) {
    if (event?.target?.files) {
      try {
        const file = event.target.files[0];
        if (file && (file.size / 1000) < MAXIMUM_NOTE_ATTACHMENT_SIZE) {
          if (DCR_ATTACHMENT_MIME_TYPES_SUPPORTED_REGEX.test(file.name)) {
            let b64Str: any = await toBase64(file);
            const dataURLPattern = /^data:[^;]+;base64,/;
            b64Str = b64Str.replace(dataURLPattern, '');
            const b64StrSplitArray = b64Str.split(',');
            const base64Str = Array.isArray(b64StrSplitArray) && b64StrSplitArray.length > 1 ? b64StrSplitArray[1] : b64Str || null;
            if (id == 'attach_practice_certificate') {
              this.practiceCertificateBase64str = base64Str;
              this.practiceCertificateFile = file;
              this.practiceCertificateTitle = file.name;
              this.isPracticeCertificateAdded = true;
            } else {
              this.workCardBase64str = base64Str;
              this.workCardFile = file;
              this.workCardTitle = file.name;
              this.isWorkCardAdded = true;
            }
            this._initViewData();
          } else {
            this.notificationService.notify(
              this.translate.instant('DCR_ATTACHMENT_MIME_TYPE_NOT_SUPPORTED_NOTIFICATION'),
              'Contact Details',
              'top',
              ToastStyle.INFO,
            );
            this.removeAttachment(false, id);
          }
        } else {
          this.notificationService.notify(
            this.translate.instant(
              'MAXIMUM_NOTE_ATTACHMENT_SIZE_NOTIFICATION',
              { size: MAXIMUM_NOTE_ATTACHMENT_SIZE }
            ),
            'Event Notes',
            'top',
            ToastStyle.INFO,
          );
          this.removeAttachment(false, id);
        }
      } catch (error) {
        console.error('loadFileFromDevice: ', error);
      }
    }
  }

  removeAttachment(event, id: string) {
    if (id == 'attach_practice_certificate') {
      if (this.practiceCertificateAttachInput?.nativeElement?.value) {
        this.practiceCertificateAttachInput.nativeElement.value = null;
        this.practiceCertificateTitle = '';
        this.isPracticeCertificateAdded = false;
        this.practiceCertificateFile = null;
        this.practiceCertificateBase64str = null;
      }
    } else {
      if (this.workcardAttachInput?.nativeElement?.value) {
        this.workcardAttachInput.nativeElement.value = null;
        this.workCardTitle = '';
        this.isWorkCardAdded = false;
        this.workCardFile = null;
        this.workCardBase64str = null;
      }
    }
    this._initViewData();
  }

  private handleNoteAttachment(id: string) {
    if (this.TYPE=='SANOFI_CHINA') {
      try {
        if (id == 'attach_practice_certificate') this.practiceCertificateAttachInput.nativeElement.click();
        else this.workcardAttachInput.nativeElement.click();
      } catch (error) {
        console.log(error);
      }
    }
  }

  private _getFormContext(){
    return {
      data: {
        entity: {
          attributes: {
            get: (fieldName) => this._getAttribute(fieldName),
          }
        }
      }
    }
  }

  private _getFormType(){
    if(this._dynamicForm){
      return 1
    }
  }

  private _getAttribute(fieldName){
    return {
      getValue: () => this._getAttributeValue(fieldName),
      setValue: (value) => this._setBusinessRuleAttributeValue(value,fieldName),
      controls: [
        {
          setVisible: (visible) => this._setVisible(visible,fieldName),
          setDisabled: (disabled) => this._setDisabled(disabled,fieldName),
        },
      ],
      setRequiredLevel: (required) => this._setIsRequired(required,fieldName),
    }
  }

  private _setVisible(visible, fieldName) {
    for (let tabIdx = 0; tabIdx < this._dynamicForm.metadata.length; tabIdx++) {
      const tab = this._dynamicForm.metadata[tabIdx];
      if (tab && tab.controls && tab.controls.length > 0) {
        let foundControl = tab.controls.find(c => c.attributeName == fieldName);
        if (foundControl) {
          foundControl.forceHide = !visible;
          this._runInitViewDataAfterBusinessRuleLogic = true;
          break;
        }
      }
    };
  }

  private _setDisabled(disabled, fieldName) {
    for (let tabIdx = 0; tabIdx < this._dynamicForm.metadata.length; tabIdx++) {
      const tab = this._dynamicForm.metadata[tabIdx];
      if (tab && tab.controls && tab.controls.length > 0) {
        let foundControl = tab.controls.find(c => c.attributeName == fieldName);
        if (foundControl) {
          foundControl.isReadOnly = disabled;
          this._runInitViewDataAfterBusinessRuleLogic = true;
          break;
        }
      }
    };
  }

  private _setIsRequired(required,fieldName) {
    for (let tabIdx = 0; tabIdx < this._dynamicForm.metadata.length; tabIdx++) {
      const tab = this._dynamicForm.metadata[tabIdx];
      if (tab && tab.controls && tab.controls.length > 0) {
        let foundControl = tab.controls.find(c => c.attributeName == fieldName);
        if (foundControl) {
          foundControl.isRequired = required == 'required';
          this._runInitViewDataAfterBusinessRuleLogic = true;
          break;
        }
      }
    };
  }

  private _getAttributeValue(fieldName){
    let targetControl: Control = this._getTargetControl(fieldName);
    if(targetControl) {
      if(targetControl.dataType == ControlDataType.PicklistType){
        if (this._currentFormValue && this._currentFormValue.hasOwnProperty(targetControl.attributeName)) {
          return parseInt(this._currentFormValue[targetControl.attributeName]);
        }else{
          return null;
        }
      }else if(targetControl.dataType == ControlDataType.LookupType){
        const comparisonValue = !this.isHandleEditAddressFormField ? (targetControl.isCustom ? this._customFormValue : this._currentFormValue) : (targetControl.isCustom ? this._existingCustomFormValue : this._existingFormValue);
        const objName = targetControl.isCustom ? targetControl.schemaName : (targetControl.isCustomAttribute ? targetControl.schemaName : targetControl.attributeName);
        if (comparisonValue && comparisonValue.hasOwnProperty('lookupfields')) {
          let idx = comparisonValue['lookupfields'].findIndex(a => a.name == objName);
          if (idx >= 0) {
            return comparisonValue['lookupfields'][idx].id;
          }
        }
        return null;
      }else if(targetControl.dataType == ControlDataType.BooleanType){
        const value = this._getInputTextForFormField(targetControl);
        return value=='Yes'? true : value =='No'?false:null;
      }else {
        return this._getInputTextForFormField(targetControl);
      }
    } else {
      return null;
    }

  }

  private _setBusinessRuleAttributeValue(value,fieldName){
    let targetControl: Control = this._getTargetControl(fieldName);
    let currentValue = this._getAttributeValue(fieldName);
    if(currentValue != value){
      if(targetControl && targetControl.dataType == ControlDataType.PicklistType){
        try {
          const optionValue = targetControl.optionSet.find(option => option.value == value);
          if(optionValue){
            const optionStr = optionValue.displayNames.find(a=> a.languagecode == this._activeLanguageCode);
            if(optionStr){
              this._setAttributeStringValue(targetControl.attributeName,optionStr.description);
            }
          }
        } catch (error) {console.log(error);}
      }
      if(targetControl) this._setAttributeValue(targetControl,value,true,'',false);
    }
  }

  private _sanitizeGuid(guid) {
    var guidRegex = /^[A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12}$/;
    // Check if the provided 'guid' matches the GUID format
    if (guid.match(guidRegex)) {
      // If it's a valid GUID, return it in the canonical format (lowercase with dashes)
      return guid.toLowerCase();
    } else {
      // If it's not a valid GUID, return null or handle the error as needed
      return null;
    }
  }
  private _runBusinessRulesLogic(){
    const businessRules = this.formDetail && this.formDetail.formMetadata && this.formDetail.formMetadata.businessRules ? this.formDetail.formMetadata.businessRules : [];
    const functionMap: Array<Function> = [];

    // Create a map of function names to actual functions
    businessRules.forEach((funcString) => {
      try {
        if(funcString && funcString.logicFunction){
          funcString.logicFunction = funcString.logicFunction.replace('(eventContext)','(eventContext,Mscrm,Xrm)')
          const func = new Function('return ' + funcString.logicFunction)();
          if (func) {
            functionMap.push(func);
          }
        }

      } catch (error) {
        console.error(`Error parsing function: ${error}`);
      }
    });

    for (const func of functionMap) {
      try {
        const Mscrm = {
          BusinessRules: {
            Utility: {
              isNull: (o) => o == null || o === undefined,
              sanitizeGuid: (guid) =>  this._sanitizeGuid(guid),
            },
            ErrorHandlerFactory: {
              getHandler: function (e, f) {
                return {
                  handleError: () => {
                    throw e;
                  },
                };
              },
            },
          },
        };

        const Xrm = {
          Page: {
            data: {
              entity: undefined,
            },
            ui: {
              getFormType:() => this._getFormType(),
            }
          },
        };
        const eventContext = {
          getFormContext: () => this._getFormContext()
        }
        func(eventContext,Mscrm,Xrm);
      } catch (error) {
        console.error('Error executing function:', error);
      }
    }
    if(this._runInitViewDataAfterBusinessRuleLogic){
      this._initViewData();
      this._runInitViewDataAfterBusinessRuleLogic = false;
    }

  }

  private _runHardcodedLogic(){
    if(this.MODE == 'CREATE_MODE' && this.formDetail && this.formDetail.formMetadata && this.formDetail.formMetadata.entityName == 'indskr_setbooking'){
      try {
        let control = this._getTargetControl('indskr_status');
        control.isReadOnly = true;
        this._setAttributeValue(control, SetBookingStatus.DRAFT, true);
        this._setAttributeStringValue(control.attributeName, 'Draft');
      } catch (error) {}
    }
  }

  public clickedForScrap(event, item:OmniAccordionViewDataModel, attriuteName) {
    // ionChange provides the authoritative new state; (click) path falls back to toggle
    item.isCheckedForScrap = event?.detail?.checked ?? !item.isCheckedForScrap;
    let targetControl = this._getTargetControl(attriuteName);
    this._targetControlViewData(targetControl);  // what the hell there is no logic for the linked entity section. let's add it
  }

  public handleAccordionView(event, targetControl: Control, target, item:OmniAccordionViewDataModel) {
    if(!targetControl || this.disableForm) return;
    if(target=='scrapFromList') {
      this.clickedForScrap(event, item, targetControl.attributeName)
    } else if (target == 'mainLabel' || target == 'rightIcon' || !target) {
      // Handle edit click - open edit form for linked entity
      // Check if edit is allowed (not disabled) - disableEditArrow defaults to false if not set
      if (item && item.isDeactivate !== true) {
        this.openEditFormExistingData(event, item);
      }
    }
  }

  private _setDefaultValue(control:Control) {
    const disableDefaultValueList = ['indskr_mdm', 'indskr_mdmrequesttype', 'indskr_mdmid', 'indskr_accountsourcetype', 'indskr_contactsourcetype'];
    if (control?.attributeName && disableDefaultValueList.includes(control.attributeName)) return;

    // Skip setting default value if the value is already set in _currentFormValue
    if (this._currentFormValue && this._currentFormValue.hasOwnProperty(control.attributeName)) {
      return;
    }

    // Applying a configured default is system-initiated, not a user edit — don't mark the form dirty.
    this._isApplyingDefaultValue = true;
    try {
      this._applyDefaultValue(control);
    } finally {
      this._isApplyingDefaultValue = false;
    }
  }

  private _applyDefaultValue(control:Control) {
    if(control.dataType == ControlDataType.PicklistType && control.defaultValue>-1) {
      if(control.optionSet) {
        let defaultOption = control.optionSet.find(option => option.value == control.defaultValue);
        let defaultDisplayName = '';
        if(defaultOption && defaultOption.displayNames && defaultOption.displayNames.length>0) {
          let foundDisplayName = defaultOption.displayNames.find(a=> a.languagecode == this._activeLanguageCode) || defaultOption.displayNames.find(a=> a.languagecode == '1033')
          defaultDisplayName = foundDisplayName.description;
        }
        this._setAttributeStringValue(control.attributeName, defaultDisplayName);
        this._setAttributeValue(control, control.defaultValue, false);
        if (control.attributeName == 'indskr_rolepharma'
            || control.attributeName == 'indskr_rolevaccine'
            || control.attributeName == 'indskr_departmentvaccine'
            || control.attributeName == 'indskr_positionretail'
            || control.attributeName == 'indskr_titleretail'
            || control.attributeName == 'indskr_titlepharma') {
            this._currentFormStringValues[control.attributeName + '_Desc'] = defaultOption.descriptions[0].description;
        }
        if(control.attributeName == 'indskr_operationtype') {
          let typeConfig =  this.authService.user.ioConfigurations?.find(o=>o.configName=="KitBooking.OperationTypes.SubTypes.Relation");
          let data = { id:'', title:''};
          let dropdownListDetail: IndDropdownListDetailModel = this.dynamicFormsService.getDropdownListViewFromOptionSet(control.optionSet, '', this._activeLanguageCode);
          if(typeConfig && typeConfig.configValue) {
            let selectedTypeConfig = JSON.parse(typeConfig.configValue).find(o=> o["BU"].toLowerCase().trim() == this.authService.user.businessUnitName.toLowerCase().trim());
            if(selectedTypeConfig && dropdownListDetail && dropdownListDetail.data) {
              let foundOption = dropdownListDetail.data.find(option => option.title.toLowerCase().trim() == selectedTypeConfig['operationType'].toLowerCase().trim());
              if(foundOption) {
                data.title = foundOption.title;
                data.id = foundOption.id;
              }
            }
            this._setAttributeStringValue(control.attributeName, data.title);
            this._setAttributeValue(control, data.id, false);
          }
        }
      }
    } else if(control.dataType == ControlDataType.BooleanType) {
      control.defaultValue ? this._setAttributeValue(control, true, false) : this._setAttributeValue(control, false, false)
    }
  }

  private _setDisabeEditArrow(lookupEntitySetName: string) {
    const foundControl = this._getTargetControlbyLookupEtity(lookupEntitySetName);
    if (foundControl && this.linkedEntityValues[foundControl.attributeName]) {
      this.linkedEntityValues[foundControl.attributeName].map(item => {
        item.disableEditArrow = true;
      });
    }
  }

  public getTranslatedString(text: string) {
    return this.localizationService.getTranslatedString(text, EntityNameForTranslation.MobileAppForm)
  }

  trackById(index: number, item: any) { return item?.id || item?.ID || index; }
}